import { getDefaultExportFromCjs as ll, commonjsGlobal as Ku } from "./ghl-ui.es436.js";
import { __module as Qu } from "./ghl-ui.es440.js";
(function(Hu, cl) {
  (function(Ie) {
    Hu.exports = Ie();
  })(function() {
    var Ie = (Pe, oe) => () => (oe || Pe((oe = { exports: {} }).exports, oe), oe.exports), jt = Ie((Pe, oe) => {
      var ue = function(ce) {
        return ce && ce.Math == Math && ce;
      };
      oe.exports = ue(typeof globalThis == "object" && globalThis) || ue(typeof window == "object" && window) || ue(typeof self == "object" && self) || ue(typeof Ku == "object" && Ku) || function() {
        return this;
      }() || Function("return this")();
    }), Lt = Ie((Pe, oe) => {
      oe.exports = function(ue) {
        try {
          return !!ue();
        } catch {
          return !0;
        }
      };
    }), Mt = Ie((Pe, oe) => {
      var ue = Lt();
      oe.exports = !ue(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), Mn = Ie((Pe, oe) => {
      var ue = Lt();
      oe.exports = !ue(function() {
        var ce = (function() {
        }).bind();
        return typeof ce != "function" || ce.hasOwnProperty("prototype");
      });
    }), Ut = Ie((Pe, oe) => {
      var ue = Mn(), ce = Function.prototype.call;
      oe.exports = ue ? ce.bind(ce) : function() {
        return ce.apply(ce, arguments);
      };
    }), Zu = Ie((Pe) => {
      var oe = {}.propertyIsEnumerable, ue = Object.getOwnPropertyDescriptor, ce = ue && !oe.call({ 1: 2 }, 1);
      Pe.f = ce ? function(se) {
        var Ce = ue(this, se);
        return !!Ce && Ce.enumerable;
      } : oe;
    }), $n = Ie((Pe, oe) => {
      oe.exports = function(ue, ce) {
        return { enumerable: !(ue & 1), configurable: !(ue & 2), writable: !(ue & 4), value: ce };
      };
    }), _t = Ie((Pe, oe) => {
      var ue = Mn(), ce = Function.prototype, se = ce.call, Ce = ue && ce.bind.bind(se, se);
      oe.exports = ue ? Ce : function(be) {
        return function() {
          return se.apply(be, arguments);
        };
      };
    }), gn = Ie((Pe, oe) => {
      var ue = _t(), ce = ue({}.toString), se = ue("".slice);
      oe.exports = function(Ce) {
        return se(ce(Ce), 8, -1);
      };
    }), ei = Ie((Pe, oe) => {
      var ue = _t(), ce = Lt(), se = gn(), Ce = Object, be = ue("".split);
      oe.exports = ce(function() {
        return !Ce("z").propertyIsEnumerable(0);
      }) ? function(Ne) {
        return se(Ne) == "String" ? be(Ne, "") : Ce(Ne);
      } : Ce;
    }), Rn = Ie((Pe, oe) => {
      oe.exports = function(ue) {
        return ue == null;
      };
    }), Fr = Ie((Pe, oe) => {
      var ue = Rn(), ce = TypeError;
      oe.exports = function(se) {
        if (ue(se))
          throw ce("Can't call method on " + se);
        return se;
      };
    }), Vn = Ie((Pe, oe) => {
      var ue = ei(), ce = Fr();
      oe.exports = function(se) {
        return ue(ce(se));
      };
    }), Ar = Ie((Pe, oe) => {
      var ue = typeof document == "object" && document.all, ce = typeof ue > "u" && ue !== void 0;
      oe.exports = { all: ue, IS_HTMLDDA: ce };
    }), kt = Ie((Pe, oe) => {
      var ue = Ar(), ce = ue.all;
      oe.exports = ue.IS_HTMLDDA ? function(se) {
        return typeof se == "function" || se === ce;
      } : function(se) {
        return typeof se == "function";
      };
    }), Yt = Ie((Pe, oe) => {
      var ue = kt(), ce = Ar(), se = ce.all;
      oe.exports = ce.IS_HTMLDDA ? function(Ce) {
        return typeof Ce == "object" ? Ce !== null : ue(Ce) || Ce === se;
      } : function(Ce) {
        return typeof Ce == "object" ? Ce !== null : ue(Ce);
      };
    }), yn = Ie((Pe, oe) => {
      var ue = jt(), ce = kt(), se = function(Ce) {
        return ce(Ce) ? Ce : void 0;
      };
      oe.exports = function(Ce, be) {
        return arguments.length < 2 ? se(ue[Ce]) : ue[Ce] && ue[Ce][be];
      };
    }), vr = Ie((Pe, oe) => {
      var ue = _t();
      oe.exports = ue({}.isPrototypeOf);
    }), ti = Ie((Pe, oe) => {
      var ue = yn();
      oe.exports = ue("navigator", "userAgent") || "";
    }), ni = Ie((Pe, oe) => {
      var ue = jt(), ce = ti(), se = ue.process, Ce = ue.Deno, be = se && se.versions || Ce && Ce.version, Ne = be && be.v8, Te, ke;
      Ne && (Te = Ne.split("."), ke = Te[0] > 0 && Te[0] < 4 ? 1 : +(Te[0] + Te[1])), !ke && ce && (Te = ce.match(/Edge\/(\d+)/), (!Te || Te[1] >= 74) && (Te = ce.match(/Chrome\/(\d+)/), Te && (ke = +Te[1]))), oe.exports = ke;
    }), xr = Ie((Pe, oe) => {
      var ue = ni(), ce = Lt();
      oe.exports = !!Object.getOwnPropertySymbols && !ce(function() {
        var se = Symbol();
        return !String(se) || !(Object(se) instanceof Symbol) || !Symbol.sham && ue && ue < 41;
      });
    }), br = Ie((Pe, oe) => {
      var ue = xr();
      oe.exports = ue && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), Sr = Ie((Pe, oe) => {
      var ue = yn(), ce = kt(), se = vr(), Ce = br(), be = Object;
      oe.exports = Ce ? function(Ne) {
        return typeof Ne == "symbol";
      } : function(Ne) {
        var Te = ue("Symbol");
        return ce(Te) && se(Te.prototype, be(Ne));
      };
    }), Jn = Ie((Pe, oe) => {
      var ue = String;
      oe.exports = function(ce) {
        try {
          return ue(ce);
        } catch {
          return "Object";
        }
      };
    }), hn = Ie((Pe, oe) => {
      var ue = kt(), ce = Jn(), se = TypeError;
      oe.exports = function(Ce) {
        if (ue(Ce))
          return Ce;
        throw se(ce(Ce) + " is not a function");
      };
    }), qn = Ie((Pe, oe) => {
      var ue = hn(), ce = Rn();
      oe.exports = function(se, Ce) {
        var be = se[Ce];
        return ce(be) ? void 0 : ue(be);
      };
    }), ri = Ie((Pe, oe) => {
      var ue = Ut(), ce = kt(), se = Yt(), Ce = TypeError;
      oe.exports = function(be, Ne) {
        var Te, ke;
        if (Ne === "string" && ce(Te = be.toString) && !se(ke = ue(Te, be)) || ce(Te = be.valueOf) && !se(ke = ue(Te, be)) || Ne !== "string" && ce(Te = be.toString) && !se(ke = ue(Te, be)))
          return ke;
        throw Ce("Can't convert object to primitive value");
      };
    }), ui = Ie((Pe, oe) => {
      oe.exports = !1;
    }), Gn = Ie((Pe, oe) => {
      var ue = jt(), ce = Object.defineProperty;
      oe.exports = function(se, Ce) {
        try {
          ce(ue, se, { value: Ce, configurable: !0, writable: !0 });
        } catch {
          ue[se] = Ce;
        }
        return Ce;
      };
    }), Wn = Ie((Pe, oe) => {
      var ue = jt(), ce = Gn(), se = "__core-js_shared__", Ce = ue[se] || ce(se, {});
      oe.exports = Ce;
    }), Tr = Ie((Pe, oe) => {
      var ue = ui(), ce = Wn();
      (oe.exports = function(se, Ce) {
        return ce[se] || (ce[se] = Ce !== void 0 ? Ce : {});
      })("versions", []).push({ version: "3.26.1", mode: ue ? "pure" : "global", copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Xn = Ie((Pe, oe) => {
      var ue = Fr(), ce = Object;
      oe.exports = function(se) {
        return ce(ue(se));
      };
    }), Jt = Ie((Pe, oe) => {
      var ue = _t(), ce = Xn(), se = ue({}.hasOwnProperty);
      oe.exports = Object.hasOwn || function(Ce, be) {
        return se(ce(Ce), be);
      };
    }), Br = Ie((Pe, oe) => {
      var ue = _t(), ce = 0, se = Math.random(), Ce = ue(1 .toString);
      oe.exports = function(be) {
        return "Symbol(" + (be === void 0 ? "" : be) + ")_" + Ce(++ce + se, 36);
      };
    }), zt = Ie((Pe, oe) => {
      var ue = jt(), ce = Tr(), se = Jt(), Ce = Br(), be = xr(), Ne = br(), Te = ce("wks"), ke = ue.Symbol, Ve = ke && ke.for, We = Ne ? ke : ke && ke.withoutSetter || Ce;
      oe.exports = function(Xe) {
        if (!se(Te, Xe) || !(be || typeof Te[Xe] == "string")) {
          var Je = "Symbol." + Xe;
          be && se(ke, Xe) ? Te[Xe] = ke[Xe] : Ne && Ve ? Te[Xe] = Ve(Je) : Te[Xe] = We(Je);
        }
        return Te[Xe];
      };
    }), ii = Ie((Pe, oe) => {
      var ue = Ut(), ce = Yt(), se = Sr(), Ce = qn(), be = ri(), Ne = zt(), Te = TypeError, ke = Ne("toPrimitive");
      oe.exports = function(Ve, We) {
        if (!ce(Ve) || se(Ve))
          return Ve;
        var Xe = Ce(Ve, ke), Je;
        if (Xe) {
          if (We === void 0 && (We = "default"), Je = ue(Xe, Ve, We), !ce(Je) || se(Je))
            return Je;
          throw Te("Can't convert object to primitive value");
        }
        return We === void 0 && (We = "number"), be(Ve, We);
      };
    }), Un = Ie((Pe, oe) => {
      var ue = ii(), ce = Sr();
      oe.exports = function(se) {
        var Ce = ue(se, "string");
        return ce(Ce) ? Ce : Ce + "";
      };
    }), ai = Ie((Pe, oe) => {
      var ue = jt(), ce = Yt(), se = ue.document, Ce = ce(se) && ce(se.createElement);
      oe.exports = function(be) {
        return Ce ? se.createElement(be) : {};
      };
    }), wr = Ie((Pe, oe) => {
      var ue = Mt(), ce = Lt(), se = ai();
      oe.exports = !ue && !ce(function() {
        return Object.defineProperty(se("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Nr = Ie((Pe) => {
      var oe = Mt(), ue = Ut(), ce = Zu(), se = $n(), Ce = Vn(), be = Un(), Ne = Jt(), Te = wr(), ke = Object.getOwnPropertyDescriptor;
      Pe.f = oe ? ke : function(Ve, We) {
        if (Ve = Ce(Ve), We = be(We), Te)
          try {
            return ke(Ve, We);
          } catch {
          }
        if (Ne(Ve, We))
          return se(!ue(ce.f, Ve, We), Ve[We]);
      };
    }), si = Ie((Pe, oe) => {
      var ue = Mt(), ce = Lt();
      oe.exports = ue && ce(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: !1 }).prototype != 42;
      });
    }), Kt = Ie((Pe, oe) => {
      var ue = Yt(), ce = String, se = TypeError;
      oe.exports = function(Ce) {
        if (ue(Ce))
          return Ce;
        throw se(ce(Ce) + " is not an object");
      };
    }), un = Ie((Pe) => {
      var oe = Mt(), ue = wr(), ce = si(), se = Kt(), Ce = Un(), be = TypeError, Ne = Object.defineProperty, Te = Object.getOwnPropertyDescriptor, ke = "enumerable", Ve = "configurable", We = "writable";
      Pe.f = oe ? ce ? function(Xe, Je, X) {
        if (se(Xe), Je = Ce(Je), se(X), typeof Xe == "function" && Je === "prototype" && "value" in X && We in X && !X[We]) {
          var Ke = Te(Xe, Je);
          Ke && Ke[We] && (Xe[Je] = X.value, X = { configurable: Ve in X ? X[Ve] : Ke[Ve], enumerable: ke in X ? X[ke] : Ke[ke], writable: !1 });
        }
        return Ne(Xe, Je, X);
      } : Ne : function(Xe, Je, X) {
        if (se(Xe), Je = Ce(Je), se(X), ue)
          try {
            return Ne(Xe, Je, X);
          } catch {
          }
        if ("get" in X || "set" in X)
          throw be("Accessors not supported");
        return "value" in X && (Xe[Je] = X.value), Xe;
      };
    }), kr = Ie((Pe, oe) => {
      var ue = Mt(), ce = un(), se = $n();
      oe.exports = ue ? function(Ce, be, Ne) {
        return ce.f(Ce, be, se(1, Ne));
      } : function(Ce, be, Ne) {
        return Ce[be] = Ne, Ce;
      };
    }), oi = Ie((Pe, oe) => {
      var ue = Mt(), ce = Jt(), se = Function.prototype, Ce = ue && Object.getOwnPropertyDescriptor, be = ce(se, "name"), Ne = be && (function() {
      }).name === "something", Te = be && (!ue || ue && Ce(se, "name").configurable);
      oe.exports = { EXISTS: be, PROPER: Ne, CONFIGURABLE: Te };
    }), Pr = Ie((Pe, oe) => {
      var ue = _t(), ce = kt(), se = Wn(), Ce = ue(Function.toString);
      ce(se.inspectSource) || (se.inspectSource = function(be) {
        return Ce(be);
      }), oe.exports = se.inspectSource;
    }), li = Ie((Pe, oe) => {
      var ue = jt(), ce = kt(), se = ue.WeakMap;
      oe.exports = ce(se) && /native code/.test(String(se));
    }), pi = Ie((Pe, oe) => {
      var ue = Tr(), ce = Br(), se = ue("keys");
      oe.exports = function(Ce) {
        return se[Ce] || (se[Ce] = ce(Ce));
      };
    }), jr = Ie((Pe, oe) => {
      oe.exports = {};
    }), ci = Ie((Pe, oe) => {
      var ue = li(), ce = jt(), se = Yt(), Ce = kr(), be = Jt(), Ne = Wn(), Te = pi(), ke = jr(), Ve = "Object already initialized", We = ce.TypeError, Xe = ce.WeakMap, Je, X, Ke, rt = function(H) {
        return Ke(H) ? X(H) : Je(H, {});
      }, pt = function(H) {
        return function(xt) {
          var qt;
          if (!se(xt) || (qt = X(xt)).type !== H)
            throw We("Incompatible receiver, " + H + " required");
          return qt;
        };
      };
      ue || Ne.state ? (lt = Ne.state || (Ne.state = new Xe()), lt.get = lt.get, lt.has = lt.has, lt.set = lt.set, Je = function(H, xt) {
        if (lt.has(H))
          throw We(Ve);
        return xt.facade = H, lt.set(H, xt), xt;
      }, X = function(H) {
        return lt.get(H) || {};
      }, Ke = function(H) {
        return lt.has(H);
      }) : (yt = Te("state"), ke[yt] = !0, Je = function(H, xt) {
        if (be(H, yt))
          throw We(Ve);
        return xt.facade = H, Ce(H, yt, xt), xt;
      }, X = function(H) {
        return be(H, yt) ? H[yt] : {};
      }, Ke = function(H) {
        return be(H, yt);
      });
      var lt, yt;
      oe.exports = { set: Je, get: X, has: Ke, enforce: rt, getterFor: pt };
    }), Ir = Ie((Pe, oe) => {
      var ue = Lt(), ce = kt(), se = Jt(), Ce = Mt(), be = oi().CONFIGURABLE, Ne = Pr(), Te = ci(), ke = Te.enforce, Ve = Te.get, We = Object.defineProperty, Xe = Ce && !ue(function() {
        return We(function() {
        }, "length", { value: 8 }).length !== 8;
      }), Je = String(String).split("String"), X = oe.exports = function(Ke, rt, pt) {
        String(rt).slice(0, 7) === "Symbol(" && (rt = "[" + String(rt).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), pt && pt.getter && (rt = "get " + rt), pt && pt.setter && (rt = "set " + rt), (!se(Ke, "name") || be && Ke.name !== rt) && (Ce ? We(Ke, "name", { value: rt, configurable: !0 }) : Ke.name = rt), Xe && pt && se(pt, "arity") && Ke.length !== pt.arity && We(Ke, "length", { value: pt.arity });
        try {
          pt && se(pt, "constructor") && pt.constructor ? Ce && We(Ke, "prototype", { writable: !1 }) : Ke.prototype && (Ke.prototype = void 0);
        } catch {
        }
        var lt = ke(Ke);
        return se(lt, "source") || (lt.source = Je.join(typeof rt == "string" ? rt : "")), Ke;
      };
      Function.prototype.toString = X(function() {
        return ce(this) && Ve(this).source || Ne(this);
      }, "toString");
    }), di = Ie((Pe, oe) => {
      var ue = kt(), ce = un(), se = Ir(), Ce = Gn();
      oe.exports = function(be, Ne, Te, ke) {
        ke || (ke = {});
        var Ve = ke.enumerable, We = ke.name !== void 0 ? ke.name : Ne;
        if (ue(Te) && se(Te, We, ke), ke.global)
          Ve ? be[Ne] = Te : Ce(Ne, Te);
        else {
          try {
            ke.unsafe ? be[Ne] && (Ve = !0) : delete be[Ne];
          } catch {
          }
          Ve ? be[Ne] = Te : ce.f(be, Ne, { value: Te, enumerable: !1, configurable: !ke.nonConfigurable, writable: !ke.nonWritable });
        }
        return be;
      };
    }), Di = Ie((Pe, oe) => {
      var ue = Math.ceil, ce = Math.floor;
      oe.exports = Math.trunc || function(se) {
        var Ce = +se;
        return (Ce > 0 ? ce : ue)(Ce);
      };
    }), Yn = Ie((Pe, oe) => {
      var ue = Di();
      oe.exports = function(ce) {
        var se = +ce;
        return se !== se || se === 0 ? 0 : ue(se);
      };
    }), fi = Ie((Pe, oe) => {
      var ue = Yn(), ce = Math.max, se = Math.min;
      oe.exports = function(Ce, be) {
        var Ne = ue(Ce);
        return Ne < 0 ? ce(Ne + be, 0) : se(Ne, be);
      };
    }), mi = Ie((Pe, oe) => {
      var ue = Yn(), ce = Math.min;
      oe.exports = function(se) {
        return se > 0 ? ce(ue(se), 9007199254740991) : 0;
      };
    }), an = Ie((Pe, oe) => {
      var ue = mi();
      oe.exports = function(ce) {
        return ue(ce.length);
      };
    }), gi = Ie((Pe, oe) => {
      var ue = Vn(), ce = fi(), se = an(), Ce = function(be) {
        return function(Ne, Te, ke) {
          var Ve = ue(Ne), We = se(Ve), Xe = ce(ke, We), Je;
          if (be && Te != Te) {
            for (; We > Xe; )
              if (Je = Ve[Xe++], Je != Je)
                return !0;
          } else
            for (; We > Xe; Xe++)
              if ((be || Xe in Ve) && Ve[Xe] === Te)
                return be || Xe || 0;
          return !be && -1;
        };
      };
      oe.exports = { includes: Ce(!0), indexOf: Ce(!1) };
    }), yi = Ie((Pe, oe) => {
      var ue = _t(), ce = Jt(), se = Vn(), Ce = gi().indexOf, be = jr(), Ne = ue([].push);
      oe.exports = function(Te, ke) {
        var Ve = se(Te), We = 0, Xe = [], Je;
        for (Je in Ve)
          !ce(be, Je) && ce(Ve, Je) && Ne(Xe, Je);
        for (; ke.length > We; )
          ce(Ve, Je = ke[We++]) && (~Ce(Xe, Je) || Ne(Xe, Je));
        return Xe;
      };
    }), hi = Ie((Pe, oe) => {
      oe.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), Ei = Ie((Pe) => {
      var oe = yi(), ue = hi(), ce = ue.concat("length", "prototype");
      Pe.f = Object.getOwnPropertyNames || function(se) {
        return oe(se, ce);
      };
    }), Ci = Ie((Pe) => {
      Pe.f = Object.getOwnPropertySymbols;
    }), Fi = Ie((Pe, oe) => {
      var ue = yn(), ce = _t(), se = Ei(), Ce = Ci(), be = Kt(), Ne = ce([].concat);
      oe.exports = ue("Reflect", "ownKeys") || function(Te) {
        var ke = se.f(be(Te)), Ve = Ce.f;
        return Ve ? Ne(ke, Ve(Te)) : ke;
      };
    }), Ai = Ie((Pe, oe) => {
      var ue = Jt(), ce = Fi(), se = Nr(), Ce = un();
      oe.exports = function(be, Ne, Te) {
        for (var ke = ce(Ne), Ve = Ce.f, We = se.f, Xe = 0; Xe < ke.length; Xe++) {
          var Je = ke[Xe];
          !ue(be, Je) && !(Te && ue(Te, Je)) && Ve(be, Je, We(Ne, Je));
        }
      };
    }), vi = Ie((Pe, oe) => {
      var ue = Lt(), ce = kt(), se = /#|\.prototype\./, Ce = function(Ve, We) {
        var Xe = Ne[be(Ve)];
        return Xe == ke ? !0 : Xe == Te ? !1 : ce(We) ? ue(We) : !!We;
      }, be = Ce.normalize = function(Ve) {
        return String(Ve).replace(se, ".").toLowerCase();
      }, Ne = Ce.data = {}, Te = Ce.NATIVE = "N", ke = Ce.POLYFILL = "P";
      oe.exports = Ce;
    }), En = Ie((Pe, oe) => {
      var ue = jt(), ce = Nr().f, se = kr(), Ce = di(), be = Gn(), Ne = Ai(), Te = vi();
      oe.exports = function(ke, Ve) {
        var We = ke.target, Xe = ke.global, Je = ke.stat, X, Ke, rt, pt, lt, yt;
        if (Xe ? Ke = ue : Je ? Ke = ue[We] || be(We, {}) : Ke = (ue[We] || {}).prototype, Ke)
          for (rt in Ve) {
            if (lt = Ve[rt], ke.dontCallGetSet ? (yt = ce(Ke, rt), pt = yt && yt.value) : pt = Ke[rt], X = Te(Xe ? rt : We + (Je ? "." : "#") + rt, ke.forced), !X && pt !== void 0) {
              if (typeof lt == typeof pt)
                continue;
              Ne(lt, pt);
            }
            (ke.sham || pt && pt.sham) && se(lt, "sham", !0), Ce(Ke, rt, lt, ke);
          }
      };
    }), Lr = Ie((Pe, oe) => {
      var ue = gn();
      oe.exports = Array.isArray || function(ce) {
        return ue(ce) == "Array";
      };
    }), xi = Ie((Pe, oe) => {
      var ue = TypeError, ce = 9007199254740991;
      oe.exports = function(se) {
        if (se > ce)
          throw ue("Maximum allowed index exceeded");
        return se;
      };
    }), bi = Ie((Pe, oe) => {
      var ue = gn(), ce = _t();
      oe.exports = function(se) {
        if (ue(se) === "Function")
          return ce(se);
      };
    }), _r = Ie((Pe, oe) => {
      var ue = bi(), ce = hn(), se = Mn(), Ce = ue(ue.bind);
      oe.exports = function(be, Ne) {
        return ce(be), Ne === void 0 ? be : se ? Ce(be, Ne) : function() {
          return be.apply(Ne, arguments);
        };
      };
    }), Or = Ie((Pe, oe) => {
      var ue = Lr(), ce = an(), se = xi(), Ce = _r(), be = function(Ne, Te, ke, Ve, We, Xe, Je, X) {
        for (var Ke = We, rt = 0, pt = Je ? Ce(Je, X) : !1, lt, yt; rt < Ve; )
          rt in ke && (lt = pt ? pt(ke[rt], rt, Te) : ke[rt], Xe > 0 && ue(lt) ? (yt = ce(lt), Ke = be(Ne, Te, lt, yt, Ke, Xe - 1) - 1) : (se(Ke + 1), Ne[Ke] = lt), Ke++), rt++;
        return Ke;
      };
      oe.exports = be;
    }), Si = Ie((Pe, oe) => {
      var ue = zt(), ce = ue("toStringTag"), se = {};
      se[ce] = "z", oe.exports = String(se) === "[object z]";
    }), Mr = Ie((Pe, oe) => {
      var ue = Si(), ce = kt(), se = gn(), Ce = zt(), be = Ce("toStringTag"), Ne = Object, Te = se(function() {
        return arguments;
      }()) == "Arguments", ke = function(Ve, We) {
        try {
          return Ve[We];
        } catch {
        }
      };
      oe.exports = ue ? se : function(Ve) {
        var We, Xe, Je;
        return Ve === void 0 ? "Undefined" : Ve === null ? "Null" : typeof (Xe = ke(We = Ne(Ve), be)) == "string" ? Xe : Te ? se(We) : (Je = se(We)) == "Object" && ce(We.callee) ? "Arguments" : Je;
      };
    }), Ti = Ie((Pe, oe) => {
      var ue = _t(), ce = Lt(), se = kt(), Ce = Mr(), be = yn(), Ne = Pr(), Te = function() {
      }, ke = [], Ve = be("Reflect", "construct"), We = /^\s*(?:class|function)\b/, Xe = ue(We.exec), Je = !We.exec(Te), X = function(rt) {
        if (!se(rt))
          return !1;
        try {
          return Ve(Te, ke, rt), !0;
        } catch {
          return !1;
        }
      }, Ke = function(rt) {
        if (!se(rt))
          return !1;
        switch (Ce(rt)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        try {
          return Je || !!Xe(We, Ne(rt));
        } catch {
          return !0;
        }
      };
      Ke.sham = !0, oe.exports = !Ve || ce(function() {
        var rt;
        return X(X.call) || !X(Object) || !X(function() {
          rt = !0;
        }) || rt;
      }) ? Ke : X;
    }), Bi = Ie((Pe, oe) => {
      var ue = Lr(), ce = Ti(), se = Yt(), Ce = zt(), be = Ce("species"), Ne = Array;
      oe.exports = function(Te) {
        var ke;
        return ue(Te) && (ke = Te.constructor, ce(ke) && (ke === Ne || ue(ke.prototype)) ? ke = void 0 : se(ke) && (ke = ke[be], ke === null && (ke = void 0))), ke === void 0 ? Ne : ke;
      };
    }), $r = Ie((Pe, oe) => {
      var ue = Bi();
      oe.exports = function(ce, se) {
        return new (ue(ce))(se === 0 ? 0 : se);
      };
    }), wi = Ie(() => {
      var Pe = En(), oe = Or(), ue = hn(), ce = Xn(), se = an(), Ce = $r();
      Pe({ target: "Array", proto: !0 }, { flatMap: function(be) {
        var Ne = ce(this), Te = se(Ne), ke;
        return ue(be), ke = Ce(Ne, 0), ke.length = oe(ke, Ne, Ne, Te, 0, 1, be, arguments.length > 1 ? arguments[1] : void 0), ke;
      } });
    }), Rr = Ie((Pe, oe) => {
      oe.exports = {};
    }), Ni = Ie((Pe, oe) => {
      var ue = zt(), ce = Rr(), se = ue("iterator"), Ce = Array.prototype;
      oe.exports = function(be) {
        return be !== void 0 && (ce.Array === be || Ce[se] === be);
      };
    }), Vr = Ie((Pe, oe) => {
      var ue = Mr(), ce = qn(), se = Rn(), Ce = Rr(), be = zt(), Ne = be("iterator");
      oe.exports = function(Te) {
        if (!se(Te))
          return ce(Te, Ne) || ce(Te, "@@iterator") || Ce[ue(Te)];
      };
    }), ki = Ie((Pe, oe) => {
      var ue = Ut(), ce = hn(), se = Kt(), Ce = Jn(), be = Vr(), Ne = TypeError;
      oe.exports = function(Te, ke) {
        var Ve = arguments.length < 2 ? be(Te) : ke;
        if (ce(Ve))
          return se(ue(Ve, Te));
        throw Ne(Ce(Te) + " is not iterable");
      };
    }), Pi = Ie((Pe, oe) => {
      var ue = Ut(), ce = Kt(), se = qn();
      oe.exports = function(Ce, be, Ne) {
        var Te, ke;
        ce(Ce);
        try {
          if (Te = se(Ce, "return"), !Te) {
            if (be === "throw")
              throw Ne;
            return Ne;
          }
          Te = ue(Te, Ce);
        } catch (Ve) {
          ke = !0, Te = Ve;
        }
        if (be === "throw")
          throw Ne;
        if (ke)
          throw Te;
        return ce(Te), Ne;
      };
    }), ji = Ie((Pe, oe) => {
      var ue = _r(), ce = Ut(), se = Kt(), Ce = Jn(), be = Ni(), Ne = an(), Te = vr(), ke = ki(), Ve = Vr(), We = Pi(), Xe = TypeError, Je = function(Ke, rt) {
        this.stopped = Ke, this.result = rt;
      }, X = Je.prototype;
      oe.exports = function(Ke, rt, pt) {
        var lt = pt && pt.that, yt = !!(pt && pt.AS_ENTRIES), H = !!(pt && pt.IS_RECORD), xt = !!(pt && pt.IS_ITERATOR), qt = !!(pt && pt.INTERRUPTED), Qt = ue(rt, lt), Pt, $t, Ct, Cn, It, Fn, An, vn = function(bt) {
          return Pt && We(Pt, "normal", bt), new Je(!0, bt);
        }, xn = function(bt) {
          return yt ? (se(bt), qt ? Qt(bt[0], bt[1], vn) : Qt(bt[0], bt[1])) : qt ? Qt(bt, vn) : Qt(bt);
        };
        if (H)
          Pt = Ke.iterator;
        else if (xt)
          Pt = Ke;
        else {
          if ($t = Ve(Ke), !$t)
            throw Xe(Ce(Ke) + " is not iterable");
          if (be($t)) {
            for (Ct = 0, Cn = Ne(Ke); Cn > Ct; Ct++)
              if (It = xn(Ke[Ct]), It && Te(X, It))
                return It;
            return new Je(!1);
          }
          Pt = ke(Ke, $t);
        }
        for (Fn = H ? Ke.next : Pt.next; !(An = ce(Fn, Pt)).done; ) {
          try {
            It = xn(An.value);
          } catch (bt) {
            We(Pt, "throw", bt);
          }
          if (typeof It == "object" && It && Te(X, It))
            return It;
        }
        return new Je(!1);
      };
    }), Ii = Ie((Pe, oe) => {
      var ue = Un(), ce = un(), se = $n();
      oe.exports = function(Ce, be, Ne) {
        var Te = ue(be);
        Te in Ce ? ce.f(Ce, Te, se(0, Ne)) : Ce[Te] = Ne;
      };
    }), Li = Ie(() => {
      var Pe = En(), oe = ji(), ue = Ii();
      Pe({ target: "Object", stat: !0 }, { fromEntries: function(ce) {
        var se = {};
        return oe(ce, function(Ce, be) {
          ue(se, Ce, be);
        }, { AS_ENTRIES: !0 }), se;
      } });
    }), _i = Ie((Pe, oe) => {
      var ue = Ir(), ce = un();
      oe.exports = function(se, Ce, be) {
        return be.get && ue(be.get, Ce, { getter: !0 }), be.set && ue(be.set, Ce, { setter: !0 }), ce.f(se, Ce, be);
      };
    }), Oi = Ie((Pe, oe) => {
      var ue = Kt();
      oe.exports = function() {
        var ce = ue(this), se = "";
        return ce.hasIndices && (se += "d"), ce.global && (se += "g"), ce.ignoreCase && (se += "i"), ce.multiline && (se += "m"), ce.dotAll && (se += "s"), ce.unicode && (se += "u"), ce.unicodeSets && (se += "v"), ce.sticky && (se += "y"), se;
      };
    }), Mi = Ie(() => {
      var Pe = jt(), oe = Mt(), ue = _i(), ce = Oi(), se = Lt(), Ce = Pe.RegExp, be = Ce.prototype, Ne = oe && se(function() {
        var Te = !0;
        try {
          Ce(".", "d");
        } catch {
          Te = !1;
        }
        var ke = {}, Ve = "", We = Te ? "dgimsy" : "gimsy", Xe = function(rt, pt) {
          Object.defineProperty(ke, rt, { get: function() {
            return Ve += pt, !0;
          } });
        }, Je = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        Te && (Je.hasIndices = "d");
        for (var X in Je)
          Xe(X, Je[X]);
        var Ke = Object.getOwnPropertyDescriptor(be, "flags").get.call(ke);
        return Ke !== We || Ve !== We;
      });
      Ne && ue(be, "flags", { configurable: !0, get: ce });
    }), $i = Ie(() => {
      var Pe = En(), oe = jt();
      Pe({ global: !0, forced: oe.globalThis !== oe }, { globalThis: oe });
    }), Ri = Ie(() => {
      $i();
    }), Vi = Ie(() => {
      var Pe = En(), oe = Or(), ue = Xn(), ce = an(), se = Yn(), Ce = $r();
      Pe({ target: "Array", proto: !0 }, { flat: function() {
        var be = arguments.length ? arguments[0] : void 0, Ne = ue(this), Te = ce(Ne), ke = Ce(Ne, 0);
        return ke.length = oe(ke, Ne, Ne, Te, 0, be === void 0 ? 1 : se(be)), ke;
      } });
    }), Ji = Ie((Pe, oe) => {
      var ue = ["cliName", "cliCategory", "cliDescription"], ce = ["_"], se = ["languageId"];
      function Ce(u, l) {
        if (u == null)
          return {};
        var t = be(u, l), s, a;
        if (Object.getOwnPropertySymbols) {
          var e = Object.getOwnPropertySymbols(u);
          for (a = 0; a < e.length; a++)
            s = e[a], !(l.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(u, s) && (t[s] = u[s]);
        }
        return t;
      }
      function be(u, l) {
        if (u == null)
          return {};
        var t = {}, s = Object.keys(u), a, e;
        for (e = 0; e < s.length; e++)
          a = s[e], !(l.indexOf(a) >= 0) && (t[a] = u[a]);
        return t;
      }
      wi(), Li(), Mi(), Ri(), Vi();
      var Ne = Object.create, Te = Object.defineProperty, ke = Object.getOwnPropertyDescriptor, Ve = Object.getOwnPropertyNames, We = Object.getPrototypeOf, Xe = Object.prototype.hasOwnProperty, Je = (u, l) => function() {
        return u && (l = (0, u[Ve(u)[0]])(u = 0)), l;
      }, X = (u, l) => function() {
        return l || (0, u[Ve(u)[0]])((l = { exports: {} }).exports, l), l.exports;
      }, Ke = (u, l) => {
        for (var t in l)
          Te(u, t, { get: l[t], enumerable: !0 });
      }, rt = (u, l, t, s) => {
        if (l && typeof l == "object" || typeof l == "function")
          for (let a of Ve(l))
            !Xe.call(u, a) && a !== t && Te(u, a, { get: () => l[a], enumerable: !(s = ke(l, a)) || s.enumerable });
        return u;
      }, pt = (u, l, t) => (t = u != null ? Ne(We(u)) : {}, rt(l || !u || !u.__esModule ? Te(t, "default", { value: u, enumerable: !0 }) : t, u)), lt = (u) => rt(Te({}, "__esModule", { value: !0 }), u), yt, H = Je({ "<define:process>"() {
        yt = { env: {}, argv: [] };
      } }), xt = X({ "package.json"(u, l) {
        l.exports = { version: "2.8.8" };
      } }), qt = X({ "node_modules/diff/lib/diff/base.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.default = l;
        function l() {
        }
        l.prototype = { diff: function(a, e) {
          var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.callback;
          typeof n == "function" && (r = n, n = {}), this.options = n;
          var o = this;
          function c(A) {
            return r ? (setTimeout(function() {
              r(void 0, A);
            }, 0), !0) : A;
          }
          a = this.castInput(a), e = this.castInput(e), a = this.removeEmpty(this.tokenize(a)), e = this.removeEmpty(this.tokenize(e));
          var h = e.length, m = a.length, y = 1, p = h + m, d = [{ newPos: -1, components: [] }], C = this.extractCommon(d[0], e, a, 0);
          if (d[0].newPos + 1 >= h && C + 1 >= m)
            return c([{ value: this.join(e), count: e.length }]);
          function w() {
            for (var A = -1 * y; A <= y; A += 2) {
              var N = void 0, S = d[A - 1], j = d[A + 1], k = (j ? j.newPos : 0) - A;
              S && (d[A - 1] = void 0);
              var J = S && S.newPos + 1 < h, f = j && 0 <= k && k < m;
              if (!J && !f) {
                d[A] = void 0;
                continue;
              }
              if (!J || f && S.newPos < j.newPos ? (N = s(j), o.pushComponent(N.components, void 0, !0)) : (N = S, N.newPos++, o.pushComponent(N.components, !0, void 0)), k = o.extractCommon(N, e, a, A), N.newPos + 1 >= h && k + 1 >= m)
                return c(t(o, N.components, e, a, o.useLongestToken));
              d[A] = N;
            }
            y++;
          }
          if (r)
            (function A() {
              setTimeout(function() {
                if (y > p)
                  return r();
                w() || A();
              }, 0);
            })();
          else
            for (; y <= p; ) {
              var P = w();
              if (P)
                return P;
            }
        }, pushComponent: function(a, e, n) {
          var r = a[a.length - 1];
          r && r.added === e && r.removed === n ? a[a.length - 1] = { count: r.count + 1, added: e, removed: n } : a.push({ count: 1, added: e, removed: n });
        }, extractCommon: function(a, e, n, r) {
          for (var o = e.length, c = n.length, h = a.newPos, m = h - r, y = 0; h + 1 < o && m + 1 < c && this.equals(e[h + 1], n[m + 1]); )
            h++, m++, y++;
          return y && a.components.push({ count: y }), a.newPos = h, m;
        }, equals: function(a, e) {
          return this.options.comparator ? this.options.comparator(a, e) : a === e || this.options.ignoreCase && a.toLowerCase() === e.toLowerCase();
        }, removeEmpty: function(a) {
          for (var e = [], n = 0; n < a.length; n++)
            a[n] && e.push(a[n]);
          return e;
        }, castInput: function(a) {
          return a;
        }, tokenize: function(a) {
          return a.split("");
        }, join: function(a) {
          return a.join("");
        } };
        function t(a, e, n, r, o) {
          for (var c = 0, h = e.length, m = 0, y = 0; c < h; c++) {
            var p = e[c];
            if (p.removed) {
              if (p.value = a.join(r.slice(y, y + p.count)), y += p.count, c && e[c - 1].added) {
                var d = e[c - 1];
                e[c - 1] = e[c], e[c] = d;
              }
            } else {
              if (!p.added && o) {
                var C = n.slice(m, m + p.count);
                C = C.map(function(P, A) {
                  var N = r[y + A];
                  return N.length > P.length ? N : P;
                }), p.value = a.join(C);
              } else
                p.value = a.join(n.slice(m, m + p.count));
              m += p.count, p.added || (y += p.count);
            }
          }
          var w = e[h - 1];
          return h > 1 && typeof w.value == "string" && (w.added || w.removed) && a.equals("", w.value) && (e[h - 2].value += w.value, e.pop()), e;
        }
        function s(a) {
          return { newPos: a.newPos, components: a.components.slice(0) };
        }
      } }), Qt = X({ "node_modules/diff/lib/diff/array.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.diffArrays = a, u.arrayDiff = void 0;
        var l = t(qt());
        function t(e) {
          return e && e.__esModule ? e : { default: e };
        }
        var s = new l.default();
        u.arrayDiff = s, s.tokenize = function(e) {
          return e.slice();
        }, s.join = s.removeEmpty = function(e) {
          return e;
        };
        function a(e, n, r) {
          return s.diff(e, n, r);
        }
      } }), Pt = X({ "src/document/doc-builders.js"(u, l) {
        H();
        function t(F) {
          return { type: "concat", parts: F };
        }
        function s(F) {
          return { type: "indent", contents: F };
        }
        function a(F, i) {
          return { type: "align", contents: i, n: F };
        }
        function e(F) {
          let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return { type: "group", id: i.id, contents: F, break: !!i.shouldBreak, expandedStates: i.expandedStates };
        }
        function n(F) {
          return a(Number.NEGATIVE_INFINITY, F);
        }
        function r(F) {
          return a({ type: "root" }, F);
        }
        function o(F) {
          return a(-1, F);
        }
        function c(F, i) {
          return e(F[0], Object.assign(Object.assign({}, i), {}, { expandedStates: F }));
        }
        function h(F) {
          return { type: "fill", parts: F };
        }
        function m(F, i) {
          let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return { type: "if-break", breakContents: F, flatContents: i, groupId: g.groupId };
        }
        function y(F, i) {
          return { type: "indent-if-break", contents: F, groupId: i.groupId, negate: i.negate };
        }
        function p(F) {
          return { type: "line-suffix", contents: F };
        }
        var d = { type: "line-suffix-boundary" }, C = { type: "break-parent" }, w = { type: "trim" }, P = { type: "line", hard: !0 }, A = { type: "line", hard: !0, literal: !0 }, N = { type: "line" }, S = { type: "line", soft: !0 }, j = t([P, C]), k = t([A, C]), J = { type: "cursor", placeholder: Symbol("cursor") };
        function f(F, i) {
          let g = [];
          for (let E = 0; E < i.length; E++)
            E !== 0 && g.push(F), g.push(i[E]);
          return t(g);
        }
        function T(F, i, g) {
          let E = F;
          if (i > 0) {
            for (let x = 0; x < Math.floor(i / g); ++x)
              E = s(E);
            E = a(i % g, E), E = a(Number.NEGATIVE_INFINITY, E);
          }
          return E;
        }
        function D(F, i) {
          return { type: "label", label: F, contents: i };
        }
        l.exports = { concat: t, join: f, line: N, softline: S, hardline: j, literalline: k, group: e, conditionalGroup: c, fill: h, lineSuffix: p, lineSuffixBoundary: d, cursor: J, breakParent: C, ifBreak: m, trim: w, indent: s, indentIfBreak: y, align: a, addAlignmentToDoc: T, markAsRoot: r, dedentToRoot: n, dedent: o, hardlineWithoutBreakParent: P, literallineWithoutBreakParent: A, label: D };
      } }), $t = X({ "src/common/end-of-line.js"(u, l) {
        H();
        function t(n) {
          let r = n.indexOf("\r");
          return r >= 0 ? n.charAt(r + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function s(n) {
          switch (n) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function a(n, r) {
          let o;
          switch (r) {
            case `
`:
              o = /\n/g;
              break;
            case "\r":
              o = /\r/g;
              break;
            case `\r
`:
              o = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(r)}.`);
          }
          let c = n.match(o);
          return c ? c.length : 0;
        }
        function e(n) {
          return n.replace(/\r\n?/g, `
`);
        }
        l.exports = { guessEndOfLine: t, convertEndOfLineToChars: s, countEndOfLineChars: a, normalizeEndOfLine: e };
      } }), Ct = X({ "src/utils/get-last.js"(u, l) {
        H();
        var t = (s) => s[s.length - 1];
        l.exports = t;
      } });
      function Cn() {
        let { onlyFirst: u = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(l, u ? void 0 : "g");
      }
      var It = Je({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        H();
      } });
      function Fn(u) {
        if (typeof u != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof u}\``);
        return u.replace(Cn(), "");
      }
      var An = Je({ "node_modules/strip-ansi/index.js"() {
        H(), It();
      } });
      function vn(u) {
        return Number.isInteger(u) ? u >= 4352 && (u <= 4447 || u === 9001 || u === 9002 || 11904 <= u && u <= 12871 && u !== 12351 || 12880 <= u && u <= 19903 || 19968 <= u && u <= 42182 || 43360 <= u && u <= 43388 || 44032 <= u && u <= 55203 || 63744 <= u && u <= 64255 || 65040 <= u && u <= 65049 || 65072 <= u && u <= 65131 || 65281 <= u && u <= 65376 || 65504 <= u && u <= 65510 || 110592 <= u && u <= 110593 || 127488 <= u && u <= 127569 || 131072 <= u && u <= 262141) : !1;
      }
      var xn = Je({ "node_modules/is-fullwidth-code-point/index.js"() {
        H();
      } }), bt = X({ "node_modules/emoji-regex/index.js"(u, l) {
        H(), l.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), Jr = {};
      Ke(Jr, { default: () => qi });
      function qi(u) {
        if (typeof u != "string" || u.length === 0 || (u = Fn(u), u.length === 0))
          return 0;
        u = u.replace((0, qr.default)(), "  ");
        let l = 0;
        for (let t = 0; t < u.length; t++) {
          let s = u.codePointAt(t);
          s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t++, l += vn(s) ? 2 : 1);
        }
        return l;
      }
      var qr, Gi = Je({ "node_modules/string-width/index.js"() {
        H(), An(), xn(), qr = pt(bt());
      } }), Gr = X({ "src/utils/get-string-width.js"(u, l) {
        H();
        var t = (Gi(), lt(Jr)).default, s = /[^\x20-\x7F]/;
        function a(e) {
          return e ? s.test(e) ? t(e) : e.length : 0;
        }
        l.exports = a;
      } }), sn = X({ "src/document/doc-utils.js"(u, l) {
        H();
        var t = Ct(), { literalline: s, join: a } = Pt(), e = (i) => Array.isArray(i) || i && i.type === "concat", n = (i) => {
          if (Array.isArray(i))
            return i;
          if (i.type !== "concat" && i.type !== "fill")
            throw new Error("Expect doc type to be `concat` or `fill`.");
          return i.parts;
        }, r = {};
        function o(i, g, E, x) {
          let b = [i];
          for (; b.length > 0; ) {
            let B = b.pop();
            if (B === r) {
              E(b.pop());
              continue;
            }
            if (E && b.push(B, r), !g || g(B) !== !1)
              if (e(B) || B.type === "fill") {
                let I = n(B);
                for (let M = I.length, V = M - 1; V >= 0; --V)
                  b.push(I[V]);
              } else if (B.type === "if-break")
                B.flatContents && b.push(B.flatContents), B.breakContents && b.push(B.breakContents);
              else if (B.type === "group" && B.expandedStates)
                if (x)
                  for (let I = B.expandedStates.length, M = I - 1; M >= 0; --M)
                    b.push(B.expandedStates[M]);
                else
                  b.push(B.contents);
              else
                B.contents && b.push(B.contents);
          }
        }
        function c(i, g) {
          let E = /* @__PURE__ */ new Map();
          return x(i);
          function x(B) {
            if (E.has(B))
              return E.get(B);
            let I = b(B);
            return E.set(B, I), I;
          }
          function b(B) {
            if (Array.isArray(B))
              return g(B.map(x));
            if (B.type === "concat" || B.type === "fill") {
              let I = B.parts.map(x);
              return g(Object.assign(Object.assign({}, B), {}, { parts: I }));
            }
            if (B.type === "if-break") {
              let I = B.breakContents && x(B.breakContents), M = B.flatContents && x(B.flatContents);
              return g(Object.assign(Object.assign({}, B), {}, { breakContents: I, flatContents: M }));
            }
            if (B.type === "group" && B.expandedStates) {
              let I = B.expandedStates.map(x), M = I[0];
              return g(Object.assign(Object.assign({}, B), {}, { contents: M, expandedStates: I }));
            }
            if (B.contents) {
              let I = x(B.contents);
              return g(Object.assign(Object.assign({}, B), {}, { contents: I }));
            }
            return g(B);
          }
        }
        function h(i, g, E) {
          let x = E, b = !1;
          function B(I) {
            let M = g(I);
            if (M !== void 0 && (b = !0, x = M), b)
              return !1;
          }
          return o(i, B), x;
        }
        function m(i) {
          if (i.type === "group" && i.break || i.type === "line" && i.hard || i.type === "break-parent")
            return !0;
        }
        function y(i) {
          return h(i, m, !1);
        }
        function p(i) {
          if (i.length > 0) {
            let g = t(i);
            !g.expandedStates && !g.break && (g.break = "propagated");
          }
          return null;
        }
        function d(i) {
          let g = /* @__PURE__ */ new Set(), E = [];
          function x(B) {
            if (B.type === "break-parent" && p(E), B.type === "group") {
              if (E.push(B), g.has(B))
                return !1;
              g.add(B);
            }
          }
          function b(B) {
            B.type === "group" && E.pop().break && p(E);
          }
          o(i, x, b, !0);
        }
        function C(i) {
          return i.type === "line" && !i.hard ? i.soft ? "" : " " : i.type === "if-break" ? i.flatContents || "" : i;
        }
        function w(i) {
          return c(i, C);
        }
        var P = (i, g) => i && i.type === "line" && i.hard && g && g.type === "break-parent";
        function A(i) {
          if (!i)
            return i;
          if (e(i) || i.type === "fill") {
            let g = n(i);
            for (; g.length > 1 && P(...g.slice(-2)); )
              g.length -= 2;
            if (g.length > 0) {
              let E = A(t(g));
              g[g.length - 1] = E;
            }
            return Array.isArray(i) ? g : Object.assign(Object.assign({}, i), {}, { parts: g });
          }
          switch (i.type) {
            case "align":
            case "indent":
            case "indent-if-break":
            case "group":
            case "line-suffix":
            case "label": {
              let g = A(i.contents);
              return Object.assign(Object.assign({}, i), {}, { contents: g });
            }
            case "if-break": {
              let g = A(i.breakContents), E = A(i.flatContents);
              return Object.assign(Object.assign({}, i), {}, { breakContents: g, flatContents: E });
            }
          }
          return i;
        }
        function N(i) {
          return A(j(i));
        }
        function S(i) {
          switch (i.type) {
            case "fill":
              if (i.parts.every((E) => E === ""))
                return "";
              break;
            case "group":
              if (!i.contents && !i.id && !i.break && !i.expandedStates)
                return "";
              if (i.contents.type === "group" && i.contents.id === i.id && i.contents.break === i.break && i.contents.expandedStates === i.expandedStates)
                return i.contents;
              break;
            case "align":
            case "indent":
            case "indent-if-break":
            case "line-suffix":
              if (!i.contents)
                return "";
              break;
            case "if-break":
              if (!i.flatContents && !i.breakContents)
                return "";
              break;
          }
          if (!e(i))
            return i;
          let g = [];
          for (let E of n(i)) {
            if (!E)
              continue;
            let [x, ...b] = e(E) ? n(E) : [E];
            typeof x == "string" && typeof t(g) == "string" ? g[g.length - 1] += x : g.push(x), g.push(...b);
          }
          return g.length === 0 ? "" : g.length === 1 ? g[0] : Array.isArray(i) ? g : Object.assign(Object.assign({}, i), {}, { parts: g });
        }
        function j(i) {
          return c(i, (g) => S(g));
        }
        function k(i) {
          let g = [], E = i.filter(Boolean);
          for (; E.length > 0; ) {
            let x = E.shift();
            if (x) {
              if (e(x)) {
                E.unshift(...n(x));
                continue;
              }
              if (g.length > 0 && typeof t(g) == "string" && typeof x == "string") {
                g[g.length - 1] += x;
                continue;
              }
              g.push(x);
            }
          }
          return g;
        }
        function J(i) {
          return c(i, (g) => Array.isArray(g) ? k(g) : g.parts ? Object.assign(Object.assign({}, g), {}, { parts: k(g.parts) }) : g);
        }
        function f(i) {
          return c(i, (g) => typeof g == "string" && g.includes(`
`) ? T(g) : g);
        }
        function T(i) {
          let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
          return a(g, i.split(`
`)).parts;
        }
        function D(i) {
          if (i.type === "line")
            return !0;
        }
        function F(i) {
          return h(i, D, !1);
        }
        l.exports = { isConcat: e, getDocParts: n, willBreak: y, traverseDoc: o, findInDoc: h, mapDoc: c, propagateBreaks: d, removeLines: w, stripTrailingHardline: N, normalizeParts: k, normalizeDoc: J, cleanDoc: j, replaceTextEndOfLine: T, replaceEndOfLine: f, canBreak: F };
      } }), Wi = X({ "src/document/doc-printer.js"(u, l) {
        H();
        var { convertEndOfLineToChars: t } = $t(), s = Ct(), a = Gr(), { fill: e, cursor: n, indent: r } = Pt(), { isConcat: o, getDocParts: c } = sn(), h, m = 1, y = 2;
        function p() {
          return { value: "", length: 0, queue: [] };
        }
        function d(S, j) {
          return w(S, { type: "indent" }, j);
        }
        function C(S, j, k) {
          return j === Number.NEGATIVE_INFINITY ? S.root || p() : j < 0 ? w(S, { type: "dedent" }, k) : j ? j.type === "root" ? Object.assign(Object.assign({}, S), {}, { root: S }) : w(S, { type: typeof j == "string" ? "stringAlign" : "numberAlign", n: j }, k) : S;
        }
        function w(S, j, k) {
          let J = j.type === "dedent" ? S.queue.slice(0, -1) : [...S.queue, j], f = "", T = 0, D = 0, F = 0;
          for (let I of J)
            switch (I.type) {
              case "indent":
                E(), k.useTabs ? i(1) : g(k.tabWidth);
                break;
              case "stringAlign":
                E(), f += I.n, T += I.n.length;
                break;
              case "numberAlign":
                D += 1, F += I.n;
                break;
              default:
                throw new Error(`Unexpected type '${I.type}'`);
            }
          return b(), Object.assign(Object.assign({}, S), {}, { value: f, length: T, queue: J });
          function i(I) {
            f += "	".repeat(I), T += k.tabWidth * I;
          }
          function g(I) {
            f += " ".repeat(I), T += I;
          }
          function E() {
            k.useTabs ? x() : b();
          }
          function x() {
            D > 0 && i(D), B();
          }
          function b() {
            F > 0 && g(F), B();
          }
          function B() {
            D = 0, F = 0;
          }
        }
        function P(S) {
          if (S.length === 0)
            return 0;
          let j = 0;
          for (; S.length > 0 && typeof s(S) == "string" && /^[\t ]*$/.test(s(S)); )
            j += S.pop().length;
          if (S.length > 0 && typeof s(S) == "string") {
            let k = s(S).replace(/[\t ]*$/, "");
            j += s(S).length - k.length, S[S.length - 1] = k;
          }
          return j;
        }
        function A(S, j, k, J, f) {
          let T = j.length, D = [S], F = [];
          for (; k >= 0; ) {
            if (D.length === 0) {
              if (T === 0)
                return !0;
              D.push(j[--T]);
              continue;
            }
            let { mode: i, doc: g } = D.pop();
            if (typeof g == "string")
              F.push(g), k -= a(g);
            else if (o(g) || g.type === "fill") {
              let E = c(g);
              for (let x = E.length - 1; x >= 0; x--)
                D.push({ mode: i, doc: E[x] });
            } else
              switch (g.type) {
                case "indent":
                case "align":
                case "indent-if-break":
                case "label":
                  D.push({ mode: i, doc: g.contents });
                  break;
                case "trim":
                  k += P(F);
                  break;
                case "group": {
                  if (f && g.break)
                    return !1;
                  let E = g.break ? m : i, x = g.expandedStates && E === m ? s(g.expandedStates) : g.contents;
                  D.push({ mode: E, doc: x });
                  break;
                }
                case "if-break": {
                  let E = (g.groupId ? h[g.groupId] || y : i) === m ? g.breakContents : g.flatContents;
                  E && D.push({ mode: i, doc: E });
                  break;
                }
                case "line":
                  if (i === m || g.hard)
                    return !0;
                  g.soft || (F.push(" "), k--);
                  break;
                case "line-suffix":
                  J = !0;
                  break;
                case "line-suffix-boundary":
                  if (J)
                    return !1;
                  break;
              }
          }
          return !1;
        }
        function N(S, j) {
          h = {};
          let k = j.printWidth, J = t(j.endOfLine), f = 0, T = [{ ind: p(), mode: m, doc: S }], D = [], F = !1, i = [];
          for (; T.length > 0; ) {
            let { ind: E, mode: x, doc: b } = T.pop();
            if (typeof b == "string") {
              let B = J !== `
` ? b.replace(/\n/g, J) : b;
              D.push(B), f += a(B);
            } else if (o(b)) {
              let B = c(b);
              for (let I = B.length - 1; I >= 0; I--)
                T.push({ ind: E, mode: x, doc: B[I] });
            } else
              switch (b.type) {
                case "cursor":
                  D.push(n.placeholder);
                  break;
                case "indent":
                  T.push({ ind: d(E, j), mode: x, doc: b.contents });
                  break;
                case "align":
                  T.push({ ind: C(E, b.n, j), mode: x, doc: b.contents });
                  break;
                case "trim":
                  f -= P(D);
                  break;
                case "group":
                  switch (x) {
                    case y:
                      if (!F) {
                        T.push({ ind: E, mode: b.break ? m : y, doc: b.contents });
                        break;
                      }
                    case m: {
                      F = !1;
                      let B = { ind: E, mode: y, doc: b.contents }, I = k - f, M = i.length > 0;
                      if (!b.break && A(B, T, I, M))
                        T.push(B);
                      else if (b.expandedStates) {
                        let V = s(b.expandedStates);
                        if (b.break) {
                          T.push({ ind: E, mode: m, doc: V });
                          break;
                        } else
                          for (let $ = 1; $ < b.expandedStates.length + 1; $++)
                            if ($ >= b.expandedStates.length) {
                              T.push({ ind: E, mode: m, doc: V });
                              break;
                            } else {
                              let U = b.expandedStates[$], L = { ind: E, mode: y, doc: U };
                              if (A(L, T, I, M)) {
                                T.push(L);
                                break;
                              }
                            }
                      } else
                        T.push({ ind: E, mode: m, doc: b.contents });
                      break;
                    }
                  }
                  b.id && (h[b.id] = s(T).mode);
                  break;
                case "fill": {
                  let B = k - f, { parts: I } = b;
                  if (I.length === 0)
                    break;
                  let [M, V] = I, $ = { ind: E, mode: y, doc: M }, U = { ind: E, mode: m, doc: M }, L = A($, [], B, i.length > 0, !0);
                  if (I.length === 1) {
                    L ? T.push($) : T.push(U);
                    break;
                  }
                  let ee = { ind: E, mode: y, doc: V }, R = { ind: E, mode: m, doc: V };
                  if (I.length === 2) {
                    L ? T.push(ee, $) : T.push(R, U);
                    break;
                  }
                  I.splice(0, 2);
                  let O = { ind: E, mode: x, doc: e(I) }, Z = I[0];
                  A({ ind: E, mode: y, doc: [M, V, Z] }, [], B, i.length > 0, !0) ? T.push(O, ee, $) : L ? T.push(O, R, $) : T.push(O, R, U);
                  break;
                }
                case "if-break":
                case "indent-if-break": {
                  let B = b.groupId ? h[b.groupId] : x;
                  if (B === m) {
                    let I = b.type === "if-break" ? b.breakContents : b.negate ? b.contents : r(b.contents);
                    I && T.push({ ind: E, mode: x, doc: I });
                  }
                  if (B === y) {
                    let I = b.type === "if-break" ? b.flatContents : b.negate ? r(b.contents) : b.contents;
                    I && T.push({ ind: E, mode: x, doc: I });
                  }
                  break;
                }
                case "line-suffix":
                  i.push({ ind: E, mode: x, doc: b.contents });
                  break;
                case "line-suffix-boundary":
                  i.length > 0 && T.push({ ind: E, mode: x, doc: { type: "line", hard: !0 } });
                  break;
                case "line":
                  switch (x) {
                    case y:
                      if (b.hard)
                        F = !0;
                      else {
                        b.soft || (D.push(" "), f += 1);
                        break;
                      }
                    case m:
                      if (i.length > 0) {
                        T.push({ ind: E, mode: x, doc: b }, ...i.reverse()), i.length = 0;
                        break;
                      }
                      b.literal ? E.root ? (D.push(J, E.root.value), f = E.root.length) : (D.push(J), f = 0) : (f -= P(D), D.push(J + E.value), f = E.length);
                      break;
                  }
                  break;
                case "label":
                  T.push({ ind: E, mode: x, doc: b.contents });
                  break;
              }
            T.length === 0 && i.length > 0 && (T.push(...i.reverse()), i.length = 0);
          }
          let g = D.indexOf(n.placeholder);
          if (g !== -1) {
            let E = D.indexOf(n.placeholder, g + 1), x = D.slice(0, g).join(""), b = D.slice(g + 1, E).join(""), B = D.slice(E + 1).join("");
            return { formatted: x + b + B, cursorNodeStart: x.length, cursorNodeText: b };
          }
          return { formatted: D.join("") };
        }
        l.exports = { printDocToString: N };
      } }), Xi = X({ "src/document/doc-debug.js"(u, l) {
        H();
        var { isConcat: t, getDocParts: s } = sn();
        function a(n) {
          if (!n)
            return "";
          if (t(n)) {
            let r = [];
            for (let o of s(n))
              if (t(o))
                r.push(...a(o).parts);
              else {
                let c = a(o);
                c !== "" && r.push(c);
              }
            return { type: "concat", parts: r };
          }
          return n.type === "if-break" ? Object.assign(Object.assign({}, n), {}, { breakContents: a(n.breakContents), flatContents: a(n.flatContents) }) : n.type === "group" ? Object.assign(Object.assign({}, n), {}, { contents: a(n.contents), expandedStates: n.expandedStates && n.expandedStates.map(a) }) : n.type === "fill" ? { type: "fill", parts: n.parts.map(a) } : n.contents ? Object.assign(Object.assign({}, n), {}, { contents: a(n.contents) }) : n;
        }
        function e(n) {
          let r = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Set();
          return c(a(n));
          function c(m, y, p) {
            if (typeof m == "string")
              return JSON.stringify(m);
            if (t(m)) {
              let d = s(m).map(c).filter(Boolean);
              return d.length === 1 ? d[0] : `[${d.join(", ")}]`;
            }
            if (m.type === "line") {
              let d = Array.isArray(p) && p[y + 1] && p[y + 1].type === "break-parent";
              return m.literal ? d ? "literalline" : "literallineWithoutBreakParent" : m.hard ? d ? "hardline" : "hardlineWithoutBreakParent" : m.soft ? "softline" : "line";
            }
            if (m.type === "break-parent")
              return Array.isArray(p) && p[y - 1] && p[y - 1].type === "line" && p[y - 1].hard ? void 0 : "breakParent";
            if (m.type === "trim")
              return "trim";
            if (m.type === "indent")
              return "indent(" + c(m.contents) + ")";
            if (m.type === "align")
              return m.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + c(m.contents) + ")" : m.n < 0 ? "dedent(" + c(m.contents) + ")" : m.n.type === "root" ? "markAsRoot(" + c(m.contents) + ")" : "align(" + JSON.stringify(m.n) + ", " + c(m.contents) + ")";
            if (m.type === "if-break")
              return "ifBreak(" + c(m.breakContents) + (m.flatContents ? ", " + c(m.flatContents) : "") + (m.groupId ? (m.flatContents ? "" : ', ""') + `, { groupId: ${h(m.groupId)} }` : "") + ")";
            if (m.type === "indent-if-break") {
              let d = [];
              m.negate && d.push("negate: true"), m.groupId && d.push(`groupId: ${h(m.groupId)}`);
              let C = d.length > 0 ? `, { ${d.join(", ")} }` : "";
              return `indentIfBreak(${c(m.contents)}${C})`;
            }
            if (m.type === "group") {
              let d = [];
              m.break && m.break !== "propagated" && d.push("shouldBreak: true"), m.id && d.push(`id: ${h(m.id)}`);
              let C = d.length > 0 ? `, { ${d.join(", ")} }` : "";
              return m.expandedStates ? `conditionalGroup([${m.expandedStates.map((w) => c(w)).join(",")}]${C})` : `group(${c(m.contents)}${C})`;
            }
            if (m.type === "fill")
              return `fill([${m.parts.map((d) => c(d)).join(", ")}])`;
            if (m.type === "line-suffix")
              return "lineSuffix(" + c(m.contents) + ")";
            if (m.type === "line-suffix-boundary")
              return "lineSuffixBoundary";
            if (m.type === "label")
              return `label(${JSON.stringify(m.label)}, ${c(m.contents)})`;
            throw new Error("Unknown doc type " + m.type);
          }
          function h(m) {
            if (typeof m != "symbol")
              return JSON.stringify(String(m));
            if (m in r)
              return r[m];
            let y = String(m).slice(7, -1) || "symbol";
            for (let p = 0; ; p++) {
              let d = y + (p > 0 ? ` #${p}` : "");
              if (!o.has(d))
                return o.add(d), r[m] = `Symbol.for(${JSON.stringify(d)})`;
            }
          }
        }
        l.exports = { printDocToDebug: e };
      } }), Qe = X({ "src/document/index.js"(u, l) {
        H(), l.exports = { builders: Pt(), printer: Wi(), utils: sn(), debug: Xi() };
      } }), Wr = {};
      Ke(Wr, { default: () => Ui });
      function Ui(u) {
        if (typeof u != "string")
          throw new TypeError("Expected a string");
        return u.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var Yi = Je({ "node_modules/escape-string-regexp/index.js"() {
        H();
      } }), Xr = X({ "node_modules/semver/internal/debug.js"(u, l) {
        H();
        var t = typeof yt == "object" && yt.env && yt.env.NODE_DEBUG && /\bsemver\b/i.test(yt.env.NODE_DEBUG) ? function() {
          for (var s = arguments.length, a = new Array(s), e = 0; e < s; e++)
            a[e] = arguments[e];
          return console.error("SEMVER", ...a);
        } : () => {
        };
        l.exports = t;
      } }), Ur = X({ "node_modules/semver/internal/constants.js"(u, l) {
        H();
        var t = "2.0.0", s = 256, a = Number.MAX_SAFE_INTEGER || 9007199254740991, e = 16;
        l.exports = { SEMVER_SPEC_VERSION: t, MAX_LENGTH: s, MAX_SAFE_INTEGER: a, MAX_SAFE_COMPONENT_LENGTH: e };
      } }), zi = X({ "node_modules/semver/internal/re.js"(u, l) {
        H();
        var { MAX_SAFE_COMPONENT_LENGTH: t } = Ur(), s = Xr();
        u = l.exports = {};
        var a = u.re = [], e = u.src = [], n = u.t = {}, r = 0, o = (c, h, m) => {
          let y = r++;
          s(c, y, h), n[c] = y, e[y] = h, a[y] = new RegExp(h, m ? "g" : void 0);
        };
        o("NUMERICIDENTIFIER", "0|[1-9]\\d*"), o("NUMERICIDENTIFIERLOOSE", "[0-9]+"), o("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), o("MAINVERSION", `(${e[n.NUMERICIDENTIFIER]})\\.(${e[n.NUMERICIDENTIFIER]})\\.(${e[n.NUMERICIDENTIFIER]})`), o("MAINVERSIONLOOSE", `(${e[n.NUMERICIDENTIFIERLOOSE]})\\.(${e[n.NUMERICIDENTIFIERLOOSE]})\\.(${e[n.NUMERICIDENTIFIERLOOSE]})`), o("PRERELEASEIDENTIFIER", `(?:${e[n.NUMERICIDENTIFIER]}|${e[n.NONNUMERICIDENTIFIER]})`), o("PRERELEASEIDENTIFIERLOOSE", `(?:${e[n.NUMERICIDENTIFIERLOOSE]}|${e[n.NONNUMERICIDENTIFIER]})`), o("PRERELEASE", `(?:-(${e[n.PRERELEASEIDENTIFIER]}(?:\\.${e[n.PRERELEASEIDENTIFIER]})*))`), o("PRERELEASELOOSE", `(?:-?(${e[n.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${e[n.PRERELEASEIDENTIFIERLOOSE]})*))`), o("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), o("BUILD", `(?:\\+(${e[n.BUILDIDENTIFIER]}(?:\\.${e[n.BUILDIDENTIFIER]})*))`), o("FULLPLAIN", `v?${e[n.MAINVERSION]}${e[n.PRERELEASE]}?${e[n.BUILD]}?`), o("FULL", `^${e[n.FULLPLAIN]}$`), o("LOOSEPLAIN", `[v=\\s]*${e[n.MAINVERSIONLOOSE]}${e[n.PRERELEASELOOSE]}?${e[n.BUILD]}?`), o("LOOSE", `^${e[n.LOOSEPLAIN]}$`), o("GTLT", "((?:<|>)?=?)"), o("XRANGEIDENTIFIERLOOSE", `${e[n.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), o("XRANGEIDENTIFIER", `${e[n.NUMERICIDENTIFIER]}|x|X|\\*`), o("XRANGEPLAIN", `[v=\\s]*(${e[n.XRANGEIDENTIFIER]})(?:\\.(${e[n.XRANGEIDENTIFIER]})(?:\\.(${e[n.XRANGEIDENTIFIER]})(?:${e[n.PRERELEASE]})?${e[n.BUILD]}?)?)?`), o("XRANGEPLAINLOOSE", `[v=\\s]*(${e[n.XRANGEIDENTIFIERLOOSE]})(?:\\.(${e[n.XRANGEIDENTIFIERLOOSE]})(?:\\.(${e[n.XRANGEIDENTIFIERLOOSE]})(?:${e[n.PRERELEASELOOSE]})?${e[n.BUILD]}?)?)?`), o("XRANGE", `^${e[n.GTLT]}\\s*${e[n.XRANGEPLAIN]}$`), o("XRANGELOOSE", `^${e[n.GTLT]}\\s*${e[n.XRANGEPLAINLOOSE]}$`), o("COERCE", `(^|[^\\d])(\\d{1,${t}})(?:\\.(\\d{1,${t}}))?(?:\\.(\\d{1,${t}}))?(?:$|[^\\d])`), o("COERCERTL", e[n.COERCE], !0), o("LONETILDE", "(?:~>?)"), o("TILDETRIM", `(\\s*)${e[n.LONETILDE]}\\s+`, !0), u.tildeTrimReplace = "$1~", o("TILDE", `^${e[n.LONETILDE]}${e[n.XRANGEPLAIN]}$`), o("TILDELOOSE", `^${e[n.LONETILDE]}${e[n.XRANGEPLAINLOOSE]}$`), o("LONECARET", "(?:\\^)"), o("CARETTRIM", `(\\s*)${e[n.LONECARET]}\\s+`, !0), u.caretTrimReplace = "$1^", o("CARET", `^${e[n.LONECARET]}${e[n.XRANGEPLAIN]}$`), o("CARETLOOSE", `^${e[n.LONECARET]}${e[n.XRANGEPLAINLOOSE]}$`), o("COMPARATORLOOSE", `^${e[n.GTLT]}\\s*(${e[n.LOOSEPLAIN]})$|^$`), o("COMPARATOR", `^${e[n.GTLT]}\\s*(${e[n.FULLPLAIN]})$|^$`), o("COMPARATORTRIM", `(\\s*)${e[n.GTLT]}\\s*(${e[n.LOOSEPLAIN]}|${e[n.XRANGEPLAIN]})`, !0), u.comparatorTrimReplace = "$1$2$3", o("HYPHENRANGE", `^\\s*(${e[n.XRANGEPLAIN]})\\s+-\\s+(${e[n.XRANGEPLAIN]})\\s*$`), o("HYPHENRANGELOOSE", `^\\s*(${e[n.XRANGEPLAINLOOSE]})\\s+-\\s+(${e[n.XRANGEPLAINLOOSE]})\\s*$`), o("STAR", "(<|>)?=?\\s*\\*"), o("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), o("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), Ki = X({ "node_modules/semver/internal/parse-options.js"(u, l) {
        H();
        var t = ["includePrerelease", "loose", "rtl"], s = (a) => a ? typeof a != "object" ? { loose: !0 } : t.filter((e) => a[e]).reduce((e, n) => (e[n] = !0, e), {}) : {};
        l.exports = s;
      } }), Qi = X({ "node_modules/semver/internal/identifiers.js"(u, l) {
        H();
        var t = /^[0-9]+$/, s = (e, n) => {
          let r = t.test(e), o = t.test(n);
          return r && o && (e = +e, n = +n), e === n ? 0 : r && !o ? -1 : o && !r ? 1 : e < n ? -1 : 1;
        }, a = (e, n) => s(n, e);
        l.exports = { compareIdentifiers: s, rcompareIdentifiers: a };
      } }), Hi = X({ "node_modules/semver/classes/semver.js"(u, l) {
        H();
        var t = Xr(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: a } = Ur(), { re: e, t: n } = zi(), r = Ki(), { compareIdentifiers: o } = Qi(), c = class {
          constructor(h, m) {
            if (m = r(m), h instanceof c) {
              if (h.loose === !!m.loose && h.includePrerelease === !!m.includePrerelease)
                return h;
              h = h.version;
            } else if (typeof h != "string")
              throw new TypeError(`Invalid Version: ${h}`);
            if (h.length > s)
              throw new TypeError(`version is longer than ${s} characters`);
            t("SemVer", h, m), this.options = m, this.loose = !!m.loose, this.includePrerelease = !!m.includePrerelease;
            let y = h.trim().match(m.loose ? e[n.LOOSE] : e[n.FULL]);
            if (!y)
              throw new TypeError(`Invalid Version: ${h}`);
            if (this.raw = h, this.major = +y[1], this.minor = +y[2], this.patch = +y[3], this.major > a || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > a || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > a || this.patch < 0)
              throw new TypeError("Invalid patch version");
            y[4] ? this.prerelease = y[4].split(".").map((p) => {
              if (/^[0-9]+$/.test(p)) {
                let d = +p;
                if (d >= 0 && d < a)
                  return d;
              }
              return p;
            }) : this.prerelease = [], this.build = y[5] ? y[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(h) {
            if (t("SemVer.compare", this.version, this.options, h), !(h instanceof c)) {
              if (typeof h == "string" && h === this.version)
                return 0;
              h = new c(h, this.options);
            }
            return h.version === this.version ? 0 : this.compareMain(h) || this.comparePre(h);
          }
          compareMain(h) {
            return h instanceof c || (h = new c(h, this.options)), o(this.major, h.major) || o(this.minor, h.minor) || o(this.patch, h.patch);
          }
          comparePre(h) {
            if (h instanceof c || (h = new c(h, this.options)), this.prerelease.length && !h.prerelease.length)
              return -1;
            if (!this.prerelease.length && h.prerelease.length)
              return 1;
            if (!this.prerelease.length && !h.prerelease.length)
              return 0;
            let m = 0;
            do {
              let y = this.prerelease[m], p = h.prerelease[m];
              if (t("prerelease compare", m, y, p), y === void 0 && p === void 0)
                return 0;
              if (p === void 0)
                return 1;
              if (y === void 0)
                return -1;
              if (y !== p)
                return o(y, p);
            } while (++m);
          }
          compareBuild(h) {
            h instanceof c || (h = new c(h, this.options));
            let m = 0;
            do {
              let y = this.build[m], p = h.build[m];
              if (t("prerelease compare", m, y, p), y === void 0 && p === void 0)
                return 0;
              if (p === void 0)
                return 1;
              if (y === void 0)
                return -1;
              if (y !== p)
                return o(y, p);
            } while (++m);
          }
          inc(h, m) {
            switch (h) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", m);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", m);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", m), this.inc("pre", m);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", m), this.inc("pre", m);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let y = this.prerelease.length;
                  for (; --y >= 0; )
                    typeof this.prerelease[y] == "number" && (this.prerelease[y]++, y = -2);
                  y === -1 && this.prerelease.push(0);
                }
                m && (o(this.prerelease[0], m) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [m, 0]) : this.prerelease = [m, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${h}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        l.exports = c;
      } }), zn = X({ "node_modules/semver/functions/compare.js"(u, l) {
        H();
        var t = Hi(), s = (a, e, n) => new t(a, n).compare(new t(e, n));
        l.exports = s;
      } }), Zi = X({ "node_modules/semver/functions/lt.js"(u, l) {
        H();
        var t = zn(), s = (a, e, n) => t(a, e, n) < 0;
        l.exports = s;
      } }), ea = X({ "node_modules/semver/functions/gte.js"(u, l) {
        H();
        var t = zn(), s = (a, e, n) => t(a, e, n) >= 0;
        l.exports = s;
      } }), ta = X({ "src/utils/arrayify.js"(u, l) {
        H(), l.exports = (t, s) => Object.entries(t).map((a) => {
          let [e, n] = a;
          return Object.assign({ [s]: e }, n);
        });
      } }), na = X({ "node_modules/outdent/lib/index.js"(u, l) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.outdent = void 0;
        function t() {
          for (var A = [], N = 0; N < arguments.length; N++)
            A[N] = arguments[N];
        }
        function s() {
          return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : a();
        }
        function a() {
          return { add: t, delete: t, get: t, set: t, has: function(A) {
            return !1;
          } };
        }
        var e = Object.prototype.hasOwnProperty, n = function(A, N) {
          return e.call(A, N);
        };
        function r(A, N) {
          for (var S in N)
            n(N, S) && (A[S] = N[S]);
          return A;
        }
        var o = /^[ \t]*(?:\r\n|\r|\n)/, c = /(?:\r\n|\r|\n)[ \t]*$/, h = /^(?:[\r\n]|$)/, m = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, y = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function p(A, N, S) {
          var j = 0, k = A[0].match(m);
          k && (j = k[1].length);
          var J = "(\\r\\n|\\r|\\n).{0," + j + "}", f = new RegExp(J, "g");
          N && (A = A.slice(1));
          var T = S.newline, D = S.trimLeadingNewline, F = S.trimTrailingNewline, i = typeof T == "string", g = A.length, E = A.map(function(x, b) {
            return x = x.replace(f, "$1"), b === 0 && D && (x = x.replace(o, "")), b === g - 1 && F && (x = x.replace(c, "")), i && (x = x.replace(/\r\n|\n|\r/g, function(B) {
              return T;
            })), x;
          });
          return E;
        }
        function d(A, N) {
          for (var S = "", j = 0, k = A.length; j < k; j++)
            S += A[j], j < k - 1 && (S += N[j]);
          return S;
        }
        function C(A) {
          return n(A, "raw") && n(A, "length");
        }
        function w(A) {
          var N = s(), S = s();
          function j(J) {
            for (var f = [], T = 1; T < arguments.length; T++)
              f[T - 1] = arguments[T];
            if (C(J)) {
              var D = J, F = (f[0] === j || f[0] === P) && y.test(D[0]) && h.test(D[1]), i = F ? S : N, g = i.get(D);
              if (g || (g = p(D, F, A), i.set(D, g)), f.length === 0)
                return g[0];
              var E = d(g, F ? f.slice(1) : f);
              return E;
            } else
              return w(r(r({}, A), J || {}));
          }
          var k = r(j, { string: function(J) {
            return p([J], !1, A)[0];
          } });
          return k;
        }
        var P = w({ trimLeadingNewline: !0, trimTrailingNewline: !0 });
        if (u.outdent = P, u.default = P, typeof l < "u")
          try {
            l.exports = P, Object.defineProperty(P, "__esModule", { value: !0 }), P.default = P, P.outdent = P;
          } catch {
          }
      } }), ra = X({ "src/main/core-options.js"(u, l) {
        H();
        var { outdent: t } = na(), s = "Config", a = "Editor", e = "Format", n = "Other", r = "Output", o = "Global", c = "Special", h = { cursorOffset: { since: "1.4.0", category: c, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: a }, endOfLine: { since: "1.15.0", category: o, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: c, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: n, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: c, type: "boolean", default: !1, description: "Insert @format pragma into file's first docblock comment.", cliCategory: n }, parser: { since: "0.0.10", category: o, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (m) => typeof m == "string" || typeof m == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: !0, default: [{ value: [] }], category: o, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (m) => typeof m == "string" || typeof m == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: !0, default: [{ value: [] }], category: o, description: t`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (m) => typeof m == "string" || typeof m == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: o, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: c, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, rangeStart: { since: "1.4.0", category: c, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a }, requirePragma: { since: "1.7.0", category: c, type: "boolean", default: !1, description: t`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: n }, tabWidth: { type: "int", category: o, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: o, type: "boolean", default: !1, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: o, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        l.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: a, CATEGORY_FORMAT: e, CATEGORY_OTHER: n, CATEGORY_OUTPUT: r, CATEGORY_GLOBAL: o, CATEGORY_SPECIAL: c, options: h };
      } }), Kn = X({ "src/main/support.js"(u, l) {
        H();
        var t = { compare: zn(), lt: Zi(), gte: ea() }, s = ta(), a = xt().version, e = ra().options;
        function n() {
          let { plugins: o = [], showUnreleased: c = !1, showDeprecated: h = !1, showInternal: m = !1 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = a.split("-", 1)[0], p = o.flatMap((A) => A.languages || []).filter(C), d = s(Object.assign({}, ...o.map((A) => {
            let { options: N } = A;
            return N;
          }), e), "name").filter((A) => C(A) && w(A)).sort((A, N) => A.name === N.name ? 0 : A.name < N.name ? -1 : 1).map(P).map((A) => {
            A = Object.assign({}, A), Array.isArray(A.default) && (A.default = A.default.length === 1 ? A.default[0].value : A.default.filter(C).sort((S, j) => t.compare(j.since, S.since))[0].value), Array.isArray(A.choices) && (A.choices = A.choices.filter((S) => C(S) && w(S)), A.name === "parser" && r(A, p, o));
            let N = Object.fromEntries(o.filter((S) => S.defaultOptions && S.defaultOptions[A.name] !== void 0).map((S) => [S.name, S.defaultOptions[A.name]]));
            return Object.assign(Object.assign({}, A), {}, { pluginDefaults: N });
          });
          return { languages: p, options: d };
          function C(A) {
            return c || !("since" in A) || A.since && t.gte(y, A.since);
          }
          function w(A) {
            return h || !("deprecated" in A) || A.deprecated && t.lt(y, A.deprecated);
          }
          function P(A) {
            return m ? A : Ce(A, ue);
          }
        }
        function r(o, c, h) {
          let m = new Set(o.choices.map((y) => y.value));
          for (let y of c)
            if (y.parsers) {
              for (let p of y.parsers)
                if (!m.has(p)) {
                  m.add(p);
                  let d = h.find((w) => w.parsers && w.parsers[p]), C = y.name;
                  d && d.name && (C += ` (plugin: ${d.name})`), o.choices.push({ value: p, description: C });
                }
            }
        }
        l.exports = { getSupportInfo: n };
      } }), Qn = X({ "src/utils/is-non-empty-array.js"(u, l) {
        H();
        function t(s) {
          return Array.isArray(s) && s.length > 0;
        }
        l.exports = t;
      } }), bn = X({ "src/utils/text/skip.js"(u, l) {
        H();
        function t(r) {
          return (o, c, h) => {
            let m = h && h.backwards;
            if (c === !1)
              return !1;
            let { length: y } = o, p = c;
            for (; p >= 0 && p < y; ) {
              let d = o.charAt(p);
              if (r instanceof RegExp) {
                if (!r.test(d))
                  return p;
              } else if (!r.includes(d))
                return p;
              m ? p-- : p++;
            }
            return p === -1 || p === y ? p : !1;
          };
        }
        var s = t(/\s/), a = t(" 	"), e = t(",; 	"), n = t(/[^\n\r]/);
        l.exports = { skipWhitespace: s, skipSpaces: a, skipToLineEnd: e, skipEverythingButNewLine: n };
      } }), Yr = X({ "src/utils/text/skip-inline-comment.js"(u, l) {
        H();
        function t(s, a) {
          if (a === !1)
            return !1;
          if (s.charAt(a) === "/" && s.charAt(a + 1) === "*") {
            for (let e = a + 2; e < s.length; ++e)
              if (s.charAt(e) === "*" && s.charAt(e + 1) === "/")
                return e + 2;
          }
          return a;
        }
        l.exports = t;
      } }), zr = X({ "src/utils/text/skip-trailing-comment.js"(u, l) {
        H();
        var { skipEverythingButNewLine: t } = bn();
        function s(a, e) {
          return e === !1 ? !1 : a.charAt(e) === "/" && a.charAt(e + 1) === "/" ? t(a, e) : e;
        }
        l.exports = s;
      } }), Kr = X({ "src/utils/text/skip-newline.js"(u, l) {
        H();
        function t(s, a, e) {
          let n = e && e.backwards;
          if (a === !1)
            return !1;
          let r = s.charAt(a);
          if (n) {
            if (s.charAt(a - 1) === "\r" && r === `
`)
              return a - 2;
            if (r === `
` || r === "\r" || r === "\u2028" || r === "\u2029")
              return a - 1;
          } else {
            if (r === "\r" && s.charAt(a + 1) === `
`)
              return a + 2;
            if (r === `
` || r === "\r" || r === "\u2028" || r === "\u2029")
              return a + 1;
          }
          return a;
        }
        l.exports = t;
      } }), ua = X({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(u, l) {
        H();
        var t = Yr(), s = Kr(), a = zr(), { skipSpaces: e } = bn();
        function n(r, o) {
          let c = null, h = o;
          for (; h !== c; )
            c = h, h = e(r, h), h = t(r, h), h = a(r, h), h = s(r, h);
          return h;
        }
        l.exports = n;
      } }), at = X({ "src/common/util.js"(u, l) {
        H();
        var { default: t } = (Yi(), lt(Wr)), s = Ct(), { getSupportInfo: a } = Kn(), e = Qn(), n = Gr(), { skipWhitespace: r, skipSpaces: o, skipToLineEnd: c, skipEverythingButNewLine: h } = bn(), m = Yr(), y = zr(), p = Kr(), d = ua(), C = (R) => R[R.length - 2];
        function w(R) {
          return (O, Z, ie) => {
            let te = ie && ie.backwards;
            if (Z === !1)
              return !1;
            let { length: ge } = O, q = Z;
            for (; q >= 0 && q < ge; ) {
              let z = O.charAt(q);
              if (R instanceof RegExp) {
                if (!R.test(z))
                  return q;
              } else if (!R.includes(z))
                return q;
              te ? q-- : q++;
            }
            return q === -1 || q === ge ? q : !1;
          };
        }
        function P(R, O) {
          let Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ie = o(R, Z.backwards ? O - 1 : O, Z), te = p(R, ie, Z);
          return ie !== te;
        }
        function A(R, O, Z) {
          for (let ie = O; ie < Z; ++ie)
            if (R.charAt(ie) === `
`)
              return !0;
          return !1;
        }
        function N(R, O, Z) {
          let ie = Z(O) - 1;
          ie = o(R, ie, { backwards: !0 }), ie = p(R, ie, { backwards: !0 }), ie = o(R, ie, { backwards: !0 });
          let te = p(R, ie, { backwards: !0 });
          return ie !== te;
        }
        function S(R, O) {
          let Z = null, ie = O;
          for (; ie !== Z; )
            Z = ie, ie = c(R, ie), ie = m(R, ie), ie = o(R, ie);
          return ie = y(R, ie), ie = p(R, ie), ie !== !1 && P(R, ie);
        }
        function j(R, O, Z) {
          return S(R, Z(O));
        }
        function k(R, O, Z) {
          return d(R, Z(O));
        }
        function J(R, O, Z) {
          return R.charAt(k(R, O, Z));
        }
        function f(R, O) {
          let Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return o(R, Z.backwards ? O - 1 : O, Z) !== O;
        }
        function T(R, O) {
          let Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ie = 0;
          for (let te = Z; te < R.length; ++te)
            R[te] === "	" ? ie = ie + O - ie % O : ie++;
          return ie;
        }
        function D(R, O) {
          let Z = R.lastIndexOf(`
`);
          return Z === -1 ? 0 : T(R.slice(Z + 1).match(/^[\t ]*/)[0], O);
        }
        function F(R, O) {
          let Z = { quote: '"', regex: /"/g, escaped: "&quot;" }, ie = { quote: "'", regex: /'/g, escaped: "&apos;" }, te = O === "'" ? ie : Z, ge = te === ie ? Z : ie, q = te;
          if (R.includes(te.quote) || R.includes(ge.quote)) {
            let z = (R.match(te.regex) || []).length, De = (R.match(ge.regex) || []).length;
            q = z > De ? ge : te;
          }
          return q;
        }
        function i(R, O) {
          let Z = R.slice(1, -1), ie = O.parser === "json" || O.parser === "json5" && O.quoteProps === "preserve" && !O.singleQuote ? '"' : O.__isInHtmlAttribute ? "'" : F(Z, O.singleQuote ? "'" : '"').quote;
          return g(Z, ie, !(O.parser === "css" || O.parser === "less" || O.parser === "scss" || O.__embeddedInHtml));
        }
        function g(R, O, Z) {
          let ie = O === '"' ? "'" : '"', te = /\\(.)|(["'])/gs, ge = R.replace(te, (q, z, De) => z === ie ? z : De === O ? "\\" + De : De || (Z && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(z) ? z : "\\" + z));
          return O + ge + O;
        }
        function E(R) {
          return R.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function x(R, O) {
          let Z = R.match(new RegExp(`(${t(O)})+`, "g"));
          return Z === null ? 0 : Z.reduce((ie, te) => Math.max(ie, te.length / O.length), 0);
        }
        function b(R, O) {
          let Z = R.match(new RegExp(`(${t(O)})+`, "g"));
          if (Z === null)
            return 0;
          let ie = /* @__PURE__ */ new Map(), te = 0;
          for (let ge of Z) {
            let q = ge.length / O.length;
            ie.set(q, !0), q > te && (te = q);
          }
          for (let ge = 1; ge < te; ge++)
            if (!ie.get(ge))
              return ge;
          return te + 1;
        }
        function B(R, O) {
          (R.comments || (R.comments = [])).push(O), O.printed = !1, O.nodeDescription = ee(R);
        }
        function I(R, O) {
          O.leading = !0, O.trailing = !1, B(R, O);
        }
        function M(R, O, Z) {
          O.leading = !1, O.trailing = !1, Z && (O.marker = Z), B(R, O);
        }
        function V(R, O) {
          O.leading = !1, O.trailing = !0, B(R, O);
        }
        function $(R, O) {
          let { languages: Z } = a({ plugins: O.plugins }), ie = Z.find((te) => {
            let { name: ge } = te;
            return ge.toLowerCase() === R;
          }) || Z.find((te) => {
            let { aliases: ge } = te;
            return Array.isArray(ge) && ge.includes(R);
          }) || Z.find((te) => {
            let { extensions: ge } = te;
            return Array.isArray(ge) && ge.includes(`.${R}`);
          });
          return ie && ie.parsers[0];
        }
        function U(R) {
          return R && R.type === "front-matter";
        }
        function L(R) {
          let O = /* @__PURE__ */ new WeakMap();
          return function(Z) {
            return O.has(Z) || O.set(Z, Symbol(R)), O.get(Z);
          };
        }
        function ee(R) {
          let O = R.type || R.kind || "(unknown type)", Z = String(R.name || R.id && (typeof R.id == "object" ? R.id.name : R.id) || R.key && (typeof R.key == "object" ? R.key.name : R.key) || R.value && (typeof R.value == "object" ? "" : String(R.value)) || R.operator || "");
          return Z.length > 20 && (Z = Z.slice(0, 19) + "…"), O + (Z ? " " + Z : "");
        }
        l.exports = { inferParserByLanguage: $, getStringWidth: n, getMaxContinuousCount: x, getMinNotPresentContinuousCount: b, getPenultimate: C, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d, getNextNonSpaceNonCommentCharacterIndex: k, getNextNonSpaceNonCommentCharacter: J, skip: w, skipWhitespace: r, skipSpaces: o, skipToLineEnd: c, skipEverythingButNewLine: h, skipInlineComment: m, skipTrailingComment: y, skipNewline: p, isNextLineEmptyAfterIndex: S, isNextLineEmpty: j, isPreviousLineEmpty: N, hasNewline: P, hasNewlineInRange: A, hasSpaces: f, getAlignmentSize: T, getIndentSize: D, getPreferredQuote: F, printString: i, printNumber: E, makeString: g, addLeadingComment: I, addDanglingComment: M, addTrailingComment: V, isFrontMatterNode: U, isNonEmptyArray: e, createGroupIdMapper: L };
      } }), Qr = {};
      Ke(Qr, { basename: () => nu, default: () => iu, delimiter: () => nr, dirname: () => tu, extname: () => ru, isAbsolute: () => Zn, join: () => Zr, normalize: () => Hn, relative: () => eu, resolve: () => Sn, sep: () => tr });
      function Hr(u, l) {
        for (var t = 0, s = u.length - 1; s >= 0; s--) {
          var a = u[s];
          a === "." ? u.splice(s, 1) : a === ".." ? (u.splice(s, 1), t++) : t && (u.splice(s, 1), t--);
        }
        if (l)
          for (; t--; t)
            u.unshift("..");
        return u;
      }
      function Sn() {
        for (var u = "", l = !1, t = arguments.length - 1; t >= -1 && !l; t--) {
          var s = t >= 0 ? arguments[t] : "/";
          if (typeof s != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          s && (u = s + "/" + u, l = s.charAt(0) === "/");
        }
        return u = Hr(er(u.split("/"), function(a) {
          return !!a;
        }), !l).join("/"), (l ? "/" : "") + u || ".";
      }
      function Hn(u) {
        var l = Zn(u), t = au(u, -1) === "/";
        return u = Hr(er(u.split("/"), function(s) {
          return !!s;
        }), !l).join("/"), !u && !l && (u = "."), u && t && (u += "/"), (l ? "/" : "") + u;
      }
      function Zn(u) {
        return u.charAt(0) === "/";
      }
      function Zr() {
        var u = Array.prototype.slice.call(arguments, 0);
        return Hn(er(u, function(l, t) {
          if (typeof l != "string")
            throw new TypeError("Arguments to path.join must be strings");
          return l;
        }).join("/"));
      }
      function eu(u, l) {
        u = Sn(u).substr(1), l = Sn(l).substr(1);
        function t(c) {
          for (var h = 0; h < c.length && c[h] === ""; h++)
            ;
          for (var m = c.length - 1; m >= 0 && c[m] === ""; m--)
            ;
          return h > m ? [] : c.slice(h, m - h + 1);
        }
        for (var s = t(u.split("/")), a = t(l.split("/")), e = Math.min(s.length, a.length), n = e, r = 0; r < e; r++)
          if (s[r] !== a[r]) {
            n = r;
            break;
          }
        for (var o = [], r = n; r < s.length; r++)
          o.push("..");
        return o = o.concat(a.slice(n)), o.join("/");
      }
      function tu(u) {
        var l = Tn(u), t = l[0], s = l[1];
        return !t && !s ? "." : (s && (s = s.substr(0, s.length - 1)), t + s);
      }
      function nu(u, l) {
        var t = Tn(u)[2];
        return l && t.substr(-1 * l.length) === l && (t = t.substr(0, t.length - l.length)), t;
      }
      function ru(u) {
        return Tn(u)[3];
      }
      function er(u, l) {
        if (u.filter)
          return u.filter(l);
        for (var t = [], s = 0; s < u.length; s++)
          l(u[s], s, u) && t.push(u[s]);
        return t;
      }
      var uu, Tn, tr, nr, iu, au, ia = Je({ "node-modules-polyfills:path"() {
        H(), uu = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Tn = function(u) {
          return uu.exec(u).slice(1);
        }, tr = "/", nr = ":", iu = { extname: ru, basename: nu, dirname: tu, sep: tr, delimiter: nr, relative: eu, join: Zr, isAbsolute: Zn, normalize: Hn, resolve: Sn }, au = "ab".substr(-1) === "b" ? function(u, l, t) {
          return u.substr(l, t);
        } : function(u, l, t) {
          return l < 0 && (l = u.length + l), u.substr(l, t);
        };
      } }), aa = X({ "node-modules-polyfills-commonjs:path"(u, l) {
        H();
        var t = (ia(), lt(Qr));
        if (t && t.default) {
          l.exports = t.default;
          for (let s in t)
            l.exports[s] = t[s];
        } else
          t && (l.exports = t);
      } }), on = X({ "src/common/errors.js"(u, l) {
        H();
        var t = class extends Error {
        }, s = class extends Error {
        }, a = class extends Error {
        }, e = class extends Error {
        };
        l.exports = { ConfigError: t, DebugError: s, UndefinedParserError: a, ArgExpansionBailout: e };
      } }), Ot = {};
      Ke(Ot, { __assign: () => wn, __asyncDelegator: () => Ea, __asyncGenerator: () => ha, __asyncValues: () => Ca, __await: () => ln, __awaiter: () => da, __classPrivateFieldGet: () => xa, __classPrivateFieldSet: () => ba, __createBinding: () => fa, __decorate: () => la, __exportStar: () => ma, __extends: () => sa, __generator: () => Da, __importDefault: () => va, __importStar: () => Aa, __makeTemplateObject: () => Fa, __metadata: () => ca, __param: () => pa, __read: () => su, __rest: () => oa, __spread: () => ga, __spreadArrays: () => ya, __values: () => rr });
      function sa(u, l) {
        Bn(u, l);
        function t() {
          this.constructor = u;
        }
        u.prototype = l === null ? Object.create(l) : (t.prototype = l.prototype, new t());
      }
      function oa(u, l) {
        var t = {};
        for (var s in u)
          Object.prototype.hasOwnProperty.call(u, s) && l.indexOf(s) < 0 && (t[s] = u[s]);
        if (u != null && typeof Object.getOwnPropertySymbols == "function")
          for (var a = 0, s = Object.getOwnPropertySymbols(u); a < s.length; a++)
            l.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(u, s[a]) && (t[s[a]] = u[s[a]]);
        return t;
      }
      function la(u, l, t, s) {
        var a = arguments.length, e = a < 3 ? l : s === null ? s = Object.getOwnPropertyDescriptor(l, t) : s, n;
        if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
          e = Reflect.decorate(u, l, t, s);
        else
          for (var r = u.length - 1; r >= 0; r--)
            (n = u[r]) && (e = (a < 3 ? n(e) : a > 3 ? n(l, t, e) : n(l, t)) || e);
        return a > 3 && e && Object.defineProperty(l, t, e), e;
      }
      function pa(u, l) {
        return function(t, s) {
          l(t, s, u);
        };
      }
      function ca(u, l) {
        if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
          return Reflect.metadata(u, l);
      }
      function da(u, l, t, s) {
        function a(e) {
          return e instanceof t ? e : new t(function(n) {
            n(e);
          });
        }
        return new (t || (t = Promise))(function(e, n) {
          function r(h) {
            try {
              c(s.next(h));
            } catch (m) {
              n(m);
            }
          }
          function o(h) {
            try {
              c(s.throw(h));
            } catch (m) {
              n(m);
            }
          }
          function c(h) {
            h.done ? e(h.value) : a(h.value).then(r, o);
          }
          c((s = s.apply(u, l || [])).next());
        });
      }
      function Da(u, l) {
        var t = { label: 0, sent: function() {
          if (e[0] & 1)
            throw e[1];
          return e[1];
        }, trys: [], ops: [] }, s, a, e, n;
        return n = { next: r(0), throw: r(1), return: r(2) }, typeof Symbol == "function" && (n[Symbol.iterator] = function() {
          return this;
        }), n;
        function r(c) {
          return function(h) {
            return o([c, h]);
          };
        }
        function o(c) {
          if (s)
            throw new TypeError("Generator is already executing.");
          for (; t; )
            try {
              if (s = 1, a && (e = c[0] & 2 ? a.return : c[0] ? a.throw || ((e = a.return) && e.call(a), 0) : a.next) && !(e = e.call(a, c[1])).done)
                return e;
              switch (a = 0, e && (c = [c[0] & 2, e.value]), c[0]) {
                case 0:
                case 1:
                  e = c;
                  break;
                case 4:
                  return t.label++, { value: c[1], done: !1 };
                case 5:
                  t.label++, a = c[1], c = [0];
                  continue;
                case 7:
                  c = t.ops.pop(), t.trys.pop();
                  continue;
                default:
                  if (e = t.trys, !(e = e.length > 0 && e[e.length - 1]) && (c[0] === 6 || c[0] === 2)) {
                    t = 0;
                    continue;
                  }
                  if (c[0] === 3 && (!e || c[1] > e[0] && c[1] < e[3])) {
                    t.label = c[1];
                    break;
                  }
                  if (c[0] === 6 && t.label < e[1]) {
                    t.label = e[1], e = c;
                    break;
                  }
                  if (e && t.label < e[2]) {
                    t.label = e[2], t.ops.push(c);
                    break;
                  }
                  e[2] && t.ops.pop(), t.trys.pop();
                  continue;
              }
              c = l.call(u, t);
            } catch (h) {
              c = [6, h], a = 0;
            } finally {
              s = e = 0;
            }
          if (c[0] & 5)
            throw c[1];
          return { value: c[0] ? c[1] : void 0, done: !0 };
        }
      }
      function fa(u, l, t, s) {
        s === void 0 && (s = t), u[s] = l[t];
      }
      function ma(u, l) {
        for (var t in u)
          t !== "default" && !l.hasOwnProperty(t) && (l[t] = u[t]);
      }
      function rr(u) {
        var l = typeof Symbol == "function" && Symbol.iterator, t = l && u[l], s = 0;
        if (t)
          return t.call(u);
        if (u && typeof u.length == "number")
          return { next: function() {
            return u && s >= u.length && (u = void 0), { value: u && u[s++], done: !u };
          } };
        throw new TypeError(l ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }
      function su(u, l) {
        var t = typeof Symbol == "function" && u[Symbol.iterator];
        if (!t)
          return u;
        var s = t.call(u), a, e = [], n;
        try {
          for (; (l === void 0 || l-- > 0) && !(a = s.next()).done; )
            e.push(a.value);
        } catch (r) {
          n = { error: r };
        } finally {
          try {
            a && !a.done && (t = s.return) && t.call(s);
          } finally {
            if (n)
              throw n.error;
          }
        }
        return e;
      }
      function ga() {
        for (var u = [], l = 0; l < arguments.length; l++)
          u = u.concat(su(arguments[l]));
        return u;
      }
      function ya() {
        for (var u = 0, l = 0, t = arguments.length; l < t; l++)
          u += arguments[l].length;
        for (var s = Array(u), a = 0, l = 0; l < t; l++)
          for (var e = arguments[l], n = 0, r = e.length; n < r; n++, a++)
            s[a] = e[n];
        return s;
      }
      function ln(u) {
        return this instanceof ln ? (this.v = u, this) : new ln(u);
      }
      function ha(u, l, t) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var s = t.apply(u, l || []), a, e = [];
        return a = {}, n("next"), n("throw"), n("return"), a[Symbol.asyncIterator] = function() {
          return this;
        }, a;
        function n(y) {
          s[y] && (a[y] = function(p) {
            return new Promise(function(d, C) {
              e.push([y, p, d, C]) > 1 || r(y, p);
            });
          });
        }
        function r(y, p) {
          try {
            o(s[y](p));
          } catch (d) {
            m(e[0][3], d);
          }
        }
        function o(y) {
          y.value instanceof ln ? Promise.resolve(y.value.v).then(c, h) : m(e[0][2], y);
        }
        function c(y) {
          r("next", y);
        }
        function h(y) {
          r("throw", y);
        }
        function m(y, p) {
          y(p), e.shift(), e.length && r(e[0][0], e[0][1]);
        }
      }
      function Ea(u) {
        var l, t;
        return l = {}, s("next"), s("throw", function(a) {
          throw a;
        }), s("return"), l[Symbol.iterator] = function() {
          return this;
        }, l;
        function s(a, e) {
          l[a] = u[a] ? function(n) {
            return (t = !t) ? { value: ln(u[a](n)), done: a === "return" } : e ? e(n) : n;
          } : e;
        }
      }
      function Ca(u) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var l = u[Symbol.asyncIterator], t;
        return l ? l.call(u) : (u = typeof rr == "function" ? rr(u) : u[Symbol.iterator](), t = {}, s("next"), s("throw"), s("return"), t[Symbol.asyncIterator] = function() {
          return this;
        }, t);
        function s(e) {
          t[e] = u[e] && function(n) {
            return new Promise(function(r, o) {
              n = u[e](n), a(r, o, n.done, n.value);
            });
          };
        }
        function a(e, n, r, o) {
          Promise.resolve(o).then(function(c) {
            e({ value: c, done: r });
          }, n);
        }
      }
      function Fa(u, l) {
        return Object.defineProperty ? Object.defineProperty(u, "raw", { value: l }) : u.raw = l, u;
      }
      function Aa(u) {
        if (u && u.__esModule)
          return u;
        var l = {};
        if (u != null)
          for (var t in u)
            Object.hasOwnProperty.call(u, t) && (l[t] = u[t]);
        return l.default = u, l;
      }
      function va(u) {
        return u && u.__esModule ? u : { default: u };
      }
      function xa(u, l) {
        if (!l.has(u))
          throw new TypeError("attempted to get private field on non-instance");
        return l.get(u);
      }
      function ba(u, l, t) {
        if (!l.has(u))
          throw new TypeError("attempted to set private field on non-instance");
        return l.set(u, t), t;
      }
      var Bn, wn, Rt = Je({ "node_modules/tslib/tslib.es6.js"() {
        H(), Bn = function(u, l) {
          return Bn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, s) {
            t.__proto__ = s;
          } || function(t, s) {
            for (var a in s)
              s.hasOwnProperty(a) && (t[a] = s[a]);
          }, Bn(u, l);
        }, wn = function() {
          return wn = Object.assign || function(u) {
            for (var l, t = 1, s = arguments.length; t < s; t++) {
              l = arguments[t];
              for (var a in l)
                Object.prototype.hasOwnProperty.call(l, a) && (u[a] = l[a]);
            }
            return u;
          }, wn.apply(this, arguments);
        };
      } }), ou = X({ "node_modules/vnopts/lib/descriptors/api.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.apiDescriptor = { key: (l) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(l) ? l : JSON.stringify(l), value(l) {
          if (l === null || typeof l != "object")
            return JSON.stringify(l);
          if (Array.isArray(l))
            return `[${l.map((s) => u.apiDescriptor.value(s)).join(", ")}]`;
          let t = Object.keys(l);
          return t.length === 0 ? "{}" : `{ ${t.map((s) => `${u.apiDescriptor.key(s)}: ${u.apiDescriptor.value(l[s])}`).join(", ")} }`;
        }, pair: (l) => {
          let { key: t, value: s } = l;
          return u.apiDescriptor.value({ [t]: s });
        } };
      } }), Sa = X({ "node_modules/vnopts/lib/descriptors/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(ou(), u);
      } }), Nn = X({ "scripts/build/shims/chalk.cjs"(u, l) {
        H();
        var t = (s) => s;
        t.grey = t, t.red = t, t.bold = t, t.yellow = t, t.blue = t, t.default = t, l.exports = t;
      } }), lu = X({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Nn();
        u.commonDeprecatedHandler = (t, s, a) => {
          let { descriptor: e } = a, n = [`${l.default.yellow(typeof t == "string" ? e.key(t) : e.pair(t))} is deprecated`];
          return s && n.push(`we now treat it as ${l.default.blue(typeof s == "string" ? e.key(s) : e.pair(s))}`), n.join("; ") + ".";
        };
      } }), Ta = X({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(lu(), u);
      } }), Ba = X({ "node_modules/vnopts/lib/handlers/invalid/common.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Nn();
        u.commonInvalidHandler = (t, s, a) => [`Invalid ${l.default.red(a.descriptor.key(t))} value.`, `Expected ${l.default.blue(a.schemas[t].expected(a))},`, `but received ${l.default.red(a.descriptor.value(s))}.`].join(" ");
      } }), pu = X({ "node_modules/vnopts/lib/handlers/invalid/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(Ba(), u);
      } }), wa = X({ "node_modules/vnopts/node_modules/leven/index.js"(u, l) {
        H();
        var t = [], s = [];
        l.exports = function(a, e) {
          if (a === e)
            return 0;
          var n = a;
          a.length > e.length && (a = e, e = n);
          var r = a.length, o = e.length;
          if (r === 0)
            return o;
          if (o === 0)
            return r;
          for (; r > 0 && a.charCodeAt(~-r) === e.charCodeAt(~-o); )
            r--, o--;
          if (r === 0)
            return o;
          for (var c = 0; c < r && a.charCodeAt(c) === e.charCodeAt(c); )
            c++;
          if (r -= c, o -= c, r === 0)
            return o;
          for (var h, m, y, p, d = 0, C = 0; d < r; )
            s[c + d] = a.charCodeAt(c + d), t[d] = ++d;
          for (; C < o; )
            for (h = e.charCodeAt(c + C), y = C++, m = C, d = 0; d < r; d++)
              p = h === s[c + d] ? y : y + 1, y = t[d], m = t[d] = y > m ? p > m ? m + 1 : p : p > y ? y + 1 : p;
          return m;
        };
      } }), cu = X({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Nn(), t = wa();
        u.levenUnknownHandler = (s, a, e) => {
          let { descriptor: n, logger: r, schemas: o } = e, c = [`Ignored unknown option ${l.default.yellow(n.pair({ key: s, value: a }))}.`], h = Object.keys(o).sort().find((m) => t(s, m) < 3);
          h && c.push(`Did you mean ${l.default.blue(n.key(h))}?`), r.warn(c.join(" "));
        };
      } }), Na = X({ "node_modules/vnopts/lib/handlers/unknown/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(cu(), u);
      } }), ka = X({ "node_modules/vnopts/lib/handlers/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(Ta(), u), l.__exportStar(pu(), u), l.__exportStar(Na(), u);
      } }), Vt = X({ "node_modules/vnopts/lib/schema.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
        function t(e, n) {
          let r = new e(n), o = Object.create(r);
          for (let c of l)
            c in n && (o[c] = a(n[c], r, s.prototype[c].length));
          return o;
        }
        u.createSchema = t;
        var s = class {
          constructor(e) {
            this.name = e.name;
          }
          static create(e) {
            return t(this, e);
          }
          default(e) {
          }
          expected(e) {
            return "nothing";
          }
          validate(e, n) {
            return !1;
          }
          deprecated(e, n) {
            return !1;
          }
          forward(e, n) {
          }
          redirect(e, n) {
          }
          overlap(e, n, r) {
            return e;
          }
          preprocess(e, n) {
            return e;
          }
          postprocess(e, n) {
            return e;
          }
        };
        u.Schema = s;
        function a(e, n, r) {
          return typeof e == "function" ? function() {
            for (var o = arguments.length, c = new Array(o), h = 0; h < o; h++)
              c[h] = arguments[h];
            return e(...c.slice(0, r - 1), n, ...c.slice(r - 1));
          } : () => e;
        }
      } }), Pa = X({ "node_modules/vnopts/lib/schemas/alias.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = class extends l.Schema {
          constructor(s) {
            super(s), this._sourceName = s.sourceName;
          }
          expected(s) {
            return s.schemas[this._sourceName].expected(s);
          }
          validate(s, a) {
            return a.schemas[this._sourceName].validate(s, a);
          }
          redirect(s, a) {
            return this._sourceName;
          }
        };
        u.AliasSchema = t;
      } }), ja = X({ "node_modules/vnopts/lib/schemas/any.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = class extends l.Schema {
          expected() {
            return "anything";
          }
          validate() {
            return !0;
          }
        };
        u.AnySchema = t;
      } }), Ia = X({ "node_modules/vnopts/lib/schemas/array.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot)), t = Vt(), s = class extends t.Schema {
          constructor(e) {
            var { valueSchema: n, name: r = n.name } = e, o = l.__rest(e, ["valueSchema", "name"]);
            super(Object.assign({}, o, { name: r })), this._valueSchema = n;
          }
          expected(e) {
            return `an array of ${this._valueSchema.expected(e)}`;
          }
          validate(e, n) {
            if (!Array.isArray(e))
              return !1;
            let r = [];
            for (let o of e) {
              let c = n.normalizeValidateResult(this._valueSchema.validate(o, n), o);
              c !== !0 && r.push(c.value);
            }
            return r.length === 0 ? !0 : { value: r };
          }
          deprecated(e, n) {
            let r = [];
            for (let o of e) {
              let c = n.normalizeDeprecatedResult(this._valueSchema.deprecated(o, n), o);
              c !== !1 && r.push(...c.map((h) => {
                let { value: m } = h;
                return { value: [m] };
              }));
            }
            return r;
          }
          forward(e, n) {
            let r = [];
            for (let o of e) {
              let c = n.normalizeForwardResult(this._valueSchema.forward(o, n), o);
              r.push(...c.map(a));
            }
            return r;
          }
          redirect(e, n) {
            let r = [], o = [];
            for (let c of e) {
              let h = n.normalizeRedirectResult(this._valueSchema.redirect(c, n), c);
              "remain" in h && r.push(h.remain), o.push(...h.redirect.map(a));
            }
            return r.length === 0 ? { redirect: o } : { redirect: o, remain: r };
          }
          overlap(e, n) {
            return e.concat(n);
          }
        };
        u.ArraySchema = s;
        function a(e) {
          let { from: n, to: r } = e;
          return { from: [n], to: r };
        }
      } }), La = X({ "node_modules/vnopts/lib/schemas/boolean.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = class extends l.Schema {
          expected() {
            return "true or false";
          }
          validate(s) {
            return typeof s == "boolean";
          }
        };
        u.BooleanSchema = t;
      } }), ur = X({ "node_modules/vnopts/lib/utils.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        function l(p, d) {
          let C = /* @__PURE__ */ Object.create(null);
          for (let w of p) {
            let P = w[d];
            if (C[P])
              throw new Error(`Duplicate ${d} ${JSON.stringify(P)}`);
            C[P] = w;
          }
          return C;
        }
        u.recordFromArray = l;
        function t(p, d) {
          let C = /* @__PURE__ */ new Map();
          for (let w of p) {
            let P = w[d];
            if (C.has(P))
              throw new Error(`Duplicate ${d} ${JSON.stringify(P)}`);
            C.set(P, w);
          }
          return C;
        }
        u.mapFromArray = t;
        function s() {
          let p = /* @__PURE__ */ Object.create(null);
          return (d) => {
            let C = JSON.stringify(d);
            return p[C] ? !0 : (p[C] = !0, !1);
          };
        }
        u.createAutoChecklist = s;
        function a(p, d) {
          let C = [], w = [];
          for (let P of p)
            d(P) ? C.push(P) : w.push(P);
          return [C, w];
        }
        u.partition = a;
        function e(p) {
          return p === Math.floor(p);
        }
        u.isInt = e;
        function n(p, d) {
          if (p === d)
            return 0;
          let C = typeof p, w = typeof d, P = ["undefined", "object", "boolean", "number", "string"];
          return C !== w ? P.indexOf(C) - P.indexOf(w) : C !== "string" ? Number(p) - Number(d) : p.localeCompare(d);
        }
        u.comparePrimitive = n;
        function r(p) {
          return p === void 0 ? {} : p;
        }
        u.normalizeDefaultResult = r;
        function o(p, d) {
          return p === !0 ? !0 : p === !1 ? { value: d } : p;
        }
        u.normalizeValidateResult = o;
        function c(p, d) {
          let C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
          return p === !1 ? !1 : p === !0 ? C ? !0 : [{ value: d }] : "value" in p ? [p] : p.length === 0 ? !1 : p;
        }
        u.normalizeDeprecatedResult = c;
        function h(p, d) {
          return typeof p == "string" || "key" in p ? { from: d, to: p } : "from" in p ? { from: p.from, to: p.to } : { from: d, to: p.to };
        }
        u.normalizeTransferResult = h;
        function m(p, d) {
          return p === void 0 ? [] : Array.isArray(p) ? p.map((C) => h(C, d)) : [h(p, d)];
        }
        u.normalizeForwardResult = m;
        function y(p, d) {
          let C = m(typeof p == "object" && "redirect" in p ? p.redirect : p, d);
          return C.length === 0 ? { remain: d, redirect: C } : typeof p == "object" && "remain" in p ? { remain: p.remain, redirect: C } : { redirect: C };
        }
        u.normalizeRedirectResult = y;
      } }), _a = X({ "node_modules/vnopts/lib/schemas/choice.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = ur(), s = class extends l.Schema {
          constructor(a) {
            super(a), this._choices = t.mapFromArray(a.choices.map((e) => e && typeof e == "object" ? e : { value: e }), "value");
          }
          expected(a) {
            let { descriptor: e } = a, n = Array.from(this._choices.keys()).map((c) => this._choices.get(c)).filter((c) => !c.deprecated).map((c) => c.value).sort(t.comparePrimitive).map(e.value), r = n.slice(0, -2), o = n.slice(-2);
            return r.concat(o.join(" or ")).join(", ");
          }
          validate(a) {
            return this._choices.has(a);
          }
          deprecated(a) {
            let e = this._choices.get(a);
            return e && e.deprecated ? { value: a } : !1;
          }
          forward(a) {
            let e = this._choices.get(a);
            return e ? e.forward : void 0;
          }
          redirect(a) {
            let e = this._choices.get(a);
            return e ? e.redirect : void 0;
          }
        };
        u.ChoiceSchema = s;
      } }), du = X({ "node_modules/vnopts/lib/schemas/number.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = class extends l.Schema {
          expected() {
            return "a number";
          }
          validate(s, a) {
            return typeof s == "number";
          }
        };
        u.NumberSchema = t;
      } }), Oa = X({ "node_modules/vnopts/lib/schemas/integer.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = ur(), t = du(), s = class extends t.NumberSchema {
          expected() {
            return "an integer";
          }
          validate(a, e) {
            return e.normalizeValidateResult(super.validate(a, e), a) === !0 && l.isInt(a);
          }
        };
        u.IntegerSchema = s;
      } }), Ma = X({ "node_modules/vnopts/lib/schemas/string.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Vt(), t = class extends l.Schema {
          expected() {
            return "a string";
          }
          validate(s) {
            return typeof s == "string";
          }
        };
        u.StringSchema = t;
      } }), $a = X({ "node_modules/vnopts/lib/schemas/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(Pa(), u), l.__exportStar(ja(), u), l.__exportStar(Ia(), u), l.__exportStar(La(), u), l.__exportStar(_a(), u), l.__exportStar(Oa(), u), l.__exportStar(du(), u), l.__exportStar(Ma(), u);
      } }), Ra = X({ "node_modules/vnopts/lib/defaults.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = ou(), t = lu(), s = pu(), a = cu();
        u.defaultDescriptor = l.apiDescriptor, u.defaultUnknownHandler = a.levenUnknownHandler, u.defaultInvalidHandler = s.commonInvalidHandler, u.defaultDeprecatedHandler = t.commonDeprecatedHandler;
      } }), Va = X({ "node_modules/vnopts/lib/normalize.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Ra(), t = ur();
        u.normalize = (a, e, n) => new s(e, n).normalize(a);
        var s = class {
          constructor(a, e) {
            let { logger: n = console, descriptor: r = l.defaultDescriptor, unknown: o = l.defaultUnknownHandler, invalid: c = l.defaultInvalidHandler, deprecated: h = l.defaultDeprecatedHandler } = e || {};
            this._utils = { descriptor: r, logger: n || { warn: () => {
            } }, schemas: t.recordFromArray(a, "name"), normalizeDefaultResult: t.normalizeDefaultResult, normalizeDeprecatedResult: t.normalizeDeprecatedResult, normalizeForwardResult: t.normalizeForwardResult, normalizeRedirectResult: t.normalizeRedirectResult, normalizeValidateResult: t.normalizeValidateResult }, this._unknownHandler = o, this._invalidHandler = c, this._deprecatedHandler = h, this.cleanHistory();
          }
          cleanHistory() {
            this._hasDeprecationWarned = t.createAutoChecklist();
          }
          normalize(a) {
            let e = {}, n = [a], r = () => {
              for (; n.length !== 0; ) {
                let o = n.shift(), c = this._applyNormalization(o, e);
                n.push(...c);
              }
            };
            r();
            for (let o of Object.keys(this._utils.schemas)) {
              let c = this._utils.schemas[o];
              if (!(o in e)) {
                let h = t.normalizeDefaultResult(c.default(this._utils));
                "value" in h && n.push({ [o]: h.value });
              }
            }
            r();
            for (let o of Object.keys(this._utils.schemas)) {
              let c = this._utils.schemas[o];
              o in e && (e[o] = c.postprocess(e[o], this._utils));
            }
            return e;
          }
          _applyNormalization(a, e) {
            let n = [], [r, o] = t.partition(Object.keys(a), (c) => c in this._utils.schemas);
            for (let c of r) {
              let h = this._utils.schemas[c], m = h.preprocess(a[c], this._utils), y = t.normalizeValidateResult(h.validate(m, this._utils), m);
              if (y !== !0) {
                let { value: w } = y, P = this._invalidHandler(c, w, this._utils);
                throw typeof P == "string" ? new Error(P) : P;
              }
              let p = (w) => {
                let { from: P, to: A } = w;
                n.push(typeof A == "string" ? { [A]: P } : { [A.key]: A.value });
              }, d = (w) => {
                let { value: P, redirectTo: A } = w, N = t.normalizeDeprecatedResult(h.deprecated(P, this._utils), m, !0);
                if (N !== !1)
                  if (N === !0)
                    this._hasDeprecationWarned(c) || this._utils.logger.warn(this._deprecatedHandler(c, A, this._utils));
                  else
                    for (let { value: S } of N) {
                      let j = { key: c, value: S };
                      if (!this._hasDeprecationWarned(j)) {
                        let k = typeof A == "string" ? { key: A, value: S } : A;
                        this._utils.logger.warn(this._deprecatedHandler(j, k, this._utils));
                      }
                    }
              };
              t.normalizeForwardResult(h.forward(m, this._utils), m).forEach(p);
              let C = t.normalizeRedirectResult(h.redirect(m, this._utils), m);
              if (C.redirect.forEach(p), "remain" in C) {
                let w = C.remain;
                e[c] = c in e ? h.overlap(e[c], w, this._utils) : w, d({ value: w });
              }
              for (let { from: w, to: P } of C.redirect)
                d({ value: w, redirectTo: P });
            }
            for (let c of o) {
              let h = a[c], m = this._unknownHandler(c, h, this._utils);
              if (m)
                for (let y of Object.keys(m)) {
                  let p = { [y]: m[y] };
                  y in this._utils.schemas ? n.push(p) : Object.assign(e, p);
                }
            }
            return n;
          }
        };
        u.Normalizer = s;
      } }), Ja = X({ "node_modules/vnopts/lib/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = (Rt(), lt(Ot));
        l.__exportStar(Sa(), u), l.__exportStar(ka(), u), l.__exportStar($a(), u), l.__exportStar(Va(), u), l.__exportStar(Vt(), u);
      } }), qa = X({ "src/main/options-normalizer.js"(u, l) {
        H();
        var t = Ja(), s = Ct(), a = { key: (y) => y.length === 1 ? `-${y}` : `--${y}`, value: (y) => t.apiDescriptor.value(y), pair: (y) => {
          let { key: p, value: d } = y;
          return d === !1 ? `--no-${p}` : d === !0 ? a.key(p) : d === "" ? `${a.key(p)} without an argument` : `${a.key(p)}=${d}`;
        } }, e = (y) => {
          let { colorsModule: p, levenshteinDistance: d } = y;
          return class extends t.ChoiceSchema {
            constructor(C) {
              let { name: w, flags: P } = C;
              super({ name: w, choices: P }), this._flags = [...P].sort();
            }
            preprocess(C, w) {
              if (typeof C == "string" && C.length > 0 && !this._flags.includes(C)) {
                let P = this._flags.find((A) => d(A, C) < 3);
                if (P)
                  return w.logger.warn([`Unknown flag ${p.yellow(w.descriptor.value(C))},`, `did you mean ${p.blue(w.descriptor.value(P))}?`].join(" ")), P;
              }
              return C;
            }
            expected() {
              return "a flag";
            }
          };
        }, n;
        function r(y, p) {
          let { logger: d = !1, isCLI: C = !1, passThrough: w = !1, colorsModule: P = null, levenshteinDistance: A = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, N = w ? Array.isArray(w) ? (T, D) => w.includes(T) ? { [T]: D } : void 0 : (T, D) => ({ [T]: D }) : (T, D, F) => {
            let i = F.schemas, g = Ce(i, ce);
            return t.levenUnknownHandler(T, D, Object.assign(Object.assign({}, F), {}, { schemas: g }));
          }, S = C ? a : t.apiDescriptor, j = o(p, { isCLI: C, colorsModule: P, levenshteinDistance: A }), k = new t.Normalizer(j, { logger: d, unknown: N, descriptor: S }), J = d !== !1;
          J && n && (k._hasDeprecationWarned = n);
          let f = k.normalize(y);
          return J && (n = k._hasDeprecationWarned), C && f["plugin-search"] === !1 && (f["plugin-search-dir"] = !1), f;
        }
        function o(y, p) {
          let { isCLI: d, colorsModule: C, levenshteinDistance: w } = p, P = [];
          d && P.push(t.AnySchema.create({ name: "_" }));
          for (let A of y)
            P.push(c(A, { isCLI: d, optionInfos: y, colorsModule: C, levenshteinDistance: w })), A.alias && d && P.push(t.AliasSchema.create({ name: A.alias, sourceName: A.name }));
          return P;
        }
        function c(y, p) {
          let { isCLI: d, optionInfos: C, colorsModule: w, levenshteinDistance: P } = p, { name: A } = y;
          if (A === "plugin-search-dir" || A === "pluginSearchDirs")
            return t.AnySchema.create({ name: A, preprocess(k) {
              return k === !1 || (k = Array.isArray(k) ? k : [k]), k;
            }, validate(k) {
              return k === !1 ? !0 : k.every((J) => typeof J == "string");
            }, expected() {
              return "false or paths to plugin search dir";
            } });
          let N = { name: A }, S, j = {};
          switch (y.type) {
            case "int":
              S = t.IntegerSchema, d && (N.preprocess = Number);
              break;
            case "string":
              S = t.StringSchema;
              break;
            case "choice":
              S = t.ChoiceSchema, N.choices = y.choices.map((k) => typeof k == "object" && k.redirect ? Object.assign(Object.assign({}, k), {}, { redirect: { to: { key: y.name, value: k.redirect } } }) : k);
              break;
            case "boolean":
              S = t.BooleanSchema;
              break;
            case "flag":
              S = e({ colorsModule: w, levenshteinDistance: P }), N.flags = C.flatMap((k) => [k.alias, k.description && k.name, k.oppositeDescription && `no-${k.name}`].filter(Boolean));
              break;
            case "path":
              S = t.StringSchema;
              break;
            default:
              throw new Error(`Unexpected type ${y.type}`);
          }
          if (y.exception ? N.validate = (k, J, f) => y.exception(k) || J.validate(k, f) : N.validate = (k, J, f) => k === void 0 || J.validate(k, f), y.redirect && (j.redirect = (k) => k ? { to: { key: y.redirect.option, value: y.redirect.value } } : void 0), y.deprecated && (j.deprecated = !0), d && !y.array) {
            let k = N.preprocess || ((J) => J);
            N.preprocess = (J, f, T) => f.preprocess(k(Array.isArray(J) ? s(J) : J), T);
          }
          return y.array ? t.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, d ? { preprocess: (k) => Array.isArray(k) ? k : [k] } : {}), j), {}, { valueSchema: S.create(N) })) : S.create(Object.assign(Object.assign({}, N), j));
        }
        function h(y, p, d) {
          return r(y, p, d);
        }
        function m(y, p, d) {
          return r(y, p, Object.assign({ isCLI: !0 }, d));
        }
        l.exports = { normalizeApiOptions: h, normalizeCliOptions: m };
      } }), vt = X({ "src/language-js/loc.js"(u, l) {
        H();
        var t = Qn();
        function s(o) {
          var c, h;
          let m = o.range ? o.range[0] : o.start, y = (c = (h = o.declaration) === null || h === void 0 ? void 0 : h.decorators) !== null && c !== void 0 ? c : o.decorators;
          return t(y) ? Math.min(s(y[0]), m) : m;
        }
        function a(o) {
          return o.range ? o.range[1] : o.end;
        }
        function e(o, c) {
          let h = s(o);
          return Number.isInteger(h) && h === s(c);
        }
        function n(o, c) {
          let h = a(o);
          return Number.isInteger(h) && h === a(c);
        }
        function r(o, c) {
          return e(o, c) && n(o, c);
        }
        l.exports = { locStart: s, locEnd: a, hasSameLocStart: e, hasSameLoc: r };
      } }), Ga = X({ "src/main/load-parser.js"(u, l) {
        H(), l.exports = () => {
        };
      } }), Wa = X({ "scripts/build/shims/babel-highlight.cjs"(u, l) {
        H();
        var t = Nn(), s = { shouldHighlight: () => !1, getChalk: () => t };
        l.exports = s;
      } }), Xa = X({ "node_modules/@babel/code-frame/lib/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.codeFrameColumns = n, u.default = r;
        var l = Wa(), t = !1;
        function s(o) {
          return { gutter: o.grey, marker: o.red.bold, message: o.red.bold };
        }
        var a = /\r\n|[\n\r\u2028\u2029]/;
        function e(o, c, h) {
          let m = Object.assign({ column: 0, line: -1 }, o.start), y = Object.assign({}, m, o.end), { linesAbove: p = 2, linesBelow: d = 3 } = h || {}, C = m.line, w = m.column, P = y.line, A = y.column, N = Math.max(C - (p + 1), 0), S = Math.min(c.length, P + d);
          C === -1 && (N = 0), P === -1 && (S = c.length);
          let j = P - C, k = {};
          if (j)
            for (let J = 0; J <= j; J++) {
              let f = J + C;
              if (!w)
                k[f] = !0;
              else if (J === 0) {
                let T = c[f - 1].length;
                k[f] = [w, T - w + 1];
              } else if (J === j)
                k[f] = [0, A];
              else {
                let T = c[f - J].length;
                k[f] = [0, T];
              }
            }
          else
            w === A ? w ? k[C] = [w, 0] : k[C] = !0 : k[C] = [w, A - w];
          return { start: N, end: S, markerLines: k };
        }
        function n(o, c) {
          let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, m = (h.highlightCode || h.forceColor) && (0, l.shouldHighlight)(h), y = (0, l.getChalk)(h), p = s(y), d = (k, J) => m ? k(J) : J, C = o.split(a), { start: w, end: P, markerLines: A } = e(c, C, h), N = c.start && typeof c.start.column == "number", S = String(P).length, j = (m ? (0, l.default)(o, h) : o).split(a, P).slice(w, P).map((k, J) => {
            let f = w + 1 + J, T = ` ${` ${f}`.slice(-S)} |`, D = A[f], F = !A[f + 1];
            if (D) {
              let i = "";
              if (Array.isArray(D)) {
                let g = k.slice(0, Math.max(D[0] - 1, 0)).replace(/[^\t]/g, " "), E = D[1] || 1;
                i = [`
 `, d(p.gutter, T.replace(/\d/g, " ")), " ", g, d(p.marker, "^").repeat(E)].join(""), F && h.message && (i += " " + d(p.message, h.message));
              }
              return [d(p.marker, ">"), d(p.gutter, T), k.length > 0 ? ` ${k}` : "", i].join("");
            } else
              return ` ${d(p.gutter, T)}${k.length > 0 ? ` ${k}` : ""}`;
          }).join(`
`);
          return h.message && !N && (j = `${" ".repeat(S + 1)}${h.message}
${j}`), m ? y.reset(j) : j;
        }
        function r(o, c, h) {
          let m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          if (!t) {
            t = !0;
            let y = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
            if (yt.emitWarning)
              yt.emitWarning(y, "DeprecationWarning");
            else {
              let p = new Error(y);
              p.name = "DeprecationWarning", console.warn(new Error(y));
            }
          }
          return h = Math.max(h, 0), n(o, { start: { column: h, line: c } }, m);
        }
      } }), ir = X({ "src/main/parser.js"(u, l) {
        H();
        var { ConfigError: t } = on(), s = vt();
        Ga();
        var { locStart: a, locEnd: e } = s, n = Object.getOwnPropertyNames, r = Object.getOwnPropertyDescriptor;
        function o(m) {
          let y = {};
          for (let p of m.plugins)
            if (p.parsers)
              for (let d of n(p.parsers))
                Object.defineProperty(y, d, r(p.parsers, d));
          return y;
        }
        function c(m) {
          let y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o(m);
          if (typeof m.parser == "function")
            return { parse: m.parser, astFormat: "estree", locStart: a, locEnd: e };
          if (typeof m.parser == "string") {
            if (Object.prototype.hasOwnProperty.call(y, m.parser))
              return y[m.parser];
            throw new t(`Couldn't resolve parser "${m.parser}". Parsers must be explicitly added to the standalone bundle.`);
          }
        }
        function h(m, y) {
          let p = o(y), d = Object.defineProperties({}, Object.fromEntries(Object.keys(p).map((w) => [w, { enumerable: !0, get() {
            return p[w].parse;
          } }]))), C = c(y, p);
          try {
            return C.preprocess && (m = C.preprocess(m, y)), { text: m, ast: C.parse(m, d, y) };
          } catch (w) {
            let { loc: P } = w;
            if (P) {
              let { codeFrameColumns: A } = Xa();
              throw w.codeFrame = A(m, P, { highlightCode: !0 }), w.message += `
` + w.codeFrame, w;
            }
            throw w;
          }
        }
        l.exports = { parse: h, resolveParser: c };
      } }), Du = X({ "src/main/options.js"(u, l) {
        H();
        var t = aa(), { UndefinedParserError: s } = on(), { getSupportInfo: a } = Kn(), e = qa(), { resolveParser: n } = ir(), r = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
        function o(m) {
          let y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = Object.assign({}, m), d = a({ plugins: m.plugins, showUnreleased: !0, showDeprecated: !0 }).options, C = Object.assign(Object.assign({}, r), Object.fromEntries(d.filter((S) => S.default !== void 0).map((S) => [S.name, S.default])));
          if (!p.parser) {
            if (!p.filepath)
              (y.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), p.parser = "babel";
            else if (p.parser = h(p.filepath, p.plugins), !p.parser)
              throw new s(`No parser could be inferred for file: ${p.filepath}`);
          }
          let w = n(e.normalizeApiOptions(p, [d.find((S) => S.name === "parser")], { passThrough: !0, logger: !1 }));
          p.astFormat = w.astFormat, p.locEnd = w.locEnd, p.locStart = w.locStart;
          let P = c(p);
          p.printer = P.printers[p.astFormat];
          let A = Object.fromEntries(d.filter((S) => S.pluginDefaults && S.pluginDefaults[P.name] !== void 0).map((S) => [S.name, S.pluginDefaults[P.name]])), N = Object.assign(Object.assign({}, C), A);
          for (let [S, j] of Object.entries(N))
            (p[S] === null || p[S] === void 0) && (p[S] = j);
          return p.parser === "json" && (p.trailingComma = "none"), e.normalizeApiOptions(p, d, Object.assign({ passThrough: Object.keys(r) }, y));
        }
        function c(m) {
          let { astFormat: y } = m;
          if (!y)
            throw new Error("getPlugin() requires astFormat to be set");
          let p = m.plugins.find((d) => d.printers && d.printers[y]);
          if (!p)
            throw new Error(`Couldn't find plugin for AST format "${y}"`);
          return p;
        }
        function h(m, y) {
          let p = t.basename(m).toLowerCase(), d = a({ plugins: y }).languages.filter((C) => C.since !== null).find((C) => C.extensions && C.extensions.some((w) => p.endsWith(w)) || C.filenames && C.filenames.some((w) => w.toLowerCase() === p));
          return d && d.parsers[0];
        }
        l.exports = { normalize: o, hiddenDefaults: r, inferParser: h };
      } }), Ua = X({ "src/main/massage-ast.js"(u, l) {
        H();
        function t(s, a, e) {
          if (Array.isArray(s))
            return s.map((c) => t(c, a, e)).filter(Boolean);
          if (!s || typeof s != "object")
            return s;
          let n = a.printer.massageAstNode, r;
          n && n.ignoredProperties ? r = n.ignoredProperties : r = /* @__PURE__ */ new Set();
          let o = {};
          for (let [c, h] of Object.entries(s))
            !r.has(c) && typeof h != "function" && (o[c] = t(h, a, s));
          if (n) {
            let c = n(s, o, e);
            if (c === null)
              return;
            if (c)
              return c;
          }
          return o;
        }
        l.exports = t;
      } }), pn = X({ "scripts/build/shims/assert.cjs"(u, l) {
        H();
        var t = () => {
        };
        t.ok = t, t.strictEqual = t, l.exports = t;
      } }), ht = X({ "src/main/comments.js"(u, l) {
        H();
        var t = pn(), { builders: { line: s, hardline: a, breakParent: e, indent: n, lineSuffix: r, join: o, cursor: c } } = Qe(), { hasNewline: h, skipNewline: m, skipSpaces: y, isPreviousLineEmpty: p, addLeadingComment: d, addDanglingComment: C, addTrailingComment: w } = at(), P = /* @__PURE__ */ new WeakMap();
        function A(I, M, V) {
          if (!I)
            return;
          let { printer: $, locStart: U, locEnd: L } = M;
          if (V) {
            if ($.canAttachComment && $.canAttachComment(I)) {
              let R;
              for (R = V.length - 1; R >= 0 && !(U(V[R]) <= U(I) && L(V[R]) <= L(I)); --R)
                ;
              V.splice(R + 1, 0, I);
              return;
            }
          } else if (P.has(I))
            return P.get(I);
          let ee = $.getCommentChildNodes && $.getCommentChildNodes(I, M) || typeof I == "object" && Object.entries(I).filter((R) => {
            let [O] = R;
            return O !== "enclosingNode" && O !== "precedingNode" && O !== "followingNode" && O !== "tokens" && O !== "comments" && O !== "parent";
          }).map((R) => {
            let [, O] = R;
            return O;
          });
          if (ee) {
            V || (V = [], P.set(I, V));
            for (let R of ee)
              A(R, M, V);
            return V;
          }
        }
        function N(I, M, V, $) {
          let { locStart: U, locEnd: L } = V, ee = U(M), R = L(M), O = A(I, V), Z, ie, te = 0, ge = O.length;
          for (; te < ge; ) {
            let q = te + ge >> 1, z = O[q], De = U(z), fe = L(z);
            if (De <= ee && R <= fe)
              return N(z, M, V, z);
            if (fe <= ee) {
              Z = z, te = q + 1;
              continue;
            }
            if (R <= De) {
              ie = z, ge = q;
              continue;
            }
            throw new Error("Comment location overlaps with node location");
          }
          if ($ && $.type === "TemplateLiteral") {
            let { quasis: q } = $, z = F(q, M, V);
            Z && F(q, Z, V) !== z && (Z = null), ie && F(q, ie, V) !== z && (ie = null);
          }
          return { enclosingNode: $, precedingNode: Z, followingNode: ie };
        }
        var S = () => !1;
        function j(I, M, V, $) {
          if (!Array.isArray(I))
            return;
          let U = [], { locStart: L, locEnd: ee, printer: { handleComments: R = {} } } = $, { avoidAstMutation: O, ownLine: Z = S, endOfLine: ie = S, remaining: te = S } = R, ge = I.map((q, z) => Object.assign(Object.assign({}, N(M, q, $)), {}, { comment: q, text: V, options: $, ast: M, isLastComment: I.length - 1 === z }));
          for (let [q, z] of ge.entries()) {
            let { comment: De, precedingNode: fe, enclosingNode: we, followingNode: Q, text: W, options: ne, ast: re, isLastComment: he } = z;
            if (ne.parser === "json" || ne.parser === "json5" || ne.parser === "__js_expression" || ne.parser === "__vue_expression" || ne.parser === "__vue_ts_expression") {
              if (L(De) - L(re) <= 0) {
                d(re, De);
                continue;
              }
              if (ee(De) - ee(re) >= 0) {
                w(re, De);
                continue;
              }
            }
            let Fe;
            if (O ? Fe = [z] : (De.enclosingNode = we, De.precedingNode = fe, De.followingNode = Q, Fe = [De, W, ne, re, he]), J(W, ne, ge, q))
              De.placement = "ownLine", Z(...Fe) || (Q ? d(Q, De) : fe ? w(fe, De) : C(we || re, De));
            else if (f(W, ne, ge, q))
              De.placement = "endOfLine", ie(...Fe) || (fe ? w(fe, De) : Q ? d(Q, De) : C(we || re, De));
            else if (De.placement = "remaining", !te(...Fe))
              if (fe && Q) {
                let ve = U.length;
                ve > 0 && U[ve - 1].followingNode !== Q && T(U, W, ne), U.push(z);
              } else
                fe ? w(fe, De) : Q ? d(Q, De) : C(we || re, De);
          }
          if (T(U, V, $), !O)
            for (let q of I)
              delete q.precedingNode, delete q.enclosingNode, delete q.followingNode;
        }
        var k = (I) => !/[\S\n\u2028\u2029]/.test(I);
        function J(I, M, V, $) {
          let { comment: U, precedingNode: L } = V[$], { locStart: ee, locEnd: R } = M, O = ee(U);
          if (L)
            for (let Z = $ - 1; Z >= 0; Z--) {
              let { comment: ie, precedingNode: te } = V[Z];
              if (te !== L || !k(I.slice(R(ie), O)))
                break;
              O = ee(ie);
            }
          return h(I, O, { backwards: !0 });
        }
        function f(I, M, V, $) {
          let { comment: U, followingNode: L } = V[$], { locStart: ee, locEnd: R } = M, O = R(U);
          if (L)
            for (let Z = $ + 1; Z < V.length; Z++) {
              let { comment: ie, followingNode: te } = V[Z];
              if (te !== L || !k(I.slice(O, ee(ie))))
                break;
              O = R(ie);
            }
          return h(I, O);
        }
        function T(I, M, V) {
          let $ = I.length;
          if ($ === 0)
            return;
          let { precedingNode: U, followingNode: L, enclosingNode: ee } = I[0], R = V.printer.getGapRegex && V.printer.getGapRegex(ee) || /^[\s(]*$/, O = V.locStart(L), Z;
          for (Z = $; Z > 0; --Z) {
            let { comment: ie, precedingNode: te, followingNode: ge } = I[Z - 1];
            t.strictEqual(te, U), t.strictEqual(ge, L);
            let q = M.slice(V.locEnd(ie), O);
            if (R.test(q))
              O = V.locStart(ie);
            else
              break;
          }
          for (let [ie, { comment: te }] of I.entries())
            ie < Z ? w(U, te) : d(L, te);
          for (let ie of [U, L])
            ie.comments && ie.comments.length > 1 && ie.comments.sort((te, ge) => V.locStart(te) - V.locStart(ge));
          I.length = 0;
        }
        function D(I, M) {
          let V = I.getValue();
          return V.printed = !0, M.printer.printComment(I, M);
        }
        function F(I, M, V) {
          let $ = V.locStart(M) - 1;
          for (let U = 1; U < I.length; ++U)
            if ($ < V.locStart(I[U]))
              return U - 1;
          return 0;
        }
        function i(I, M) {
          let V = I.getValue(), $ = [D(I, M)], { printer: U, originalText: L, locStart: ee, locEnd: R } = M;
          if (U.isBlockComment && U.isBlockComment(V)) {
            let Z = h(L, R(V)) ? h(L, ee(V), { backwards: !0 }) ? a : s : " ";
            $.push(Z);
          } else
            $.push(a);
          let O = m(L, y(L, R(V)));
          return O !== !1 && h(L, O) && $.push(a), $;
        }
        function g(I, M) {
          let V = I.getValue(), $ = D(I, M), { printer: U, originalText: L, locStart: ee } = M, R = U.isBlockComment && U.isBlockComment(V);
          if (h(L, ee(V), { backwards: !0 })) {
            let Z = p(L, V, ee);
            return r([a, Z ? a : "", $]);
          }
          let O = [" ", $];
          return R || (O = [r(O), e]), O;
        }
        function E(I, M, V, $) {
          let U = [], L = I.getValue();
          return !L || !L.comments || (I.each(() => {
            let ee = I.getValue();
            !ee.leading && !ee.trailing && (!$ || $(ee)) && U.push(D(I, M));
          }, "comments"), U.length === 0) ? "" : V ? o(a, U) : n([a, o(a, U)]);
        }
        function x(I, M, V) {
          let $ = I.getValue();
          if (!$)
            return {};
          let U = $.comments || [];
          V && (U = U.filter((O) => !V.has(O)));
          let L = $ === M.cursorNode;
          if (U.length === 0) {
            let O = L ? c : "";
            return { leading: O, trailing: O };
          }
          let ee = [], R = [];
          return I.each(() => {
            let O = I.getValue();
            if (V && V.has(O))
              return;
            let { leading: Z, trailing: ie } = O;
            Z ? ee.push(i(I, M)) : ie && R.push(g(I, M));
          }, "comments"), L && (ee.unshift(c), R.push(c)), { leading: ee, trailing: R };
        }
        function b(I, M, V, $) {
          let { leading: U, trailing: L } = x(I, V, $);
          return !U && !L ? M : [U, M, L];
        }
        function B(I) {
          if (I)
            for (let M of I) {
              if (!M.printed)
                throw new Error('Comment "' + M.value.trim() + '" was not printed. Please report this error!');
              delete M.printed;
            }
        }
        l.exports = { attach: j, printComments: b, printCommentsSeparately: x, printDanglingComments: E, getSortedChildNodes: A, ensureAllCommentsPrinted: B };
      } }), Ya = X({ "src/common/ast-path.js"(u, l) {
        H();
        var t = Ct();
        function s(n, r) {
          let o = a(n.stack, r);
          return o === -1 ? null : n.stack[o];
        }
        function a(n, r) {
          for (let o = n.length - 1; o >= 0; o -= 2) {
            let c = n[o];
            if (c && !Array.isArray(c) && --r < 0)
              return o;
          }
          return -1;
        }
        var e = class {
          constructor(n) {
            this.stack = [n];
          }
          getName() {
            let { stack: n } = this, { length: r } = n;
            return r > 1 ? n[r - 2] : null;
          }
          getValue() {
            return t(this.stack);
          }
          getNode() {
            let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s(this, n);
          }
          getParentNode() {
            let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s(this, n + 1);
          }
          call(n) {
            let { stack: r } = this, { length: o } = r, c = t(r);
            for (var h = arguments.length, m = new Array(h > 1 ? h - 1 : 0), y = 1; y < h; y++)
              m[y - 1] = arguments[y];
            for (let d of m)
              c = c[d], r.push(d, c);
            let p = n(this);
            return r.length = o, p;
          }
          callParent(n) {
            let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = a(this.stack, r + 1), c = this.stack.splice(o + 1), h = n(this);
            return this.stack.push(...c), h;
          }
          each(n) {
            let { stack: r } = this, { length: o } = r, c = t(r);
            for (var h = arguments.length, m = new Array(h > 1 ? h - 1 : 0), y = 1; y < h; y++)
              m[y - 1] = arguments[y];
            for (let p of m)
              c = c[p], r.push(p, c);
            for (let p = 0; p < c.length; ++p)
              r.push(p, c[p]), n(this, p, c), r.length -= 2;
            r.length = o;
          }
          map(n) {
            let r = [];
            for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), h = 1; h < o; h++)
              c[h - 1] = arguments[h];
            return this.each((m, y, p) => {
              r[y] = n(m, y, p);
            }, ...c), r;
          }
          try(n) {
            let { stack: r } = this, o = [...r];
            try {
              return n();
            } finally {
              r.length = 0, r.push(...o);
            }
          }
          match() {
            let n = this.stack.length - 1, r = null, o = this.stack[n--];
            for (var c = arguments.length, h = new Array(c), m = 0; m < c; m++)
              h[m] = arguments[m];
            for (let y of h) {
              if (o === void 0)
                return !1;
              let p = null;
              if (typeof r == "number" && (p = r, r = this.stack[n--], o = this.stack[n--]), y && !y(o, r, p))
                return !1;
              r = this.stack[n--], o = this.stack[n--];
            }
            return !0;
          }
          findAncestor(n) {
            let r = this.stack.length - 1, o = null, c = this.stack[r--];
            for (; c; ) {
              let h = null;
              if (typeof o == "number" && (h = o, o = this.stack[r--], c = this.stack[r--]), o !== null && n(c, o, h))
                return c;
              o = this.stack[r--], c = this.stack[r--];
            }
          }
        };
        l.exports = e;
      } }), za = X({ "src/main/multiparser.js"(u, l) {
        H();
        var { utils: { stripTrailingHardline: t } } = Qe(), { normalize: s } = Du(), a = ht();
        function e(r, o, c, h) {
          if (c.printer.embed && c.embeddedLanguageFormatting === "auto")
            return c.printer.embed(r, o, (m, y, p) => n(m, y, c, h, p), c);
        }
        function n(r, o, c, h) {
          let { stripTrailingHardline: m = !1 } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, y = s(Object.assign(Object.assign(Object.assign({}, c), o), {}, { parentParser: c.parser, originalText: r }), { passThrough: !0 }), p = ir().parse(r, y), { ast: d } = p;
          r = p.text;
          let C = d.comments;
          delete d.comments, a.attach(C, d, r, y), y[Symbol.for("comments")] = C || [], y[Symbol.for("tokens")] = d.tokens || [];
          let w = h(d, y);
          return a.ensureAllCommentsPrinted(C), m ? typeof w == "string" ? w.replace(/(?:\r?\n)*$/, "") : t(w) : w;
        }
        l.exports = { printSubtree: e };
      } }), Ka = X({ "src/main/ast-to-doc.js"(u, l) {
        H();
        var t = Ya(), { builders: { hardline: s, addAlignmentToDoc: a }, utils: { propagateBreaks: e } } = Qe(), { printComments: n } = ht(), r = za();
        function o(m, y) {
          let p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: d } = y;
          d.preprocess && (m = d.preprocess(m, y));
          let C = /* @__PURE__ */ new Map(), w = new t(m), P = A();
          return p > 0 && (P = a([s, P], p, y.tabWidth)), e(P), P;
          function A(S, j) {
            return S === void 0 || S === w ? N(j) : Array.isArray(S) ? w.call(() => N(j), ...S) : w.call(() => N(j), S);
          }
          function N(S) {
            let j = w.getValue(), k = j && typeof j == "object" && S === void 0;
            if (k && C.has(j))
              return C.get(j);
            let J = h(w, y, A, S);
            return k && C.set(j, J), J;
          }
        }
        function c(m, y) {
          let { originalText: p, [Symbol.for("comments")]: d, locStart: C, locEnd: w } = y, P = C(m), A = w(m), N = /* @__PURE__ */ new Set();
          for (let S of d)
            C(S) >= P && w(S) <= A && (S.printed = !0, N.add(S));
          return { doc: p.slice(P, A), printedComments: N };
        }
        function h(m, y, p, d) {
          let C = m.getValue(), { printer: w } = y, P, A;
          if (w.hasPrettierIgnore && w.hasPrettierIgnore(m))
            ({ doc: P, printedComments: A } = c(C, y));
          else {
            if (C)
              try {
                P = r.printSubtree(m, p, y, o);
              } catch (N) {
                if (globalThis.PRETTIER_DEBUG)
                  throw N;
              }
            P || (P = w.print(m, y, p, d));
          }
          return (!w.willPrintOwnComments || !w.willPrintOwnComments(m, y)) && (P = n(m, P, y, A)), P;
        }
        l.exports = o;
      } }), Qa = X({ "src/main/range-util.js"(u, l) {
        H();
        var t = pn(), s = ht(), a = (d) => {
          let { parser: C } = d;
          return C === "json" || C === "json5" || C === "json-stringify";
        };
        function e(d, C) {
          let w = [d.node, ...d.parentNodes], P = /* @__PURE__ */ new Set([C.node, ...C.parentNodes]);
          return w.find((A) => h.has(A.type) && P.has(A));
        }
        function n(d) {
          let C = d.length - 1;
          for (; ; ) {
            let w = d[C];
            if (w && (w.type === "Program" || w.type === "File"))
              C--;
            else
              break;
          }
          return d.slice(0, C + 1);
        }
        function r(d, C, w) {
          let { locStart: P, locEnd: A } = w, N = d.node, S = C.node;
          if (N === S)
            return { startNode: N, endNode: S };
          let j = P(d.node);
          for (let J of n(C.parentNodes))
            if (P(J) >= j)
              S = J;
            else
              break;
          let k = A(C.node);
          for (let J of n(d.parentNodes)) {
            if (A(J) <= k)
              N = J;
            else
              break;
            if (N === S)
              break;
          }
          return { startNode: N, endNode: S };
        }
        function o(d, C, w, P) {
          let A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], N = arguments.length > 5 ? arguments[5] : void 0, { locStart: S, locEnd: j } = w, k = S(d), J = j(d);
          if (!(C > J || C < k || N === "rangeEnd" && C === k || N === "rangeStart" && C === J)) {
            for (let f of s.getSortedChildNodes(d, w)) {
              let T = o(f, C, w, P, [d, ...A], N);
              if (T)
                return T;
            }
            if (!P || P(d, A[0]))
              return { node: d, parentNodes: A };
          }
        }
        function c(d, C) {
          return C !== "DeclareExportDeclaration" && d !== "TypeParameterDeclaration" && (d === "Directive" || d === "TypeAlias" || d === "TSExportAssignment" || d.startsWith("Declare") || d.startsWith("TSDeclare") || d.endsWith("Statement") || d.endsWith("Declaration"));
        }
        var h = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), m = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
        function y(d, C, w) {
          if (!C)
            return !1;
          switch (d.parser) {
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "acorn":
            case "espree":
            case "meriyah":
            case "__babel_estree":
              return c(C.type, w && w.type);
            case "json":
            case "json5":
            case "json-stringify":
              return h.has(C.type);
            case "graphql":
              return m.has(C.kind);
            case "vue":
              return C.tag !== "root";
          }
          return !1;
        }
        function p(d, C, w) {
          let { rangeStart: P, rangeEnd: A, locStart: N, locEnd: S } = C;
          t.ok(A > P);
          let j = d.slice(P, A).search(/\S/), k = j === -1;
          if (!k)
            for (P += j; A > P && !/\S/.test(d[A - 1]); --A)
              ;
          let J = o(w, P, C, (F, i) => y(C, F, i), [], "rangeStart"), f = k ? J : o(w, A, C, (F) => y(C, F), [], "rangeEnd");
          if (!J || !f)
            return { rangeStart: 0, rangeEnd: 0 };
          let T, D;
          if (a(C)) {
            let F = e(J, f);
            T = F, D = F;
          } else
            ({ startNode: T, endNode: D } = r(J, f, C));
          return { rangeStart: Math.min(N(T), N(D)), rangeEnd: Math.max(S(T), S(D)) };
        }
        l.exports = { calculateRange: p, findNodeAtOffset: o };
      } }), Ha = X({ "src/main/core.js"(u, l) {
        H();
        var { diffArrays: t } = Qt(), { printer: { printDocToString: s }, debug: { printDocToDebug: a } } = Qe(), { getAlignmentSize: e } = at(), { guessEndOfLine: n, convertEndOfLineToChars: r, countEndOfLineChars: o, normalizeEndOfLine: c } = $t(), h = Du().normalize, m = Ua(), y = ht(), p = ir(), d = Ka(), C = Qa(), w = "\uFEFF", P = Symbol("cursor");
        function A(D, F, i) {
          let g = F.comments;
          return g && (delete F.comments, y.attach(g, F, D, i)), i[Symbol.for("comments")] = g || [], i[Symbol.for("tokens")] = F.tokens || [], i.originalText = D, g;
        }
        function N(D, F) {
          let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
          if (!D || D.trim().length === 0)
            return { formatted: "", cursorOffset: -1, comments: [] };
          let { ast: g, text: E } = p.parse(D, F);
          if (F.cursorOffset >= 0) {
            let I = C.findNodeAtOffset(g, F.cursorOffset, F);
            I && I.node && (F.cursorNode = I.node);
          }
          let x = A(E, g, F), b = d(g, F, i), B = s(b, F);
          if (y.ensureAllCommentsPrinted(x), i > 0) {
            let I = B.formatted.trim();
            B.cursorNodeStart !== void 0 && (B.cursorNodeStart -= B.formatted.indexOf(I)), B.formatted = I + r(F.endOfLine);
          }
          if (F.cursorOffset >= 0) {
            let I, M, V, $, U;
            if (F.cursorNode && B.cursorNodeText ? (I = F.locStart(F.cursorNode), M = E.slice(I, F.locEnd(F.cursorNode)), V = F.cursorOffset - I, $ = B.cursorNodeStart, U = B.cursorNodeText) : (I = 0, M = E, V = F.cursorOffset, $ = 0, U = B.formatted), M === U)
              return { formatted: B.formatted, cursorOffset: $ + V, comments: x };
            let L = [...M];
            L.splice(V, 0, P);
            let ee = [...U], R = t(L, ee), O = $;
            for (let Z of R)
              if (Z.removed) {
                if (Z.value.includes(P))
                  break;
              } else
                O += Z.count;
            return { formatted: B.formatted, cursorOffset: O, comments: x };
          }
          return { formatted: B.formatted, cursorOffset: -1, comments: x };
        }
        function S(D, F) {
          let { ast: i, text: g } = p.parse(D, F), { rangeStart: E, rangeEnd: x } = C.calculateRange(g, F, i), b = g.slice(E, x), B = Math.min(E, g.lastIndexOf(`
`, E) + 1), I = g.slice(B, E).match(/^\s*/)[0], M = e(I, F.tabWidth), V = N(b, Object.assign(Object.assign({}, F), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: F.cursorOffset > E && F.cursorOffset <= x ? F.cursorOffset - E : -1, endOfLine: "lf" }), M), $ = V.formatted.trimEnd(), { cursorOffset: U } = F;
          U > x ? U += $.length - b.length : V.cursorOffset >= 0 && (U = V.cursorOffset + E);
          let L = g.slice(0, E) + $ + g.slice(x);
          if (F.endOfLine !== "lf") {
            let ee = r(F.endOfLine);
            U >= 0 && ee === `\r
` && (U += o(L.slice(0, U), `
`)), L = L.replace(/\n/g, ee);
          }
          return { formatted: L, cursorOffset: U, comments: V.comments };
        }
        function j(D, F, i) {
          return typeof F != "number" || Number.isNaN(F) || F < 0 || F > D.length ? i : F;
        }
        function k(D, F) {
          let { cursorOffset: i, rangeStart: g, rangeEnd: E } = F;
          return i = j(D, i, -1), g = j(D, g, 0), E = j(D, E, D.length), Object.assign(Object.assign({}, F), {}, { cursorOffset: i, rangeStart: g, rangeEnd: E });
        }
        function J(D, F) {
          let { cursorOffset: i, rangeStart: g, rangeEnd: E, endOfLine: x } = k(D, F), b = D.charAt(0) === w;
          if (b && (D = D.slice(1), i--, g--, E--), x === "auto" && (x = n(D)), D.includes("\r")) {
            let B = (I) => o(D.slice(0, Math.max(I, 0)), `\r
`);
            i -= B(i), g -= B(g), E -= B(E), D = c(D);
          }
          return { hasBOM: b, text: D, options: k(D, Object.assign(Object.assign({}, F), {}, { cursorOffset: i, rangeStart: g, rangeEnd: E, endOfLine: x })) };
        }
        function f(D, F) {
          let i = p.resolveParser(F);
          return !i.hasPragma || i.hasPragma(D);
        }
        function T(D, F) {
          let { hasBOM: i, text: g, options: E } = J(D, h(F));
          if (E.rangeStart >= E.rangeEnd && g !== "" || E.requirePragma && !f(g, E))
            return { formatted: D, cursorOffset: F.cursorOffset, comments: [] };
          let x;
          return E.rangeStart > 0 || E.rangeEnd < g.length ? x = S(g, E) : (!E.requirePragma && E.insertPragma && E.printer.insertPragma && !f(g, E) && (g = E.printer.insertPragma(g)), x = N(g, E)), i && (x.formatted = w + x.formatted, x.cursorOffset >= 0 && x.cursorOffset++), x;
        }
        l.exports = { formatWithCursor: T, parse(D, F, i) {
          let { text: g, options: E } = J(D, h(F)), x = p.parse(g, E);
          return i && (x.ast = m(x.ast, E)), x;
        }, formatAST(D, F) {
          F = h(F);
          let i = d(D, F);
          return s(i, F);
        }, formatDoc(D, F) {
          return T(a(D), Object.assign(Object.assign({}, F), {}, { parser: "__js_expression" })).formatted;
        }, printToDoc(D, F) {
          F = h(F);
          let { ast: i, text: g } = p.parse(D, F);
          return A(g, i, F), d(i, F);
        }, printDocToString(D, F) {
          return s(D, h(F));
        } };
      } }), Za = X({ "src/common/util-shared.js"(u, l) {
        H();
        var { getMaxContinuousCount: t, getStringWidth: s, getAlignmentSize: a, getIndentSize: e, skip: n, skipWhitespace: r, skipSpaces: o, skipNewline: c, skipToLineEnd: h, skipEverythingButNewLine: m, skipInlineComment: y, skipTrailingComment: p, hasNewline: d, hasNewlineInRange: C, hasSpaces: w, isNextLineEmpty: P, isNextLineEmptyAfterIndex: A, isPreviousLineEmpty: N, getNextNonSpaceNonCommentCharacterIndex: S, makeString: j, addLeadingComment: k, addDanglingComment: J, addTrailingComment: f } = at();
        l.exports = { getMaxContinuousCount: t, getStringWidth: s, getAlignmentSize: a, getIndentSize: e, skip: n, skipWhitespace: r, skipSpaces: o, skipNewline: c, skipToLineEnd: h, skipEverythingButNewLine: m, skipInlineComment: y, skipTrailingComment: p, hasNewline: d, hasNewlineInRange: C, hasSpaces: w, isNextLineEmpty: P, isNextLineEmptyAfterIndex: A, isPreviousLineEmpty: N, getNextNonSpaceNonCommentCharacterIndex: S, makeString: j, addLeadingComment: k, addDanglingComment: J, addTrailingComment: f };
      } }), Gt = X({ "src/utils/create-language.js"(u, l) {
        H(), l.exports = function(t, s) {
          let { languageId: a } = t, e = Ce(t, se);
          return Object.assign(Object.assign({ linguistLanguageId: a }, e), s(t));
        };
      } }), es = X({ "node_modules/esutils/lib/ast.js"(u, l) {
        H(), function() {
          function t(o) {
            if (o == null)
              return !1;
            switch (o.type) {
              case "ArrayExpression":
              case "AssignmentExpression":
              case "BinaryExpression":
              case "CallExpression":
              case "ConditionalExpression":
              case "FunctionExpression":
              case "Identifier":
              case "Literal":
              case "LogicalExpression":
              case "MemberExpression":
              case "NewExpression":
              case "ObjectExpression":
              case "SequenceExpression":
              case "ThisExpression":
              case "UnaryExpression":
              case "UpdateExpression":
                return !0;
            }
            return !1;
          }
          function s(o) {
            if (o == null)
              return !1;
            switch (o.type) {
              case "DoWhileStatement":
              case "ForInStatement":
              case "ForStatement":
              case "WhileStatement":
                return !0;
            }
            return !1;
          }
          function a(o) {
            if (o == null)
              return !1;
            switch (o.type) {
              case "BlockStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "DebuggerStatement":
              case "DoWhileStatement":
              case "EmptyStatement":
              case "ExpressionStatement":
              case "ForInStatement":
              case "ForStatement":
              case "IfStatement":
              case "LabeledStatement":
              case "ReturnStatement":
              case "SwitchStatement":
              case "ThrowStatement":
              case "TryStatement":
              case "VariableDeclaration":
              case "WhileStatement":
              case "WithStatement":
                return !0;
            }
            return !1;
          }
          function e(o) {
            return a(o) || o != null && o.type === "FunctionDeclaration";
          }
          function n(o) {
            switch (o.type) {
              case "IfStatement":
                return o.alternate != null ? o.alternate : o.consequent;
              case "LabeledStatement":
              case "ForStatement":
              case "ForInStatement":
              case "WhileStatement":
              case "WithStatement":
                return o.body;
            }
            return null;
          }
          function r(o) {
            var c;
            if (o.type !== "IfStatement" || o.alternate == null)
              return !1;
            c = o.consequent;
            do {
              if (c.type === "IfStatement" && c.alternate == null)
                return !0;
              c = n(c);
            } while (c);
            return !1;
          }
          l.exports = { isExpression: t, isStatement: a, isIterationStatement: s, isSourceElement: e, isProblematicIfStatement: r, trailingStatement: n };
        }();
      } }), fu = X({ "node_modules/esutils/lib/code.js"(u, l) {
        H(), function() {
          var t, s, a, e, n, r;
          s = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
          function o(A) {
            return 48 <= A && A <= 57;
          }
          function c(A) {
            return 48 <= A && A <= 57 || 97 <= A && A <= 102 || 65 <= A && A <= 70;
          }
          function h(A) {
            return A >= 48 && A <= 55;
          }
          a = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
          function m(A) {
            return A === 32 || A === 9 || A === 11 || A === 12 || A === 160 || A >= 5760 && a.indexOf(A) >= 0;
          }
          function y(A) {
            return A === 10 || A === 13 || A === 8232 || A === 8233;
          }
          function p(A) {
            if (A <= 65535)
              return String.fromCharCode(A);
            var N = String.fromCharCode(Math.floor((A - 65536) / 1024) + 55296), S = String.fromCharCode((A - 65536) % 1024 + 56320);
            return N + S;
          }
          for (e = new Array(128), r = 0; r < 128; ++r)
            e[r] = r >= 97 && r <= 122 || r >= 65 && r <= 90 || r === 36 || r === 95;
          for (n = new Array(128), r = 0; r < 128; ++r)
            n[r] = r >= 97 && r <= 122 || r >= 65 && r <= 90 || r >= 48 && r <= 57 || r === 36 || r === 95;
          function d(A) {
            return A < 128 ? e[A] : s.NonAsciiIdentifierStart.test(p(A));
          }
          function C(A) {
            return A < 128 ? n[A] : s.NonAsciiIdentifierPart.test(p(A));
          }
          function w(A) {
            return A < 128 ? e[A] : t.NonAsciiIdentifierStart.test(p(A));
          }
          function P(A) {
            return A < 128 ? n[A] : t.NonAsciiIdentifierPart.test(p(A));
          }
          l.exports = { isDecimalDigit: o, isHexDigit: c, isOctalDigit: h, isWhiteSpace: m, isLineTerminator: y, isIdentifierStartES5: d, isIdentifierPartES5: C, isIdentifierStartES6: w, isIdentifierPartES6: P };
        }();
      } }), ts = X({ "node_modules/esutils/lib/keyword.js"(u, l) {
        H(), function() {
          var t = fu();
          function s(d) {
            switch (d) {
              case "implements":
              case "interface":
              case "package":
              case "private":
              case "protected":
              case "public":
              case "static":
              case "let":
                return !0;
              default:
                return !1;
            }
          }
          function a(d, C) {
            return !C && d === "yield" ? !1 : e(d, C);
          }
          function e(d, C) {
            if (C && s(d))
              return !0;
            switch (d.length) {
              case 2:
                return d === "if" || d === "in" || d === "do";
              case 3:
                return d === "var" || d === "for" || d === "new" || d === "try";
              case 4:
                return d === "this" || d === "else" || d === "case" || d === "void" || d === "with" || d === "enum";
              case 5:
                return d === "while" || d === "break" || d === "catch" || d === "throw" || d === "const" || d === "yield" || d === "class" || d === "super";
              case 6:
                return d === "return" || d === "typeof" || d === "delete" || d === "switch" || d === "export" || d === "import";
              case 7:
                return d === "default" || d === "finally" || d === "extends";
              case 8:
                return d === "function" || d === "continue" || d === "debugger";
              case 10:
                return d === "instanceof";
              default:
                return !1;
            }
          }
          function n(d, C) {
            return d === "null" || d === "true" || d === "false" || a(d, C);
          }
          function r(d, C) {
            return d === "null" || d === "true" || d === "false" || e(d, C);
          }
          function o(d) {
            return d === "eval" || d === "arguments";
          }
          function c(d) {
            var C, w, P;
            if (d.length === 0 || (P = d.charCodeAt(0), !t.isIdentifierStartES5(P)))
              return !1;
            for (C = 1, w = d.length; C < w; ++C)
              if (P = d.charCodeAt(C), !t.isIdentifierPartES5(P))
                return !1;
            return !0;
          }
          function h(d, C) {
            return (d - 55296) * 1024 + (C - 56320) + 65536;
          }
          function m(d) {
            var C, w, P, A, N;
            if (d.length === 0)
              return !1;
            for (N = t.isIdentifierStartES6, C = 0, w = d.length; C < w; ++C) {
              if (P = d.charCodeAt(C), 55296 <= P && P <= 56319) {
                if (++C, C >= w || (A = d.charCodeAt(C), !(56320 <= A && A <= 57343)))
                  return !1;
                P = h(P, A);
              }
              if (!N(P))
                return !1;
              N = t.isIdentifierPartES6;
            }
            return !0;
          }
          function y(d, C) {
            return c(d) && !n(d, C);
          }
          function p(d, C) {
            return m(d) && !r(d, C);
          }
          l.exports = { isKeywordES5: a, isKeywordES6: e, isReservedWordES5: n, isReservedWordES6: r, isRestrictedWord: o, isIdentifierNameES5: c, isIdentifierNameES6: m, isIdentifierES5: y, isIdentifierES6: p };
        }();
      } }), ns = X({ "node_modules/esutils/lib/utils.js"(u) {
        H(), function() {
          u.ast = es(), u.code = fu(), u.keyword = ts();
        }();
      } }), Wt = X({ "src/language-js/utils/is-block-comment.js"(u, l) {
        H();
        var t = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), s = (a) => t.has(a == null ? void 0 : a.type);
        l.exports = s;
      } }), rs = X({ "src/language-js/utils/is-node-matches.js"(u, l) {
        H();
        function t(a, e) {
          let n = e.split(".");
          for (let r = n.length - 1; r >= 0; r--) {
            let o = n[r];
            if (r === 0)
              return a.type === "Identifier" && a.name === o;
            if (a.type !== "MemberExpression" || a.optional || a.computed || a.property.type !== "Identifier" || a.property.name !== o)
              return !1;
            a = a.object;
          }
        }
        function s(a, e) {
          return e.some((n) => t(a, n));
        }
        l.exports = s;
      } }), Dt = X({ "src/language-js/utils/index.js"(u, l) {
        H();
        var t = ns().keyword.isIdentifierNameES5, { getLast: s, hasNewline: a, skipWhitespace: e, isNonEmptyArray: n, isNextLineEmptyAfterIndex: r, getStringWidth: o } = at(), { locStart: c, locEnd: h, hasSameLocStart: m } = vt(), y = Wt(), p = rs(), d = "(?:(?=.)\\s)", C = new RegExp(`^${d}*:`), w = new RegExp(`^${d}*::`);
        function P(_) {
          var Ee, qe;
          return ((Ee = _.extra) === null || Ee === void 0 ? void 0 : Ee.parenthesized) && y((qe = _.trailingComments) === null || qe === void 0 ? void 0 : qe[0]) && C.test(_.trailingComments[0].value);
        }
        function A(_) {
          let Ee = _ == null ? void 0 : _[0];
          return y(Ee) && w.test(Ee.value);
        }
        function N(_, Ee) {
          if (!_ || typeof _ != "object")
            return !1;
          if (Array.isArray(_))
            return _.some((st) => N(st, Ee));
          let qe = Ee(_);
          return typeof qe == "boolean" ? qe : Object.values(_).some((st) => N(st, Ee));
        }
        function S(_) {
          return _.type === "AssignmentExpression" || _.type === "BinaryExpression" || _.type === "LogicalExpression" || _.type === "NGPipeExpression" || _.type === "ConditionalExpression" || De(_) || fe(_) || _.type === "SequenceExpression" || _.type === "TaggedTemplateExpression" || _.type === "BindExpression" || _.type === "UpdateExpression" && !_.prefix || wt(_) || _.type === "TSNonNullExpression";
        }
        function j(_) {
          var Ee, qe, st, ot, St, gt;
          return _.expressions ? _.expressions[0] : (Ee = (qe = (st = (ot = (St = (gt = _.left) !== null && gt !== void 0 ? gt : _.test) !== null && St !== void 0 ? St : _.callee) !== null && ot !== void 0 ? ot : _.object) !== null && st !== void 0 ? st : _.tag) !== null && qe !== void 0 ? qe : _.argument) !== null && Ee !== void 0 ? Ee : _.expression;
        }
        function k(_, Ee) {
          if (Ee.expressions)
            return ["expressions", 0];
          if (Ee.left)
            return ["left"];
          if (Ee.test)
            return ["test"];
          if (Ee.object)
            return ["object"];
          if (Ee.callee)
            return ["callee"];
          if (Ee.tag)
            return ["tag"];
          if (Ee.argument)
            return ["argument"];
          if (Ee.expression)
            return ["expression"];
          throw new Error("Unexpected node has no left side.");
        }
        function J(_) {
          return _ = new Set(_), (Ee) => _.has(Ee == null ? void 0 : Ee.type);
        }
        var f = J(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), T = J(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
        function D(_) {
          let Ee = _.getParentNode();
          return _.getName() === "declaration" && T(Ee) ? Ee : null;
        }
        var F = J(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
        function i(_) {
          return _.type === "NumericLiteral" || _.type === "Literal" && typeof _.value == "number";
        }
        function g(_) {
          return _.type === "UnaryExpression" && (_.operator === "+" || _.operator === "-") && i(_.argument);
        }
        function E(_) {
          return _.type === "StringLiteral" || _.type === "Literal" && typeof _.value == "string";
        }
        var x = J(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), b = J(["FunctionExpression", "ArrowFunctionExpression"]);
        function B(_) {
          return _.type === "FunctionExpression" || _.type === "ArrowFunctionExpression" && _.body.type === "BlockStatement";
        }
        function I(_) {
          return De(_) && _.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(_.callee.name);
        }
        var M = J(["JSXElement", "JSXFragment"]);
        function V(_, Ee) {
          if (_.parentParser !== "markdown" && _.parentParser !== "mdx")
            return !1;
          let qe = Ee.getNode();
          if (!qe.expression || !M(qe.expression))
            return !1;
          let st = Ee.getParentNode();
          return st.type === "Program" && st.body.length === 1;
        }
        function $(_) {
          return _.kind === "get" || _.kind === "set";
        }
        function U(_) {
          return $(_) || m(_, _.value);
        }
        function L(_) {
          return (_.type === "ObjectTypeProperty" || _.type === "ObjectTypeInternalSlot") && _.value.type === "FunctionTypeAnnotation" && !_.static && !U(_);
        }
        function ee(_) {
          return (_.type === "TypeAnnotation" || _.type === "TSTypeAnnotation") && _.typeAnnotation.type === "FunctionTypeAnnotation" && !_.static && !m(_, _.typeAnnotation);
        }
        var R = J(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
        function O(_) {
          return fe(_) || _.type === "BindExpression" && !!_.object;
        }
        var Z = /* @__PURE__ */ new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
        function ie(_) {
          return _ ? !!((_.type === "GenericTypeAnnotation" || _.type === "TSTypeReference") && !_.typeParameters || Z.has(_.type)) : !1;
        }
        function te(_) {
          let Ee = /^(?:before|after)(?:Each|All)$/;
          return _.callee.type === "Identifier" && Ee.test(_.callee.name) && _.arguments.length === 1;
        }
        var ge = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
        function q(_) {
          return p(_, ge);
        }
        function z(_, Ee) {
          if (_.type !== "CallExpression")
            return !1;
          if (_.arguments.length === 1) {
            if (I(_) && Ee && z(Ee))
              return b(_.arguments[0]);
            if (te(_))
              return I(_.arguments[0]);
          } else if ((_.arguments.length === 2 || _.arguments.length === 3) && (_.arguments[0].type === "TemplateLiteral" || E(_.arguments[0])) && q(_.callee))
            return _.arguments[2] && !i(_.arguments[2]) ? !1 : (_.arguments.length === 2 ? b(_.arguments[1]) : B(_.arguments[1]) && xe(_.arguments[1]).length <= 1) || I(_.arguments[1]);
          return !1;
        }
        var De = J(["CallExpression", "OptionalCallExpression"]), fe = J(["MemberExpression", "OptionalMemberExpression"]);
        function we(_) {
          let Ee = "expressions";
          _.type === "TSTemplateLiteralType" && (Ee = "types");
          let qe = _[Ee];
          return qe.length === 0 ? !1 : qe.every((st) => {
            if (Ye(st))
              return !1;
            if (st.type === "Identifier" || st.type === "ThisExpression")
              return !0;
            if (fe(st)) {
              let ot = st;
              for (; fe(ot); )
                if (ot.property.type !== "Identifier" && ot.property.type !== "Literal" && ot.property.type !== "StringLiteral" && ot.property.type !== "NumericLiteral" || (ot = ot.object, Ye(ot)))
                  return !1;
              return ot.type === "Identifier" || ot.type === "ThisExpression";
            }
            return !1;
          });
        }
        function Q(_, Ee) {
          return _ === "+" || _ === "-" ? _ + Ee : Ee;
        }
        function W(_, Ee) {
          let qe = c(Ee), st = e(_, h(Ee));
          return st !== !1 && _.slice(qe, qe + 2) === "/*" && _.slice(st, st + 2) === "*/";
        }
        function ne(_, Ee) {
          return M(Ee) ? et(Ee) : Ye(Ee, Oe.Leading, (qe) => a(_, h(qe)));
        }
        function re(_, Ee) {
          return Ee.parser !== "json" && E(_.key) && le(_.key).slice(1, -1) === _.key.value && (t(_.key.value) && !(Ee.parser === "babel-ts" && _.type === "ClassProperty" || Ee.parser === "typescript" && _.type === "PropertyDefinition") || he(_.key.value) && String(Number(_.key.value)) === _.key.value && (Ee.parser === "babel" || Ee.parser === "acorn" || Ee.parser === "espree" || Ee.parser === "meriyah" || Ee.parser === "__babel_estree"));
        }
        function he(_) {
          return /^(?:\d+|\d+\.\d+)$/.test(_);
        }
        function Fe(_, Ee) {
          let qe = /^[fx]?(?:describe|it|test)$/;
          return Ee.type === "TaggedTemplateExpression" && Ee.quasi === _ && Ee.tag.type === "MemberExpression" && Ee.tag.property.type === "Identifier" && Ee.tag.property.name === "each" && (Ee.tag.object.type === "Identifier" && qe.test(Ee.tag.object.name) || Ee.tag.object.type === "MemberExpression" && Ee.tag.object.property.type === "Identifier" && (Ee.tag.object.property.name === "only" || Ee.tag.object.property.name === "skip") && Ee.tag.object.object.type === "Identifier" && qe.test(Ee.tag.object.object.name));
        }
        function ve(_) {
          return _.quasis.some((Ee) => Ee.value.raw.includes(`
`));
        }
        function Re(_, Ee) {
          return (_.type === "TemplateLiteral" && ve(_) || _.type === "TaggedTemplateExpression" && ve(_.quasi)) && !a(Ee, c(_), { backwards: !0 });
        }
        function tt(_) {
          if (!Ye(_))
            return !1;
          let Ee = s(pe(_, Oe.Dangling));
          return Ee && !y(Ee);
        }
        function Ze(_) {
          if (_.length <= 1)
            return !1;
          let Ee = 0;
          for (let qe of _)
            if (b(qe)) {
              if (Ee += 1, Ee > 1)
                return !0;
            } else if (De(qe)) {
              for (let st of qe.arguments)
                if (b(st))
                  return !0;
            }
          return !1;
        }
        function $e(_) {
          let Ee = _.getValue(), qe = _.getParentNode();
          return De(Ee) && De(qe) && qe.callee === Ee && Ee.arguments.length > qe.arguments.length && qe.arguments.length > 0;
        }
        function Ge(_, Ee) {
          if (Ee >= 2)
            return !1;
          let qe = (gt) => Ge(gt, Ee + 1), st = _.type === "Literal" && "regex" in _ && _.regex.pattern || _.type === "RegExpLiteral" && _.pattern;
          if (st && o(st) > 5)
            return !1;
          if (_.type === "Literal" || _.type === "BigIntLiteral" || _.type === "DecimalLiteral" || _.type === "BooleanLiteral" || _.type === "NullLiteral" || _.type === "NumericLiteral" || _.type === "RegExpLiteral" || _.type === "StringLiteral" || _.type === "Identifier" || _.type === "ThisExpression" || _.type === "Super" || _.type === "PrivateName" || _.type === "PrivateIdentifier" || _.type === "ArgumentPlaceholder" || _.type === "Import")
            return !0;
          if (_.type === "TemplateLiteral")
            return _.quasis.every((gt) => !gt.value.raw.includes(`
`)) && _.expressions.every(qe);
          if (_.type === "ObjectExpression")
            return _.properties.every((gt) => !gt.computed && (gt.shorthand || gt.value && qe(gt.value)));
          if (_.type === "ArrayExpression")
            return _.elements.every((gt) => gt === null || qe(gt));
          if (Ft(_))
            return (_.type === "ImportExpression" || Ge(_.callee, Ee)) && ft(_).every(qe);
          if (fe(_))
            return Ge(_.object, Ee) && Ge(_.property, Ee);
          let ot = { "!": !0, "-": !0, "+": !0, "~": !0 };
          if (_.type === "UnaryExpression" && ot[_.operator])
            return Ge(_.argument, Ee);
          let St = { "++": !0, "--": !0 };
          return _.type === "UpdateExpression" && St[_.operator] ? Ge(_.argument, Ee) : _.type === "TSNonNullExpression" ? Ge(_.expression, Ee) : !1;
        }
        function le(_) {
          var Ee, qe;
          return (Ee = (qe = _.extra) === null || qe === void 0 ? void 0 : qe.raw) !== null && Ee !== void 0 ? Ee : _.raw;
        }
        function G(_) {
          return _;
        }
        function me(_) {
          return _.filepath && /\.tsx$/i.test(_.filepath);
        }
        function K(_) {
          let Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
          return _.trailingComma === "es5" && Ee === "es5" || _.trailingComma === "all" && (Ee === "all" || Ee === "es5");
        }
        function de(_, Ee) {
          switch (_.type) {
            case "BinaryExpression":
            case "LogicalExpression":
            case "AssignmentExpression":
            case "NGPipeExpression":
              return de(_.left, Ee);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return de(_.object, Ee);
            case "TaggedTemplateExpression":
              return _.tag.type === "FunctionExpression" ? !1 : de(_.tag, Ee);
            case "CallExpression":
            case "OptionalCallExpression":
              return _.callee.type === "FunctionExpression" ? !1 : de(_.callee, Ee);
            case "ConditionalExpression":
              return de(_.test, Ee);
            case "UpdateExpression":
              return !_.prefix && de(_.argument, Ee);
            case "BindExpression":
              return _.object && de(_.object, Ee);
            case "SequenceExpression":
              return de(_.expressions[0], Ee);
            case "TSSatisfiesExpression":
            case "TSAsExpression":
            case "TSNonNullExpression":
              return de(_.expression, Ee);
            default:
              return Ee(_);
          }
        }
        var je = { "==": !0, "!=": !0, "===": !0, "!==": !0 }, Be = { "*": !0, "/": !0, "%": !0 }, ye = { ">>": !0, ">>>": !0, "<<": !0 };
        function v(_, Ee) {
          return !(ae(Ee) !== ae(_) || _ === "**" || je[_] && je[Ee] || Ee === "%" && Be[_] || _ === "%" && Be[Ee] || Ee !== _ && Be[Ee] && Be[_] || ye[_] && ye[Ee]);
        }
        var Y = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((_, Ee) => _.map((qe) => [qe, Ee])));
        function ae(_) {
          return Y.get(_);
        }
        function Ae(_) {
          return !!ye[_] || _ === "|" || _ === "^" || _ === "&";
        }
        function Se(_) {
          var Ee;
          if (_.rest)
            return !0;
          let qe = xe(_);
          return ((Ee = s(qe)) === null || Ee === void 0 ? void 0 : Ee.type) === "RestElement";
        }
        var Me = /* @__PURE__ */ new WeakMap();
        function xe(_) {
          if (Me.has(_))
            return Me.get(_);
          let Ee = [];
          return _.this && Ee.push(_.this), Array.isArray(_.parameters) ? Ee.push(..._.parameters) : Array.isArray(_.params) && Ee.push(..._.params), _.rest && Ee.push(_.rest), Me.set(_, Ee), Ee;
        }
        function mt(_, Ee) {
          let qe = _.getValue(), st = 0, ot = (St) => Ee(St, st++);
          qe.this && _.call(ot, "this"), Array.isArray(qe.parameters) ? _.each(ot, "parameters") : Array.isArray(qe.params) && _.each(ot, "params"), qe.rest && _.call(ot, "rest");
        }
        var _e = /* @__PURE__ */ new WeakMap();
        function ft(_) {
          if (_e.has(_))
            return _e.get(_);
          let Ee = _.arguments;
          return _.type === "ImportExpression" && (Ee = [_.source], _.attributes && Ee.push(_.attributes)), _e.set(_, Ee), Ee;
        }
        function Le(_, Ee) {
          let qe = _.getValue();
          qe.type === "ImportExpression" ? (_.call((st) => Ee(st, 0), "source"), qe.attributes && _.call((st) => Ee(st, 1), "attributes")) : _.each(Ee, "arguments");
        }
        function Ue(_) {
          return _.value.trim() === "prettier-ignore" && !_.unignore;
        }
        function et(_) {
          return _ && (_.prettierIgnore || Ye(_, Oe.PrettierIgnore));
        }
        function ct(_) {
          let Ee = _.getValue();
          return et(Ee);
        }
        var Oe = { Leading: 2, Trailing: 4, Dangling: 8, Block: 16, Line: 32, PrettierIgnore: 64, First: 128, Last: 256 }, He = (_, Ee) => {
          if (typeof _ == "function" && (Ee = _, _ = 0), _ || Ee)
            return (qe, st, ot) => !(_ & Oe.Leading && !qe.leading || _ & Oe.Trailing && !qe.trailing || _ & Oe.Dangling && (qe.leading || qe.trailing) || _ & Oe.Block && !y(qe) || _ & Oe.Line && !f(qe) || _ & Oe.First && st !== 0 || _ & Oe.Last && st !== ot.length - 1 || _ & Oe.PrettierIgnore && !Ue(qe) || Ee && !Ee(qe));
        };
        function Ye(_, Ee, qe) {
          if (!n(_ == null ? void 0 : _.comments))
            return !1;
          let st = He(Ee, qe);
          return st ? _.comments.some(st) : !0;
        }
        function pe(_, Ee, qe) {
          if (!Array.isArray(_ == null ? void 0 : _.comments))
            return [];
          let st = He(Ee, qe);
          return st ? _.comments.filter(st) : _.comments;
        }
        var Bt = (_, Ee) => {
          let { originalText: qe } = Ee;
          return r(qe, h(_));
        };
        function Ft(_) {
          return De(_) || _.type === "NewExpression" || _.type === "ImportExpression";
        }
        function ut(_) {
          return _ && (_.type === "ObjectProperty" || _.type === "Property" && !_.method && _.kind === "init");
        }
        function it(_) {
          return !!_.__isUsingHackPipeline;
        }
        var dt = Symbol("ifWithoutBlockAndSameLineComment");
        function wt(_) {
          return _.type === "TSAsExpression" || _.type === "TSSatisfiesExpression";
        }
        l.exports = { getFunctionParameters: xe, iterateFunctionParametersPath: mt, getCallArguments: ft, iterateCallArgumentsPath: Le, hasRestParameter: Se, getLeftSide: j, getLeftSidePathName: k, getParentExportDeclaration: D, getTypeScriptMappedTypeModifier: Q, hasFlowAnnotationComment: A, hasFlowShorthandAnnotationComment: P, hasLeadingOwnLineComment: ne, hasNakedLeftSide: S, hasNode: N, hasIgnoreComment: ct, hasNodeIgnoreComment: et, identity: G, isBinaryish: R, isCallLikeExpression: Ft, isEnabledHackPipeline: it, isLineComment: f, isPrettierIgnoreComment: Ue, isCallExpression: De, isMemberExpression: fe, isExportDeclaration: T, isFlowAnnotationComment: W, isFunctionCompositionArgs: Ze, isFunctionNotation: U, isFunctionOrArrowExpression: b, isGetterOrSetter: $, isJestEachTemplateLiteral: Fe, isJsxNode: M, isLiteral: F, isLongCurriedCallExpression: $e, isSimpleCallArgument: Ge, isMemberish: O, isNumericLiteral: i, isSignedNumericLiteral: g, isObjectProperty: ut, isObjectType: x, isObjectTypePropertyAFunction: L, isSimpleType: ie, isSimpleNumber: he, isSimpleTemplateLiteral: we, isStringLiteral: E, isStringPropSafeToUnquote: re, isTemplateOnItsOwnLine: Re, isTestCall: z, isTheOnlyJsxElementInMarkdown: V, isTSXFile: me, isTypeAnnotationAFunction: ee, isNextLineEmpty: Bt, needsHardlineAfterDanglingComment: tt, rawText: le, shouldPrintComma: K, isBitwiseOperator: Ae, shouldFlatten: v, startsWithNoLookaheadToken: de, getPrecedence: ae, hasComment: Ye, getComments: pe, CommentCheckFlags: Oe, markerForIfWithoutBlockAndSameLineComment: dt, isTSTypeExpression: wt };
      } }), Ht = X({ "src/language-js/print/template-literal.js"(u, l) {
        H();
        var t = Ct(), { getStringWidth: s, getIndentSize: a } = at(), { builders: { join: e, hardline: n, softline: r, group: o, indent: c, align: h, lineSuffixBoundary: m, addAlignmentToDoc: y }, printer: { printDocToString: p }, utils: { mapDoc: d } } = Qe(), { isBinaryish: C, isJestEachTemplateLiteral: w, isSimpleTemplateLiteral: P, hasComment: A, isMemberExpression: N, isTSTypeExpression: S } = Dt();
        function j(F, i, g) {
          let E = F.getValue();
          if (E.type === "TemplateLiteral" && w(E, F.getParentNode())) {
            let M = k(F, g, i);
            if (M)
              return M;
          }
          let x = "expressions";
          E.type === "TSTemplateLiteralType" && (x = "types");
          let b = [], B = F.map(i, x), I = P(E);
          return I && (B = B.map((M) => p(M, Object.assign(Object.assign({}, g), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), b.push(m, "`"), F.each((M) => {
            let V = M.getName();
            if (b.push(i()), V < B.length) {
              let { tabWidth: $ } = g, U = M.getValue(), L = a(U.value.raw, $), ee = B[V];
              if (!I) {
                let O = E[x][V];
                (A(O) || N(O) || O.type === "ConditionalExpression" || O.type === "SequenceExpression" || S(O) || C(O)) && (ee = [c([r, ee]), r]);
              }
              let R = L === 0 && U.value.raw.endsWith(`
`) ? h(Number.NEGATIVE_INFINITY, ee) : y(ee, L, $);
              b.push(o(["${", R, m, "}"]));
            }
          }, "quasis"), b.push("`"), b;
        }
        function k(F, i, g) {
          let E = F.getNode(), x = E.quasis[0].value.raw.trim().split(/\s*\|\s*/);
          if (x.length > 1 || x.some((b) => b.length > 0)) {
            i.__inJestEach = !0;
            let b = F.map(g, "expressions");
            i.__inJestEach = !1;
            let B = [], I = b.map((L) => "${" + p(L, Object.assign(Object.assign({}, i), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), M = [{ hasLineBreak: !1, cells: [] }];
            for (let L = 1; L < E.quasis.length; L++) {
              let ee = t(M), R = I[L - 1];
              ee.cells.push(R), R.includes(`
`) && (ee.hasLineBreak = !0), E.quasis[L].value.raw.includes(`
`) && M.push({ hasLineBreak: !1, cells: [] });
            }
            let V = Math.max(x.length, ...M.map((L) => L.cells.length)), $ = Array.from({ length: V }).fill(0), U = [{ cells: x }, ...M.filter((L) => L.cells.length > 0)];
            for (let { cells: L } of U.filter((ee) => !ee.hasLineBreak))
              for (let [ee, R] of L.entries())
                $[ee] = Math.max($[ee], s(R));
            return B.push(m, "`", c([n, e(n, U.map((L) => e(" | ", L.cells.map((ee, R) => L.hasLineBreak ? ee : ee + " ".repeat($[R] - s(ee))))))]), n, "`"), B;
          }
        }
        function J(F, i) {
          let g = F.getValue(), E = i();
          return A(g) && (E = o([c([r, E]), r])), ["${", E, m, "}"];
        }
        function f(F, i) {
          return F.map((g) => J(g, i), "expressions");
        }
        function T(F, i) {
          return d(F, (g) => typeof g == "string" ? i ? g.replace(/(\\*)`/g, "$1$1\\`") : D(g) : g);
        }
        function D(F) {
          return F.replace(/([\\`]|\${)/g, "\\$1");
        }
        l.exports = { printTemplateLiteral: j, printTemplateExpressions: f, escapeTemplateCharacters: T, uncookTemplateElementValue: D };
      } }), us = X({ "src/language-js/embed/markdown.js"(u, l) {
        H();
        var { builders: { indent: t, softline: s, literalline: a, dedentToRoot: e } } = Qe(), { escapeTemplateCharacters: n } = Ht();
        function r(c, h, m) {
          let y = c.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (w, P) => "\\".repeat(P.length / 2) + "`"), p = o(y), d = p !== "";
          d && (y = y.replace(new RegExp(`^${p}`, "gm"), ""));
          let C = n(m(y, { parser: "markdown", __inJsTemplate: !0 }, { stripTrailingHardline: !0 }), !0);
          return ["`", d ? t([s, C]) : [a, e(C)], s, "`"];
        }
        function o(c) {
          let h = c.match(/^([^\S\n]*)\S/m);
          return h === null ? "" : h[1];
        }
        l.exports = r;
      } }), is = X({ "src/language-js/embed/css.js"(u, l) {
        H();
        var { isNonEmptyArray: t } = at(), { builders: { indent: s, hardline: a, softline: e }, utils: { mapDoc: n, replaceEndOfLine: r, cleanDoc: o } } = Qe(), { printTemplateExpressions: c } = Ht();
        function h(p, d, C) {
          let w = p.getValue(), P = w.quasis.map((k) => k.value.raw), A = 0, N = P.reduce((k, J, f) => f === 0 ? J : k + "@prettier-placeholder-" + A++ + "-id" + J, ""), S = C(N, { parser: "scss" }, { stripTrailingHardline: !0 }), j = c(p, d);
          return m(S, w, j);
        }
        function m(p, d, C) {
          if (d.quasis.length === 1 && !d.quasis[0].value.raw.trim())
            return "``";
          let w = y(p, C);
          if (!w)
            throw new Error("Couldn't insert all the expressions");
          return ["`", s([a, w]), e, "`"];
        }
        function y(p, d) {
          if (!t(d))
            return p;
          let C = 0, w = n(o(p), (P) => typeof P != "string" || !P.includes("@prettier-placeholder") ? P : P.split(/@prettier-placeholder-(\d+)-id/).map((A, N) => N % 2 === 0 ? r(A) : (C++, d[A])));
          return d.length === C ? w : null;
        }
        l.exports = h;
      } }), as = X({ "src/language-js/embed/graphql.js"(u, l) {
        H();
        var { builders: { indent: t, join: s, hardline: a } } = Qe(), { escapeTemplateCharacters: e, printTemplateExpressions: n } = Ht();
        function r(c, h, m) {
          let y = c.getValue(), p = y.quasis.length;
          if (p === 1 && y.quasis[0].value.raw.trim() === "")
            return "``";
          let d = n(c, h), C = [];
          for (let w = 0; w < p; w++) {
            let P = y.quasis[w], A = w === 0, N = w === p - 1, S = P.value.cooked, j = S.split(`
`), k = j.length, J = d[w], f = k > 2 && j[0].trim() === "" && j[1].trim() === "", T = k > 2 && j[k - 1].trim() === "" && j[k - 2].trim() === "", D = j.every((i) => /^\s*(?:#[^\n\r]*)?$/.test(i));
            if (!N && /#[^\n\r]*$/.test(j[k - 1]))
              return null;
            let F = null;
            D ? F = o(j) : F = m(S, { parser: "graphql" }, { stripTrailingHardline: !0 }), F ? (F = e(F, !1), !A && f && C.push(""), C.push(F), !N && T && C.push("")) : !A && !N && f && C.push(""), J && C.push(J);
          }
          return ["`", t([a, s(a, C)]), a, "`"];
        }
        function o(c) {
          let h = [], m = !1, y = c.map((p) => p.trim());
          for (let [p, d] of y.entries())
            d !== "" && (y[p - 1] === "" && m ? h.push([a, d]) : h.push(d), m = !0);
          return h.length === 0 ? null : s(a, h);
        }
        l.exports = r;
      } }), ss = X({ "src/language-js/embed/html.js"(u, l) {
        H();
        var { builders: { indent: t, line: s, hardline: a, group: e }, utils: { mapDoc: n } } = Qe(), { printTemplateExpressions: r, uncookTemplateElementValue: o } = Ht(), c = 0;
        function h(m, y, p, d, C) {
          let { parser: w } = C, P = m.getValue(), A = c;
          c = c + 1 >>> 0;
          let N = (g) => `PRETTIER_HTML_PLACEHOLDER_${g}_${A}_IN_JS`, S = P.quasis.map((g, E, x) => E === x.length - 1 ? g.value.cooked : g.value.cooked + N(E)).join(""), j = r(m, y);
          if (j.length === 0 && S.trim().length === 0)
            return "``";
          let k = new RegExp(N("(\\d+)"), "g"), J = 0, f = p(S, { parser: w, __onHtmlRoot(g) {
            J = g.children.length;
          } }, { stripTrailingHardline: !0 }), T = n(f, (g) => {
            if (typeof g != "string")
              return g;
            let E = [], x = g.split(k);
            for (let b = 0; b < x.length; b++) {
              let B = x[b];
              if (b % 2 === 0) {
                B && (B = o(B), d.__embeddedInHtml && (B = B.replace(/<\/(script)\b/gi, "<\\/$1")), E.push(B));
                continue;
              }
              let I = Number(B);
              E.push(j[I]);
            }
            return E;
          }), D = /^\s/.test(S) ? " " : "", F = /\s$/.test(S) ? " " : "", i = d.htmlWhitespaceSensitivity === "ignore" ? a : D && F ? s : null;
          return e(i ? ["`", t([i, e(T)]), i, "`"] : ["`", D, J > 1 ? t(e(T)) : e(T), F, "`"]);
        }
        l.exports = h;
      } }), os = X({ "src/language-js/embed.js"(u, l) {
        H();
        var { hasComment: t, CommentCheckFlags: s, isObjectProperty: a } = Dt(), e = us(), n = is(), r = as(), o = ss();
        function c(f) {
          if (y(f) || w(f) || P(f) || p(f))
            return "css";
          if (S(f))
            return "graphql";
          if (k(f))
            return "html";
          if (d(f))
            return "angular";
          if (m(f))
            return "markdown";
        }
        function h(f, T, D, F) {
          let i = f.getValue();
          if (i.type !== "TemplateLiteral" || J(i))
            return;
          let g = c(f);
          if (g) {
            if (g === "markdown")
              return e(f, T, D);
            if (g === "css")
              return n(f, T, D);
            if (g === "graphql")
              return r(f, T, D);
            if (g === "html" || g === "angular")
              return o(f, T, D, F, { parser: g });
          }
        }
        function m(f) {
          let T = f.getValue(), D = f.getParentNode();
          return D && D.type === "TaggedTemplateExpression" && T.quasis.length === 1 && D.tag.type === "Identifier" && (D.tag.name === "md" || D.tag.name === "markdown");
        }
        function y(f) {
          let T = f.getValue(), D = f.getParentNode(), F = f.getParentNode(1);
          return F && T.quasis && D.type === "JSXExpressionContainer" && F.type === "JSXElement" && F.openingElement.name.name === "style" && F.openingElement.attributes.some((i) => i.name.name === "jsx") || D && D.type === "TaggedTemplateExpression" && D.tag.type === "Identifier" && D.tag.name === "css" || D && D.type === "TaggedTemplateExpression" && D.tag.type === "MemberExpression" && D.tag.object.name === "css" && (D.tag.property.name === "global" || D.tag.property.name === "resolve");
        }
        function p(f) {
          return f.match((T) => T.type === "TemplateLiteral", (T, D) => T.type === "ArrayExpression" && D === "elements", (T, D) => a(T) && T.key.type === "Identifier" && T.key.name === "styles" && D === "value", ...C);
        }
        function d(f) {
          return f.match((T) => T.type === "TemplateLiteral", (T, D) => a(T) && T.key.type === "Identifier" && T.key.name === "template" && D === "value", ...C);
        }
        var C = [(f, T) => f.type === "ObjectExpression" && T === "properties", (f, T) => f.type === "CallExpression" && f.callee.type === "Identifier" && f.callee.name === "Component" && T === "arguments", (f, T) => f.type === "Decorator" && T === "expression"];
        function w(f) {
          let T = f.getParentNode();
          if (!T || T.type !== "TaggedTemplateExpression")
            return !1;
          let D = T.tag.type === "ParenthesizedExpression" ? T.tag.expression : T.tag;
          switch (D.type) {
            case "MemberExpression":
              return A(D.object) || N(D);
            case "CallExpression":
              return A(D.callee) || D.callee.type === "MemberExpression" && (D.callee.object.type === "MemberExpression" && (A(D.callee.object.object) || N(D.callee.object)) || D.callee.object.type === "CallExpression" && A(D.callee.object.callee));
            case "Identifier":
              return D.name === "css";
            default:
              return !1;
          }
        }
        function P(f) {
          let T = f.getParentNode(), D = f.getParentNode(1);
          return D && T.type === "JSXExpressionContainer" && D.type === "JSXAttribute" && D.name.type === "JSXIdentifier" && D.name.name === "css";
        }
        function A(f) {
          return f.type === "Identifier" && f.name === "styled";
        }
        function N(f) {
          return /^[A-Z]/.test(f.object.name) && f.property.name === "extend";
        }
        function S(f) {
          let T = f.getValue(), D = f.getParentNode();
          return j(T, "GraphQL") || D && (D.type === "TaggedTemplateExpression" && (D.tag.type === "MemberExpression" && D.tag.object.name === "graphql" && D.tag.property.name === "experimental" || D.tag.type === "Identifier" && (D.tag.name === "gql" || D.tag.name === "graphql")) || D.type === "CallExpression" && D.callee.type === "Identifier" && D.callee.name === "graphql");
        }
        function j(f, T) {
          return t(f, s.Block | s.Leading, (D) => {
            let { value: F } = D;
            return F === ` ${T} `;
          });
        }
        function k(f) {
          return j(f.getValue(), "HTML") || f.match((T) => T.type === "TemplateLiteral", (T, D) => T.type === "TaggedTemplateExpression" && T.tag.type === "Identifier" && T.tag.name === "html" && D === "quasi");
        }
        function J(f) {
          let { quasis: T } = f;
          return T.some((D) => {
            let { value: { cooked: F } } = D;
            return F === null;
          });
        }
        l.exports = h;
      } }), ls = X({ "src/language-js/clean.js"(u, l) {
        H();
        var t = Wt(), s = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a = (n) => {
          for (let r of n.quasis)
            delete r.value;
        };
        function e(n, r, o) {
          if (n.type === "Program" && delete r.sourceType, (n.type === "BigIntLiteral" || n.type === "BigIntLiteralTypeAnnotation") && r.value && (r.value = r.value.toLowerCase()), (n.type === "BigIntLiteral" || n.type === "Literal") && r.bigint && (r.bigint = r.bigint.toLowerCase()), n.type === "DecimalLiteral" && (r.value = Number(r.value)), n.type === "Literal" && r.decimal && (r.decimal = Number(r.decimal)), n.type === "EmptyStatement" || n.type === "JSXText" || n.type === "JSXExpressionContainer" && (n.expression.type === "Literal" || n.expression.type === "StringLiteral") && n.expression.value === " ")
            return null;
          if ((n.type === "Property" || n.type === "ObjectProperty" || n.type === "MethodDefinition" || n.type === "ClassProperty" || n.type === "ClassMethod" || n.type === "PropertyDefinition" || n.type === "TSDeclareMethod" || n.type === "TSPropertySignature" || n.type === "ObjectTypeProperty") && typeof n.key == "object" && n.key && (n.key.type === "Literal" || n.key.type === "NumericLiteral" || n.key.type === "StringLiteral" || n.key.type === "Identifier") && delete r.key, n.type === "JSXElement" && n.openingElement.name.name === "style" && n.openingElement.attributes.some((m) => m.name.name === "jsx"))
            for (let { type: m, expression: y } of r.children)
              m === "JSXExpressionContainer" && y.type === "TemplateLiteral" && a(y);
          n.type === "JSXAttribute" && n.name.name === "css" && n.value.type === "JSXExpressionContainer" && n.value.expression.type === "TemplateLiteral" && a(r.value.expression), n.type === "JSXAttribute" && n.value && n.value.type === "Literal" && /["']|&quot;|&apos;/.test(n.value.value) && (r.value.value = r.value.value.replace(/["']|&quot;|&apos;/g, '"'));
          let c = n.expression || n.callee;
          if (n.type === "Decorator" && c.type === "CallExpression" && c.callee.name === "Component" && c.arguments.length === 1) {
            let m = n.expression.arguments[0].properties;
            for (let [y, p] of r.expression.arguments[0].properties.entries())
              switch (m[y].key.name) {
                case "styles":
                  p.value.type === "ArrayExpression" && a(p.value.elements[0]);
                  break;
                case "template":
                  p.value.type === "TemplateLiteral" && a(p.value);
                  break;
              }
          }
          if (n.type === "TaggedTemplateExpression" && (n.tag.type === "MemberExpression" || n.tag.type === "Identifier" && (n.tag.name === "gql" || n.tag.name === "graphql" || n.tag.name === "css" || n.tag.name === "md" || n.tag.name === "markdown" || n.tag.name === "html") || n.tag.type === "CallExpression") && a(r.quasi), n.type === "TemplateLiteral") {
            var h;
            (!((h = n.leadingComments) === null || h === void 0) && h.some((m) => t(m) && ["GraphQL", "HTML"].some((y) => m.value === ` ${y} `)) || o.type === "CallExpression" && o.callee.name === "graphql" || !n.leadingComments) && a(r);
          }
          if (n.type === "InterpreterDirective" && (r.value = r.value.trimEnd()), (n.type === "TSIntersectionType" || n.type === "TSUnionType") && n.types.length === 1)
            return r.types[0];
        }
        e.ignoredProperties = s, l.exports = e;
      } }), mu = {};
      Ke(mu, { EOL: () => or, arch: () => ps, cpus: () => Au, default: () => Tu, endianness: () => gu, freemem: () => Cu, getNetworkInterfaces: () => Su, hostname: () => yu, loadavg: () => hu, networkInterfaces: () => bu, platform: () => cs, release: () => xu, tmpDir: () => ar, tmpdir: () => sr, totalmem: () => Fu, type: () => vu, uptime: () => Eu });
      function gu() {
        if (typeof kn > "u") {
          var u = new ArrayBuffer(2), l = new Uint8Array(u), t = new Uint16Array(u);
          if (l[0] = 1, l[1] = 2, t[0] === 258)
            kn = "BE";
          else if (t[0] === 513)
            kn = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return kn;
      }
      function yu() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function hu() {
        return [];
      }
      function Eu() {
        return 0;
      }
      function Cu() {
        return Number.MAX_VALUE;
      }
      function Fu() {
        return Number.MAX_VALUE;
      }
      function Au() {
        return [];
      }
      function vu() {
        return "Browser";
      }
      function xu() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function bu() {
      }
      function Su() {
      }
      function ps() {
        return "javascript";
      }
      function cs() {
        return "browser";
      }
      function ar() {
        return "/tmp";
      }
      var kn, sr, or, Tu, ds = Je({ "node-modules-polyfills:os"() {
        H(), sr = ar, or = `
`, Tu = { EOL: or, tmpdir: sr, tmpDir: ar, networkInterfaces: bu, getNetworkInterfaces: Su, release: xu, type: vu, cpus: Au, totalmem: Fu, freemem: Cu, uptime: Eu, loadavg: hu, hostname: yu, endianness: gu };
      } }), Ds = X({ "node-modules-polyfills-commonjs:os"(u, l) {
        H();
        var t = (ds(), lt(mu));
        if (t && t.default) {
          l.exports = t.default;
          for (let s in t)
            l.exports[s] = t[s];
        } else
          t && (l.exports = t);
      } }), fs = X({ "node_modules/detect-newline/index.js"(u, l) {
        H();
        var t = (s) => {
          if (typeof s != "string")
            throw new TypeError("Expected a string");
          let a = s.match(/(?:\r?\n)/g) || [];
          if (a.length === 0)
            return;
          let e = a.filter((r) => r === `\r
`).length, n = a.length - e;
          return e > n ? `\r
` : `
`;
        };
        l.exports = t, l.exports.graceful = (s) => typeof s == "string" && t(s) || `
`;
      } }), ms = X({ "node_modules/jest-docblock/build/index.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.extract = p, u.parse = C, u.parseWithComments = w, u.print = P, u.strip = d;
        function l() {
          let N = Ds();
          return l = function() {
            return N;
          }, N;
        }
        function t() {
          let N = s(fs());
          return t = function() {
            return N;
          }, N;
        }
        function s(N) {
          return N && N.__esModule ? N : { default: N };
        }
        var a = /\*\/$/, e = /^\/\*\*?/, n = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, r = /(^|\s+)\/\/([^\r\n]*)/g, o = /^(\r?\n)+/, c = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, h = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, m = /(\r?\n|^) *\* ?/g, y = [];
        function p(N) {
          let S = N.match(n);
          return S ? S[0].trimLeft() : "";
        }
        function d(N) {
          let S = N.match(n);
          return S && S[0] ? N.substring(S[0].length) : N;
        }
        function C(N) {
          return w(N).pragmas;
        }
        function w(N) {
          let S = (0, t().default)(N) || l().EOL;
          N = N.replace(e, "").replace(a, "").replace(m, "$1");
          let j = "";
          for (; j !== N; )
            j = N, N = N.replace(c, `${S}$1 $2${S}`);
          N = N.replace(o, "").trimRight();
          let k = /* @__PURE__ */ Object.create(null), J = N.replace(h, "").replace(o, "").trimRight(), f;
          for (; f = h.exec(N); ) {
            let T = f[2].replace(r, "");
            typeof k[f[1]] == "string" || Array.isArray(k[f[1]]) ? k[f[1]] = y.concat(k[f[1]], T) : k[f[1]] = T;
          }
          return { comments: J, pragmas: k };
        }
        function P(N) {
          let { comments: S = "", pragmas: j = {} } = N, k = (0, t().default)(S) || l().EOL, J = "/**", f = " *", T = " */", D = Object.keys(j), F = D.map((g) => A(g, j[g])).reduce((g, E) => g.concat(E), []).map((g) => `${f} ${g}${k}`).join("");
          if (!S) {
            if (D.length === 0)
              return "";
            if (D.length === 1 && !Array.isArray(j[D[0]])) {
              let g = j[D[0]];
              return `${J} ${A(D[0], g)[0]}${T}`;
            }
          }
          let i = S.split(k).map((g) => `${f} ${g}`).join(k) + k;
          return J + k + (S ? i : "") + (S && D.length ? f + k : "") + F + T;
        }
        function A(N, S) {
          return y.concat(S).map((j) => `@${N} ${j}`.trim());
        }
      } }), gs = X({ "src/language-js/utils/get-shebang.js"(u, l) {
        H();
        function t(s) {
          if (!s.startsWith("#!"))
            return "";
          let a = s.indexOf(`
`);
          return a === -1 ? s : s.slice(0, a);
        }
        l.exports = t;
      } }), Bu = X({ "src/language-js/pragma.js"(u, l) {
        H();
        var { parseWithComments: t, strip: s, extract: a, print: e } = ms(), { normalizeEndOfLine: n } = $t(), r = gs();
        function o(m) {
          let y = r(m);
          y && (m = m.slice(y.length + 1));
          let p = a(m), { pragmas: d, comments: C } = t(p);
          return { shebang: y, text: m, pragmas: d, comments: C };
        }
        function c(m) {
          let y = Object.keys(o(m).pragmas);
          return y.includes("prettier") || y.includes("format");
        }
        function h(m) {
          let { shebang: y, text: p, pragmas: d, comments: C } = o(m), w = s(p), P = e({ pragmas: Object.assign({ format: "" }, d), comments: C.trimStart() });
          return (y ? `${y}
` : "") + n(P) + (w.startsWith(`
`) ? `
` : `

`) + w;
        }
        l.exports = { hasPragma: c, insertPragma: h };
      } }), ys = X({ "src/language-js/utils/is-type-cast-comment.js"(u, l) {
        H();
        var t = Wt();
        function s(a) {
          return t(a) && a.value[0] === "*" && /@(?:type|satisfies)\b/.test(a.value);
        }
        l.exports = s;
      } }), wu = X({ "src/language-js/comments.js"(u, l) {
        H();
        var { getLast: t, hasNewline: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a, getNextNonSpaceNonCommentCharacter: e, hasNewlineInRange: n, addLeadingComment: r, addTrailingComment: o, addDanglingComment: c, getNextNonSpaceNonCommentCharacterIndex: h, isNonEmptyArray: m } = at(), { getFunctionParameters: y, isPrettierIgnoreComment: p, isJsxNode: d, hasFlowShorthandAnnotationComment: C, hasFlowAnnotationComment: w, hasIgnoreComment: P, isCallLikeExpression: A, getCallArguments: N, isCallExpression: S, isMemberExpression: j, isObjectProperty: k, isLineComment: J, getComments: f, CommentCheckFlags: T, markerForIfWithoutBlockAndSameLineComment: D } = Dt(), { locStart: F, locEnd: i } = vt(), g = Wt(), E = ys();
        function x(ye) {
          return [G, we, ee, $, U, L, ie, ve, re, Fe, Re, tt, ge, Q, W].some((v) => v(ye));
        }
        function b(ye) {
          return [V, we, R, Re, $, U, L, ie, Q, ne, he, Fe, Ge, W, K].some((v) => v(ye));
        }
        function B(ye) {
          return [G, $, U, O, fe, ge, Fe, De, z, me, W, le].some((v) => v(ye));
        }
        function I(ye, v) {
          let Y = (ye.body || ye.properties).find((ae) => {
            let { type: Ae } = ae;
            return Ae !== "EmptyStatement";
          });
          Y ? r(Y, v) : c(ye, v);
        }
        function M(ye, v) {
          ye.type === "BlockStatement" ? I(ye, v) : r(ye, v);
        }
        function V(ye) {
          let { comment: v, followingNode: Y } = ye;
          return Y && E(v) ? (r(Y, v), !0) : !1;
        }
        function $(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae, text: Se } = ye;
          if ((ae == null ? void 0 : ae.type) !== "IfStatement" || !Ae)
            return !1;
          if (e(Se, v, i) === ")")
            return o(Y, v), !0;
          if (Y === ae.consequent && Ae === ae.alternate) {
            if (Y.type === "BlockStatement")
              o(Y, v);
            else {
              let Me = v.type === "SingleLine" || v.loc.start.line === v.loc.end.line, xe = v.loc.start.line === Y.loc.start.line;
              Me && xe ? c(Y, v, D) : c(ae, v);
            }
            return !0;
          }
          return Ae.type === "BlockStatement" ? (I(Ae, v), !0) : Ae.type === "IfStatement" ? (M(Ae.consequent, v), !0) : ae.consequent === Ae ? (r(Ae, v), !0) : !1;
        }
        function U(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae, text: Se } = ye;
          return (ae == null ? void 0 : ae.type) !== "WhileStatement" || !Ae ? !1 : e(Se, v, i) === ")" ? (o(Y, v), !0) : Ae.type === "BlockStatement" ? (I(Ae, v), !0) : ae.body === Ae ? (r(Ae, v), !0) : !1;
        }
        function L(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae } = ye;
          return (ae == null ? void 0 : ae.type) !== "TryStatement" && (ae == null ? void 0 : ae.type) !== "CatchClause" || !Ae ? !1 : ae.type === "CatchClause" && Y ? (o(Y, v), !0) : Ae.type === "BlockStatement" ? (I(Ae, v), !0) : Ae.type === "TryStatement" ? (M(Ae.finalizer, v), !0) : Ae.type === "CatchClause" ? (M(Ae.body, v), !0) : !1;
        }
        function ee(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae } = ye;
          return j(Y) && (ae == null ? void 0 : ae.type) === "Identifier" ? (r(Y, v), !0) : !1;
        }
        function R(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae, text: Se } = ye, Me = Y && !n(Se, i(Y), F(v));
          return (!Y || !Me) && ((ae == null ? void 0 : ae.type) === "ConditionalExpression" || (ae == null ? void 0 : ae.type) === "TSConditionalType") && Ae ? (r(Ae, v), !0) : !1;
        }
        function O(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae } = ye;
          return k(ae) && ae.shorthand && ae.key === Y && ae.value.type === "AssignmentPattern" ? (o(ae.value.left, v), !0) : !1;
        }
        var Z = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
        function ie(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae } = ye;
          if (Z.has(ae == null ? void 0 : ae.type)) {
            if (m(ae.decorators) && !(Ae && Ae.type === "Decorator"))
              return o(t(ae.decorators), v), !0;
            if (ae.body && Ae === ae.body)
              return I(ae.body, v), !0;
            if (Ae) {
              if (ae.superClass && Ae === ae.superClass && Y && (Y === ae.id || Y === ae.typeParameters))
                return o(Y, v), !0;
              for (let Se of ["implements", "extends", "mixins"])
                if (ae[Se] && Ae === ae[Se][0])
                  return Y && (Y === ae.id || Y === ae.typeParameters || Y === ae.superClass) ? o(Y, v) : c(ae, v, Se), !0;
            }
          }
          return !1;
        }
        var te = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty"]);
        function ge(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, text: Ae } = ye;
          return ae && Y && e(Ae, v, i) === "(" && (ae.type === "Property" || ae.type === "TSDeclareMethod" || ae.type === "TSAbstractMethodDefinition") && Y.type === "Identifier" && ae.key === Y && e(Ae, Y, i) !== ":" || (Y == null ? void 0 : Y.type) === "Decorator" && te.has(ae == null ? void 0 : ae.type) ? (o(Y, v), !0) : !1;
        }
        var q = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
        function z(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, text: Ae } = ye;
          return e(Ae, v, i) !== "(" ? !1 : Y && q.has(ae == null ? void 0 : ae.type) ? (o(Y, v), !0) : !1;
        }
        function De(ye) {
          let { comment: v, enclosingNode: Y, text: ae } = ye;
          if ((Y == null ? void 0 : Y.type) !== "ArrowFunctionExpression")
            return !1;
          let Ae = h(ae, v, i);
          return Ae !== !1 && ae.slice(Ae, Ae + 2) === "=>" ? (c(Y, v), !0) : !1;
        }
        function fe(ye) {
          let { comment: v, enclosingNode: Y, text: ae } = ye;
          return e(ae, v, i) !== ")" ? !1 : Y && (de(Y) && y(Y).length === 0 || A(Y) && N(Y).length === 0) ? (c(Y, v), !0) : ((Y == null ? void 0 : Y.type) === "MethodDefinition" || (Y == null ? void 0 : Y.type) === "TSAbstractMethodDefinition") && y(Y.value).length === 0 ? (c(Y.value, v), !0) : !1;
        }
        function we(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae, text: Se } = ye;
          if ((Y == null ? void 0 : Y.type) === "FunctionTypeParam" && (ae == null ? void 0 : ae.type) === "FunctionTypeAnnotation" && (Ae == null ? void 0 : Ae.type) !== "FunctionTypeParam" || ((Y == null ? void 0 : Y.type) === "Identifier" || (Y == null ? void 0 : Y.type) === "AssignmentPattern") && ae && de(ae) && e(Se, v, i) === ")")
            return o(Y, v), !0;
          if ((ae == null ? void 0 : ae.type) === "FunctionDeclaration" && (Ae == null ? void 0 : Ae.type) === "BlockStatement") {
            let Me = (() => {
              let xe = y(ae);
              if (xe.length > 0)
                return a(Se, i(t(xe)));
              let mt = a(Se, i(ae.id));
              return mt !== !1 && a(Se, mt + 1);
            })();
            if (F(v) > Me)
              return I(Ae, v), !0;
          }
          return !1;
        }
        function Q(ye) {
          let { comment: v, enclosingNode: Y } = ye;
          return (Y == null ? void 0 : Y.type) === "LabeledStatement" ? (r(Y, v), !0) : !1;
        }
        function W(ye) {
          let { comment: v, enclosingNode: Y } = ye;
          return ((Y == null ? void 0 : Y.type) === "ContinueStatement" || (Y == null ? void 0 : Y.type) === "BreakStatement") && !Y.label ? (o(Y, v), !0) : !1;
        }
        function ne(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae } = ye;
          return S(ae) && Y && ae.callee === Y && ae.arguments.length > 0 ? (r(ae.arguments[0], v), !0) : !1;
        }
        function re(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae } = ye;
          return (ae == null ? void 0 : ae.type) === "UnionTypeAnnotation" || (ae == null ? void 0 : ae.type) === "TSUnionType" ? (p(v) && (Ae.prettierIgnore = !0, v.unignore = !0), Y ? (o(Y, v), !0) : !1) : (((Ae == null ? void 0 : Ae.type) === "UnionTypeAnnotation" || (Ae == null ? void 0 : Ae.type) === "TSUnionType") && p(v) && (Ae.types[0].prettierIgnore = !0, v.unignore = !0), !1);
        }
        function he(ye) {
          let { comment: v, enclosingNode: Y } = ye;
          return k(Y) ? (r(Y, v), !0) : !1;
        }
        function Fe(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae, ast: Ae, isLastComment: Se } = ye;
          return Ae && Ae.body && Ae.body.length === 0 ? (Se ? c(Ae, v) : r(Ae, v), !0) : (Y == null ? void 0 : Y.type) === "Program" && (Y == null ? void 0 : Y.body.length) === 0 && !m(Y.directives) ? (Se ? c(Y, v) : r(Y, v), !0) : (ae == null ? void 0 : ae.type) === "Program" && (ae == null ? void 0 : ae.body.length) === 0 && (Y == null ? void 0 : Y.type) === "ModuleExpression" ? (c(ae, v), !0) : !1;
        }
        function ve(ye) {
          let { comment: v, enclosingNode: Y } = ye;
          return (Y == null ? void 0 : Y.type) === "ForInStatement" || (Y == null ? void 0 : Y.type) === "ForOfStatement" ? (r(Y, v), !0) : !1;
        }
        function Re(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, text: Ae } = ye;
          if ((ae == null ? void 0 : ae.type) === "ImportSpecifier" || (ae == null ? void 0 : ae.type) === "ExportSpecifier")
            return r(ae, v), !0;
          let Se = (Y == null ? void 0 : Y.type) === "ImportSpecifier" && (ae == null ? void 0 : ae.type) === "ImportDeclaration", Me = (Y == null ? void 0 : Y.type) === "ExportSpecifier" && (ae == null ? void 0 : ae.type) === "ExportNamedDeclaration";
          return (Se || Me) && s(Ae, i(v)) ? (o(Y, v), !0) : !1;
        }
        function tt(ye) {
          let { comment: v, enclosingNode: Y } = ye;
          return (Y == null ? void 0 : Y.type) === "AssignmentPattern" ? (r(Y, v), !0) : !1;
        }
        var Ze = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), $e = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
        function Ge(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae } = ye;
          return Ze.has(Y == null ? void 0 : Y.type) && ae && ($e.has(ae.type) || g(v)) ? (r(ae, v), !0) : !1;
        }
        function le(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae, text: Ae } = ye;
          return !ae && ((Y == null ? void 0 : Y.type) === "TSMethodSignature" || (Y == null ? void 0 : Y.type) === "TSDeclareFunction" || (Y == null ? void 0 : Y.type) === "TSAbstractMethodDefinition") && e(Ae, v, i) === ";" ? (o(Y, v), !0) : !1;
        }
        function G(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae } = ye;
          if (p(v) && (Y == null ? void 0 : Y.type) === "TSMappedType" && (ae == null ? void 0 : ae.type) === "TSTypeParameter" && ae.constraint)
            return Y.prettierIgnore = !0, v.unignore = !0, !0;
        }
        function me(ye) {
          let { comment: v, precedingNode: Y, enclosingNode: ae, followingNode: Ae } = ye;
          return (ae == null ? void 0 : ae.type) !== "TSMappedType" ? !1 : (Ae == null ? void 0 : Ae.type) === "TSTypeParameter" && Ae.name ? (r(Ae.name, v), !0) : (Y == null ? void 0 : Y.type) === "TSTypeParameter" && Y.constraint ? (o(Y.constraint, v), !0) : !1;
        }
        function K(ye) {
          let { comment: v, enclosingNode: Y, followingNode: ae } = ye;
          return !Y || Y.type !== "SwitchCase" || Y.test || !ae || ae !== Y.consequent[0] ? !1 : (ae.type === "BlockStatement" && J(v) ? I(ae, v) : c(Y, v), !0);
        }
        function de(ye) {
          return ye.type === "ArrowFunctionExpression" || ye.type === "FunctionExpression" || ye.type === "FunctionDeclaration" || ye.type === "ObjectMethod" || ye.type === "ClassMethod" || ye.type === "TSDeclareFunction" || ye.type === "TSCallSignatureDeclaration" || ye.type === "TSConstructSignatureDeclaration" || ye.type === "TSMethodSignature" || ye.type === "TSConstructorType" || ye.type === "TSFunctionType" || ye.type === "TSDeclareMethod";
        }
        function je(ye, v) {
          if ((v.parser === "typescript" || v.parser === "flow" || v.parser === "acorn" || v.parser === "espree" || v.parser === "meriyah" || v.parser === "__babel_estree") && ye.type === "MethodDefinition" && ye.value && ye.value.type === "FunctionExpression" && y(ye.value).length === 0 && !ye.value.returnType && !m(ye.value.typeParameters) && ye.value.body)
            return [...ye.decorators || [], ye.key, ye.value.body];
        }
        function Be(ye) {
          let v = ye.getValue(), Y = ye.getParentNode(), ae = (Ae) => w(f(Ae, T.Leading)) || w(f(Ae, T.Trailing));
          return (v && (d(v) || C(v) || S(Y) && ae(v)) || Y && (Y.type === "JSXSpreadAttribute" || Y.type === "JSXSpreadChild" || Y.type === "UnionTypeAnnotation" || Y.type === "TSUnionType" || (Y.type === "ClassDeclaration" || Y.type === "ClassExpression") && Y.superClass === v)) && (!P(ye) || Y.type === "UnionTypeAnnotation" || Y.type === "TSUnionType");
        }
        l.exports = { handleOwnLineComment: x, handleEndOfLineComment: b, handleRemainingComment: B, getCommentChildNodes: je, willPrintOwnComments: Be };
      } }), Zt = X({ "src/language-js/needs-parens.js"(u, l) {
        H();
        var t = Ct(), s = Qn(), { getFunctionParameters: a, getLeftSidePathName: e, hasFlowShorthandAnnotationComment: n, hasNakedLeftSide: r, hasNode: o, isBitwiseOperator: c, startsWithNoLookaheadToken: h, shouldFlatten: m, getPrecedence: y, isCallExpression: p, isMemberExpression: d, isObjectProperty: C, isTSTypeExpression: w } = Dt();
        function P(f, T) {
          let D = f.getParentNode();
          if (!D)
            return !1;
          let F = f.getName(), i = f.getNode();
          if (T.__isInHtmlInterpolation && !T.bracketSpacing && j(i) && k(f))
            return !0;
          if (A(i))
            return !1;
          if (T.parser !== "flow" && n(f.getValue()))
            return !0;
          if (i.type === "Identifier") {
            if (i.extra && i.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(i.name) || F === "left" && (i.name === "async" && !D.await || i.name === "let") && D.type === "ForOfStatement")
              return !0;
            if (i.name === "let") {
              var g;
              let x = (g = f.findAncestor((b) => b.type === "ForOfStatement")) === null || g === void 0 ? void 0 : g.left;
              if (x && h(x, (b) => b === i))
                return !0;
            }
            if (F === "object" && i.name === "let" && D.type === "MemberExpression" && D.computed && !D.optional) {
              let x = f.findAncestor((B) => B.type === "ExpressionStatement" || B.type === "ForStatement" || B.type === "ForInStatement"), b = x ? x.type === "ExpressionStatement" ? x.expression : x.type === "ForStatement" ? x.init : x.left : void 0;
              if (b && h(b, (B) => B === i))
                return !0;
            }
            return !1;
          }
          if (i.type === "ObjectExpression" || i.type === "FunctionExpression" || i.type === "ClassExpression" || i.type === "DoExpression") {
            var E;
            let x = (E = f.findAncestor((b) => b.type === "ExpressionStatement")) === null || E === void 0 ? void 0 : E.expression;
            if (x && h(x, (b) => b === i))
              return !0;
          }
          switch (D.type) {
            case "ParenthesizedExpression":
              return !1;
            case "ClassDeclaration":
            case "ClassExpression": {
              if (F === "superClass" && (i.type === "ArrowFunctionExpression" || i.type === "AssignmentExpression" || i.type === "AwaitExpression" || i.type === "BinaryExpression" || i.type === "ConditionalExpression" || i.type === "LogicalExpression" || i.type === "NewExpression" || i.type === "ObjectExpression" || i.type === "SequenceExpression" || i.type === "TaggedTemplateExpression" || i.type === "UnaryExpression" || i.type === "UpdateExpression" || i.type === "YieldExpression" || i.type === "TSNonNullExpression"))
                return !0;
              break;
            }
            case "ExportDefaultDeclaration":
              return J(f, T) || i.type === "SequenceExpression";
            case "Decorator": {
              if (F === "expression") {
                if (d(i) && i.computed)
                  return !0;
                let x = !1, b = !1, B = i;
                for (; B; )
                  switch (B.type) {
                    case "MemberExpression":
                      b = !0, B = B.object;
                      break;
                    case "CallExpression":
                      if (b || x)
                        return T.parser !== "typescript";
                      x = !0, B = B.callee;
                      break;
                    case "Identifier":
                      return !1;
                    case "TaggedTemplateExpression":
                      return T.parser !== "typescript";
                    default:
                      return !0;
                  }
                return !0;
              }
              break;
            }
            case "ArrowFunctionExpression": {
              if (F === "body" && i.type !== "SequenceExpression" && h(i, (x) => x.type === "ObjectExpression"))
                return !0;
              break;
            }
          }
          switch (i.type) {
            case "UpdateExpression":
              if (D.type === "UnaryExpression")
                return i.prefix && (i.operator === "++" && D.operator === "+" || i.operator === "--" && D.operator === "-");
            case "UnaryExpression":
              switch (D.type) {
                case "UnaryExpression":
                  return i.operator === D.operator && (i.operator === "+" || i.operator === "-");
                case "BindExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F === "object";
                case "TaggedTemplateExpression":
                  return !0;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "BinaryExpression":
                  return F === "left" && D.operator === "**";
                case "TSNonNullExpression":
                  return !0;
                default:
                  return !1;
              }
            case "BinaryExpression": {
              if (D.type === "UpdateExpression" || i.operator === "in" && N(f))
                return !0;
              if (i.operator === "|>" && i.extra && i.extra.parenthesized) {
                let x = f.getParentNode(1);
                if (x.type === "BinaryExpression" && x.operator === "|>")
                  return !0;
              }
            }
            case "TSTypeAssertion":
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "LogicalExpression":
              switch (D.type) {
                case "TSSatisfiesExpression":
                case "TSAsExpression":
                  return !w(i);
                case "ConditionalExpression":
                  return w(i);
                case "CallExpression":
                case "NewExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "ClassExpression":
                case "ClassDeclaration":
                  return F === "superClass";
                case "TSTypeAssertion":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "JSXSpreadAttribute":
                case "SpreadElement":
                case "SpreadProperty":
                case "BindExpression":
                case "AwaitExpression":
                case "TSNonNullExpression":
                case "UpdateExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F === "object";
                case "AssignmentExpression":
                case "AssignmentPattern":
                  return F === "left" && (i.type === "TSTypeAssertion" || w(i));
                case "LogicalExpression":
                  if (i.type === "LogicalExpression")
                    return D.operator !== i.operator;
                case "BinaryExpression": {
                  let { operator: x, type: b } = i;
                  if (!x && b !== "TSTypeAssertion")
                    return !0;
                  let B = y(x), I = D.operator, M = y(I);
                  return M > B || F === "right" && M === B || M === B && !m(I, x) ? !0 : M < B && x === "%" ? I === "+" || I === "-" : !!c(I);
                }
                default:
                  return !1;
              }
            case "SequenceExpression":
              switch (D.type) {
                case "ReturnStatement":
                  return !1;
                case "ForStatement":
                  return !1;
                case "ExpressionStatement":
                  return F !== "expression";
                case "ArrowFunctionExpression":
                  return F !== "body";
                default:
                  return !0;
              }
            case "YieldExpression":
              if (D.type === "UnaryExpression" || D.type === "AwaitExpression" || w(D) || D.type === "TSNonNullExpression")
                return !0;
            case "AwaitExpression":
              switch (D.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                  return !0;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F === "object";
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "ConditionalExpression":
                  return F === "test";
                case "BinaryExpression":
                  return !(!i.argument && D.operator === "|>");
                default:
                  return !1;
              }
            case "TSConditionalType":
            case "TSFunctionType":
            case "TSConstructorType":
              if (F === "extendsType" && D.type === "TSConditionalType") {
                if (i.type === "TSConditionalType")
                  return !0;
                let { typeAnnotation: x } = i.returnType || i.typeAnnotation;
                if (x.type === "TSTypePredicate" && x.typeAnnotation && (x = x.typeAnnotation.typeAnnotation), x.type === "TSInferType" && x.typeParameter.constraint)
                  return !0;
              }
              if (F === "checkType" && D.type === "TSConditionalType")
                return !0;
            case "TSUnionType":
            case "TSIntersectionType":
              if ((D.type === "TSUnionType" || D.type === "TSIntersectionType") && D.types.length > 1 && (!i.types || i.types.length > 1))
                return !0;
            case "TSInferType":
              if (i.type === "TSInferType" && D.type === "TSRestType")
                return !1;
            case "TSTypeOperator":
              return D.type === "TSArrayType" || D.type === "TSOptionalType" || D.type === "TSRestType" || F === "objectType" && D.type === "TSIndexedAccessType" || D.type === "TSTypeOperator" || D.type === "TSTypeAnnotation" && f.getParentNode(1).type.startsWith("TSJSDoc");
            case "TSTypeQuery":
              return F === "objectType" && D.type === "TSIndexedAccessType" || F === "elementType" && D.type === "TSArrayType";
            case "TypeofTypeAnnotation":
              return F === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType") || F === "elementType" && D.type === "ArrayTypeAnnotation";
            case "ArrayTypeAnnotation":
              return D.type === "NullableTypeAnnotation";
            case "IntersectionTypeAnnotation":
            case "UnionTypeAnnotation":
              return D.type === "ArrayTypeAnnotation" || D.type === "NullableTypeAnnotation" || D.type === "IntersectionTypeAnnotation" || D.type === "UnionTypeAnnotation" || F === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType");
            case "NullableTypeAnnotation":
              return D.type === "ArrayTypeAnnotation" || F === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType");
            case "FunctionTypeAnnotation": {
              let x = D.type === "NullableTypeAnnotation" ? f.getParentNode(1) : D;
              return x.type === "UnionTypeAnnotation" || x.type === "IntersectionTypeAnnotation" || x.type === "ArrayTypeAnnotation" || F === "objectType" && (x.type === "IndexedAccessType" || x.type === "OptionalIndexedAccessType") || x.type === "NullableTypeAnnotation" || D.type === "FunctionTypeParam" && D.name === null && a(i).some((b) => b.typeAnnotation && b.typeAnnotation.type === "NullableTypeAnnotation");
            }
            case "OptionalIndexedAccessType":
              return F === "objectType" && D.type === "IndexedAccessType";
            case "StringLiteral":
            case "NumericLiteral":
            case "Literal":
              if (typeof i.value == "string" && D.type === "ExpressionStatement" && !D.directive) {
                let x = f.getParentNode(1);
                return x.type === "Program" || x.type === "BlockStatement";
              }
              return F === "object" && D.type === "MemberExpression" && typeof i.value == "number";
            case "AssignmentExpression": {
              let x = f.getParentNode(1);
              return F === "body" && D.type === "ArrowFunctionExpression" ? !0 : F === "key" && (D.type === "ClassProperty" || D.type === "PropertyDefinition") && D.computed || (F === "init" || F === "update") && D.type === "ForStatement" ? !1 : D.type === "ExpressionStatement" ? i.left.type === "ObjectPattern" : !(F === "key" && D.type === "TSPropertySignature" || D.type === "AssignmentExpression" || D.type === "SequenceExpression" && x && x.type === "ForStatement" && (x.init === D || x.update === D) || F === "value" && D.type === "Property" && x && x.type === "ObjectPattern" && x.properties.includes(D) || D.type === "NGChainedExpression");
            }
            case "ConditionalExpression":
              switch (D.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "BinaryExpression":
                case "LogicalExpression":
                case "NGPipeExpression":
                case "ExportDefaultDeclaration":
                case "AwaitExpression":
                case "JSXSpreadAttribute":
                case "TSTypeAssertion":
                case "TypeCastExpression":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                  return !0;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "ConditionalExpression":
                  return F === "test";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F === "object";
                default:
                  return !1;
              }
            case "FunctionExpression":
              switch (D.type) {
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "TaggedTemplateExpression":
                  return !0;
                default:
                  return !1;
              }
            case "ArrowFunctionExpression":
              switch (D.type) {
                case "BinaryExpression":
                  return D.operator !== "|>" || i.extra && i.extra.parenthesized;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F === "callee";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F === "object";
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "AwaitExpression":
                case "TSTypeAssertion":
                  return !0;
                case "ConditionalExpression":
                  return F === "test";
                default:
                  return !1;
              }
            case "ClassExpression":
              if (s(i.decorators))
                return !0;
              switch (D.type) {
                case "NewExpression":
                  return F === "callee";
                default:
                  return !1;
              }
            case "OptionalMemberExpression":
            case "OptionalCallExpression": {
              let x = f.getParentNode(1);
              if (F === "object" && D.type === "MemberExpression" || F === "callee" && (D.type === "CallExpression" || D.type === "NewExpression") || D.type === "TSNonNullExpression" && x.type === "MemberExpression" && x.object === D)
                return !0;
            }
            case "CallExpression":
            case "MemberExpression":
            case "TaggedTemplateExpression":
            case "TSNonNullExpression":
              if (F === "callee" && (D.type === "BindExpression" || D.type === "NewExpression")) {
                let x = i;
                for (; x; )
                  switch (x.type) {
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return !0;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                    case "BindExpression":
                      x = x.object;
                      break;
                    case "TaggedTemplateExpression":
                      x = x.tag;
                      break;
                    case "TSNonNullExpression":
                      x = x.expression;
                      break;
                    default:
                      return !1;
                  }
              }
              return !1;
            case "BindExpression":
              return F === "callee" && (D.type === "BindExpression" || D.type === "NewExpression") || F === "object" && d(D);
            case "NGPipeExpression":
              return !(D.type === "NGRoot" || D.type === "NGMicrosyntaxExpression" || D.type === "ObjectProperty" && !(i.extra && i.extra.parenthesized) || D.type === "ArrayExpression" || p(D) && D.arguments[F] === i || F === "right" && D.type === "NGPipeExpression" || F === "property" && D.type === "MemberExpression" || D.type === "AssignmentExpression");
            case "JSXFragment":
            case "JSXElement":
              return F === "callee" || F === "left" && D.type === "BinaryExpression" && D.operator === "<" || D.type !== "ArrayExpression" && D.type !== "ArrowFunctionExpression" && D.type !== "AssignmentExpression" && D.type !== "AssignmentPattern" && D.type !== "BinaryExpression" && D.type !== "NewExpression" && D.type !== "ConditionalExpression" && D.type !== "ExpressionStatement" && D.type !== "JsExpressionRoot" && D.type !== "JSXAttribute" && D.type !== "JSXElement" && D.type !== "JSXExpressionContainer" && D.type !== "JSXFragment" && D.type !== "LogicalExpression" && !p(D) && !C(D) && D.type !== "ReturnStatement" && D.type !== "ThrowStatement" && D.type !== "TypeCastExpression" && D.type !== "VariableDeclarator" && D.type !== "YieldExpression";
            case "TypeAnnotation":
              return F === "returnType" && D.type === "ArrowFunctionExpression" && S(i);
          }
          return !1;
        }
        function A(f) {
          return f.type === "BlockStatement" || f.type === "BreakStatement" || f.type === "ClassBody" || f.type === "ClassDeclaration" || f.type === "ClassMethod" || f.type === "ClassProperty" || f.type === "PropertyDefinition" || f.type === "ClassPrivateProperty" || f.type === "ContinueStatement" || f.type === "DebuggerStatement" || f.type === "DeclareClass" || f.type === "DeclareExportAllDeclaration" || f.type === "DeclareExportDeclaration" || f.type === "DeclareFunction" || f.type === "DeclareInterface" || f.type === "DeclareModule" || f.type === "DeclareModuleExports" || f.type === "DeclareVariable" || f.type === "DoWhileStatement" || f.type === "EnumDeclaration" || f.type === "ExportAllDeclaration" || f.type === "ExportDefaultDeclaration" || f.type === "ExportNamedDeclaration" || f.type === "ExpressionStatement" || f.type === "ForInStatement" || f.type === "ForOfStatement" || f.type === "ForStatement" || f.type === "FunctionDeclaration" || f.type === "IfStatement" || f.type === "ImportDeclaration" || f.type === "InterfaceDeclaration" || f.type === "LabeledStatement" || f.type === "MethodDefinition" || f.type === "ReturnStatement" || f.type === "SwitchStatement" || f.type === "ThrowStatement" || f.type === "TryStatement" || f.type === "TSDeclareFunction" || f.type === "TSEnumDeclaration" || f.type === "TSImportEqualsDeclaration" || f.type === "TSInterfaceDeclaration" || f.type === "TSModuleDeclaration" || f.type === "TSNamespaceExportDeclaration" || f.type === "TypeAlias" || f.type === "VariableDeclaration" || f.type === "WhileStatement" || f.type === "WithStatement";
        }
        function N(f) {
          let T = 0, D = f.getValue();
          for (; D; ) {
            let F = f.getParentNode(T++);
            if (F && F.type === "ForStatement" && F.init === D)
              return !0;
            D = F;
          }
          return !1;
        }
        function S(f) {
          return o(f, (T) => T.type === "ObjectTypeAnnotation" && o(T, (D) => D.type === "FunctionTypeAnnotation" || void 0) || void 0);
        }
        function j(f) {
          switch (f.type) {
            case "ObjectExpression":
              return !0;
            default:
              return !1;
          }
        }
        function k(f) {
          let T = f.getValue(), D = f.getParentNode(), F = f.getName();
          switch (D.type) {
            case "NGPipeExpression":
              if (typeof F == "number" && D.arguments[F] === T && D.arguments.length - 1 === F)
                return f.callParent(k);
              break;
            case "ObjectProperty":
              if (F === "value") {
                let i = f.getParentNode(1);
                return t(i.properties) === D;
              }
              break;
            case "BinaryExpression":
            case "LogicalExpression":
              if (F === "right")
                return f.callParent(k);
              break;
            case "ConditionalExpression":
              if (F === "alternate")
                return f.callParent(k);
              break;
            case "UnaryExpression":
              if (D.prefix)
                return f.callParent(k);
              break;
          }
          return !1;
        }
        function J(f, T) {
          let D = f.getValue(), F = f.getParentNode();
          return D.type === "FunctionExpression" || D.type === "ClassExpression" ? F.type === "ExportDefaultDeclaration" || !P(f, T) : !r(D) || F.type !== "ExportDefaultDeclaration" && P(f, T) ? !1 : f.call((i) => J(i, T), ...e(f, D));
        }
        l.exports = P;
      } }), Nu = X({ "src/language-js/print-preprocess.js"(u, l) {
        H();
        function t(s, a) {
          switch (a.parser) {
            case "json":
            case "json5":
            case "json-stringify":
            case "__js_expression":
            case "__vue_expression":
            case "__vue_ts_expression":
              return Object.assign(Object.assign({}, s), {}, { type: a.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s, comments: [], rootMarker: a.rootMarker });
            default:
              return s;
          }
        }
        l.exports = t;
      } }), hs = X({ "src/language-js/print/html-binding.js"(u, l) {
        H();
        var { builders: { join: t, line: s, group: a, softline: e, indent: n } } = Qe();
        function r(c, h, m) {
          let y = c.getValue();
          if (h.__onHtmlBindingRoot && c.getName() === null && h.__onHtmlBindingRoot(y, h), y.type === "File") {
            if (h.__isVueForBindingLeft)
              return c.call((p) => {
                let d = t([",", s], p.map(m, "params")), { params: C } = p.getValue();
                return C.length === 1 ? d : ["(", n([e, a(d)]), e, ")"];
              }, "program", "body", 0);
            if (h.__isVueBindings)
              return c.call((p) => t([",", s], p.map(m, "params")), "program", "body", 0);
          }
        }
        function o(c) {
          switch (c.type) {
            case "MemberExpression":
              switch (c.property.type) {
                case "Identifier":
                case "NumericLiteral":
                case "StringLiteral":
                  return o(c.object);
              }
              return !1;
            case "Identifier":
              return !0;
            default:
              return !1;
          }
        }
        l.exports = { isVueEventBindingExpression: o, printHtmlBinding: r };
      } }), lr = X({ "src/language-js/print/binaryish.js"(u, l) {
        H();
        var { printComments: t } = ht(), { getLast: s } = at(), { builders: { join: a, line: e, softline: n, group: r, indent: o, align: c, indentIfBreak: h }, utils: { cleanDoc: m, getDocParts: y, isConcat: p } } = Qe(), { hasLeadingOwnLineComment: d, isBinaryish: C, isJsxNode: w, shouldFlatten: P, hasComment: A, CommentCheckFlags: N, isCallExpression: S, isMemberExpression: j, isObjectProperty: k, isEnabledHackPipeline: J } = Dt(), f = 0;
        function T(i, g, E) {
          let x = i.getValue(), b = i.getParentNode(), B = i.getParentNode(1), I = x !== b.body && (b.type === "IfStatement" || b.type === "WhileStatement" || b.type === "SwitchStatement" || b.type === "DoWhileStatement"), M = J(g) && x.operator === "|>", V = D(i, E, g, !1, I);
          if (I)
            return V;
          if (M)
            return r(V);
          if (S(b) && b.callee === x || b.type === "UnaryExpression" || j(b) && !b.computed)
            return r([o([n, ...V]), n]);
          let $ = b.type === "ReturnStatement" || b.type === "ThrowStatement" || b.type === "JSXExpressionContainer" && B.type === "JSXAttribute" || x.operator !== "|" && b.type === "JsExpressionRoot" || x.type !== "NGPipeExpression" && (b.type === "NGRoot" && g.parser === "__ng_binding" || b.type === "NGMicrosyntaxExpression" && B.type === "NGMicrosyntax" && B.body.length === 1) || x === b.body && b.type === "ArrowFunctionExpression" || x !== b.body && b.type === "ForStatement" || b.type === "ConditionalExpression" && B.type !== "ReturnStatement" && B.type !== "ThrowStatement" && !S(B) || b.type === "TemplateLiteral", U = b.type === "AssignmentExpression" || b.type === "VariableDeclarator" || b.type === "ClassProperty" || b.type === "PropertyDefinition" || b.type === "TSAbstractPropertyDefinition" || b.type === "ClassPrivateProperty" || k(b), L = C(x.left) && P(x.operator, x.left.operator);
          if ($ || F(x) && !L || !F(x) && U)
            return r(V);
          if (V.length === 0)
            return "";
          let ee = w(x.right), R = V.findIndex((q) => typeof q != "string" && !Array.isArray(q) && q.type === "group"), O = V.slice(0, R === -1 ? 1 : R + 1), Z = V.slice(O.length, ee ? -1 : void 0), ie = Symbol("logicalChain-" + ++f), te = r([...O, o(Z)], { id: ie });
          if (!ee)
            return te;
          let ge = s(V);
          return r([te, h(ge, { groupId: ie })]);
        }
        function D(i, g, E, x, b) {
          let B = i.getValue();
          if (!C(B))
            return [r(g())];
          let I = [];
          P(B.operator, B.left.operator) ? I = i.call((Z) => D(Z, g, E, !0, b), "left") : I.push(r(g("left")));
          let M = F(B), V = (B.operator === "|>" || B.type === "NGPipeExpression" || B.operator === "|" && E.parser === "__vue_expression") && !d(E.originalText, B.right), $ = B.type === "NGPipeExpression" ? "|" : B.operator, U = B.type === "NGPipeExpression" && B.arguments.length > 0 ? r(o([e, ": ", a([e, ": "], i.map(g, "arguments").map((Z) => c(2, r(Z))))])) : "", L;
          if (M)
            L = [$, " ", g("right"), U];
          else {
            let Z = J(E) && $ === "|>" ? i.call((ie) => D(ie, g, E, !0, b), "right") : g("right");
            L = [V ? e : "", $, V ? " " : e, Z, U];
          }
          let ee = i.getParentNode(), R = A(B.left, N.Trailing | N.Line), O = R || !(b && B.type === "LogicalExpression") && ee.type !== B.type && B.left.type !== B.type && B.right.type !== B.type;
          if (I.push(V ? "" : " ", O ? r(L, { shouldBreak: R }) : L), x && A(B)) {
            let Z = m(t(i, I, E));
            return p(Z) || Z.type === "fill" ? y(Z) : [Z];
          }
          return I;
        }
        function F(i) {
          return i.type !== "LogicalExpression" ? !1 : !!(i.right.type === "ObjectExpression" && i.right.properties.length > 0 || i.right.type === "ArrayExpression" && i.right.elements.length > 0 || w(i.right));
        }
        l.exports = { printBinaryishExpression: T, shouldInlineLogicalExpression: F };
      } }), Es = X({ "src/language-js/print/angular.js"(u, l) {
        H();
        var { builders: { join: t, line: s, group: a } } = Qe(), { hasNode: e, hasComment: n, getComments: r } = Dt(), { printBinaryishExpression: o } = lr();
        function c(y, p, d) {
          let C = y.getValue();
          if (C.type.startsWith("NG"))
            switch (C.type) {
              case "NGRoot":
                return [d("node"), n(C.node) ? " //" + r(C.node)[0].value.trimEnd() : ""];
              case "NGPipeExpression":
                return o(y, p, d);
              case "NGChainedExpression":
                return a(t([";", s], y.map((w) => m(w) ? d() : ["(", d(), ")"], "expressions")));
              case "NGEmptyExpression":
                return "";
              case "NGQuotedExpression":
                return [C.prefix, ": ", C.value.trim()];
              case "NGMicrosyntax":
                return y.map((w, P) => [P === 0 ? "" : h(w.getValue(), P, C) ? " " : [";", s], d()], "body");
              case "NGMicrosyntaxKey":
                return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(C.name) ? C.name : JSON.stringify(C.name);
              case "NGMicrosyntaxExpression":
                return [d("expression"), C.alias === null ? "" : [" as ", d("alias")]];
              case "NGMicrosyntaxKeyedExpression": {
                let w = y.getName(), P = y.getParentNode(), A = h(C, w, P) || (w === 1 && (C.key.name === "then" || C.key.name === "else") || w === 2 && C.key.name === "else" && P.body[w - 1].type === "NGMicrosyntaxKeyedExpression" && P.body[w - 1].key.name === "then") && P.body[0].type === "NGMicrosyntaxExpression";
                return [d("key"), A ? " " : ": ", d("expression")];
              }
              case "NGMicrosyntaxLet":
                return ["let ", d("key"), C.value === null ? "" : [" = ", d("value")]];
              case "NGMicrosyntaxAs":
                return [d("key"), " as ", d("alias")];
              default:
                throw new Error(`Unknown Angular node type: ${JSON.stringify(C.type)}.`);
            }
        }
        function h(y, p, d) {
          return y.type === "NGMicrosyntaxKeyedExpression" && y.key.name === "of" && p === 1 && d.body[0].type === "NGMicrosyntaxLet" && d.body[0].value === null;
        }
        function m(y) {
          return e(y.getValue(), (p) => {
            switch (p.type) {
              case void 0:
                return !1;
              case "CallExpression":
              case "OptionalCallExpression":
              case "AssignmentExpression":
                return !0;
            }
          });
        }
        l.exports = { printAngular: c };
      } }), Cs = X({ "src/language-js/print/jsx.js"(u, l) {
        H();
        var { printComments: t, printDanglingComments: s, printCommentsSeparately: a } = ht(), { builders: { line: e, hardline: n, softline: r, group: o, indent: c, conditionalGroup: h, fill: m, ifBreak: y, lineSuffixBoundary: p, join: d }, utils: { willBreak: C } } = Qe(), { getLast: w, getPreferredQuote: P } = at(), { isJsxNode: A, rawText: N, isCallExpression: S, isStringLiteral: j, isBinaryish: k, hasComment: J, CommentCheckFlags: f, hasNodeIgnoreComment: T } = Dt(), D = Zt(), { willPrintOwnComments: F } = wu(), i = (W) => W === "" || W === e || W === n || W === r;
        function g(W, ne, re) {
          let he = W.getValue();
          if (he.type === "JSXElement" && De(he))
            return [re("openingElement"), re("closingElement")];
          let Fe = he.type === "JSXElement" ? re("openingElement") : re("openingFragment"), ve = he.type === "JSXElement" ? re("closingElement") : re("closingFragment");
          if (he.children.length === 1 && he.children[0].type === "JSXExpressionContainer" && (he.children[0].expression.type === "TemplateLiteral" || he.children[0].expression.type === "TaggedTemplateExpression"))
            return [Fe, ...W.map(re, "children"), ve];
          he.children = he.children.map((v) => we(v) ? { type: "JSXText", value: " ", raw: " " } : v);
          let Re = he.children.some(A), tt = he.children.filter((v) => v.type === "JSXExpressionContainer").length > 1, Ze = he.type === "JSXElement" && he.openingElement.attributes.length > 1, $e = C(Fe) || Re || Ze || tt, Ge = W.getParentNode().rootMarker === "mdx", le = ne.singleQuote ? "{' '}" : '{" "}', G = Ge ? " " : y([le, r], " "), me = he.openingElement && he.openingElement.name && he.openingElement.name.name === "fbt", K = E(W, ne, re, G, me), de = he.children.some((v) => fe(v));
          for (let v = K.length - 2; v >= 0; v--) {
            let Y = K[v] === "" && K[v + 1] === "", ae = K[v] === n && K[v + 1] === "" && K[v + 2] === n, Ae = (K[v] === r || K[v] === n) && K[v + 1] === "" && K[v + 2] === G, Se = K[v] === G && K[v + 1] === "" && (K[v + 2] === r || K[v + 2] === n), Me = K[v] === G && K[v + 1] === "" && K[v + 2] === G, xe = K[v] === r && K[v + 1] === "" && K[v + 2] === n || K[v] === n && K[v + 1] === "" && K[v + 2] === r;
            ae && de || Y || Ae || Me || xe ? K.splice(v, 2) : Se && K.splice(v + 1, 2);
          }
          for (; K.length > 0 && i(w(K)); )
            K.pop();
          for (; K.length > 1 && i(K[0]) && i(K[1]); )
            K.shift(), K.shift();
          let je = [];
          for (let [v, Y] of K.entries()) {
            if (Y === G) {
              if (v === 1 && K[v - 1] === "") {
                if (K.length === 2) {
                  je.push(le);
                  continue;
                }
                je.push([le, n]);
                continue;
              } else if (v === K.length - 1) {
                je.push(le);
                continue;
              } else if (K[v - 1] === "" && K[v - 2] === n) {
                je.push(le);
                continue;
              }
            }
            je.push(Y), C(Y) && ($e = !0);
          }
          let Be = de ? m(je) : o(je, { shouldBreak: !0 });
          if (Ge)
            return Be;
          let ye = o([Fe, c([n, Be]), n, ve]);
          return $e ? ye : h([o([Fe, ...K, ve]), ye]);
        }
        function E(W, ne, re, he, Fe) {
          let ve = [];
          return W.each((Re, tt, Ze) => {
            let $e = Re.getValue();
            if ($e.type === "JSXText") {
              let Ge = N($e);
              if (fe($e)) {
                let le = Ge.split(ge);
                if (le[0] === "") {
                  if (ve.push(""), le.shift(), /\n/.test(le[0])) {
                    let me = Ze[tt + 1];
                    ve.push(b(Fe, le[1], $e, me));
                  } else
                    ve.push(he);
                  le.shift();
                }
                let G;
                if (w(le) === "" && (le.pop(), G = le.pop()), le.length === 0)
                  return;
                for (let [me, K] of le.entries())
                  me % 2 === 1 ? ve.push(e) : ve.push(K);
                if (G !== void 0)
                  if (/\n/.test(G)) {
                    let me = Ze[tt + 1];
                    ve.push(b(Fe, w(ve), $e, me));
                  } else
                    ve.push(he);
                else {
                  let me = Ze[tt + 1];
                  ve.push(x(Fe, w(ve), $e, me));
                }
              } else
                /\n/.test(Ge) ? Ge.match(/\n/g).length > 1 && ve.push("", n) : ve.push("", he);
            } else {
              let Ge = re();
              ve.push(Ge);
              let le = Ze[tt + 1];
              if (le && fe(le)) {
                let G = z(N(le)).split(ge)[0];
                ve.push(x(Fe, G, $e, le));
              } else
                ve.push(n);
            }
          }, "children"), ve;
        }
        function x(W, ne, re, he) {
          return W ? "" : re.type === "JSXElement" && !re.closingElement || he && he.type === "JSXElement" && !he.closingElement ? ne.length === 1 ? r : n : r;
        }
        function b(W, ne, re, he) {
          return W ? n : ne.length === 1 ? re.type === "JSXElement" && !re.closingElement || he && he.type === "JSXElement" && !he.closingElement ? n : r : n;
        }
        function B(W, ne, re) {
          let he = W.getParentNode();
          if (!he || { ArrayExpression: !0, JSXAttribute: !0, JSXElement: !0, JSXExpressionContainer: !0, JSXFragment: !0, ExpressionStatement: !0, CallExpression: !0, OptionalCallExpression: !0, ConditionalExpression: !0, JsExpressionRoot: !0 }[he.type])
            return ne;
          let Fe = W.match(void 0, (Re) => Re.type === "ArrowFunctionExpression", S, (Re) => Re.type === "JSXExpressionContainer"), ve = D(W, re);
          return o([ve ? "" : y("("), c([r, ne]), r, ve ? "" : y(")")], { shouldBreak: Fe });
        }
        function I(W, ne, re) {
          let he = W.getValue(), Fe = [];
          if (Fe.push(re("name")), he.value) {
            let ve;
            if (j(he.value)) {
              let Re = N(he.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: tt, quote: Ze, regex: $e } = P(Re, ne.jsxSingleQuote ? "'" : '"');
              Re = Re.replace($e, tt);
              let { leading: Ge, trailing: le } = W.call(() => a(W, ne), "value");
              ve = [Ge, Ze, Re, Ze, le];
            } else
              ve = re("value");
            Fe.push("=", ve);
          }
          return Fe;
        }
        function M(W, ne, re) {
          let he = W.getValue(), Fe = (ve, Re) => ve.type === "JSXEmptyExpression" || !J(ve) && (ve.type === "ArrayExpression" || ve.type === "ObjectExpression" || ve.type === "ArrowFunctionExpression" || ve.type === "AwaitExpression" && (Fe(ve.argument, ve) || ve.argument.type === "JSXElement") || S(ve) || ve.type === "FunctionExpression" || ve.type === "TemplateLiteral" || ve.type === "TaggedTemplateExpression" || ve.type === "DoExpression" || A(Re) && (ve.type === "ConditionalExpression" || k(ve)));
          return Fe(he.expression, W.getParentNode(0)) ? o(["{", re("expression"), p, "}"]) : o(["{", c([r, re("expression")]), r, p, "}"]);
        }
        function V(W, ne, re) {
          let he = W.getValue(), Fe = he.name && J(he.name) || he.typeParameters && J(he.typeParameters);
          if (he.selfClosing && he.attributes.length === 0 && !Fe)
            return ["<", re("name"), re("typeParameters"), " />"];
          if (he.attributes && he.attributes.length === 1 && he.attributes[0].value && j(he.attributes[0].value) && !he.attributes[0].value.value.includes(`
`) && !Fe && !J(he.attributes[0]))
            return o(["<", re("name"), re("typeParameters"), " ", ...W.map(re, "attributes"), he.selfClosing ? " />" : ">"]);
          let ve = he.attributes && he.attributes.some((tt) => tt.value && j(tt.value) && tt.value.value.includes(`
`)), Re = ne.singleAttributePerLine && he.attributes.length > 1 ? n : e;
          return o(["<", re("name"), re("typeParameters"), c(W.map(() => [Re, re()], "attributes")), ...$(he, ne, Fe)], { shouldBreak: ve });
        }
        function $(W, ne, re) {
          return W.selfClosing ? [e, "/>"] : U(W, ne, re) ? [">"] : [r, ">"];
        }
        function U(W, ne, re) {
          let he = W.attributes.length > 0 && J(w(W.attributes), f.Trailing);
          return W.attributes.length === 0 && !re || (ne.bracketSameLine || ne.jsxBracketSameLine) && (!re || W.attributes.length > 0) && !he;
        }
        function L(W, ne, re) {
          let he = W.getValue(), Fe = [];
          Fe.push("</");
          let ve = re("name");
          return J(he.name, f.Leading | f.Line) ? Fe.push(c([n, ve]), n) : J(he.name, f.Leading | f.Block) ? Fe.push(" ", ve) : Fe.push(ve), Fe.push(">"), Fe;
        }
        function ee(W, ne) {
          let re = W.getValue(), he = J(re), Fe = J(re, f.Line), ve = re.type === "JSXOpeningFragment";
          return [ve ? "<" : "</", c([Fe ? n : he && !ve ? " " : "", s(W, ne, !0)]), Fe ? n : "", ">"];
        }
        function R(W, ne, re) {
          let he = t(W, g(W, ne, re), ne);
          return B(W, he, ne);
        }
        function O(W, ne) {
          let re = W.getValue(), he = J(re, f.Line);
          return [s(W, ne, !he), he ? n : ""];
        }
        function Z(W, ne, re) {
          let he = W.getValue();
          return ["{", W.call((Fe) => {
            let ve = ["...", re()], Re = Fe.getValue();
            return !J(Re) || !F(Fe) ? ve : [c([r, t(Fe, ve, ne)]), r];
          }, he.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
        }
        function ie(W, ne, re) {
          let he = W.getValue();
          if (he.type.startsWith("JSX"))
            switch (he.type) {
              case "JSXAttribute":
                return I(W, ne, re);
              case "JSXIdentifier":
                return String(he.name);
              case "JSXNamespacedName":
                return d(":", [re("namespace"), re("name")]);
              case "JSXMemberExpression":
                return d(".", [re("object"), re("property")]);
              case "JSXSpreadAttribute":
                return Z(W, ne, re);
              case "JSXSpreadChild":
                return Z(W, ne, re);
              case "JSXExpressionContainer":
                return M(W, ne, re);
              case "JSXFragment":
              case "JSXElement":
                return R(W, ne, re);
              case "JSXOpeningElement":
                return V(W, ne, re);
              case "JSXClosingElement":
                return L(W, ne, re);
              case "JSXOpeningFragment":
              case "JSXClosingFragment":
                return ee(W, ne);
              case "JSXEmptyExpression":
                return O(W, ne);
              case "JSXText":
                throw new Error("JSXText should be handled by JSXElement");
              default:
                throw new Error(`Unknown JSX node type: ${JSON.stringify(he.type)}.`);
            }
        }
        var te = ` 
\r	`, ge = new RegExp("([" + te + "]+)"), q = new RegExp("[^" + te + "]"), z = (W) => W.replace(new RegExp("(?:^" + ge.source + "|" + ge.source + "$)"), "");
        function De(W) {
          if (W.children.length === 0)
            return !0;
          if (W.children.length > 1)
            return !1;
          let ne = W.children[0];
          return ne.type === "JSXText" && !fe(ne);
        }
        function fe(W) {
          return W.type === "JSXText" && (q.test(N(W)) || !/\n/.test(N(W)));
        }
        function we(W) {
          return W.type === "JSXExpressionContainer" && j(W.expression) && W.expression.value === " " && !J(W.expression);
        }
        function Q(W) {
          let ne = W.getValue(), re = W.getParentNode();
          if (!re || !ne || !A(ne) || !A(re))
            return !1;
          let he = re.children.indexOf(ne), Fe = null;
          for (let ve = he; ve > 0; ve--) {
            let Re = re.children[ve - 1];
            if (!(Re.type === "JSXText" && !fe(Re))) {
              Fe = Re;
              break;
            }
          }
          return Fe && Fe.type === "JSXExpressionContainer" && Fe.expression.type === "JSXEmptyExpression" && T(Fe.expression);
        }
        l.exports = { hasJsxIgnoreComment: Q, printJsx: ie };
      } }), Tt = X({ "src/language-js/print/misc.js"(u, l) {
        H();
        var { isNonEmptyArray: t } = at(), { builders: { indent: s, join: a, line: e } } = Qe(), { isFlowAnnotationComment: n } = Dt();
        function r(w) {
          let P = w.getValue();
          return !P.optional || P.type === "Identifier" && P === w.getParentNode().key ? "" : P.type === "OptionalCallExpression" || P.type === "OptionalMemberExpression" && P.computed ? "?." : "?";
        }
        function o(w) {
          return w.getValue().definite || w.match(void 0, (P, A) => A === "id" && P.type === "VariableDeclarator" && P.definite) ? "!" : "";
        }
        function c(w, P, A) {
          let N = w.getValue();
          return N.typeArguments ? A("typeArguments") : N.typeParameters ? A("typeParameters") : "";
        }
        function h(w, P, A) {
          let N = w.getValue();
          if (!N.typeAnnotation)
            return "";
          let S = w.getParentNode(), j = S.type === "DeclareFunction" && S.id === N;
          return n(P.originalText, N.typeAnnotation) ? [" /*: ", A("typeAnnotation"), " */"] : [j ? "" : ": ", A("typeAnnotation")];
        }
        function m(w, P, A) {
          return ["::", A("callee")];
        }
        function y(w, P, A) {
          let N = w.getValue();
          return t(N.modifiers) ? [a(" ", w.map(A, "modifiers")), " "] : "";
        }
        function p(w, P, A) {
          return w.type === "EmptyStatement" ? ";" : w.type === "BlockStatement" || A ? [" ", P] : s([e, P]);
        }
        function d(w, P, A) {
          return ["...", A("argument"), h(w, P, A)];
        }
        function C(w, P) {
          let A = w.slice(1, -1);
          if (A.includes('"') || A.includes("'"))
            return w;
          let N = P.singleQuote ? "'" : '"';
          return N + A + N;
        }
        l.exports = { printOptionalToken: r, printDefiniteToken: o, printFunctionTypeParameters: c, printBindExpressionCallee: m, printTypeScriptModifiers: y, printTypeAnnotation: h, printRestSpread: d, adjustClause: p, printDirective: C };
      } }), cn = X({ "src/language-js/print/array.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { builders: { line: s, softline: a, hardline: e, group: n, indent: r, ifBreak: o, fill: c } } = Qe(), { getLast: h, hasNewline: m } = at(), { shouldPrintComma: y, hasComment: p, CommentCheckFlags: d, isNextLineEmpty: C, isNumericLiteral: w, isSignedNumericLiteral: P } = Dt(), { locStart: A } = vt(), { printOptionalToken: N, printTypeAnnotation: S } = Tt();
        function j(T, D, F) {
          let i = T.getValue(), g = [], E = i.type === "TupleExpression" ? "#[" : "[", x = "]";
          if (i.elements.length === 0)
            p(i, d.Dangling) ? g.push(n([E, t(T, D), a, x])) : g.push(E, x);
          else {
            let b = h(i.elements), B = !(b && b.type === "RestElement"), I = b === null, M = Symbol("array"), V = !D.__inJestEach && i.elements.length > 1 && i.elements.every((L, ee, R) => {
              let O = L && L.type;
              if (O !== "ArrayExpression" && O !== "ObjectExpression")
                return !1;
              let Z = R[ee + 1];
              if (Z && O !== Z.type)
                return !1;
              let ie = O === "ArrayExpression" ? "elements" : "properties";
              return L[ie] && L[ie].length > 1;
            }), $ = k(i, D), U = B ? I ? "," : y(D) ? $ ? o(",", "", { groupId: M }) : o(",") : "" : "";
            g.push(n([E, r([a, $ ? f(T, D, F, U) : [J(T, D, "elements", F), U], t(T, D, !0)]), a, x], { shouldBreak: V, id: M }));
          }
          return g.push(N(T), S(T, D, F)), g;
        }
        function k(T, D) {
          return T.elements.length > 1 && T.elements.every((F) => F && (w(F) || P(F) && !p(F.argument)) && !p(F, d.Trailing | d.Line, (i) => !m(D.originalText, A(i), { backwards: !0 })));
        }
        function J(T, D, F, i) {
          let g = [], E = [];
          return T.each((x) => {
            g.push(E, n(i())), E = [",", s], x.getValue() && C(x.getValue(), D) && E.push(a);
          }, F), g;
        }
        function f(T, D, F, i) {
          let g = [];
          return T.each((E, x, b) => {
            let B = x === b.length - 1;
            g.push([F(), B ? i : ","]), B || g.push(C(E.getValue(), D) ? [e, e] : p(b[x + 1], d.Leading | d.Line) ? e : s);
          }, "elements"), c(g);
        }
        l.exports = { printArray: j, printArrayItems: J, isConciselyPrintedArray: k };
      } }), ku = X({ "src/language-js/print/call-arguments.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { getLast: s, getPenultimate: a } = at(), { getFunctionParameters: e, hasComment: n, CommentCheckFlags: r, isFunctionCompositionArgs: o, isJsxNode: c, isLongCurriedCallExpression: h, shouldPrintComma: m, getCallArguments: y, iterateCallArgumentsPath: p, isNextLineEmpty: d, isCallExpression: C, isStringLiteral: w, isObjectProperty: P, isTSTypeExpression: A } = Dt(), { builders: { line: N, hardline: S, softline: j, group: k, indent: J, conditionalGroup: f, ifBreak: T, breakParent: D }, utils: { willBreak: F } } = Qe(), { ArgExpansionBailout: i } = on(), { isConciselyPrintedArray: g } = cn();
        function E($, U, L) {
          let ee = $.getValue(), R = ee.type === "ImportExpression", O = y(ee);
          if (O.length === 0)
            return ["(", t($, U, !0), ")"];
          if (I(O))
            return ["(", L(["arguments", 0]), ", ", L(["arguments", 1]), ")"];
          let Z = !1, ie = !1, te = O.length - 1, ge = [];
          p($, (Q, W) => {
            let ne = Q.getNode(), re = [L()];
            W === te || (d(ne, U) ? (W === 0 && (ie = !0), Z = !0, re.push(",", S, S)) : re.push(",", N)), ge.push(re);
          });
          let q = !(R || ee.callee && ee.callee.type === "Import") && m(U, "all") ? "," : "";
          function z() {
            return k(["(", J([N, ...ge]), q, N, ")"], { shouldBreak: !0 });
          }
          if (Z || $.getParentNode().type !== "Decorator" && o(O))
            return z();
          let De = B(O), fe = b(O, U);
          if (De || fe) {
            if (De ? ge.slice(1).some(F) : ge.slice(0, -1).some(F))
              return z();
            let Q = [];
            try {
              $.try(() => {
                p($, (W, ne) => {
                  De && ne === 0 && (Q = [[L([], { expandFirstArg: !0 }), ge.length > 1 ? "," : "", ie ? S : N, ie ? S : ""], ...ge.slice(1)]), fe && ne === te && (Q = [...ge.slice(0, -1), L([], { expandLastArg: !0 })]);
                });
              });
            } catch (W) {
              if (W instanceof i)
                return z();
              throw W;
            }
            return [ge.some(F) ? D : "", f([["(", ...Q, ")"], De ? ["(", k(Q[0], { shouldBreak: !0 }), ...Q.slice(1), ")"] : ["(", ...ge.slice(0, -1), k(s(Q), { shouldBreak: !0 }), ")"], z()])];
          }
          let we = ["(", J([j, ...ge]), T(q), j, ")"];
          return h($) ? we : k(we, { shouldBreak: ge.some(F) || Z });
        }
        function x($) {
          let U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          return $.type === "ObjectExpression" && ($.properties.length > 0 || n($)) || $.type === "ArrayExpression" && ($.elements.length > 0 || n($)) || $.type === "TSTypeAssertion" && x($.expression) || A($) && x($.expression) || $.type === "FunctionExpression" || $.type === "ArrowFunctionExpression" && (!$.returnType || !$.returnType.typeAnnotation || $.returnType.typeAnnotation.type !== "TSTypeReference" || M($.body)) && ($.body.type === "BlockStatement" || $.body.type === "ArrowFunctionExpression" && x($.body, !0) || $.body.type === "ObjectExpression" || $.body.type === "ArrayExpression" || !U && (C($.body) || $.body.type === "ConditionalExpression") || c($.body)) || $.type === "DoExpression" || $.type === "ModuleExpression";
        }
        function b($, U) {
          let L = s($), ee = a($);
          return !n(L, r.Leading) && !n(L, r.Trailing) && x(L) && (!ee || ee.type !== L.type) && ($.length !== 2 || ee.type !== "ArrowFunctionExpression" || L.type !== "ArrayExpression") && !($.length > 1 && L.type === "ArrayExpression" && g(L, U));
        }
        function B($) {
          if ($.length !== 2)
            return !1;
          let [U, L] = $;
          return U.type === "ModuleExpression" && V(L) ? !0 : !n(U) && (U.type === "FunctionExpression" || U.type === "ArrowFunctionExpression" && U.body.type === "BlockStatement") && L.type !== "FunctionExpression" && L.type !== "ArrowFunctionExpression" && L.type !== "ConditionalExpression" && !x(L);
        }
        function I($) {
          return $.length === 2 && $[0].type === "ArrowFunctionExpression" && e($[0]).length === 0 && $[0].body.type === "BlockStatement" && $[1].type === "ArrayExpression" && !$.some((U) => n(U));
        }
        function M($) {
          return $.type === "BlockStatement" && ($.body.some((U) => U.type !== "EmptyStatement") || n($, r.Dangling));
        }
        function V($) {
          return $.type === "ObjectExpression" && $.properties.length === 1 && P($.properties[0]) && $.properties[0].key.type === "Identifier" && $.properties[0].key.name === "type" && w($.properties[0].value) && $.properties[0].value.value === "module";
        }
        l.exports = E;
      } }), Pu = X({ "src/language-js/print/member.js"(u, l) {
        H();
        var { builders: { softline: t, group: s, indent: a, label: e } } = Qe(), { isNumericLiteral: n, isMemberExpression: r, isCallExpression: o } = Dt(), { printOptionalToken: c } = Tt();
        function h(y, p, d) {
          let C = y.getValue(), w = y.getParentNode(), P, A = 0;
          do
            P = y.getParentNode(A), A++;
          while (P && (r(P) || P.type === "TSNonNullExpression"));
          let N = d("object"), S = m(y, p, d), j = P && (P.type === "NewExpression" || P.type === "BindExpression" || P.type === "AssignmentExpression" && P.left.type !== "Identifier") || C.computed || C.object.type === "Identifier" && C.property.type === "Identifier" && !r(w) || (w.type === "AssignmentExpression" || w.type === "VariableDeclarator") && (o(C.object) && C.object.arguments.length > 0 || C.object.type === "TSNonNullExpression" && o(C.object.expression) && C.object.expression.arguments.length > 0 || N.label === "member-chain");
          return e(N.label === "member-chain" ? "member-chain" : "member", [N, j ? S : s(a([t, S]))]);
        }
        function m(y, p, d) {
          let C = d("property"), w = y.getValue(), P = c(y);
          return w.computed ? !w.property || n(w.property) ? [P, "[", C, "]"] : s([P, "[", a([t, C]), t, "]"]) : [P, ".", C];
        }
        l.exports = { printMemberExpression: h, printMemberLookup: m };
      } }), Fs = X({ "src/language-js/print/member-chain.js"(u, l) {
        H();
        var { printComments: t } = ht(), { getLast: s, isNextLineEmptyAfterIndex: a, getNextNonSpaceNonCommentCharacterIndex: e } = at(), n = Zt(), { isCallExpression: r, isMemberExpression: o, isFunctionOrArrowExpression: c, isLongCurriedCallExpression: h, isMemberish: m, isNumericLiteral: y, isSimpleCallArgument: p, hasComment: d, CommentCheckFlags: C, isNextLineEmpty: w } = Dt(), { locEnd: P } = vt(), { builders: { join: A, hardline: N, group: S, indent: j, conditionalGroup: k, breakParent: J, label: f }, utils: { willBreak: T } } = Qe(), D = ku(), { printMemberLookup: F } = Pu(), { printOptionalToken: i, printFunctionTypeParameters: g, printBindExpressionCallee: E } = Tt();
        function x(b, B, I) {
          let M = b.getParentNode(), V = !M || M.type === "ExpressionStatement", $ = [];
          function U($e) {
            let { originalText: Ge } = B, le = e(Ge, $e, P);
            return Ge.charAt(le) === ")" ? le !== !1 && a(Ge, le + 1) : w($e, B);
          }
          function L($e) {
            let Ge = $e.getValue();
            r(Ge) && (m(Ge.callee) || r(Ge.callee)) ? ($.unshift({ node: Ge, printed: [t($e, [i($e), g($e, B, I), D($e, B, I)], B), U(Ge) ? N : ""] }), $e.call((le) => L(le), "callee")) : m(Ge) ? ($.unshift({ node: Ge, needsParens: n($e, B), printed: t($e, o(Ge) ? F($e, B, I) : E($e, B, I), B) }), $e.call((le) => L(le), "object")) : Ge.type === "TSNonNullExpression" ? ($.unshift({ node: Ge, printed: t($e, "!", B) }), $e.call((le) => L(le), "expression")) : $.unshift({ node: Ge, printed: I() });
          }
          let ee = b.getValue();
          $.unshift({ node: ee, printed: [i(b), g(b, B, I), D(b, B, I)] }), ee.callee && b.call(($e) => L($e), "callee");
          let R = [], O = [$[0]], Z = 1;
          for (; Z < $.length && ($[Z].node.type === "TSNonNullExpression" || r($[Z].node) || o($[Z].node) && $[Z].node.computed && y($[Z].node.property)); ++Z)
            O.push($[Z]);
          if (!r($[0].node))
            for (; Z + 1 < $.length && m($[Z].node) && m($[Z + 1].node); ++Z)
              O.push($[Z]);
          R.push(O), O = [];
          let ie = !1;
          for (; Z < $.length; ++Z) {
            if (ie && m($[Z].node)) {
              if ($[Z].node.computed && y($[Z].node.property)) {
                O.push($[Z]);
                continue;
              }
              R.push(O), O = [], ie = !1;
            }
            (r($[Z].node) || $[Z].node.type === "ImportExpression") && (ie = !0), O.push($[Z]), d($[Z].node, C.Trailing) && (R.push(O), O = [], ie = !1);
          }
          O.length > 0 && R.push(O);
          function te($e) {
            return /^[A-Z]|^[$_]+$/.test($e);
          }
          function ge($e) {
            return $e.length <= B.tabWidth;
          }
          function q($e) {
            let Ge = $e[1].length > 0 && $e[1][0].node.computed;
            if ($e[0].length === 1) {
              let G = $e[0][0].node;
              return G.type === "ThisExpression" || G.type === "Identifier" && (te(G.name) || V && ge(G.name) || Ge);
            }
            let le = s($e[0]).node;
            return o(le) && le.property.type === "Identifier" && (te(le.property.name) || Ge);
          }
          let z = R.length >= 2 && !d(R[1][0].node) && q(R);
          function De($e) {
            let Ge = $e.map((le) => le.printed);
            return $e.length > 0 && s($e).needsParens ? ["(", ...Ge, ")"] : Ge;
          }
          function fe($e) {
            return $e.length === 0 ? "" : j(S([N, A(N, $e.map(De))]));
          }
          let we = R.map(De), Q = we, W = z ? 3 : 2, ne = R.flat(), re = ne.slice(1, -1).some(($e) => d($e.node, C.Leading)) || ne.slice(0, -1).some(($e) => d($e.node, C.Trailing)) || R[W] && d(R[W][0].node, C.Leading);
          if (R.length <= W && !re)
            return h(b) ? Q : S(Q);
          let he = s(R[z ? 1 : 0]).node, Fe = !r(he) && U(he), ve = [De(R[0]), z ? R.slice(1, 2).map(De) : "", Fe ? N : "", fe(R.slice(z ? 2 : 1))], Re = $.map(($e) => {
            let { node: Ge } = $e;
            return Ge;
          }).filter(r);
          function tt() {
            let $e = s(s(R)).node, Ge = s(we);
            return r($e) && T(Ge) && Re.slice(0, -1).some((le) => le.arguments.some(c));
          }
          let Ze;
          return re || Re.length > 2 && Re.some(($e) => !$e.arguments.every((Ge) => p(Ge, 0))) || we.slice(0, -1).some(T) || tt() ? Ze = S(ve) : Ze = [T(Q) || Fe ? J : "", k([Q, ve])], f("member-chain", Ze);
        }
        l.exports = x;
      } }), ju = X({ "src/language-js/print/call-expression.js"(u, l) {
        H();
        var { builders: { join: t, group: s } } = Qe(), a = Zt(), { getCallArguments: e, hasFlowAnnotationComment: n, isCallExpression: r, isMemberish: o, isStringLiteral: c, isTemplateOnItsOwnLine: h, isTestCall: m, iterateCallArgumentsPath: y } = Dt(), p = Fs(), d = ku(), { printOptionalToken: C, printFunctionTypeParameters: w } = Tt();
        function P(N, S, j) {
          let k = N.getValue(), J = N.getParentNode(), f = k.type === "NewExpression", T = k.type === "ImportExpression", D = C(N), F = e(k);
          if (F.length > 0 && (!T && !f && A(k, J) || F.length === 1 && h(F[0], S.originalText) || !f && m(k, J))) {
            let E = [];
            return y(N, () => {
              E.push(j());
            }), [f ? "new " : "", j("callee"), D, w(N, S, j), "(", t(", ", E), ")"];
          }
          let i = (S.parser === "babel" || S.parser === "babel-flow") && k.callee && k.callee.type === "Identifier" && n(k.callee.trailingComments);
          if (i && (k.callee.trailingComments[0].printed = !0), !T && !f && o(k.callee) && !N.call((E) => a(E, S), "callee"))
            return p(N, S, j);
          let g = [f ? "new " : "", T ? "import" : j("callee"), D, i ? `/*:: ${k.callee.trailingComments[0].value.slice(2).trim()} */` : "", w(N, S, j), d(N, S, j)];
          return T || r(k.callee) ? s(g) : g;
        }
        function A(N, S) {
          if (N.callee.type !== "Identifier")
            return !1;
          if (N.callee.name === "require")
            return !0;
          if (N.callee.name === "define") {
            let j = e(N);
            return S.type === "ExpressionStatement" && (j.length === 1 || j.length === 2 && j[0].type === "ArrayExpression" || j.length === 3 && c(j[0]) && j[1].type === "ArrayExpression");
          }
          return !1;
        }
        l.exports = { printCallExpression: P };
      } }), dn = X({ "src/language-js/print/assignment.js"(u, l) {
        H();
        var { isNonEmptyArray: t, getStringWidth: s } = at(), { builders: { line: a, group: e, indent: n, indentIfBreak: r, lineSuffixBoundary: o }, utils: { cleanDoc: c, willBreak: h, canBreak: m } } = Qe(), { hasLeadingOwnLineComment: y, isBinaryish: p, isStringLiteral: d, isLiteral: C, isNumericLiteral: w, isCallExpression: P, isMemberExpression: A, getCallArguments: N, rawText: S, hasComment: j, isSignedNumericLiteral: k, isObjectProperty: J } = Dt(), { shouldInlineLogicalExpression: f } = lr(), { printCallExpression: T } = ju();
        function D(q, z, De, fe, we, Q) {
          let W = g(q, z, De, fe, Q), ne = De(Q, { assignmentLayout: W });
          switch (W) {
            case "break-after-operator":
              return e([e(fe), we, e(n([a, ne]))]);
            case "never-break-after-operator":
              return e([e(fe), we, " ", ne]);
            case "fluid": {
              let re = Symbol("assignment");
              return e([e(fe), we, e(n(a), { id: re }), o, r(ne, { groupId: re })]);
            }
            case "break-lhs":
              return e([fe, we, " ", e(ne)]);
            case "chain":
              return [e(fe), we, a, ne];
            case "chain-tail":
              return [e(fe), we, n([a, ne])];
            case "chain-tail-arrow-chain":
              return [e(fe), we, ne];
            case "only-left":
              return fe;
          }
        }
        function F(q, z, De) {
          let fe = q.getValue();
          return D(q, z, De, De("left"), [" ", fe.operator], "right");
        }
        function i(q, z, De) {
          return D(q, z, De, De("id"), " =", "init");
        }
        function g(q, z, De, fe, we) {
          let Q = q.getValue(), W = Q[we];
          if (!W)
            return "only-left";
          let ne = !b(W);
          if (q.match(b, B, (he) => !ne || he.type !== "ExpressionStatement" && he.type !== "VariableDeclaration"))
            return ne ? W.type === "ArrowFunctionExpression" && W.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
          if (!ne && b(W.right) || y(z.originalText, W))
            return "break-after-operator";
          if (W.type === "CallExpression" && W.callee.name === "require" || z.parser === "json5" || z.parser === "json")
            return "never-break-after-operator";
          if (x(Q) || I(Q) || $(Q) || U(Q) && m(fe))
            return "break-lhs";
          let re = ie(Q, fe, z);
          return q.call(() => E(q, z, De, re), we) ? "break-after-operator" : re || W.type === "TemplateLiteral" || W.type === "TaggedTemplateExpression" || W.type === "BooleanLiteral" || w(W) || W.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
        }
        function E(q, z, De, fe) {
          let we = q.getValue();
          if (p(we) && !f(we))
            return !0;
          switch (we.type) {
            case "StringLiteralTypeAnnotation":
            case "SequenceExpression":
              return !0;
            case "ConditionalExpression": {
              let { test: ne } = we;
              return p(ne) && !f(ne);
            }
            case "ClassExpression":
              return t(we.decorators);
          }
          if (fe)
            return !1;
          let Q = we, W = [];
          for (; ; )
            if (Q.type === "UnaryExpression")
              Q = Q.argument, W.push("argument");
            else if (Q.type === "TSNonNullExpression")
              Q = Q.expression, W.push("expression");
            else
              break;
          return !!(d(Q) || q.call(() => R(q, z, De), ...W));
        }
        function x(q) {
          if (B(q)) {
            let z = q.left || q.id;
            return z.type === "ObjectPattern" && z.properties.length > 2 && z.properties.some((De) => J(De) && (!De.shorthand || De.value && De.value.type === "AssignmentPattern"));
          }
          return !1;
        }
        function b(q) {
          return q.type === "AssignmentExpression";
        }
        function B(q) {
          return b(q) || q.type === "VariableDeclarator";
        }
        function I(q) {
          let z = M(q);
          if (t(z)) {
            let De = q.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
            if (z.length > 1 && z.some((fe) => fe[De] || fe.default))
              return !0;
          }
          return !1;
        }
        function M(q) {
          return V(q) && q.typeParameters && q.typeParameters.params ? q.typeParameters.params : null;
        }
        function V(q) {
          return q.type === "TSTypeAliasDeclaration" || q.type === "TypeAlias";
        }
        function $(q) {
          if (q.type !== "VariableDeclarator")
            return !1;
          let { typeAnnotation: z } = q.id;
          if (!z || !z.typeAnnotation)
            return !1;
          let De = L(z.typeAnnotation);
          return t(De) && De.length > 1 && De.some((fe) => t(L(fe)) || fe.type === "TSConditionalType");
        }
        function U(q) {
          return q.type === "VariableDeclarator" && q.init && q.init.type === "ArrowFunctionExpression";
        }
        function L(q) {
          return ee(q) && q.typeParameters && q.typeParameters.params ? q.typeParameters.params : null;
        }
        function ee(q) {
          return q.type === "TSTypeReference" || q.type === "GenericTypeAnnotation";
        }
        function R(q, z, De) {
          let fe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, we = q.getValue(), Q = () => R(q, z, De, !0);
          if (we.type === "TSNonNullExpression")
            return q.call(Q, "expression");
          if (P(we)) {
            if (T(q, z, De).label === "member-chain")
              return !1;
            let W = N(we);
            return !(W.length === 0 || W.length === 1 && Z(W[0], z)) || te(we, De) ? !1 : q.call(Q, "callee");
          }
          return A(we) ? q.call(Q, "object") : fe && (we.type === "Identifier" || we.type === "ThisExpression");
        }
        var O = 0.25;
        function Z(q, z) {
          let { printWidth: De } = z;
          if (j(q))
            return !1;
          let fe = De * O;
          if (q.type === "ThisExpression" || q.type === "Identifier" && q.name.length <= fe || k(q) && !j(q.argument))
            return !0;
          let we = q.type === "Literal" && "regex" in q && q.regex.pattern || q.type === "RegExpLiteral" && q.pattern;
          return we ? we.length <= fe : d(q) ? S(q).length <= fe : q.type === "TemplateLiteral" ? q.expressions.length === 0 && q.quasis[0].value.raw.length <= fe && !q.quasis[0].value.raw.includes(`
`) : C(q);
        }
        function ie(q, z, De) {
          if (!J(q))
            return !1;
          z = c(z);
          let fe = 3;
          return typeof z == "string" && s(z) < De.tabWidth + fe;
        }
        function te(q, z) {
          let De = ge(q);
          if (t(De)) {
            if (De.length > 1)
              return !0;
            if (De.length === 1) {
              let we = De[0];
              if (we.type === "TSUnionType" || we.type === "UnionTypeAnnotation" || we.type === "TSIntersectionType" || we.type === "IntersectionTypeAnnotation" || we.type === "TSTypeLiteral" || we.type === "ObjectTypeAnnotation")
                return !0;
            }
            let fe = q.typeParameters ? "typeParameters" : "typeArguments";
            if (h(z(fe)))
              return !0;
          }
          return !1;
        }
        function ge(q) {
          return q.typeParameters && q.typeParameters.params || q.typeArguments && q.typeArguments.params;
        }
        l.exports = { printVariableDeclarator: i, printAssignmentExpression: F, printAssignment: D, isArrowFunctionVariableDeclarator: U };
      } }), Pn = X({ "src/language-js/print/function-parameters.js"(u, l) {
        H();
        var { getNextNonSpaceNonCommentCharacter: t } = at(), { printDanglingComments: s } = ht(), { builders: { line: a, hardline: e, softline: n, group: r, indent: o, ifBreak: c }, utils: { removeLines: h, willBreak: m } } = Qe(), { getFunctionParameters: y, iterateFunctionParametersPath: p, isSimpleType: d, isTestCall: C, isTypeAnnotationAFunction: w, isObjectType: P, isObjectTypePropertyAFunction: A, hasRestParameter: N, shouldPrintComma: S, hasComment: j, isNextLineEmpty: k } = Dt(), { locEnd: J } = vt(), { ArgExpansionBailout: f } = on(), { printFunctionTypeParameters: T } = Tt();
        function D(E, x, b, B, I) {
          let M = E.getValue(), V = y(M), $ = I ? T(E, b, x) : "";
          if (V.length === 0)
            return [$, "(", s(E, b, !0, (Z) => t(b.originalText, Z, J) === ")"), ")"];
          let U = E.getParentNode(), L = C(U), ee = F(M), R = [];
          if (p(E, (Z, ie) => {
            let te = ie === V.length - 1;
            te && M.rest && R.push("..."), R.push(x()), !te && (R.push(","), L || ee ? R.push(" ") : k(V[ie], b) ? R.push(e, e) : R.push(a));
          }), B) {
            if (m($) || m(R))
              throw new f();
            return r([h($), "(", h(R), ")"]);
          }
          let O = V.every((Z) => !Z.decorators);
          return ee && O ? [$, "(", ...R, ")"] : L ? [$, "(", ...R, ")"] : (A(U) || w(U) || U.type === "TypeAlias" || U.type === "UnionTypeAnnotation" || U.type === "TSUnionType" || U.type === "IntersectionTypeAnnotation" || U.type === "FunctionTypeAnnotation" && U.returnType === M) && V.length === 1 && V[0].name === null && M.this !== V[0] && V[0].typeAnnotation && M.typeParameters === null && d(V[0].typeAnnotation) && !M.rest ? b.arrowParens === "always" ? ["(", ...R, ")"] : R : [$, "(", o([n, ...R]), c(!N(M) && S(b, "all") ? "," : ""), n, ")"];
        }
        function F(E) {
          if (!E)
            return !1;
          let x = y(E);
          if (x.length !== 1)
            return !1;
          let [b] = x;
          return !j(b) && (b.type === "ObjectPattern" || b.type === "ArrayPattern" || b.type === "Identifier" && b.typeAnnotation && (b.typeAnnotation.type === "TypeAnnotation" || b.typeAnnotation.type === "TSTypeAnnotation") && P(b.typeAnnotation.typeAnnotation) || b.type === "FunctionTypeParam" && P(b.typeAnnotation) || b.type === "AssignmentPattern" && (b.left.type === "ObjectPattern" || b.left.type === "ArrayPattern") && (b.right.type === "Identifier" || b.right.type === "ObjectExpression" && b.right.properties.length === 0 || b.right.type === "ArrayExpression" && b.right.elements.length === 0));
        }
        function i(E) {
          let x;
          return E.returnType ? (x = E.returnType, x.typeAnnotation && (x = x.typeAnnotation)) : E.typeAnnotation && (x = E.typeAnnotation), x;
        }
        function g(E, x) {
          let b = i(E);
          if (!b)
            return !1;
          let B = E.typeParameters && E.typeParameters.params;
          if (B) {
            if (B.length > 1)
              return !1;
            if (B.length === 1) {
              let I = B[0];
              if (I.constraint || I.default)
                return !1;
            }
          }
          return y(E).length === 1 && (P(b) || m(x));
        }
        l.exports = { printFunctionParameters: D, shouldHugFunctionParameters: F, shouldGroupFunctionParameters: g };
      } }), jn = X({ "src/language-js/print/type-annotation.js"(u, l) {
        H();
        var { printComments: t, printDanglingComments: s } = ht(), { isNonEmptyArray: a } = at(), { builders: { group: e, join: n, line: r, softline: o, indent: c, align: h, ifBreak: m } } = Qe(), y = Zt(), { locStart: p } = vt(), { isSimpleType: d, isObjectType: C, hasLeadingOwnLineComment: w, isObjectTypePropertyAFunction: P, shouldPrintComma: A } = Dt(), { printAssignment: N } = dn(), { printFunctionParameters: S, shouldGroupFunctionParameters: j } = Pn(), { printArrayItems: k } = cn();
        function J(b) {
          if (d(b) || C(b))
            return !0;
          if (b.type === "UnionTypeAnnotation" || b.type === "TSUnionType") {
            let B = b.types.filter((M) => M.type === "VoidTypeAnnotation" || M.type === "TSVoidKeyword" || M.type === "NullLiteralTypeAnnotation" || M.type === "TSNullKeyword").length, I = b.types.some((M) => M.type === "ObjectTypeAnnotation" || M.type === "TSTypeLiteral" || M.type === "GenericTypeAnnotation" || M.type === "TSTypeReference");
            if (b.types.length - 1 === B && I)
              return !0;
          }
          return !1;
        }
        function f(b, B, I) {
          let M = B.semi ? ";" : "", V = b.getValue(), $ = [];
          return $.push("opaque type ", I("id"), I("typeParameters")), V.supertype && $.push(": ", I("supertype")), V.impltype && $.push(" = ", I("impltype")), $.push(M), $;
        }
        function T(b, B, I) {
          let M = B.semi ? ";" : "", V = b.getValue(), $ = [];
          V.declare && $.push("declare "), $.push("type ", I("id"), I("typeParameters"));
          let U = V.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
          return [N(b, B, I, $, " =", U), M];
        }
        function D(b, B, I) {
          let M = b.getValue(), V = b.map(I, "types"), $ = [], U = !1;
          for (let L = 0; L < V.length; ++L)
            L === 0 ? $.push(V[L]) : C(M.types[L - 1]) && C(M.types[L]) ? $.push([" & ", U ? c(V[L]) : V[L]]) : !C(M.types[L - 1]) && !C(M.types[L]) ? $.push(c([" &", r, V[L]])) : (L > 1 && (U = !0), $.push(" & ", L > 1 ? c(V[L]) : V[L]));
          return e($);
        }
        function F(b, B, I) {
          let M = b.getValue(), V = b.getParentNode(), $ = V.type !== "TypeParameterInstantiation" && V.type !== "TSTypeParameterInstantiation" && V.type !== "GenericTypeAnnotation" && V.type !== "TSTypeReference" && V.type !== "TSTypeAssertion" && V.type !== "TupleTypeAnnotation" && V.type !== "TSTupleType" && !(V.type === "FunctionTypeParam" && !V.name && b.getParentNode(1).this !== V) && !((V.type === "TypeAlias" || V.type === "VariableDeclarator" || V.type === "TSTypeAliasDeclaration") && w(B.originalText, M)), U = J(M), L = b.map((O) => {
            let Z = I();
            return U || (Z = h(2, Z)), t(O, Z, B);
          }, "types");
          if (U)
            return n(" | ", L);
          let ee = $ && !w(B.originalText, M), R = [m([ee ? r : "", "| "]), n([r, "| "], L)];
          return y(b, B) ? e([c(R), o]) : V.type === "TupleTypeAnnotation" && V.types.length > 1 || V.type === "TSTupleType" && V.elementTypes.length > 1 ? e([c([m(["(", o]), R]), o, m(")")]) : e($ ? c(R) : R);
        }
        function i(b, B, I) {
          let M = b.getValue(), V = [], $ = b.getParentNode(0), U = b.getParentNode(1), L = b.getParentNode(2), ee = M.type === "TSFunctionType" || !(($.type === "ObjectTypeProperty" || $.type === "ObjectTypeInternalSlot") && !$.variance && !$.optional && p($) === p(M) || $.type === "ObjectTypeCallProperty" || L && L.type === "DeclareFunction"), R = ee && ($.type === "TypeAnnotation" || $.type === "TSTypeAnnotation"), O = R && ee && ($.type === "TypeAnnotation" || $.type === "TSTypeAnnotation") && U.type === "ArrowFunctionExpression";
          P($) && (ee = !0, R = !0), O && V.push("(");
          let Z = S(b, I, B, !1, !0), ie = M.returnType || M.predicate || M.typeAnnotation ? [ee ? " => " : ": ", I("returnType"), I("predicate"), I("typeAnnotation")] : "", te = j(M, ie);
          return V.push(te ? e(Z) : Z), ie && V.push(ie), O && V.push(")"), e(V);
        }
        function g(b, B, I) {
          let M = b.getValue(), V = M.type === "TSTupleType" ? "elementTypes" : "types", $ = M[V], U = a($), L = U ? o : "";
          return e(["[", c([L, k(b, B, V, I)]), m(U && A(B, "all") ? "," : ""), s(b, B, !0), L, "]"]);
        }
        function E(b, B, I) {
          let M = b.getValue(), V = M.type === "OptionalIndexedAccessType" && M.optional ? "?.[" : "[";
          return [I("objectType"), V, I("indexType"), "]"];
        }
        function x(b, B, I) {
          let M = b.getValue();
          return [M.postfix ? "" : I, B("typeAnnotation"), M.postfix ? I : ""];
        }
        l.exports = { printOpaqueType: f, printTypeAlias: T, printIntersectionType: D, printUnionType: F, printFunctionType: i, printTupleType: g, printIndexedAccessType: E, shouldHugType: J, printJSDocType: x };
      } }), In = X({ "src/language-js/print/type-parameters.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { builders: { join: s, line: a, hardline: e, softline: n, group: r, indent: o, ifBreak: c } } = Qe(), { isTestCall: h, hasComment: m, CommentCheckFlags: y, isTSXFile: p, shouldPrintComma: d, getFunctionParameters: C, isObjectType: w, getTypeScriptMappedTypeModifier: P } = Dt(), { createGroupIdMapper: A } = at(), { shouldHugType: N } = jn(), { isArrowFunctionVariableDeclarator: S } = dn(), j = A("typeParameters");
        function k(T, D, F, i) {
          let g = T.getValue();
          if (!g[i])
            return "";
          if (!Array.isArray(g[i]))
            return F(i);
          let E = T.getNode(2), x = E && h(E), b = T.match((I) => !(I[i].length === 1 && w(I[i][0])), void 0, (I, M) => M === "typeAnnotation", (I) => I.type === "Identifier", S);
          if (g[i].length === 0 || !b && (x || g[i].length === 1 && (g[i][0].type === "NullableTypeAnnotation" || N(g[i][0]))))
            return ["<", s(", ", T.map(F, i)), J(T, D), ">"];
          let B = g.type === "TSTypeParameterInstantiation" ? "" : C(g).length === 1 && p(D) && !g[i][0].constraint && T.getParentNode().type === "ArrowFunctionExpression" ? "," : d(D, "all") ? c(",") : "";
          return r(["<", o([n, s([",", a], T.map(F, i))]), B, n, ">"], { id: j(g) });
        }
        function J(T, D) {
          let F = T.getValue();
          if (!m(F, y.Dangling))
            return "";
          let i = !m(F, y.Line), g = t(T, D, i);
          return i ? g : [g, e];
        }
        function f(T, D, F) {
          let i = T.getValue(), g = [i.type === "TSTypeParameter" && i.const ? "const " : ""], E = T.getParentNode();
          return E.type === "TSMappedType" ? (E.readonly && g.push(P(E.readonly, "readonly"), " "), g.push("[", F("name")), i.constraint && g.push(" in ", F("constraint")), E.nameType && g.push(" as ", T.callParent(() => F("nameType"))), g.push("]"), g) : (i.variance && g.push(F("variance")), i.in && g.push("in "), i.out && g.push("out "), g.push(F("name")), i.bound && g.push(": ", F("bound")), i.constraint && g.push(" extends ", F("constraint")), i.default && g.push(" = ", F("default")), g);
        }
        l.exports = { printTypeParameter: f, printTypeParameters: k, getTypeParametersGroupId: j };
      } }), Dn = X({ "src/language-js/print/property.js"(u, l) {
        H();
        var { printComments: t } = ht(), { printString: s, printNumber: a } = at(), { isNumericLiteral: e, isSimpleNumber: n, isStringLiteral: r, isStringPropSafeToUnquote: o, rawText: c } = Dt(), { printAssignment: h } = dn(), m = /* @__PURE__ */ new WeakMap();
        function y(d, C, w) {
          let P = d.getNode();
          if (P.computed)
            return ["[", w("key"), "]"];
          let A = d.getParentNode(), { key: N } = P;
          if (C.quoteProps === "consistent" && !m.has(A)) {
            let S = (A.properties || A.body || A.members).some((j) => !j.computed && j.key && r(j.key) && !o(j, C));
            m.set(A, S);
          }
          if ((N.type === "Identifier" || e(N) && n(a(c(N))) && String(N.value) === a(c(N)) && !(C.parser === "typescript" || C.parser === "babel-ts")) && (C.parser === "json" || C.quoteProps === "consistent" && m.get(A))) {
            let S = s(JSON.stringify(N.type === "Identifier" ? N.name : N.value.toString()), C);
            return d.call((j) => t(j, S, C), "key");
          }
          return o(P, C) && (C.quoteProps === "as-needed" || C.quoteProps === "consistent" && !m.get(A)) ? d.call((S) => t(S, /^\d/.test(N.value) ? a(N.value) : N.value, C), "key") : w("key");
        }
        function p(d, C, w) {
          return d.getValue().shorthand ? w("value") : h(d, C, w, y(d, C, w), ":", "value");
        }
        l.exports = { printProperty: p, printPropertyKey: y };
      } }), Ln = X({ "src/language-js/print/function.js"(u, l) {
        H();
        var t = pn(), { printDanglingComments: s, printCommentsSeparately: a } = ht(), e = Ct(), { getNextNonSpaceNonCommentCharacterIndex: n } = at(), { builders: { line: r, softline: o, group: c, indent: h, ifBreak: m, hardline: y, join: p, indentIfBreak: d }, utils: { removeLines: C, willBreak: w } } = Qe(), { ArgExpansionBailout: P } = on(), { getFunctionParameters: A, hasLeadingOwnLineComment: N, isFlowAnnotationComment: S, isJsxNode: j, isTemplateOnItsOwnLine: k, shouldPrintComma: J, startsWithNoLookaheadToken: f, isBinaryish: T, isLineComment: D, hasComment: F, getComments: i, CommentCheckFlags: g, isCallLikeExpression: E, isCallExpression: x, getCallArguments: b, hasNakedLeftSide: B, getLeftSide: I } = Dt(), { locEnd: M } = vt(), { printFunctionParameters: V, shouldGroupFunctionParameters: $ } = Pn(), { printPropertyKey: U } = Dn(), { printFunctionTypeParameters: L } = Tt();
        function ee(W, ne, re, he) {
          let Fe = W.getValue(), ve = !1;
          if ((Fe.type === "FunctionDeclaration" || Fe.type === "FunctionExpression") && he && he.expandLastArg) {
            let Ge = W.getParentNode();
            x(Ge) && b(Ge).length > 1 && (ve = !0);
          }
          let Re = [];
          Fe.type === "TSDeclareFunction" && Fe.declare && Re.push("declare "), Fe.async && Re.push("async "), Fe.generator ? Re.push("function* ") : Re.push("function "), Fe.id && Re.push(ne("id"));
          let tt = V(W, ne, re, ve), Ze = z(W, ne, re), $e = $(Fe, Ze);
          return Re.push(L(W, re, ne), c([$e ? c(tt) : tt, Ze]), Fe.body ? " " : "", ne("body")), re.semi && (Fe.declare || !Fe.body) && Re.push(";"), Re;
        }
        function R(W, ne, re) {
          let he = W.getNode(), { kind: Fe } = he, ve = he.value || he, Re = [];
          return !Fe || Fe === "init" || Fe === "method" || Fe === "constructor" ? ve.async && Re.push("async ") : (t.ok(Fe === "get" || Fe === "set"), Re.push(Fe, " ")), ve.generator && Re.push("*"), Re.push(U(W, ne, re), he.optional || he.key.optional ? "?" : ""), he === ve ? Re.push(O(W, ne, re)) : ve.type === "FunctionExpression" ? Re.push(W.call((tt) => O(tt, ne, re), "value")) : Re.push(re("value")), Re;
        }
        function O(W, ne, re) {
          let he = W.getNode(), Fe = V(W, re, ne), ve = z(W, re, ne), Re = $(he, ve), tt = [L(W, ne, re), c([Re ? c(Fe) : Fe, ve])];
          return he.body ? tt.push(" ", re("body")) : tt.push(ne.semi ? ";" : ""), tt;
        }
        function Z(W, ne, re, he) {
          let Fe = W.getValue(), ve = [];
          if (Fe.async && ve.push("async "), q(W, ne))
            ve.push(re(["params", 0]));
          else {
            let tt = he && (he.expandLastArg || he.expandFirstArg), Ze = z(W, re, ne);
            if (tt) {
              if (w(Ze))
                throw new P();
              Ze = c(C(Ze));
            }
            ve.push(c([V(W, re, ne, tt, !0), Ze]));
          }
          let Re = s(W, ne, !0, (tt) => {
            let Ze = n(ne.originalText, tt, M);
            return Ze !== !1 && ne.originalText.slice(Ze, Ze + 2) === "=>";
          });
          return Re && ve.push(" ", Re), ve;
        }
        function ie(W, ne, re, he, Fe, ve) {
          let Re = W.getName(), tt = W.getParentNode(), Ze = E(tt) && Re === "callee", $e = !!(ne && ne.assignmentLayout), Ge = ve.body.type !== "BlockStatement" && ve.body.type !== "ObjectExpression" && ve.body.type !== "SequenceExpression", le = Ze && Ge || ne && ne.assignmentLayout === "chain-tail-arrow-chain", G = Symbol("arrow-chain");
          return ve.body.type === "SequenceExpression" && (Fe = c(["(", h([o, Fe]), o, ")"])), c([c(h([Ze || $e ? o : "", c(p([" =>", r], re), { shouldBreak: he })]), { id: G, shouldBreak: le }), " =>", d(Ge ? h([r, Fe]) : [" ", Fe], { groupId: G }), Ze ? m(o, "", { groupId: G }) : ""]);
        }
        function te(W, ne, re, he) {
          let Fe = W.getValue(), ve = [], Re = [], tt = !1;
          if (function G() {
            let me = Z(W, ne, re, he);
            if (ve.length === 0)
              ve.push(me);
            else {
              let { leading: K, trailing: de } = a(W, ne);
              ve.push([K, me]), Re.unshift(de);
            }
            tt = tt || Fe.returnType && A(Fe).length > 0 || Fe.typeParameters || A(Fe).some((K) => K.type !== "Identifier"), Fe.body.type !== "ArrowFunctionExpression" || he && he.expandLastArg ? Re.unshift(re("body", he)) : (Fe = Fe.body, W.call(G, "body"));
          }(), ve.length > 1)
            return ie(W, he, ve, tt, Re, Fe);
          let Ze = ve;
          if (Ze.push(" =>"), !N(ne.originalText, Fe.body) && (Fe.body.type === "ArrayExpression" || Fe.body.type === "ObjectExpression" || Fe.body.type === "BlockStatement" || j(Fe.body) || k(Fe.body, ne.originalText) || Fe.body.type === "ArrowFunctionExpression" || Fe.body.type === "DoExpression"))
            return c([...Ze, " ", Re]);
          if (Fe.body.type === "SequenceExpression")
            return c([...Ze, c([" (", h([o, Re]), o, ")"])]);
          let $e = (he && he.expandLastArg || W.getParentNode().type === "JSXExpressionContainer") && !F(Fe), Ge = he && he.expandLastArg && J(ne, "all"), le = Fe.body.type === "ConditionalExpression" && !f(Fe.body, (G) => G.type === "ObjectExpression");
          return c([...Ze, c([h([r, le ? m("", "(") : "", Re, le ? m("", ")") : ""]), $e ? [m(Ge ? "," : ""), o] : ""])]);
        }
        function ge(W) {
          let ne = A(W);
          return ne.length === 1 && !W.typeParameters && !F(W, g.Dangling) && ne[0].type === "Identifier" && !ne[0].typeAnnotation && !F(ne[0]) && !ne[0].optional && !W.predicate && !W.returnType;
        }
        function q(W, ne) {
          if (ne.arrowParens === "always")
            return !1;
          if (ne.arrowParens === "avoid") {
            let re = W.getValue();
            return ge(re);
          }
          return !1;
        }
        function z(W, ne, re) {
          let he = W.getValue(), Fe = ne("returnType");
          if (he.returnType && S(re.originalText, he.returnType))
            return [" /*: ", Fe, " */"];
          let ve = [Fe];
          return he.returnType && he.returnType.typeAnnotation && ve.unshift(": "), he.predicate && ve.push(he.returnType ? " " : ": ", ne("predicate")), ve;
        }
        function De(W, ne, re) {
          let he = W.getValue(), Fe = ne.semi ? ";" : "", ve = [];
          he.argument && (Q(ne, he.argument) ? ve.push([" (", h([y, re("argument")]), y, ")"]) : T(he.argument) || he.argument.type === "SequenceExpression" ? ve.push(c([m(" (", " "), h([o, re("argument")]), o, m(")")])) : ve.push(" ", re("argument")));
          let Re = i(he), tt = e(Re), Ze = tt && D(tt);
          return Ze && ve.push(Fe), F(he, g.Dangling) && ve.push(" ", s(W, ne, !0)), Ze || ve.push(Fe), ve;
        }
        function fe(W, ne, re) {
          return ["return", De(W, ne, re)];
        }
        function we(W, ne, re) {
          return ["throw", De(W, ne, re)];
        }
        function Q(W, ne) {
          if (N(W.originalText, ne))
            return !0;
          if (B(ne)) {
            let re = ne, he;
            for (; he = I(re); )
              if (re = he, N(W.originalText, re))
                return !0;
          }
          return !1;
        }
        l.exports = { printFunction: ee, printArrowFunction: te, printMethod: R, printReturnStatement: fe, printThrowStatement: we, printMethodInternal: O, shouldPrintParamsWithoutParens: q };
      } }), pr = X({ "src/language-js/print/decorators.js"(u, l) {
        H();
        var { isNonEmptyArray: t, hasNewline: s } = at(), { builders: { line: a, hardline: e, join: n, breakParent: r, group: o } } = Qe(), { locStart: c, locEnd: h } = vt(), { getParentExportDeclaration: m } = Dt();
        function y(P, A, N) {
          let S = P.getValue();
          return o([n(a, P.map(N, "decorators")), C(S, A) ? e : a]);
        }
        function p(P, A, N) {
          return [n(e, P.map(N, "declaration", "decorators")), e];
        }
        function d(P, A, N) {
          let S = P.getValue(), { decorators: j } = S;
          if (!t(j) || w(P.getParentNode()))
            return;
          let k = S.type === "ClassExpression" || S.type === "ClassDeclaration" || C(S, A);
          return [m(P) ? e : k ? r : "", n(a, P.map(N, "decorators")), a];
        }
        function C(P, A) {
          return P.decorators.some((N) => s(A.originalText, h(N)));
        }
        function w(P) {
          if (P.type !== "ExportDefaultDeclaration" && P.type !== "ExportNamedDeclaration" && P.type !== "DeclareExportDeclaration")
            return !1;
          let A = P.declaration && P.declaration.decorators;
          return t(A) && c(P) === c(A[0]);
        }
        l.exports = { printDecorators: d, printClassMemberDecorators: y, printDecoratorsBeforeExport: p, hasDecoratorsBeforeExport: w };
      } }), fn = X({ "src/language-js/print/class.js"(u, l) {
        H();
        var { isNonEmptyArray: t, createGroupIdMapper: s } = at(), { printComments: a, printDanglingComments: e } = ht(), { builders: { join: n, line: r, hardline: o, softline: c, group: h, indent: m, ifBreak: y } } = Qe(), { hasComment: p, CommentCheckFlags: d } = Dt(), { getTypeParametersGroupId: C } = In(), { printMethod: w } = Ln(), { printOptionalToken: P, printTypeAnnotation: A, printDefiniteToken: N } = Tt(), { printPropertyKey: S } = Dn(), { printAssignment: j } = dn(), { printClassMemberDecorators: k } = pr();
        function J(b, B, I) {
          let M = b.getValue(), V = [];
          M.declare && V.push("declare "), M.abstract && V.push("abstract "), V.push("class");
          let $ = M.id && p(M.id, d.Trailing) || M.typeParameters && p(M.typeParameters, d.Trailing) || M.superClass && p(M.superClass) || t(M.extends) || t(M.mixins) || t(M.implements), U = [], L = [];
          if (M.id && U.push(" ", I("id")), U.push(I("typeParameters")), M.superClass) {
            let ee = [g(b, B, I), I("superTypeParameters")], R = b.call((O) => ["extends ", a(O, ee, B)], "superClass");
            $ ? L.push(r, h(R)) : L.push(" ", R);
          } else
            L.push(i(b, B, I, "extends"));
          if (L.push(i(b, B, I, "mixins"), i(b, B, I, "implements")), $) {
            let ee;
            F(M) ? ee = [...U, m(L)] : ee = m([...U, L]), V.push(h(ee, { id: f(M) }));
          } else
            V.push(...U, ...L);
          return V.push(" ", I("body")), V;
        }
        var f = s("heritageGroup");
        function T(b) {
          return y(o, "", { groupId: f(b) });
        }
        function D(b) {
          return ["superClass", "extends", "mixins", "implements"].filter((B) => !!b[B]).length > 1;
        }
        function F(b) {
          return b.typeParameters && !p(b.typeParameters, d.Trailing | d.Line) && !D(b);
        }
        function i(b, B, I, M) {
          let V = b.getValue();
          if (!t(V[M]))
            return "";
          let $ = e(b, B, !0, (U) => {
            let { marker: L } = U;
            return L === M;
          });
          return [F(V) ? y(" ", r, { groupId: C(V.typeParameters) }) : r, $, $ && o, M, h(m([r, n([",", r], b.map(I, M))]))];
        }
        function g(b, B, I) {
          let M = I("superClass");
          return b.getParentNode().type === "AssignmentExpression" ? h(y(["(", m([c, M]), c, ")"], M)) : M;
        }
        function E(b, B, I) {
          let M = b.getValue(), V = [];
          return t(M.decorators) && V.push(k(b, B, I)), M.accessibility && V.push(M.accessibility + " "), M.readonly && V.push("readonly "), M.declare && V.push("declare "), M.static && V.push("static "), (M.type === "TSAbstractMethodDefinition" || M.abstract) && V.push("abstract "), M.override && V.push("override "), V.push(w(b, B, I)), V;
        }
        function x(b, B, I) {
          let M = b.getValue(), V = [], $ = B.semi ? ";" : "";
          return t(M.decorators) && V.push(k(b, B, I)), M.accessibility && V.push(M.accessibility + " "), M.declare && V.push("declare "), M.static && V.push("static "), (M.type === "TSAbstractPropertyDefinition" || M.type === "TSAbstractAccessorProperty" || M.abstract) && V.push("abstract "), M.override && V.push("override "), M.readonly && V.push("readonly "), M.variance && V.push(I("variance")), (M.type === "ClassAccessorProperty" || M.type === "AccessorProperty" || M.type === "TSAbstractAccessorProperty") && V.push("accessor "), V.push(S(b, B, I), P(b), N(b), A(b, B, I)), [j(b, B, I, V, " =", "value"), $];
        }
        l.exports = { printClass: J, printClassMethod: E, printClassProperty: x, printHardlineAfterHeritage: T };
      } }), Iu = X({ "src/language-js/print/interface.js"(u, l) {
        H();
        var { isNonEmptyArray: t } = at(), { builders: { join: s, line: a, group: e, indent: n, ifBreak: r } } = Qe(), { hasComment: o, identity: c, CommentCheckFlags: h } = Dt(), { getTypeParametersGroupId: m } = In(), { printTypeScriptModifiers: y } = Tt();
        function p(d, C, w) {
          let P = d.getValue(), A = [];
          P.declare && A.push("declare "), P.type === "TSInterfaceDeclaration" && A.push(P.abstract ? "abstract " : "", y(d, C, w)), A.push("interface");
          let N = [], S = [];
          P.type !== "InterfaceTypeAnnotation" && N.push(" ", w("id"), w("typeParameters"));
          let j = P.typeParameters && !o(P.typeParameters, h.Trailing | h.Line);
          return t(P.extends) && S.push(j ? r(" ", a, { groupId: m(P.typeParameters) }) : a, "extends ", (P.extends.length === 1 ? c : n)(s([",", a], d.map(w, "extends")))), P.id && o(P.id, h.Trailing) || t(P.extends) ? j ? A.push(e([...N, n(S)])) : A.push(e(n([...N, ...S]))) : A.push(...N, ...S), A.push(" ", w("body")), e(A);
        }
        l.exports = { printInterface: p };
      } }), Lu = X({ "src/language-js/print/module.js"(u, l) {
        H();
        var { isNonEmptyArray: t } = at(), { builders: { softline: s, group: a, indent: e, join: n, line: r, ifBreak: o, hardline: c } } = Qe(), { printDanglingComments: h } = ht(), { hasComment: m, CommentCheckFlags: y, shouldPrintComma: p, needsHardlineAfterDanglingComment: d, isStringLiteral: C, rawText: w } = Dt(), { locStart: P, hasSameLoc: A } = vt(), { hasDecoratorsBeforeExport: N, printDecoratorsBeforeExport: S } = pr();
        function j(x, b, B) {
          let I = x.getValue(), M = b.semi ? ";" : "", V = [], { importKind: $ } = I;
          return V.push("import"), $ && $ !== "value" && V.push(" ", $), V.push(D(x, b, B), T(x, b, B), i(x, b, B), M), V;
        }
        function k(x, b, B) {
          let I = x.getValue(), M = [];
          N(I) && M.push(S(x, b, B));
          let { type: V, exportKind: $, declaration: U } = I;
          return M.push("export"), (I.default || V === "ExportDefaultDeclaration") && M.push(" default"), m(I, y.Dangling) && (M.push(" ", h(x, b, !0)), d(I) && M.push(c)), U ? M.push(" ", B("declaration")) : M.push($ === "type" ? " type" : "", D(x, b, B), T(x, b, B), i(x, b, B)), f(I, b) && M.push(";"), M;
        }
        function J(x, b, B) {
          let I = x.getValue(), M = b.semi ? ";" : "", V = [], { exportKind: $, exported: U } = I;
          return V.push("export"), $ === "type" && V.push(" type"), V.push(" *"), U && V.push(" as ", B("exported")), V.push(T(x, b, B), i(x, b, B), M), V;
        }
        function f(x, b) {
          if (!b.semi)
            return !1;
          let { type: B, declaration: I } = x, M = x.default || B === "ExportDefaultDeclaration";
          if (!I)
            return !0;
          let { type: V } = I;
          return !!(M && V !== "ClassDeclaration" && V !== "FunctionDeclaration" && V !== "TSInterfaceDeclaration" && V !== "DeclareClass" && V !== "DeclareFunction" && V !== "TSDeclareFunction" && V !== "EnumDeclaration");
        }
        function T(x, b, B) {
          let I = x.getValue();
          if (!I.source)
            return "";
          let M = [];
          return F(I, b) || M.push(" from"), M.push(" ", B("source")), M;
        }
        function D(x, b, B) {
          let I = x.getValue();
          if (F(I, b))
            return "";
          let M = [" "];
          if (t(I.specifiers)) {
            let V = [], $ = [];
            x.each(() => {
              let U = x.getValue().type;
              if (U === "ExportNamespaceSpecifier" || U === "ExportDefaultSpecifier" || U === "ImportNamespaceSpecifier" || U === "ImportDefaultSpecifier")
                V.push(B());
              else if (U === "ExportSpecifier" || U === "ImportSpecifier")
                $.push(B());
              else
                throw new Error(`Unknown specifier type ${JSON.stringify(U)}`);
            }, "specifiers"), M.push(n(", ", V)), $.length > 0 && (V.length > 0 && M.push(", "), $.length > 1 || V.length > 0 || I.specifiers.some((U) => m(U)) ? M.push(a(["{", e([b.bracketSpacing ? r : s, n([",", r], $)]), o(p(b) ? "," : ""), b.bracketSpacing ? r : s, "}"])) : M.push(["{", b.bracketSpacing ? " " : "", ...$, b.bracketSpacing ? " " : "", "}"]));
          } else
            M.push("{}");
          return M;
        }
        function F(x, b) {
          let { type: B, importKind: I, source: M, specifiers: V } = x;
          return B !== "ImportDeclaration" || t(V) || I === "type" ? !1 : !/{\s*}/.test(b.originalText.slice(P(x), P(M)));
        }
        function i(x, b, B) {
          let I = x.getNode();
          return t(I.assertions) ? [" assert {", b.bracketSpacing ? " " : "", n(", ", x.map(B, "assertions")), b.bracketSpacing ? " " : "", "}"] : "";
        }
        function g(x, b, B) {
          let I = x.getNode(), { type: M } = I, V = [], $ = M === "ImportSpecifier" ? I.importKind : I.exportKind;
          $ && $ !== "value" && V.push($, " ");
          let U = M.startsWith("Import"), L = U ? "imported" : "local", ee = U ? "local" : "exported", R = I[L], O = I[ee], Z = "", ie = "";
          return M === "ExportNamespaceSpecifier" || M === "ImportNamespaceSpecifier" ? Z = "*" : R && (Z = B(L)), O && !E(I) && (ie = B(ee)), V.push(Z, Z && ie ? " as " : "", ie), V;
        }
        function E(x) {
          if (x.type !== "ImportSpecifier" && x.type !== "ExportSpecifier")
            return !1;
          let { local: b, [x.type === "ImportSpecifier" ? "imported" : "exported"]: B } = x;
          if (b.type !== B.type || !A(b, B))
            return !1;
          if (C(b))
            return b.value === B.value && w(b) === w(B);
          switch (b.type) {
            case "Identifier":
              return b.name === B.name;
            default:
              return !1;
          }
        }
        l.exports = { printImportDeclaration: j, printExportDeclaration: k, printExportAllDeclaration: J, printModuleSpecifier: g };
      } }), cr = X({ "src/language-js/print/object.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { builders: { line: s, softline: a, group: e, indent: n, ifBreak: r, hardline: o } } = Qe(), { getLast: c, hasNewlineInRange: h, hasNewline: m, isNonEmptyArray: y } = at(), { shouldPrintComma: p, hasComment: d, getComments: C, CommentCheckFlags: w, isNextLineEmpty: P } = Dt(), { locStart: A, locEnd: N } = vt(), { printOptionalToken: S, printTypeAnnotation: j } = Tt(), { shouldHugFunctionParameters: k } = Pn(), { shouldHugType: J } = jn(), { printHardlineAfterHeritage: f } = fn();
        function T(D, F, i) {
          let g = F.semi ? ";" : "", E = D.getValue(), x;
          E.type === "TSTypeLiteral" ? x = "members" : E.type === "TSInterfaceBody" ? x = "body" : x = "properties";
          let b = E.type === "ObjectTypeAnnotation", B = [x];
          b && B.push("indexers", "callProperties", "internalSlots");
          let I = B.map((q) => E[q][0]).sort((q, z) => A(q) - A(z))[0], M = D.getParentNode(0), V = b && M && (M.type === "InterfaceDeclaration" || M.type === "DeclareInterface" || M.type === "DeclareClass") && D.getName() === "body", $ = E.type === "TSInterfaceBody" || V || E.type === "ObjectPattern" && M.type !== "FunctionDeclaration" && M.type !== "FunctionExpression" && M.type !== "ArrowFunctionExpression" && M.type !== "ObjectMethod" && M.type !== "ClassMethod" && M.type !== "ClassPrivateMethod" && M.type !== "AssignmentPattern" && M.type !== "CatchClause" && E.properties.some((q) => q.value && (q.value.type === "ObjectPattern" || q.value.type === "ArrayPattern")) || E.type !== "ObjectPattern" && I && h(F.originalText, A(E), A(I)), U = V ? ";" : E.type === "TSInterfaceBody" || E.type === "TSTypeLiteral" ? r(g, ";") : ",", L = E.type === "RecordExpression" ? "#{" : E.exact ? "{|" : "{", ee = E.exact ? "|}" : "}", R = [];
          for (let q of B)
            D.each((z) => {
              let De = z.getValue();
              R.push({ node: De, printed: i(), loc: A(De) });
            }, q);
          B.length > 1 && R.sort((q, z) => q.loc - z.loc);
          let O = [], Z = R.map((q) => {
            let z = [...O, e(q.printed)];
            return O = [U, s], (q.node.type === "TSPropertySignature" || q.node.type === "TSMethodSignature" || q.node.type === "TSConstructSignatureDeclaration") && d(q.node, w.PrettierIgnore) && O.shift(), P(q.node, F) && O.push(o), z;
          });
          if (E.inexact) {
            let q;
            if (d(E, w.Dangling)) {
              let z = d(E, w.Line);
              q = [t(D, F, !0), z || m(F.originalText, N(c(C(E)))) ? o : s, "..."];
            } else
              q = ["..."];
            Z.push([...O, ...q]);
          }
          let ie = c(E[x]), te = !(E.inexact || ie && ie.type === "RestElement" || ie && (ie.type === "TSPropertySignature" || ie.type === "TSCallSignatureDeclaration" || ie.type === "TSMethodSignature" || ie.type === "TSConstructSignatureDeclaration") && d(ie, w.PrettierIgnore)), ge;
          if (Z.length === 0) {
            if (!d(E, w.Dangling))
              return [L, ee, j(D, F, i)];
            ge = e([L, t(D, F), a, ee, S(D), j(D, F, i)]);
          } else
            ge = [V && y(E.properties) ? f(M) : "", L, n([F.bracketSpacing ? s : a, ...Z]), r(te && (U !== "," || p(F)) ? U : ""), F.bracketSpacing ? s : a, ee, S(D), j(D, F, i)];
          return D.match((q) => q.type === "ObjectPattern" && !q.decorators, (q, z, De) => k(q) && (z === "params" || z === "parameters" || z === "this" || z === "rest") && De === 0) || D.match(J, (q, z) => z === "typeAnnotation", (q, z) => z === "typeAnnotation", (q, z, De) => k(q) && (z === "params" || z === "parameters" || z === "this" || z === "rest") && De === 0) || !$ && D.match((q) => q.type === "ObjectPattern", (q) => q.type === "AssignmentExpression" || q.type === "VariableDeclarator") ? ge : e(ge, { shouldBreak: $ });
        }
        l.exports = { printObject: T };
      } }), As = X({ "src/language-js/print/flow.js"(u, l) {
        H();
        var t = pn(), { printDanglingComments: s } = ht(), { printString: a, printNumber: e } = at(), { builders: { hardline: n, softline: r, group: o, indent: c } } = Qe(), { getParentExportDeclaration: h, isFunctionNotation: m, isGetterOrSetter: y, rawText: p, shouldPrintComma: d } = Dt(), { locStart: C, locEnd: w } = vt(), { replaceTextEndOfLine: P } = sn(), { printClass: A } = fn(), { printOpaqueType: N, printTypeAlias: S, printIntersectionType: j, printUnionType: k, printFunctionType: J, printTupleType: f, printIndexedAccessType: T } = jn(), { printInterface: D } = Iu(), { printTypeParameter: F, printTypeParameters: i } = In(), { printExportDeclaration: g, printExportAllDeclaration: E } = Lu(), { printArrayItems: x } = cn(), { printObject: b } = cr(), { printPropertyKey: B } = Dn(), { printOptionalToken: I, printTypeAnnotation: M, printRestSpread: V } = Tt();
        function $(L, ee, R) {
          let O = L.getValue(), Z = ee.semi ? ";" : "", ie = [];
          switch (O.type) {
            case "DeclareClass":
              return U(L, A(L, ee, R));
            case "DeclareFunction":
              return U(L, ["function ", R("id"), O.predicate ? " " : "", R("predicate"), Z]);
            case "DeclareModule":
              return U(L, ["module ", R("id"), " ", R("body")]);
            case "DeclareModuleExports":
              return U(L, ["module.exports", ": ", R("typeAnnotation"), Z]);
            case "DeclareVariable":
              return U(L, ["var ", R("id"), Z]);
            case "DeclareOpaqueType":
              return U(L, N(L, ee, R));
            case "DeclareInterface":
              return U(L, D(L, ee, R));
            case "DeclareTypeAlias":
              return U(L, S(L, ee, R));
            case "DeclareExportDeclaration":
              return U(L, g(L, ee, R));
            case "DeclareExportAllDeclaration":
              return U(L, E(L, ee, R));
            case "OpaqueType":
              return N(L, ee, R);
            case "TypeAlias":
              return S(L, ee, R);
            case "IntersectionTypeAnnotation":
              return j(L, ee, R);
            case "UnionTypeAnnotation":
              return k(L, ee, R);
            case "FunctionTypeAnnotation":
              return J(L, ee, R);
            case "TupleTypeAnnotation":
              return f(L, ee, R);
            case "GenericTypeAnnotation":
              return [R("id"), i(L, ee, R, "typeParameters")];
            case "IndexedAccessType":
            case "OptionalIndexedAccessType":
              return T(L, ee, R);
            case "TypeAnnotation":
              return R("typeAnnotation");
            case "TypeParameter":
              return F(L, ee, R);
            case "TypeofTypeAnnotation":
              return ["typeof ", R("argument")];
            case "ExistsTypeAnnotation":
              return "*";
            case "EmptyTypeAnnotation":
              return "empty";
            case "MixedTypeAnnotation":
              return "mixed";
            case "ArrayTypeAnnotation":
              return [R("elementType"), "[]"];
            case "BooleanLiteralTypeAnnotation":
              return String(O.value);
            case "EnumDeclaration":
              return ["enum ", R("id"), " ", R("body")];
            case "EnumBooleanBody":
            case "EnumNumberBody":
            case "EnumStringBody":
            case "EnumSymbolBody": {
              if (O.type === "EnumSymbolBody" || O.explicitType) {
                let te = null;
                switch (O.type) {
                  case "EnumBooleanBody":
                    te = "boolean";
                    break;
                  case "EnumNumberBody":
                    te = "number";
                    break;
                  case "EnumStringBody":
                    te = "string";
                    break;
                  case "EnumSymbolBody":
                    te = "symbol";
                    break;
                }
                ie.push("of ", te, " ");
              }
              if (O.members.length === 0 && !O.hasUnknownMembers)
                ie.push(o(["{", s(L, ee), r, "}"]));
              else {
                let te = O.members.length > 0 ? [n, x(L, ee, "members", R), O.hasUnknownMembers || d(ee) ? "," : ""] : [];
                ie.push(o(["{", c([...te, ...O.hasUnknownMembers ? [n, "..."] : []]), s(L, ee, !0), n, "}"]));
              }
              return ie;
            }
            case "EnumBooleanMember":
            case "EnumNumberMember":
            case "EnumStringMember":
              return [R("id"), " = ", typeof O.init == "object" ? R("init") : String(O.init)];
            case "EnumDefaultedMember":
              return R("id");
            case "FunctionTypeParam": {
              let te = O.name ? R("name") : L.getParentNode().this === O ? "this" : "";
              return [te, I(L), te ? ": " : "", R("typeAnnotation")];
            }
            case "InterfaceDeclaration":
            case "InterfaceTypeAnnotation":
              return D(L, ee, R);
            case "ClassImplements":
            case "InterfaceExtends":
              return [R("id"), R("typeParameters")];
            case "NullableTypeAnnotation":
              return ["?", R("typeAnnotation")];
            case "Variance": {
              let { kind: te } = O;
              return t.ok(te === "plus" || te === "minus"), te === "plus" ? "+" : "-";
            }
            case "ObjectTypeCallProperty":
              return O.static && ie.push("static "), ie.push(R("value")), ie;
            case "ObjectTypeIndexer":
              return [O.static ? "static " : "", O.variance ? R("variance") : "", "[", R("id"), O.id ? ": " : "", R("key"), "]: ", R("value")];
            case "ObjectTypeProperty": {
              let te = "";
              return O.proto ? te = "proto " : O.static && (te = "static "), [te, y(O) ? O.kind + " " : "", O.variance ? R("variance") : "", B(L, ee, R), I(L), m(O) ? "" : ": ", R("value")];
            }
            case "ObjectTypeAnnotation":
              return b(L, ee, R);
            case "ObjectTypeInternalSlot":
              return [O.static ? "static " : "", "[[", R("id"), "]]", I(L), O.method ? "" : ": ", R("value")];
            case "ObjectTypeSpreadProperty":
              return V(L, ee, R);
            case "QualifiedTypeofIdentifier":
            case "QualifiedTypeIdentifier":
              return [R("qualification"), ".", R("id")];
            case "StringLiteralTypeAnnotation":
              return P(a(p(O), ee));
            case "NumberLiteralTypeAnnotation":
              t.strictEqual(typeof O.value, "number");
            case "BigIntLiteralTypeAnnotation":
              return O.extra ? e(O.extra.raw) : e(O.raw);
            case "TypeCastExpression":
              return ["(", R("expression"), M(L, ee, R), ")"];
            case "TypeParameterDeclaration":
            case "TypeParameterInstantiation": {
              let te = i(L, ee, R, "params");
              if (ee.parser === "flow") {
                let ge = C(O), q = w(O), z = ee.originalText.lastIndexOf("/*", ge), De = ee.originalText.indexOf("*/", q);
                if (z !== -1 && De !== -1) {
                  let fe = ee.originalText.slice(z + 2, De).trim();
                  if (fe.startsWith("::") && !fe.includes("/*") && !fe.includes("*/"))
                    return ["/*:: ", te, " */"];
                }
              }
              return te;
            }
            case "InferredPredicate":
              return "%checks";
            case "DeclaredPredicate":
              return ["%checks(", R("value"), ")"];
            case "AnyTypeAnnotation":
              return "any";
            case "BooleanTypeAnnotation":
              return "boolean";
            case "BigIntTypeAnnotation":
              return "bigint";
            case "NullLiteralTypeAnnotation":
              return "null";
            case "NumberTypeAnnotation":
              return "number";
            case "SymbolTypeAnnotation":
              return "symbol";
            case "StringTypeAnnotation":
              return "string";
            case "VoidTypeAnnotation":
              return "void";
            case "ThisTypeAnnotation":
              return "this";
            case "Node":
            case "Printable":
            case "SourceLocation":
            case "Position":
            case "Statement":
            case "Function":
            case "Pattern":
            case "Expression":
            case "Declaration":
            case "Specifier":
            case "NamedSpecifier":
            case "Comment":
            case "MemberTypeAnnotation":
            case "Type":
              throw new Error("unprintable type: " + JSON.stringify(O.type));
          }
        }
        function U(L, ee) {
          let R = h(L);
          return R ? (t.strictEqual(R.type, "DeclareExportDeclaration"), ee) : ["declare ", ee];
        }
        l.exports = { printFlow: $ };
      } }), vs = X({ "src/language-js/utils/is-ts-keyword-type.js"(u, l) {
        H();
        function t(s) {
          let { type: a } = s;
          return a.startsWith("TS") && a.endsWith("Keyword");
        }
        l.exports = t;
      } }), _u = X({ "src/language-js/print/ternary.js"(u, l) {
        H();
        var { hasNewlineInRange: t } = at(), { isJsxNode: s, getComments: a, isCallExpression: e, isMemberExpression: n, isTSTypeExpression: r } = Dt(), { locStart: o, locEnd: c } = vt(), h = Wt(), { builders: { line: m, softline: y, group: p, indent: d, align: C, ifBreak: w, dedent: P, breakParent: A } } = Qe();
        function N(f) {
          let T = [f];
          for (let D = 0; D < T.length; D++) {
            let F = T[D];
            for (let i of ["test", "consequent", "alternate"]) {
              let g = F[i];
              if (s(g))
                return !0;
              g.type === "ConditionalExpression" && T.push(g);
            }
          }
          return !1;
        }
        function S(f, T, D) {
          let F = f.getValue(), i = F.type === "ConditionalExpression", g = i ? "alternate" : "falseType", E = f.getParentNode(), x = i ? D("test") : [D("checkType"), " ", "extends", " ", D("extendsType")];
          return E.type === F.type && E[g] === F ? C(2, x) : x;
        }
        var j = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
        function k(f) {
          let T = f.getValue();
          if (T.type !== "ConditionalExpression")
            return !1;
          let D, F = T;
          for (let i = 0; !D; i++) {
            let g = f.getParentNode(i);
            if (e(g) && g.callee === F || n(g) && g.object === F || g.type === "TSNonNullExpression" && g.expression === F) {
              F = g;
              continue;
            }
            g.type === "NewExpression" && g.callee === F || r(g) && g.expression === F ? (D = f.getParentNode(i + 1), F = g) : D = g;
          }
          return F === T ? !1 : D[j.get(D.type)] === F;
        }
        function J(f, T, D) {
          let F = f.getValue(), i = F.type === "ConditionalExpression", g = i ? "consequent" : "trueType", E = i ? "alternate" : "falseType", x = i ? ["test"] : ["checkType", "extendsType"], b = F[g], B = F[E], I = [], M = !1, V = f.getParentNode(), $ = V.type === F.type && x.some((De) => V[De] === F), U = V.type === F.type && !$, L, ee, R = 0;
          do
            ee = L || F, L = f.getParentNode(R), R++;
          while (L && L.type === F.type && x.every((De) => L[De] !== ee));
          let O = L || V, Z = ee;
          if (i && (s(F[x[0]]) || s(b) || s(B) || N(Z))) {
            M = !0, U = !0;
            let De = (we) => [w("("), d([y, we]), y, w(")")], fe = (we) => we.type === "NullLiteral" || we.type === "Literal" && we.value === null || we.type === "Identifier" && we.name === "undefined";
            I.push(" ? ", fe(b) ? D(g) : De(D(g)), " : ", B.type === F.type || fe(B) ? D(E) : De(D(E)));
          } else {
            let De = [m, "? ", b.type === F.type ? w("", "(") : "", C(2, D(g)), b.type === F.type ? w("", ")") : "", m, ": ", B.type === F.type ? D(E) : C(2, D(E))];
            I.push(V.type !== F.type || V[E] === F || $ ? De : T.useTabs ? P(d(De)) : C(Math.max(0, T.tabWidth - 2), De));
          }
          let ie = [...x.map((De) => a(F[De])), a(b), a(B)].flat().some((De) => h(De) && t(T.originalText, o(De), c(De))), te = (De) => V === O ? p(De, { shouldBreak: ie }) : ie ? [De, A] : De, ge = !M && (n(V) || V.type === "NGPipeExpression" && V.left === F) && !V.computed, q = k(f), z = te([S(f, T, D), U ? I : d(I), i && ge && !q ? y : ""]);
          return $ || q ? p([d([y, z]), y]) : z;
        }
        l.exports = { printTernary: J };
      } }), Ou = X({ "src/language-js/print/statement.js"(u, l) {
        H();
        var { builders: { hardline: t } } = Qe(), s = Zt(), { getLeftSidePathName: a, hasNakedLeftSide: e, isJsxNode: n, isTheOnlyJsxElementInMarkdown: r, hasComment: o, CommentCheckFlags: c, isNextLineEmpty: h } = Dt(), { shouldPrintParamsWithoutParens: m } = Ln();
        function y(S, j, k, J) {
          let f = S.getValue(), T = [], D = f.type === "ClassBody", F = p(f[J]);
          return S.each((i, g, E) => {
            let x = i.getValue();
            if (x.type === "EmptyStatement")
              return;
            let b = k();
            !j.semi && !D && !r(j, i) && d(i, j) ? o(x, c.Leading) ? T.push(k([], { needsSemi: !0 })) : T.push(";", b) : T.push(b), !j.semi && D && A(x) && N(x, E[g + 1]) && T.push(";"), x !== F && (T.push(t), h(x, j) && T.push(t));
          }, J), T;
        }
        function p(S) {
          for (let j = S.length - 1; j >= 0; j--) {
            let k = S[j];
            if (k.type !== "EmptyStatement")
              return k;
          }
        }
        function d(S, j) {
          return S.getNode().type !== "ExpressionStatement" ? !1 : S.call((k) => C(k, j), "expression");
        }
        function C(S, j) {
          let k = S.getValue();
          switch (k.type) {
            case "ParenthesizedExpression":
            case "TypeCastExpression":
            case "ArrayExpression":
            case "ArrayPattern":
            case "TemplateLiteral":
            case "TemplateElement":
            case "RegExpLiteral":
              return !0;
            case "ArrowFunctionExpression": {
              if (!m(S, j))
                return !0;
              break;
            }
            case "UnaryExpression": {
              let { prefix: J, operator: f } = k;
              if (J && (f === "+" || f === "-"))
                return !0;
              break;
            }
            case "BindExpression": {
              if (!k.object)
                return !0;
              break;
            }
            case "Literal": {
              if (k.regex)
                return !0;
              break;
            }
            default:
              if (n(k))
                return !0;
          }
          return s(S, j) ? !0 : e(k) ? S.call((J) => C(J, j), ...a(S, k)) : !1;
        }
        function w(S, j, k) {
          return y(S, j, k, "body");
        }
        function P(S, j, k) {
          return y(S, j, k, "consequent");
        }
        var A = (S) => {
          let { type: j } = S;
          return j === "ClassProperty" || j === "PropertyDefinition" || j === "ClassPrivateProperty" || j === "ClassAccessorProperty" || j === "AccessorProperty" || j === "TSAbstractPropertyDefinition" || j === "TSAbstractAccessorProperty";
        };
        function N(S, j) {
          let { type: k, name: J } = S.key;
          if (!S.computed && k === "Identifier" && (J === "static" || J === "get" || J === "set" || J === "accessor") && !S.value && !S.typeAnnotation)
            return !0;
          if (!j || j.static || j.accessibility)
            return !1;
          if (!j.computed) {
            let f = j.key && j.key.name;
            if (f === "in" || f === "instanceof")
              return !0;
          }
          if (A(j) && j.variance && !j.static && !j.declare)
            return !0;
          switch (j.type) {
            case "ClassProperty":
            case "PropertyDefinition":
            case "TSAbstractPropertyDefinition":
              return j.computed;
            case "MethodDefinition":
            case "TSAbstractMethodDefinition":
            case "ClassMethod":
            case "ClassPrivateMethod": {
              if ((j.value ? j.value.async : j.async) || j.kind === "get" || j.kind === "set")
                return !1;
              let f = j.value ? j.value.generator : j.generator;
              return !!(j.computed || f);
            }
            case "TSIndexSignature":
              return !0;
          }
          return !1;
        }
        l.exports = { printBody: w, printSwitchCaseConsequent: P };
      } }), Mu = X({ "src/language-js/print/block.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { isNonEmptyArray: s } = at(), { builders: { hardline: a, indent: e } } = Qe(), { hasComment: n, CommentCheckFlags: r, isNextLineEmpty: o } = Dt(), { printHardlineAfterHeritage: c } = fn(), { printBody: h } = Ou();
        function m(p, d, C) {
          let w = p.getValue(), P = [];
          if (w.type === "StaticBlock" && P.push("static "), w.type === "ClassBody" && s(w.body)) {
            let N = p.getParentNode();
            P.push(c(N));
          }
          P.push("{");
          let A = y(p, d, C);
          if (A)
            P.push(e([a, A]), a);
          else {
            let N = p.getParentNode(), S = p.getParentNode(1);
            N.type === "ArrowFunctionExpression" || N.type === "FunctionExpression" || N.type === "FunctionDeclaration" || N.type === "ObjectMethod" || N.type === "ClassMethod" || N.type === "ClassPrivateMethod" || N.type === "ForStatement" || N.type === "WhileStatement" || N.type === "DoWhileStatement" || N.type === "DoExpression" || N.type === "CatchClause" && !S.finalizer || N.type === "TSModuleDeclaration" || N.type === "TSDeclareFunction" || w.type === "StaticBlock" || w.type === "ClassBody" || P.push(a);
          }
          return P.push("}"), P;
        }
        function y(p, d, C) {
          let w = p.getValue(), P = s(w.directives), A = w.body.some((j) => j.type !== "EmptyStatement"), N = n(w, r.Dangling);
          if (!P && !A && !N)
            return "";
          let S = [];
          if (P && p.each((j, k, J) => {
            S.push(C()), (k < J.length - 1 || A || N) && (S.push(a), o(j.getValue(), d) && S.push(a));
          }, "directives"), A && S.push(h(p, d, C)), N && S.push(t(p, d, !0)), w.type === "Program") {
            let j = p.getParentNode();
            (!j || j.type !== "ModuleExpression") && S.push(a);
          }
          return S;
        }
        l.exports = { printBlock: m, printBlockBody: y };
      } }), xs = X({ "src/language-js/print/typescript.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { hasNewlineInRange: s } = at(), { builders: { join: a, line: e, hardline: n, softline: r, group: o, indent: c, conditionalGroup: h, ifBreak: m } } = Qe(), { isStringLiteral: y, getTypeScriptMappedTypeModifier: p, shouldPrintComma: d, isCallExpression: C, isMemberExpression: w } = Dt(), P = vs(), { locStart: A, locEnd: N } = vt(), { printOptionalToken: S, printTypeScriptModifiers: j } = Tt(), { printTernary: k } = _u(), { printFunctionParameters: J, shouldGroupFunctionParameters: f } = Pn(), { printTemplateLiteral: T } = Ht(), { printArrayItems: D } = cn(), { printObject: F } = cr(), { printClassProperty: i, printClassMethod: g } = fn(), { printTypeParameter: E, printTypeParameters: x } = In(), { printPropertyKey: b } = Dn(), { printFunction: B, printMethodInternal: I } = Ln(), { printInterface: M } = Iu(), { printBlock: V } = Mu(), { printTypeAlias: $, printIntersectionType: U, printUnionType: L, printFunctionType: ee, printTupleType: R, printIndexedAccessType: O, printJSDocType: Z } = jn();
        function ie(te, ge, q) {
          let z = te.getValue();
          if (!z.type.startsWith("TS"))
            return;
          if (P(z))
            return z.type.slice(2, -7).toLowerCase();
          let De = ge.semi ? ";" : "", fe = [];
          switch (z.type) {
            case "TSThisType":
              return "this";
            case "TSTypeAssertion": {
              let we = !(z.expression.type === "ArrayExpression" || z.expression.type === "ObjectExpression"), Q = o(["<", c([r, q("typeAnnotation")]), r, ">"]), W = [m("("), c([r, q("expression")]), r, m(")")];
              return we ? h([[Q, q("expression")], [Q, o(W, { shouldBreak: !0 })], [Q, q("expression")]]) : o([Q, q("expression")]);
            }
            case "TSDeclareFunction":
              return B(te, q, ge);
            case "TSExportAssignment":
              return ["export = ", q("expression"), De];
            case "TSModuleBlock":
              return V(te, ge, q);
            case "TSInterfaceBody":
            case "TSTypeLiteral":
              return F(te, ge, q);
            case "TSTypeAliasDeclaration":
              return $(te, ge, q);
            case "TSQualifiedName":
              return a(".", [q("left"), q("right")]);
            case "TSAbstractMethodDefinition":
            case "TSDeclareMethod":
              return g(te, ge, q);
            case "TSAbstractAccessorProperty":
            case "TSAbstractPropertyDefinition":
              return i(te, ge, q);
            case "TSInterfaceHeritage":
            case "TSExpressionWithTypeArguments":
              return fe.push(q("expression")), z.typeParameters && fe.push(q("typeParameters")), fe;
            case "TSTemplateLiteralType":
              return T(te, q, ge);
            case "TSNamedTupleMember":
              return [q("label"), z.optional ? "?" : "", ": ", q("elementType")];
            case "TSRestType":
              return ["...", q("typeAnnotation")];
            case "TSOptionalType":
              return [q("typeAnnotation"), "?"];
            case "TSInterfaceDeclaration":
              return M(te, ge, q);
            case "TSClassImplements":
              return [q("expression"), q("typeParameters")];
            case "TSTypeParameterDeclaration":
            case "TSTypeParameterInstantiation":
              return x(te, ge, q, "params");
            case "TSTypeParameter":
              return E(te, ge, q);
            case "TSSatisfiesExpression":
            case "TSAsExpression": {
              let we = z.type === "TSAsExpression" ? "as" : "satisfies";
              fe.push(q("expression"), ` ${we} `, q("typeAnnotation"));
              let Q = te.getParentNode();
              return C(Q) && Q.callee === z || w(Q) && Q.object === z ? o([c([r, ...fe]), r]) : fe;
            }
            case "TSArrayType":
              return [q("elementType"), "[]"];
            case "TSPropertySignature":
              return z.readonly && fe.push("readonly "), fe.push(b(te, ge, q), S(te)), z.typeAnnotation && fe.push(": ", q("typeAnnotation")), z.initializer && fe.push(" = ", q("initializer")), fe;
            case "TSParameterProperty":
              return z.accessibility && fe.push(z.accessibility + " "), z.export && fe.push("export "), z.static && fe.push("static "), z.override && fe.push("override "), z.readonly && fe.push("readonly "), fe.push(q("parameter")), fe;
            case "TSTypeQuery":
              return ["typeof ", q("exprName"), q("typeParameters")];
            case "TSIndexSignature": {
              let we = te.getParentNode(), Q = z.parameters.length > 1 ? m(d(ge) ? "," : "") : "", W = o([c([r, a([", ", r], te.map(q, "parameters"))]), Q, r]);
              return [z.export ? "export " : "", z.accessibility ? [z.accessibility, " "] : "", z.static ? "static " : "", z.readonly ? "readonly " : "", z.declare ? "declare " : "", "[", z.parameters ? W : "", z.typeAnnotation ? "]: " : "]", z.typeAnnotation ? q("typeAnnotation") : "", we.type === "ClassBody" ? De : ""];
            }
            case "TSTypePredicate":
              return [z.asserts ? "asserts " : "", q("parameterName"), z.typeAnnotation ? [" is ", q("typeAnnotation")] : ""];
            case "TSNonNullExpression":
              return [q("expression"), "!"];
            case "TSImportType":
              return [z.isTypeOf ? "typeof " : "", "import(", q(z.parameter ? "parameter" : "argument"), ")", z.qualifier ? [".", q("qualifier")] : "", x(te, ge, q, "typeParameters")];
            case "TSLiteralType":
              return q("literal");
            case "TSIndexedAccessType":
              return O(te, ge, q);
            case "TSConstructSignatureDeclaration":
            case "TSCallSignatureDeclaration":
            case "TSConstructorType": {
              if (z.type === "TSConstructorType" && z.abstract && fe.push("abstract "), z.type !== "TSCallSignatureDeclaration" && fe.push("new "), fe.push(o(J(te, q, ge, !1, !0))), z.returnType || z.typeAnnotation) {
                let we = z.type === "TSConstructorType";
                fe.push(we ? " => " : ": ", q("returnType"), q("typeAnnotation"));
              }
              return fe;
            }
            case "TSTypeOperator":
              return [z.operator, " ", q("typeAnnotation")];
            case "TSMappedType": {
              let we = s(ge.originalText, A(z), N(z));
              return o(["{", c([ge.bracketSpacing ? e : r, q("typeParameter"), z.optional ? p(z.optional, "?") : "", z.typeAnnotation ? ": " : "", q("typeAnnotation"), m(De)]), t(te, ge, !0), ge.bracketSpacing ? e : r, "}"], { shouldBreak: we });
            }
            case "TSMethodSignature": {
              let we = z.kind && z.kind !== "method" ? `${z.kind} ` : "";
              fe.push(z.accessibility ? [z.accessibility, " "] : "", we, z.export ? "export " : "", z.static ? "static " : "", z.readonly ? "readonly " : "", z.abstract ? "abstract " : "", z.declare ? "declare " : "", z.computed ? "[" : "", q("key"), z.computed ? "]" : "", S(te));
              let Q = J(te, q, ge, !1, !0), W = z.returnType ? "returnType" : "typeAnnotation", ne = z[W], re = ne ? q(W) : "", he = f(z, re);
              return fe.push(he ? o(Q) : Q), ne && fe.push(": ", o(re)), o(fe);
            }
            case "TSNamespaceExportDeclaration":
              return fe.push("export as namespace ", q("id")), ge.semi && fe.push(";"), o(fe);
            case "TSEnumDeclaration":
              return z.declare && fe.push("declare "), z.modifiers && fe.push(j(te, ge, q)), z.const && fe.push("const "), fe.push("enum ", q("id"), " "), z.members.length === 0 ? fe.push(o(["{", t(te, ge), r, "}"])) : fe.push(o(["{", c([n, D(te, ge, "members", q), d(ge, "es5") ? "," : ""]), t(te, ge, !0), n, "}"])), fe;
            case "TSEnumMember":
              return z.computed ? fe.push("[", q("id"), "]") : fe.push(q("id")), z.initializer && fe.push(" = ", q("initializer")), fe;
            case "TSImportEqualsDeclaration":
              return z.isExport && fe.push("export "), fe.push("import "), z.importKind && z.importKind !== "value" && fe.push(z.importKind, " "), fe.push(q("id"), " = ", q("moduleReference")), ge.semi && fe.push(";"), o(fe);
            case "TSExternalModuleReference":
              return ["require(", q("expression"), ")"];
            case "TSModuleDeclaration": {
              let we = te.getParentNode(), Q = y(z.id), W = we.type === "TSModuleDeclaration", ne = z.body && z.body.type === "TSModuleDeclaration";
              if (W)
                fe.push(".");
              else {
                z.declare && fe.push("declare "), fe.push(j(te, ge, q));
                let re = ge.originalText.slice(A(z), A(z.id));
                z.id.type === "Identifier" && z.id.name === "global" && !/namespace|module/.test(re) || fe.push(Q || /(?:^|\s)module(?:\s|$)/.test(re) ? "module " : "namespace ");
              }
              return fe.push(q("id")), ne ? fe.push(q("body")) : z.body ? fe.push(" ", o(q("body"))) : fe.push(De), fe;
            }
            case "TSConditionalType":
              return k(te, ge, q);
            case "TSInferType":
              return ["infer", " ", q("typeParameter")];
            case "TSIntersectionType":
              return U(te, ge, q);
            case "TSUnionType":
              return L(te, ge, q);
            case "TSFunctionType":
              return ee(te, ge, q);
            case "TSTupleType":
              return R(te, ge, q);
            case "TSTypeReference":
              return [q("typeName"), x(te, ge, q, "typeParameters")];
            case "TSTypeAnnotation":
              return q("typeAnnotation");
            case "TSEmptyBodyFunctionExpression":
              return I(te, ge, q);
            case "TSJSDocAllType":
              return "*";
            case "TSJSDocUnknownType":
              return "?";
            case "TSJSDocNullableType":
              return Z(te, q, "?");
            case "TSJSDocNonNullableType":
              return Z(te, q, "!");
            case "TSInstantiationExpression":
              return [q("expression"), q("typeParameters")];
            default:
              throw new Error(`Unknown TypeScript node type: ${JSON.stringify(z.type)}.`);
          }
        }
        l.exports = { printTypescript: ie };
      } }), bs = X({ "src/language-js/print/comment.js"(u, l) {
        H();
        var { hasNewline: t } = at(), { builders: { join: s, hardline: a }, utils: { replaceTextEndOfLine: e } } = Qe(), { isLineComment: n } = Dt(), { locStart: r, locEnd: o } = vt(), c = Wt();
        function h(p, d) {
          let C = p.getValue();
          if (n(C))
            return d.originalText.slice(r(C), o(C)).trimEnd();
          if (c(C)) {
            if (m(C)) {
              let A = y(C);
              return C.trailing && !t(d.originalText, r(C), { backwards: !0 }) ? [a, A] : A;
            }
            let w = o(C), P = d.originalText.slice(w - 3, w) === "*-/";
            return ["/*", e(C.value), P ? "*-/" : "*/"];
          }
          throw new Error("Not a comment: " + JSON.stringify(C));
        }
        function m(p) {
          let d = `*${p.value}*`.split(`
`);
          return d.length > 1 && d.every((C) => C.trim()[0] === "*");
        }
        function y(p) {
          let d = p.value.split(`
`);
          return ["/*", s(a, d.map((C, w) => w === 0 ? C.trimEnd() : " " + (w < d.length - 1 ? C.trim() : C.trimStart()))), "*/"];
        }
        l.exports = { printComment: h };
      } }), Ss = X({ "src/language-js/print/literal.js"(u, l) {
        H();
        var { printString: t, printNumber: s } = at(), { replaceTextEndOfLine: a } = sn(), { printDirective: e } = Tt();
        function n(h, m) {
          let y = h.getNode();
          switch (y.type) {
            case "RegExpLiteral":
              return c(y);
            case "BigIntLiteral":
              return o(y.bigint || y.extra.raw);
            case "NumericLiteral":
              return s(y.extra.raw);
            case "StringLiteral":
              return a(t(y.extra.raw, m));
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return String(y.value);
            case "DecimalLiteral":
              return s(y.value) + "m";
            case "Literal": {
              if (y.regex)
                return c(y.regex);
              if (y.bigint)
                return o(y.raw);
              if (y.decimal)
                return s(y.decimal) + "m";
              let { value: p } = y;
              return typeof p == "number" ? s(y.raw) : typeof p == "string" ? r(h) ? e(y.raw, m) : a(t(y.raw, m)) : String(p);
            }
          }
        }
        function r(h) {
          if (h.getName() !== "expression")
            return;
          let m = h.getParentNode();
          return m.type === "ExpressionStatement" && m.directive;
        }
        function o(h) {
          return h.toLowerCase();
        }
        function c(h) {
          let { pattern: m, flags: y } = h;
          return y = [...y].sort().join(""), `/${m}/${y}`;
        }
        l.exports = { printLiteral: n };
      } }), Ts = X({ "src/language-js/printer-estree.js"(u, l) {
        H();
        var { printDanglingComments: t } = ht(), { hasNewline: s } = at(), { builders: { join: a, line: e, hardline: n, softline: r, group: o, indent: c }, utils: { replaceTextEndOfLine: h } } = Qe(), m = os(), y = ls(), { insertPragma: p } = Bu(), d = wu(), C = Zt(), w = Nu(), { hasFlowShorthandAnnotationComment: P, hasComment: A, CommentCheckFlags: N, isTheOnlyJsxElementInMarkdown: S, isLineComment: j, isNextLineEmpty: k, needsHardlineAfterDanglingComment: J, hasIgnoreComment: f, isCallExpression: T, isMemberExpression: D, markerForIfWithoutBlockAndSameLineComment: F } = Dt(), { locStart: i, locEnd: g } = vt(), E = Wt(), { printHtmlBinding: x, isVueEventBindingExpression: b } = hs(), { printAngular: B } = Es(), { printJsx: I, hasJsxIgnoreComment: M } = Cs(), { printFlow: V } = As(), { printTypescript: $ } = xs(), { printOptionalToken: U, printBindExpressionCallee: L, printTypeAnnotation: ee, adjustClause: R, printRestSpread: O, printDefiniteToken: Z, printDirective: ie } = Tt(), { printImportDeclaration: te, printExportDeclaration: ge, printExportAllDeclaration: q, printModuleSpecifier: z } = Lu(), { printTernary: De } = _u(), { printTemplateLiteral: fe } = Ht(), { printArray: we } = cn(), { printObject: Q } = cr(), { printClass: W, printClassMethod: ne, printClassProperty: re } = fn(), { printProperty: he } = Dn(), { printFunction: Fe, printArrowFunction: ve, printMethod: Re, printReturnStatement: tt, printThrowStatement: Ze } = Ln(), { printCallExpression: $e } = ju(), { printVariableDeclarator: Ge, printAssignmentExpression: le } = dn(), { printBinaryishExpression: G } = lr(), { printSwitchCaseConsequent: me } = Ou(), { printMemberExpression: K } = Pu(), { printBlock: de, printBlockBody: je } = Mu(), { printComment: Be } = bs(), { printLiteral: ye } = Ss(), { printDecorators: v } = pr();
        function Y(Se, Me, xe, mt) {
          let _e = ae(Se, Me, xe, mt);
          if (!_e)
            return "";
          let ft = Se.getValue(), { type: Le } = ft;
          if (Le === "ClassMethod" || Le === "ClassPrivateMethod" || Le === "ClassProperty" || Le === "ClassAccessorProperty" || Le === "AccessorProperty" || Le === "TSAbstractAccessorProperty" || Le === "PropertyDefinition" || Le === "TSAbstractPropertyDefinition" || Le === "ClassPrivateProperty" || Le === "MethodDefinition" || Le === "TSAbstractMethodDefinition" || Le === "TSDeclareMethod")
            return _e;
          let Ue = [_e], et = v(Se, Me, xe), ct = ft.type === "ClassExpression" && et;
          if (et && (Ue = [...et, _e], !ct))
            return o(Ue);
          if (!C(Se, Me))
            return mt && mt.needsSemi && Ue.unshift(";"), Ue.length === 1 && Ue[0] === _e ? _e : Ue;
          if (ct && (Ue = [c([e, ...Ue])]), Ue.unshift("("), mt && mt.needsSemi && Ue.unshift(";"), P(ft)) {
            let [Oe] = ft.trailingComments;
            Ue.push(" /*", Oe.value.trimStart(), "*/"), Oe.printed = !0;
          }
          return ct && Ue.push(e), Ue.push(")"), Ue;
        }
        function ae(Se, Me, xe, mt) {
          let _e = Se.getValue(), ft = Me.semi ? ";" : "";
          if (!_e)
            return "";
          if (typeof _e == "string")
            return _e;
          for (let Ue of [ye, x, B, I, V, $]) {
            let et = Ue(Se, Me, xe);
            if (typeof et < "u")
              return et;
          }
          let Le = [];
          switch (_e.type) {
            case "JsExpressionRoot":
              return xe("node");
            case "JsonRoot":
              return [xe("node"), n];
            case "File":
              return _e.program && _e.program.interpreter && Le.push(xe(["program", "interpreter"])), Le.push(xe("program")), Le;
            case "Program":
              return je(Se, Me, xe);
            case "EmptyStatement":
              return "";
            case "ExpressionStatement": {
              if (Me.parser === "__vue_event_binding" || Me.parser === "__vue_ts_event_binding") {
                let et = Se.getParentNode();
                if (et.type === "Program" && et.body.length === 1 && et.body[0] === _e)
                  return [xe("expression"), b(_e.expression) ? ";" : ""];
              }
              let Ue = t(Se, Me, !0, (et) => {
                let { marker: ct } = et;
                return ct === F;
              });
              return [xe("expression"), S(Me, Se) ? "" : ft, Ue ? [" ", Ue] : ""];
            }
            case "ParenthesizedExpression":
              return !A(_e.expression) && (_e.expression.type === "ObjectExpression" || _e.expression.type === "ArrayExpression") ? ["(", xe("expression"), ")"] : o(["(", c([r, xe("expression")]), r, ")"]);
            case "AssignmentExpression":
              return le(Se, Me, xe);
            case "VariableDeclarator":
              return Ge(Se, Me, xe);
            case "BinaryExpression":
            case "LogicalExpression":
              return G(Se, Me, xe);
            case "AssignmentPattern":
              return [xe("left"), " = ", xe("right")];
            case "OptionalMemberExpression":
            case "MemberExpression":
              return K(Se, Me, xe);
            case "MetaProperty":
              return [xe("meta"), ".", xe("property")];
            case "BindExpression":
              return _e.object && Le.push(xe("object")), Le.push(o(c([r, L(Se, Me, xe)]))), Le;
            case "Identifier":
              return [_e.name, U(Se), Z(Se), ee(Se, Me, xe)];
            case "V8IntrinsicIdentifier":
              return ["%", _e.name];
            case "SpreadElement":
            case "SpreadElementPattern":
            case "SpreadProperty":
            case "SpreadPropertyPattern":
            case "RestElement":
              return O(Se, Me, xe);
            case "FunctionDeclaration":
            case "FunctionExpression":
              return Fe(Se, xe, Me, mt);
            case "ArrowFunctionExpression":
              return ve(Se, Me, xe, mt);
            case "YieldExpression":
              return Le.push("yield"), _e.delegate && Le.push("*"), _e.argument && Le.push(" ", xe("argument")), Le;
            case "AwaitExpression": {
              if (Le.push("await"), _e.argument) {
                Le.push(" ", xe("argument"));
                let Ue = Se.getParentNode();
                if (T(Ue) && Ue.callee === _e || D(Ue) && Ue.object === _e) {
                  Le = [c([r, ...Le]), r];
                  let et = Se.findAncestor((ct) => ct.type === "AwaitExpression" || ct.type === "BlockStatement");
                  if (!et || et.type !== "AwaitExpression")
                    return o(Le);
                }
              }
              return Le;
            }
            case "ExportDefaultDeclaration":
            case "ExportNamedDeclaration":
              return ge(Se, Me, xe);
            case "ExportAllDeclaration":
              return q(Se, Me, xe);
            case "ImportDeclaration":
              return te(Se, Me, xe);
            case "ImportSpecifier":
            case "ExportSpecifier":
            case "ImportNamespaceSpecifier":
            case "ExportNamespaceSpecifier":
            case "ImportDefaultSpecifier":
            case "ExportDefaultSpecifier":
              return z(Se, Me, xe);
            case "ImportAttribute":
              return [xe("key"), ": ", xe("value")];
            case "Import":
              return "import";
            case "BlockStatement":
            case "StaticBlock":
            case "ClassBody":
              return de(Se, Me, xe);
            case "ThrowStatement":
              return Ze(Se, Me, xe);
            case "ReturnStatement":
              return tt(Se, Me, xe);
            case "NewExpression":
            case "ImportExpression":
            case "OptionalCallExpression":
            case "CallExpression":
              return $e(Se, Me, xe);
            case "ObjectExpression":
            case "ObjectPattern":
            case "RecordExpression":
              return Q(Se, Me, xe);
            case "ObjectProperty":
            case "Property":
              return _e.method || _e.kind === "get" || _e.kind === "set" ? Re(Se, Me, xe) : he(Se, Me, xe);
            case "ObjectMethod":
              return Re(Se, Me, xe);
            case "Decorator":
              return ["@", xe("expression")];
            case "ArrayExpression":
            case "ArrayPattern":
            case "TupleExpression":
              return we(Se, Me, xe);
            case "SequenceExpression": {
              let Ue = Se.getParentNode(0);
              if (Ue.type === "ExpressionStatement" || Ue.type === "ForStatement") {
                let et = [];
                return Se.each((ct, Oe) => {
                  Oe === 0 ? et.push(xe()) : et.push(",", c([e, xe()]));
                }, "expressions"), o(et);
              }
              return o(a([",", e], Se.map(xe, "expressions")));
            }
            case "ThisExpression":
              return "this";
            case "Super":
              return "super";
            case "Directive":
              return [xe("value"), ft];
            case "DirectiveLiteral":
              return ie(_e.extra.raw, Me);
            case "UnaryExpression":
              return Le.push(_e.operator), /[a-z]$/.test(_e.operator) && Le.push(" "), A(_e.argument) ? Le.push(o(["(", c([r, xe("argument")]), r, ")"])) : Le.push(xe("argument")), Le;
            case "UpdateExpression":
              return Le.push(xe("argument"), _e.operator), _e.prefix && Le.reverse(), Le;
            case "ConditionalExpression":
              return De(Se, Me, xe);
            case "VariableDeclaration": {
              let Ue = Se.map(xe, "declarations"), et = Se.getParentNode(), ct = et.type === "ForStatement" || et.type === "ForInStatement" || et.type === "ForOfStatement", Oe = _e.declarations.some((Ye) => Ye.init), He;
              return Ue.length === 1 && !A(_e.declarations[0]) ? He = Ue[0] : Ue.length > 0 && (He = c(Ue[0])), Le = [_e.declare ? "declare " : "", _e.kind, He ? [" ", He] : "", c(Ue.slice(1).map((Ye) => [",", Oe && !ct ? n : e, Ye]))], ct && et.body !== _e || Le.push(ft), o(Le);
            }
            case "WithStatement":
              return o(["with (", xe("object"), ")", R(_e.body, xe("body"))]);
            case "IfStatement": {
              let Ue = R(_e.consequent, xe("consequent")), et = o(["if (", o([c([r, xe("test")]), r]), ")", Ue]);
              if (Le.push(et), _e.alternate) {
                let ct = A(_e.consequent, N.Trailing | N.Line) || J(_e), Oe = _e.consequent.type === "BlockStatement" && !ct;
                Le.push(Oe ? " " : n), A(_e, N.Dangling) && Le.push(t(Se, Me, !0), ct ? n : " "), Le.push("else", o(R(_e.alternate, xe("alternate"), _e.alternate.type === "IfStatement")));
              }
              return Le;
            }
            case "ForStatement": {
              let Ue = R(_e.body, xe("body")), et = t(Se, Me, !0), ct = et ? [et, r] : "";
              return !_e.init && !_e.test && !_e.update ? [ct, o(["for (;;)", Ue])] : [ct, o(["for (", o([c([r, xe("init"), ";", e, xe("test"), ";", e, xe("update")]), r]), ")", Ue])];
            }
            case "WhileStatement":
              return o(["while (", o([c([r, xe("test")]), r]), ")", R(_e.body, xe("body"))]);
            case "ForInStatement":
              return o(["for (", xe("left"), " in ", xe("right"), ")", R(_e.body, xe("body"))]);
            case "ForOfStatement":
              return o(["for", _e.await ? " await" : "", " (", xe("left"), " of ", xe("right"), ")", R(_e.body, xe("body"))]);
            case "DoWhileStatement": {
              let Ue = R(_e.body, xe("body"));
              return Le = [o(["do", Ue])], _e.body.type === "BlockStatement" ? Le.push(" ") : Le.push(n), Le.push("while (", o([c([r, xe("test")]), r]), ")", ft), Le;
            }
            case "DoExpression":
              return [_e.async ? "async " : "", "do ", xe("body")];
            case "BreakStatement":
              return Le.push("break"), _e.label && Le.push(" ", xe("label")), Le.push(ft), Le;
            case "ContinueStatement":
              return Le.push("continue"), _e.label && Le.push(" ", xe("label")), Le.push(ft), Le;
            case "LabeledStatement":
              return _e.body.type === "EmptyStatement" ? [xe("label"), ":;"] : [xe("label"), ": ", xe("body")];
            case "TryStatement":
              return ["try ", xe("block"), _e.handler ? [" ", xe("handler")] : "", _e.finalizer ? [" finally ", xe("finalizer")] : ""];
            case "CatchClause":
              if (_e.param) {
                let Ue = A(_e.param, (ct) => !E(ct) || ct.leading && s(Me.originalText, g(ct)) || ct.trailing && s(Me.originalText, i(ct), { backwards: !0 })), et = xe("param");
                return ["catch ", Ue ? ["(", c([r, et]), r, ") "] : ["(", et, ") "], xe("body")];
              }
              return ["catch ", xe("body")];
            case "SwitchStatement":
              return [o(["switch (", c([r, xe("discriminant")]), r, ")"]), " {", _e.cases.length > 0 ? c([n, a(n, Se.map((Ue, et, ct) => {
                let Oe = Ue.getValue();
                return [xe(), et !== ct.length - 1 && k(Oe, Me) ? n : ""];
              }, "cases"))]) : "", n, "}"];
            case "SwitchCase": {
              _e.test ? Le.push("case ", xe("test"), ":") : Le.push("default:"), A(_e, N.Dangling) && Le.push(" ", t(Se, Me, !0));
              let Ue = _e.consequent.filter((et) => et.type !== "EmptyStatement");
              if (Ue.length > 0) {
                let et = me(Se, Me, xe);
                Le.push(Ue.length === 1 && Ue[0].type === "BlockStatement" ? [" ", et] : c([n, et]));
              }
              return Le;
            }
            case "DebuggerStatement":
              return ["debugger", ft];
            case "ClassDeclaration":
            case "ClassExpression":
              return W(Se, Me, xe);
            case "ClassMethod":
            case "ClassPrivateMethod":
            case "MethodDefinition":
              return ne(Se, Me, xe);
            case "ClassProperty":
            case "PropertyDefinition":
            case "ClassPrivateProperty":
            case "ClassAccessorProperty":
            case "AccessorProperty":
              return re(Se, Me, xe);
            case "TemplateElement":
              return h(_e.value.raw);
            case "TemplateLiteral":
              return fe(Se, xe, Me);
            case "TaggedTemplateExpression":
              return [xe("tag"), xe("typeParameters"), xe("quasi")];
            case "PrivateIdentifier":
              return ["#", xe("name")];
            case "PrivateName":
              return ["#", xe("id")];
            case "InterpreterDirective":
              return Le.push("#!", _e.value, n), k(_e, Me) && Le.push(n), Le;
            case "TopicReference":
              return "%";
            case "ArgumentPlaceholder":
              return "?";
            case "ModuleExpression": {
              Le.push("module {");
              let Ue = xe("body");
              return Ue && Le.push(c([n, Ue]), n), Le.push("}"), Le;
            }
            default:
              throw new Error("unknown type: " + JSON.stringify(_e.type));
          }
        }
        function Ae(Se) {
          return Se.type && !E(Se) && !j(Se) && Se.type !== "EmptyStatement" && Se.type !== "TemplateElement" && Se.type !== "Import" && Se.type !== "TSEmptyBodyFunctionExpression";
        }
        l.exports = { preprocess: w, print: Y, embed: m, insertPragma: p, massageAstNode: y, hasPrettierIgnore(Se) {
          return f(Se) || M(Se);
        }, willPrintOwnComments: d.willPrintOwnComments, canAttachComment: Ae, printComment: Be, isBlockComment: E, handleComments: { avoidAstMutation: !0, ownLine: d.handleOwnLineComment, endOfLine: d.handleEndOfLineComment, remaining: d.handleRemainingComment }, getCommentChildNodes: d.getCommentChildNodes };
      } }), Bs = X({ "src/language-js/printer-estree-json.js"(u, l) {
        H();
        var { builders: { hardline: t, indent: s, join: a } } = Qe(), e = Nu();
        function n(h, m, y) {
          let p = h.getValue();
          switch (p.type) {
            case "JsonRoot":
              return [y("node"), t];
            case "ArrayExpression": {
              if (p.elements.length === 0)
                return "[]";
              let d = h.map(() => h.getValue() === null ? "null" : y(), "elements");
              return ["[", s([t, a([",", t], d)]), t, "]"];
            }
            case "ObjectExpression":
              return p.properties.length === 0 ? "{}" : ["{", s([t, a([",", t], h.map(y, "properties"))]), t, "}"];
            case "ObjectProperty":
              return [y("key"), ": ", y("value")];
            case "UnaryExpression":
              return [p.operator === "+" ? "" : p.operator, y("argument")];
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return p.value ? "true" : "false";
            case "StringLiteral":
              return JSON.stringify(p.value);
            case "NumericLiteral":
              return r(h) ? JSON.stringify(String(p.value)) : JSON.stringify(p.value);
            case "Identifier":
              return r(h) ? JSON.stringify(p.name) : p.name;
            case "TemplateLiteral":
              return y(["quasis", 0]);
            case "TemplateElement":
              return JSON.stringify(p.value.cooked);
            default:
              throw new Error("unknown type: " + JSON.stringify(p.type));
          }
        }
        function r(h) {
          return h.getName() === "key" && h.getParentNode().type === "ObjectProperty";
        }
        var o = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
        function c(h, m) {
          let { type: y } = h;
          if (y === "ObjectProperty") {
            let { key: p } = h;
            p.type === "Identifier" ? m.key = { type: "StringLiteral", value: p.name } : p.type === "NumericLiteral" && (m.key = { type: "StringLiteral", value: String(p.value) });
            return;
          }
          if (y === "UnaryExpression" && h.operator === "+")
            return m.argument;
          if (y === "ArrayExpression") {
            for (let [p, d] of h.elements.entries())
              d === null && m.elements.splice(p, 0, { type: "NullLiteral" });
            return;
          }
          if (y === "TemplateLiteral")
            return { type: "StringLiteral", value: h.quasis[0].value.cooked };
        }
        c.ignoredProperties = o, l.exports = { preprocess: e, print: n, massageAstNode: c };
      } }), en = X({ "src/common/common-options.js"(u, l) {
        H();
        var t = "Common";
        l.exports = { bracketSpacing: { since: "0.0.0", category: t, type: "boolean", default: !0, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t, type: "boolean", default: !1, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t, type: "choice", default: [{ since: "1.8.2", value: !0 }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t, type: "boolean", default: !1, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t, type: "boolean", default: !1, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
      } }), ws = X({ "src/language-js/options.js"(u, l) {
        H();
        var t = en(), s = "JavaScript";
        l.exports = { arrowParens: { since: "1.9.0", category: s, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t.bracketSameLine, bracketSpacing: t.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s, type: "boolean", default: !0, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s, type: "boolean", default: !1, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s, type: "choice", default: [{ since: "0.0.0", value: !1 }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t.singleAttributePerLine };
      } }), Ns = X({ "src/language-js/parse/parsers.js"() {
        H();
      } }), dr = X({ "node_modules/linguist-languages/data/JavaScript.json"(u, l) {
        l.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
      } }), ks = X({ "node_modules/linguist-languages/data/TypeScript.json"(u, l) {
        l.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
      } }), Ps = X({ "node_modules/linguist-languages/data/TSX.json"(u, l) {
        l.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
      } }), $u = X({ "node_modules/linguist-languages/data/JSON.json"(u, l) {
        l.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
      } }), js = X({ "node_modules/linguist-languages/data/JSON with Comments.json"(u, l) {
        l.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
      } }), Is = X({ "node_modules/linguist-languages/data/JSON5.json"(u, l) {
        l.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
      } }), Ls = X({ "src/language-js/index.js"(u, l) {
        H();
        var t = Gt(), s = Ts(), a = Bs(), e = ws(), n = Ns(), r = [t(dr(), (c) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...c.interpreters, "zx"], extensions: [...c.extensions.filter((h) => h !== ".jsx"), ".wxs"] })), t(dr(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t(dr(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t(ks(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t(Ps(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t($u(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t($u(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: c.extensions.filter((h) => h !== ".jsonl") })), t(js(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...c.filenames, ".eslintrc", ".swcrc"] })), t(Is(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], o = { estree: s, "estree-json": a };
        l.exports = { languages: r, options: e, printers: o, parsers: n };
      } }), _s = X({ "src/language-css/clean.js"(u, l) {
        H();
        var { isFrontMatterNode: t } = at(), s = Ct(), a = /* @__PURE__ */ new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
        function e(r, o, c) {
          if (t(r) && r.lang === "yaml" && delete o.value, r.type === "css-comment" && c.type === "css-root" && c.nodes.length > 0 && ((c.nodes[0] === r || t(c.nodes[0]) && c.nodes[1] === r) && (delete o.text, /^\*\s*@(?:format|prettier)\s*$/.test(r.text)) || c.type === "css-root" && s(c.nodes) === r))
            return null;
          if (r.type === "value-root" && delete o.text, (r.type === "media-query" || r.type === "media-query-list" || r.type === "media-feature-expression") && delete o.value, r.type === "css-rule" && delete o.params, r.type === "selector-combinator" && (o.value = o.value.replace(/\s+/g, " ")), r.type === "media-feature" && (o.value = o.value.replace(/ /g, "")), (r.type === "value-word" && (r.isColor && r.isHex || ["initial", "inherit", "unset", "revert"].includes(o.value.replace().toLowerCase())) || r.type === "media-feature" || r.type === "selector-root-invalid" || r.type === "selector-pseudo") && (o.value = o.value.toLowerCase()), r.type === "css-decl" && (o.prop = o.prop.toLowerCase()), (r.type === "css-atrule" || r.type === "css-import") && (o.name = o.name.toLowerCase()), r.type === "value-number" && (o.unit = o.unit.toLowerCase()), (r.type === "media-feature" || r.type === "media-keyword" || r.type === "media-type" || r.type === "media-unknown" || r.type === "media-url" || r.type === "media-value" || r.type === "selector-attribute" || r.type === "selector-string" || r.type === "selector-class" || r.type === "selector-combinator" || r.type === "value-string") && o.value && (o.value = n(o.value)), r.type === "selector-attribute" && (o.attribute = o.attribute.trim(), o.namespace && typeof o.namespace == "string" && (o.namespace = o.namespace.trim(), o.namespace.length === 0 && (o.namespace = !0)), o.value && (o.value = o.value.trim().replace(/^["']|["']$/g, ""), delete o.quoted)), (r.type === "media-value" || r.type === "media-type" || r.type === "value-number" || r.type === "selector-root-invalid" || r.type === "selector-class" || r.type === "selector-combinator" || r.type === "selector-tag") && o.value && (o.value = o.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (h, m, y) => {
            let p = Number(m);
            return Number.isNaN(p) ? h : p + y.toLowerCase();
          })), r.type === "selector-tag") {
            let h = r.value.toLowerCase();
            ["from", "to"].includes(h) && (o.value = h);
          }
          if (r.type === "css-atrule" && r.name.toLowerCase() === "supports" && delete o.value, r.type === "selector-unknown" && delete o.value, r.type === "value-comma_group") {
            let h = r.groups.findIndex((m) => m.type === "value-number" && m.unit === "...");
            h !== -1 && (o.groups[h].unit = "", o.groups.splice(h + 1, 0, { type: "value-word", value: "...", isColor: !1, isHex: !1 }));
          }
          if (r.type === "value-comma_group" && r.groups.some((h) => h.type === "value-atword" && h.value.endsWith("[") || h.type === "value-word" && h.value.startsWith("]")))
            return { type: "value-atword", value: r.groups.map((h) => h.value).join(""), group: { open: null, close: null, groups: [], type: "value-paren_group" } };
        }
        e.ignoredProperties = a;
        function n(r) {
          return r.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
        }
        l.exports = e;
      } }), Dr = X({ "src/utils/front-matter/print.js"(u, l) {
        H();
        var { builders: { hardline: t, markAsRoot: s } } = Qe();
        function a(e, n) {
          if (e.lang === "yaml") {
            let r = e.value.trim(), o = r ? n(r, { parser: "yaml" }, { stripTrailingHardline: !0 }) : "";
            return s([e.startDelimiter, t, o, o ? t : "", e.endDelimiter]);
          }
        }
        l.exports = a;
      } }), Os = X({ "src/language-css/embed.js"(u, l) {
        H();
        var { builders: { hardline: t } } = Qe(), s = Dr();
        function a(e, n, r) {
          let o = e.getValue();
          if (o.type === "front-matter") {
            let c = s(o, r);
            return c ? [c, t] : "";
          }
        }
        l.exports = a;
      } }), Ru = X({ "src/utils/front-matter/parse.js"(u, l) {
        H();
        var t = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function s(a) {
          let e = a.match(t);
          if (!e)
            return { content: a };
          let { startDelimiter: n, language: r, value: o = "", endDelimiter: c } = e.groups, h = r.trim() || "yaml";
          if (n === "+++" && (h = "toml"), h !== "yaml" && n !== c)
            return { content: a };
          let [m] = e;
          return { frontMatter: { type: "front-matter", lang: h, value: o, startDelimiter: n, endDelimiter: c, raw: m.replace(/\n$/, "") }, content: m.replace(/[^\n]/g, " ") + a.slice(m.length) };
        }
        l.exports = s;
      } }), Ms = X({ "src/language-css/pragma.js"(u, l) {
        H();
        var t = Bu(), s = Ru();
        function a(n) {
          return t.hasPragma(s(n).content);
        }
        function e(n) {
          let { frontMatter: r, content: o } = s(n);
          return (r ? r.raw + `

` : "") + t.insertPragma(o);
        }
        l.exports = { hasPragma: a, insertPragma: e };
      } }), $s = X({ "src/language-css/utils/index.js"(u, l) {
        H();
        var t = /* @__PURE__ */ new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
        function s(Q, W) {
          let ne = Array.isArray(W) ? W : [W], re = -1, he;
          for (; he = Q.getParentNode(++re); )
            if (ne.includes(he.type))
              return re;
          return -1;
        }
        function a(Q, W) {
          let ne = s(Q, W);
          return ne === -1 ? null : Q.getParentNode(ne);
        }
        function e(Q) {
          var W;
          let ne = a(Q, "css-decl");
          return ne == null || (W = ne.prop) === null || W === void 0 ? void 0 : W.toLowerCase();
        }
        var n = /* @__PURE__ */ new Set(["initial", "inherit", "unset", "revert"]);
        function r(Q) {
          return n.has(Q.toLowerCase());
        }
        function o(Q, W) {
          let ne = a(Q, "css-atrule");
          return (ne == null ? void 0 : ne.name) && ne.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(W.toLowerCase());
        }
        function c(Q) {
          return Q.includes("$") || Q.includes("@") || Q.includes("#") || Q.startsWith("%") || Q.startsWith("--") || Q.startsWith(":--") || Q.includes("(") && Q.includes(")") ? Q : Q.toLowerCase();
        }
        function h(Q, W) {
          var ne;
          let re = a(Q, "value-func");
          return (re == null || (ne = re.value) === null || ne === void 0 ? void 0 : ne.toLowerCase()) === W;
        }
        function m(Q) {
          var W;
          let ne = a(Q, "css-rule"), re = ne == null || (W = ne.raws) === null || W === void 0 ? void 0 : W.selector;
          return re && (re.startsWith(":import") || re.startsWith(":export"));
        }
        function y(Q, W) {
          let ne = Array.isArray(W) ? W : [W], re = a(Q, "css-atrule");
          return re && ne.includes(re.name.toLowerCase());
        }
        function p(Q) {
          let W = Q.getValue(), ne = a(Q, "css-atrule");
          return (ne == null ? void 0 : ne.name) === "import" && W.groups[0].value === "url" && W.groups.length === 2;
        }
        function d(Q) {
          return Q.type === "value-func" && Q.value.toLowerCase() === "url";
        }
        function C(Q, W) {
          var ne;
          let re = (ne = Q.getParentNode()) === null || ne === void 0 ? void 0 : ne.nodes;
          return re && re.indexOf(W) === re.length - 1;
        }
        function w(Q) {
          let { selector: W } = Q;
          return W ? typeof W == "string" && /^@.+:.*$/.test(W) || W.value && /^@.+:.*$/.test(W.value) : !1;
        }
        function P(Q) {
          return Q.type === "value-word" && ["from", "through", "end"].includes(Q.value);
        }
        function A(Q) {
          return Q.type === "value-word" && ["and", "or", "not"].includes(Q.value);
        }
        function N(Q) {
          return Q.type === "value-word" && Q.value === "in";
        }
        function S(Q) {
          return Q.type === "value-operator" && Q.value === "*";
        }
        function j(Q) {
          return Q.type === "value-operator" && Q.value === "/";
        }
        function k(Q) {
          return Q.type === "value-operator" && Q.value === "+";
        }
        function J(Q) {
          return Q.type === "value-operator" && Q.value === "-";
        }
        function f(Q) {
          return Q.type === "value-operator" && Q.value === "%";
        }
        function T(Q) {
          return S(Q) || j(Q) || k(Q) || J(Q) || f(Q);
        }
        function D(Q) {
          return Q.type === "value-word" && ["==", "!="].includes(Q.value);
        }
        function F(Q) {
          return Q.type === "value-word" && ["<", ">", "<=", ">="].includes(Q.value);
        }
        function i(Q) {
          return Q.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(Q.name);
        }
        function g(Q) {
          var W;
          return ((W = Q.raws) === null || W === void 0 ? void 0 : W.params) && /^\(\s*\)$/.test(Q.raws.params);
        }
        function E(Q) {
          return Q.name.startsWith("prettier-placeholder");
        }
        function x(Q) {
          return Q.prop.startsWith("@prettier-placeholder");
        }
        function b(Q, W) {
          return Q.value === "$$" && Q.type === "value-func" && (W == null ? void 0 : W.type) === "value-word" && !W.raws.before;
        }
        function B(Q) {
          var W, ne;
          return ((W = Q.value) === null || W === void 0 ? void 0 : W.type) === "value-root" && ((ne = Q.value.group) === null || ne === void 0 ? void 0 : ne.type) === "value-value" && Q.prop.toLowerCase() === "composes";
        }
        function I(Q) {
          var W, ne, re;
          return ((W = Q.value) === null || W === void 0 || (ne = W.group) === null || ne === void 0 || (re = ne.group) === null || re === void 0 ? void 0 : re.type) === "value-paren_group" && Q.value.group.group.open !== null && Q.value.group.group.close !== null;
        }
        function M(Q) {
          var W;
          return ((W = Q.raws) === null || W === void 0 ? void 0 : W.before) === "";
        }
        function V(Q) {
          var W, ne;
          return Q.type === "value-comma_group" && ((W = Q.groups) === null || W === void 0 || (ne = W[1]) === null || ne === void 0 ? void 0 : ne.type) === "value-colon";
        }
        function $(Q) {
          var W;
          return Q.type === "value-paren_group" && ((W = Q.groups) === null || W === void 0 ? void 0 : W[0]) && V(Q.groups[0]);
        }
        function U(Q) {
          var W;
          let ne = Q.getValue();
          if (ne.groups.length === 0)
            return !1;
          let re = Q.getParentNode(1);
          if (!$(ne) && !(re && $(re)))
            return !1;
          let he = a(Q, "css-decl");
          return !!(he != null && (W = he.prop) !== null && W !== void 0 && W.startsWith("$") || $(re) || re.type === "value-func");
        }
        function L(Q) {
          return Q.type === "value-comment" && Q.inline;
        }
        function ee(Q) {
          return Q.type === "value-word" && Q.value === "#";
        }
        function R(Q) {
          return Q.type === "value-word" && Q.value === "{";
        }
        function O(Q) {
          return Q.type === "value-word" && Q.value === "}";
        }
        function Z(Q) {
          return ["value-word", "value-atword"].includes(Q.type);
        }
        function ie(Q) {
          return (Q == null ? void 0 : Q.type) === "value-colon";
        }
        function te(Q, W) {
          if (!V(W))
            return !1;
          let { groups: ne } = W, re = ne.indexOf(Q);
          return re === -1 ? !1 : ie(ne[re + 1]);
        }
        function ge(Q) {
          return Q.value && ["not", "and", "or"].includes(Q.value.toLowerCase());
        }
        function q(Q) {
          return Q.type !== "value-func" ? !1 : t.has(Q.value.toLowerCase());
        }
        function z(Q) {
          return /\/\//.test(Q.split(/[\n\r]/).pop());
        }
        function De(Q) {
          return (Q == null ? void 0 : Q.type) === "value-atword" && Q.value.startsWith("prettier-placeholder-");
        }
        function fe(Q, W) {
          var ne, re;
          if (((ne = Q.open) === null || ne === void 0 ? void 0 : ne.value) !== "(" || ((re = Q.close) === null || re === void 0 ? void 0 : re.value) !== ")" || Q.groups.some((he) => he.type !== "value-comma_group"))
            return !1;
          if (W.type === "value-comma_group") {
            let he = W.groups.indexOf(Q) - 1, Fe = W.groups[he];
            if ((Fe == null ? void 0 : Fe.type) === "value-word" && Fe.value === "with")
              return !0;
          }
          return !1;
        }
        function we(Q) {
          var W, ne;
          return Q.type === "value-paren_group" && ((W = Q.open) === null || W === void 0 ? void 0 : W.value) === "(" && ((ne = Q.close) === null || ne === void 0 ? void 0 : ne.value) === ")";
        }
        l.exports = { getAncestorCounter: s, getAncestorNode: a, getPropOfDeclNode: e, maybeToLowerCase: c, insideValueFunctionNode: h, insideICSSRuleNode: m, insideAtRuleNode: y, insideURLFunctionInImportAtRuleNode: p, isKeyframeAtRuleKeywords: o, isWideKeywords: r, isLastNode: C, isSCSSControlDirectiveNode: i, isDetachedRulesetDeclarationNode: w, isRelationalOperatorNode: F, isEqualityOperatorNode: D, isMultiplicationNode: S, isDivisionNode: j, isAdditionNode: k, isSubtractionNode: J, isModuloNode: f, isMathOperatorNode: T, isEachKeywordNode: N, isForKeywordNode: P, isURLFunctionNode: d, isIfElseKeywordNode: A, hasComposesNode: B, hasParensAroundNode: I, hasEmptyRawBefore: M, isDetachedRulesetCallNode: g, isTemplatePlaceholderNode: E, isTemplatePropNode: x, isPostcssSimpleVarNode: b, isKeyValuePairNode: V, isKeyValuePairInParenGroupNode: $, isKeyInValuePairNode: te, isSCSSMapItemNode: U, isInlineValueCommentNode: L, isHashNode: ee, isLeftCurlyBraceNode: R, isRightCurlyBraceNode: O, isWordNode: Z, isColonNode: ie, isMediaAndSupportsKeywords: ge, isColorAdjusterFuncNode: q, lastLineHasInlineComment: z, isAtWordPlaceholderNode: De, isConfigurationNode: fe, isParenGroupNode: we };
      } }), Rs = X({ "src/utils/line-column-to-index.js"(u, l) {
        H(), l.exports = function(t, s) {
          let a = 0;
          for (let e = 0; e < t.line - 1; ++e)
            a = s.indexOf(`
`, a) + 1;
          return a + t.column;
        };
      } }), Vs = X({ "src/language-css/loc.js"(u, l) {
        H();
        var { skipEverythingButNewLine: t } = bn(), s = Ct(), a = Rs();
        function e(p, d) {
          return typeof p.sourceIndex == "number" ? p.sourceIndex : p.source ? a(p.source.start, d) - 1 : null;
        }
        function n(p, d) {
          if (p.type === "css-comment" && p.inline)
            return t(d, p.source.startOffset);
          let C = p.nodes && s(p.nodes);
          return C && p.source && !p.source.end && (p = C), p.source && p.source.end ? a(p.source.end, d) : null;
        }
        function r(p, d) {
          p.source && (p.source.startOffset = e(p, d), p.source.endOffset = n(p, d));
          for (let C in p) {
            let w = p[C];
            C === "source" || !w || typeof w != "object" || (w.type === "value-root" || w.type === "value-unknown" ? o(w, c(p), w.text || w.value) : r(w, d));
          }
        }
        function o(p, d, C) {
          p.source && (p.source.startOffset = e(p, C) + d, p.source.endOffset = n(p, C) + d);
          for (let w in p) {
            let P = p[w];
            w === "source" || !P || typeof P != "object" || o(P, d, C);
          }
        }
        function c(p) {
          let d = p.source.startOffset;
          return typeof p.prop == "string" && (d += p.prop.length), p.type === "css-atrule" && typeof p.name == "string" && (d += 1 + p.name.length + p.raws.afterName.match(/^\s*:?\s*/)[0].length), p.type !== "css-atrule" && p.raws && typeof p.raws.between == "string" && (d += p.raws.between.length), d;
        }
        function h(p) {
          let d = "initial", C = "initial", w, P = !1, A = [];
          for (let N = 0; N < p.length; N++) {
            let S = p[N];
            switch (d) {
              case "initial":
                if (S === "'") {
                  d = "single-quotes";
                  continue;
                }
                if (S === '"') {
                  d = "double-quotes";
                  continue;
                }
                if ((S === "u" || S === "U") && p.slice(N, N + 4).toLowerCase() === "url(") {
                  d = "url", N += 3;
                  continue;
                }
                if (S === "*" && p[N - 1] === "/") {
                  d = "comment-block";
                  continue;
                }
                if (S === "/" && p[N - 1] === "/") {
                  d = "comment-inline", w = N - 1;
                  continue;
                }
                continue;
              case "single-quotes":
                if (S === "'" && p[N - 1] !== "\\" && (d = C, C = "initial"), S === `
` || S === "\r")
                  return p;
                continue;
              case "double-quotes":
                if (S === '"' && p[N - 1] !== "\\" && (d = C, C = "initial"), S === `
` || S === "\r")
                  return p;
                continue;
              case "url":
                if (S === ")" && (d = "initial"), S === `
` || S === "\r")
                  return p;
                if (S === "'") {
                  d = "single-quotes", C = "url";
                  continue;
                }
                if (S === '"') {
                  d = "double-quotes", C = "url";
                  continue;
                }
                continue;
              case "comment-block":
                S === "/" && p[N - 1] === "*" && (d = "initial");
                continue;
              case "comment-inline":
                (S === '"' || S === "'" || S === "*") && (P = !0), (S === `
` || S === "\r") && (P && A.push([w, N]), d = "initial", P = !1);
                continue;
            }
          }
          for (let [N, S] of A)
            p = p.slice(0, N) + p.slice(N, S).replace(/["'*]/g, " ") + p.slice(S);
          return p;
        }
        function m(p) {
          return p.source.startOffset;
        }
        function y(p) {
          return p.source.endOffset;
        }
        l.exports = { locStart: m, locEnd: y, calculateLoc: r, replaceQuotesInInlineComments: h };
      } }), Js = X({ "src/language-css/utils/is-less-parser.js"(u, l) {
        H();
        function t(s) {
          return s.parser === "css" || s.parser === "less";
        }
        l.exports = t;
      } }), qs = X({ "src/language-css/utils/is-scss.js"(u, l) {
        H();
        function t(s, a) {
          return s === "less" || s === "scss" ? s === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a);
        }
        l.exports = t;
      } }), Gs = X({ "src/language-css/utils/css-units.evaluate.js"(u, l) {
        l.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
      } }), Ws = X({ "src/language-css/utils/print-unit.js"(u, l) {
        H();
        var t = Gs();
        function s(a) {
          let e = a.toLowerCase();
          return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : a;
        }
        l.exports = s;
      } }), Xs = X({ "src/language-css/printer-postcss.js"(u, l) {
        H();
        var t = Ct(), { printNumber: s, printString: a, hasNewline: e, isFrontMatterNode: n, isNextLineEmpty: r, isNonEmptyArray: o } = at(), { builders: { join: c, line: h, hardline: m, softline: y, group: p, fill: d, indent: C, dedent: w, ifBreak: P, breakParent: A }, utils: { removeLines: N, getDocParts: S } } = Qe(), j = _s(), k = Os(), { insertPragma: J } = Ms(), { getAncestorNode: f, getPropOfDeclNode: T, maybeToLowerCase: D, insideValueFunctionNode: F, insideICSSRuleNode: i, insideAtRuleNode: g, insideURLFunctionInImportAtRuleNode: E, isKeyframeAtRuleKeywords: x, isWideKeywords: b, isLastNode: B, isSCSSControlDirectiveNode: I, isDetachedRulesetDeclarationNode: M, isRelationalOperatorNode: V, isEqualityOperatorNode: $, isMultiplicationNode: U, isDivisionNode: L, isAdditionNode: ee, isSubtractionNode: R, isMathOperatorNode: O, isEachKeywordNode: Z, isForKeywordNode: ie, isURLFunctionNode: te, isIfElseKeywordNode: ge, hasComposesNode: q, hasParensAroundNode: z, hasEmptyRawBefore: De, isKeyValuePairNode: fe, isKeyInValuePairNode: we, isDetachedRulesetCallNode: Q, isTemplatePlaceholderNode: W, isTemplatePropNode: ne, isPostcssSimpleVarNode: re, isSCSSMapItemNode: he, isInlineValueCommentNode: Fe, isHashNode: ve, isLeftCurlyBraceNode: Re, isRightCurlyBraceNode: tt, isWordNode: Ze, isColonNode: $e, isMediaAndSupportsKeywords: Ge, isColorAdjusterFuncNode: le, lastLineHasInlineComment: G, isAtWordPlaceholderNode: me, isConfigurationNode: K, isParenGroupNode: de } = $s(), { locStart: je, locEnd: Be } = Vs(), ye = Js(), v = qs(), Y = Ws();
        function ae(Oe) {
          return Oe.trailingComma === "es5" || Oe.trailingComma === "all";
        }
        function Ae(Oe, He, Ye) {
          let pe = Oe.getValue();
          if (!pe)
            return "";
          if (typeof pe == "string")
            return pe;
          switch (pe.type) {
            case "front-matter":
              return [pe.raw, m];
            case "css-root": {
              let ut = Se(Oe, He, Ye), it = pe.raws.after.trim();
              return it.startsWith(";") && (it = it.slice(1).trim()), [ut, it ? ` ${it}` : "", S(ut).length > 0 ? m : ""];
            }
            case "css-comment": {
              let ut = pe.inline || pe.raws.inline, it = He.originalText.slice(je(pe), Be(pe));
              return ut ? it.trimEnd() : it;
            }
            case "css-rule":
              return [Ye("selector"), pe.important ? " !important" : "", pe.nodes ? [pe.selector && pe.selector.type === "selector-unknown" && G(pe.selector.value) ? h : " ", "{", pe.nodes.length > 0 ? C([m, Se(Oe, He, Ye)]) : "", m, "}", M(pe) ? ";" : ""] : ";"];
            case "css-decl": {
              let ut = Oe.getParentNode(), { between: it } = pe.raws, dt = it.trim(), wt = dt === ":", _ = q(pe) ? N(Ye("value")) : Ye("value");
              return !wt && G(dt) && (_ = C([m, w(_)])), [pe.raws.before.replace(/[\s;]/g, ""), ut.type === "css-atrule" && ut.variable || i(Oe) ? pe.prop : D(pe.prop), dt.startsWith("//") ? " " : "", dt, pe.extend ? "" : " ", ye(He) && pe.extend && pe.selector ? ["extend(", Ye("selector"), ")"] : "", _, pe.raws.important ? pe.raws.important.replace(/\s*!\s*important/i, " !important") : pe.important ? " !important" : "", pe.raws.scssDefault ? pe.raws.scssDefault.replace(/\s*!default/i, " !default") : pe.scssDefault ? " !default" : "", pe.raws.scssGlobal ? pe.raws.scssGlobal.replace(/\s*!global/i, " !global") : pe.scssGlobal ? " !global" : "", pe.nodes ? [" {", C([y, Se(Oe, He, Ye)]), y, "}"] : ne(pe) && !ut.raws.semicolon && He.originalText[Be(pe) - 1] !== ";" ? "" : He.__isHTMLStyleAttribute && B(Oe, pe) ? P(";") : ";"];
            }
            case "css-atrule": {
              let ut = Oe.getParentNode(), it = W(pe) && !ut.raws.semicolon && He.originalText[Be(pe) - 1] !== ";";
              if (ye(He)) {
                if (pe.mixin)
                  return [Ye("selector"), pe.important ? " !important" : "", it ? "" : ";"];
                if (pe.function)
                  return [pe.name, Ye("params"), it ? "" : ";"];
                if (pe.variable)
                  return ["@", pe.name, ": ", pe.value ? Ye("value") : "", pe.raws.between.trim() ? pe.raws.between.trim() + " " : "", pe.nodes ? ["{", C([pe.nodes.length > 0 ? y : "", Se(Oe, He, Ye)]), y, "}"] : "", it ? "" : ";"];
              }
              return ["@", Q(pe) || pe.name.endsWith(":") ? pe.name : D(pe.name), pe.params ? [Q(pe) ? "" : W(pe) ? pe.raws.afterName === "" ? "" : pe.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(pe.raws.afterName) ? [m, m] : /^\s*\n/.test(pe.raws.afterName) ? m : " " : " ", Ye("params")] : "", pe.selector ? C([" ", Ye("selector")]) : "", pe.value ? p([" ", Ye("value"), I(pe) ? z(pe) ? " " : h : ""]) : pe.name === "else" ? " " : "", pe.nodes ? [I(pe) ? "" : pe.selector && !pe.selector.nodes && typeof pe.selector.value == "string" && G(pe.selector.value) || !pe.selector && typeof pe.params == "string" && G(pe.params) ? h : " ", "{", C([pe.nodes.length > 0 ? y : "", Se(Oe, He, Ye)]), y, "}"] : it ? "" : ";"];
            }
            case "media-query-list": {
              let ut = [];
              return Oe.each((it) => {
                let dt = it.getValue();
                dt.type === "media-query" && dt.value === "" || ut.push(Ye());
              }, "nodes"), p(C(c(h, ut)));
            }
            case "media-query":
              return [c(" ", Oe.map(Ye, "nodes")), B(Oe, pe) ? "" : ","];
            case "media-type":
              return et(Le(pe.value, He));
            case "media-feature-expression":
              return pe.nodes ? ["(", ...Oe.map(Ye, "nodes"), ")"] : pe.value;
            case "media-feature":
              return D(Le(pe.value.replace(/ +/g, " "), He));
            case "media-colon":
              return [pe.value, " "];
            case "media-value":
              return et(Le(pe.value, He));
            case "media-keyword":
              return Le(pe.value, He);
            case "media-url":
              return Le(pe.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), He);
            case "media-unknown":
              return pe.value;
            case "selector-root":
              return p([g(Oe, "custom-selector") ? [f(Oe, "css-atrule").customSelector, h] : "", c([",", g(Oe, ["extend", "custom-selector", "nest"]) ? h : m], Oe.map(Ye, "nodes"))]);
            case "selector-selector":
              return p(C(Oe.map(Ye, "nodes")));
            case "selector-comment":
              return pe.value;
            case "selector-string":
              return Le(pe.value, He);
            case "selector-tag": {
              let ut = Oe.getParentNode(), it = ut && ut.nodes.indexOf(pe), dt = it && ut.nodes[it - 1];
              return [pe.namespace ? [pe.namespace === !0 ? "" : pe.namespace.trim(), "|"] : "", dt.type === "selector-nesting" ? pe.value : et(x(Oe, pe.value) ? pe.value.toLowerCase() : pe.value)];
            }
            case "selector-id":
              return ["#", pe.value];
            case "selector-class":
              return [".", et(Le(pe.value, He))];
            case "selector-attribute": {
              var Bt;
              return ["[", pe.namespace ? [pe.namespace === !0 ? "" : pe.namespace.trim(), "|"] : "", pe.attribute.trim(), (Bt = pe.operator) !== null && Bt !== void 0 ? Bt : "", pe.value ? Ue(Le(pe.value.trim(), He), He) : "", pe.insensitive ? " i" : "", "]"];
            }
            case "selector-combinator": {
              if (pe.value === "+" || pe.value === ">" || pe.value === "~" || pe.value === ">>>") {
                let dt = Oe.getParentNode();
                return [dt.type === "selector-selector" && dt.nodes[0] === pe ? "" : h, pe.value, B(Oe, pe) ? "" : " "];
              }
              let ut = pe.value.trim().startsWith("(") ? h : "", it = et(Le(pe.value.trim(), He)) || h;
              return [ut, it];
            }
            case "selector-universal":
              return [pe.namespace ? [pe.namespace === !0 ? "" : pe.namespace.trim(), "|"] : "", pe.value];
            case "selector-pseudo":
              return [D(pe.value), o(pe.nodes) ? p(["(", C([y, c([",", h], Oe.map(Ye, "nodes"))]), y, ")"]) : ""];
            case "selector-nesting":
              return pe.value;
            case "selector-unknown": {
              let ut = f(Oe, "css-rule");
              if (ut && ut.isSCSSNesterProperty)
                return et(Le(D(pe.value), He));
              let it = Oe.getParentNode();
              if (it.raws && it.raws.selector) {
                let wt = je(it), _ = wt + it.raws.selector.length;
                return He.originalText.slice(wt, _).trim();
              }
              let dt = Oe.getParentNode(1);
              if (it.type === "value-paren_group" && dt && dt.type === "value-func" && dt.value === "selector") {
                let wt = Be(it.open) + 1, _ = je(it.close), Ee = He.originalText.slice(wt, _).trim();
                return G(Ee) ? [A, Ee] : Ee;
              }
              return pe.value;
            }
            case "value-value":
            case "value-root":
              return Ye("group");
            case "value-comment":
              return He.originalText.slice(je(pe), Be(pe));
            case "value-comma_group": {
              let ut = Oe.getParentNode(), it = Oe.getParentNode(1), dt = T(Oe), wt = dt && ut.type === "value-value" && (dt === "grid" || dt.startsWith("grid-template")), _ = f(Oe, "css-atrule"), Ee = _ && I(_), qe = pe.groups.some((Nt) => Fe(Nt)), st = Oe.map(Ye, "groups"), ot = [], St = F(Oe, "url"), gt = !1, At = !1;
              for (let Nt = 0; Nt < pe.groups.length; ++Nt) {
                var Ft;
                ot.push(st[Nt]);
                let Et = pe.groups[Nt - 1], ze = pe.groups[Nt], nt = pe.groups[Nt + 1], On = pe.groups[Nt + 2];
                if (St) {
                  (nt && ee(nt) || ee(ze)) && ot.push(" ");
                  continue;
                }
                if (g(Oe, "forward") && ze.type === "value-word" && ze.value && Et !== void 0 && Et.type === "value-word" && Et.value === "as" && nt.type === "value-operator" && nt.value === "*" || !nt || ze.type === "value-word" && ze.value.endsWith("-") && me(nt))
                  continue;
                if (ze.type === "value-string" && ze.quoted) {
                  let Er = ze.value.lastIndexOf("#{"), Cr = ze.value.lastIndexOf("}");
                  Er !== -1 && Cr !== -1 ? gt = Er > Cr : Er !== -1 ? gt = !0 : Cr !== -1 && (gt = !1);
                }
                if (gt || $e(ze) || $e(nt) || ze.type === "value-atword" && (ze.value === "" || ze.value.endsWith("[")) || nt.type === "value-word" && nt.value.startsWith("]") || ze.value === "~" || ze.value && ze.value.includes("\\") && nt && nt.type !== "value-comment" || Et && Et.value && Et.value.indexOf("\\") === Et.value.length - 1 && ze.type === "value-operator" && ze.value === "/" || ze.value === "\\" || re(ze, nt) || ve(ze) || Re(ze) || tt(nt) || Re(nt) && De(nt) || tt(ze) && De(nt) || ze.value === "--" && ve(nt))
                  continue;
                let hr = O(ze), Uu = O(nt);
                if ((hr && ve(nt) || Uu && tt(ze)) && De(nt) || !Et && L(ze) || F(Oe, "calc") && (ee(ze) || ee(nt) || R(ze) || R(nt)) && De(nt))
                  continue;
                let ol = (ee(ze) || R(ze)) && Nt === 0 && (nt.type === "value-number" || nt.isHex) && it && le(it) && !De(nt), Yu = On && On.type === "value-func" || On && Ze(On) || ze.type === "value-func" || Ze(ze), zu = nt.type === "value-func" || Ze(nt) || Et && Et.type === "value-func" || Et && Ze(Et);
                if (!(!(U(nt) || U(ze)) && !F(Oe, "calc") && !ol && (L(nt) && !Yu || L(ze) && !zu || ee(nt) && !Yu || ee(ze) && !zu || R(nt) || R(ze)) && (De(nt) || hr && (!Et || Et && O(Et)))) && !((He.parser === "scss" || He.parser === "less") && hr && ze.value === "-" && de(nt) && Be(ze) === je(nt.open) && nt.open.value === "(")) {
                  if (Fe(ze)) {
                    if (ut.type === "value-paren_group") {
                      ot.push(w(m));
                      continue;
                    }
                    ot.push(m);
                    continue;
                  }
                  if (Ee && ($(nt) || V(nt) || ge(nt) || Z(ze) || ie(ze))) {
                    ot.push(" ");
                    continue;
                  }
                  if (_ && _.name.toLowerCase() === "namespace") {
                    ot.push(" ");
                    continue;
                  }
                  if (wt) {
                    ze.source && nt.source && ze.source.start.line !== nt.source.start.line ? (ot.push(m), At = !0) : ot.push(" ");
                    continue;
                  }
                  if (Uu) {
                    ot.push(" ");
                    continue;
                  }
                  if (!(nt && nt.value === "...") && !(me(ze) && me(nt) && Be(ze) === je(nt))) {
                    if (me(ze) && de(nt) && Be(ze) === je(nt.open)) {
                      ot.push(y);
                      continue;
                    }
                    if (ze.value === "with" && de(nt)) {
                      ot.push(" ");
                      continue;
                    }
                    (Ft = ze.value) !== null && Ft !== void 0 && Ft.endsWith("#") && nt.value === "{" && de(nt.group) || ot.push(h);
                  }
                }
              }
              return qe && ot.push(A), At && ot.unshift(m), Ee ? p(C(ot)) : E(Oe) ? p(d(ot)) : p(C(d(ot)));
            }
            case "value-paren_group": {
              let ut = Oe.getParentNode();
              if (ut && te(ut) && (pe.groups.length === 1 || pe.groups.length > 0 && pe.groups[0].type === "value-comma_group" && pe.groups[0].groups.length > 0 && pe.groups[0].groups[0].type === "value-word" && pe.groups[0].groups[0].value.startsWith("data:")))
                return [pe.open ? Ye("open") : "", c(",", Oe.map(Ye, "groups")), pe.close ? Ye("close") : ""];
              if (!pe.open) {
                let St = Oe.map(Ye, "groups"), gt = [];
                for (let At = 0; At < St.length; At++)
                  At !== 0 && gt.push([",", h]), gt.push(St[At]);
                return p(C(d(gt)));
              }
              let it = he(Oe), dt = t(pe.groups), wt = dt && dt.type === "value-comment", _ = we(pe, ut), Ee = K(pe, ut), qe = Ee || it && !_, st = Ee || _, ot = p([pe.open ? Ye("open") : "", C([y, c([h], Oe.map((St, gt) => {
                let At = St.getValue(), Nt = gt === pe.groups.length - 1, Et = [Ye(), Nt ? "" : ","];
                if (fe(At) && At.type === "value-comma_group" && At.groups && At.groups[0].type !== "value-paren_group" && At.groups[2] && At.groups[2].type === "value-paren_group") {
                  let ze = S(Et[0].contents.contents);
                  ze[1] = p(ze[1]), Et = [p(w(Et))];
                }
                if (!Nt && At.type === "value-comma_group" && o(At.groups)) {
                  let ze = t(At.groups);
                  !ze.source && ze.close && (ze = ze.close), ze.source && r(He.originalText, ze, Be) && Et.push(m);
                }
                return Et;
              }, "groups"))]), P(!wt && v(He.parser, He.originalText) && it && ae(He) ? "," : ""), y, pe.close ? Ye("close") : ""], { shouldBreak: qe });
              return st ? w(ot) : ot;
            }
            case "value-func":
              return [pe.value, g(Oe, "supports") && Ge(pe) ? " " : "", Ye("group")];
            case "value-paren":
              return pe.value;
            case "value-number":
              return [ct(pe.value), Y(pe.unit)];
            case "value-operator":
              return pe.value;
            case "value-word":
              return pe.isColor && pe.isHex || b(pe.value) ? pe.value.toLowerCase() : pe.value;
            case "value-colon": {
              let ut = Oe.getParentNode(), it = ut && ut.groups.indexOf(pe), dt = it && ut.groups[it - 1];
              return [pe.value, dt && typeof dt.value == "string" && t(dt.value) === "\\" || F(Oe, "url") ? "" : h];
            }
            case "value-comma":
              return [pe.value, " "];
            case "value-string":
              return a(pe.raws.quote + pe.value + pe.raws.quote, He);
            case "value-atword":
              return ["@", pe.value];
            case "value-unicode-range":
              return pe.value;
            case "value-unknown":
              return pe.value;
            default:
              throw new Error(`Unknown postcss type ${JSON.stringify(pe.type)}`);
          }
        }
        function Se(Oe, He, Ye) {
          let pe = [];
          return Oe.each((Bt, Ft, ut) => {
            let it = ut[Ft - 1];
            if (it && it.type === "css-comment" && it.text.trim() === "prettier-ignore") {
              let dt = Bt.getValue();
              pe.push(He.originalText.slice(je(dt), Be(dt)));
            } else
              pe.push(Ye());
            Ft !== ut.length - 1 && (ut[Ft + 1].type === "css-comment" && !e(He.originalText, je(ut[Ft + 1]), { backwards: !0 }) && !n(ut[Ft]) || ut[Ft + 1].type === "css-atrule" && ut[Ft + 1].name === "else" && ut[Ft].type !== "css-comment" ? pe.push(" ") : (pe.push(He.__isHTMLStyleAttribute ? h : m), r(He.originalText, Bt.getValue(), Be) && !n(ut[Ft]) && pe.push(m)));
          }, "nodes"), pe;
        }
        var Me = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, xe = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, mt = /[A-Za-z]+/g, _e = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, ft = new RegExp(Me.source + `|(${_e.source})?(${xe.source})(${mt.source})?`, "g");
        function Le(Oe, He) {
          return Oe.replace(Me, (Ye) => a(Ye, He));
        }
        function Ue(Oe, He) {
          let Ye = He.singleQuote ? "'" : '"';
          return Oe.includes('"') || Oe.includes("'") ? Oe : Ye + Oe + Ye;
        }
        function et(Oe) {
          return Oe.replace(ft, (He, Ye, pe, Bt, Ft) => !pe && Bt ? ct(Bt) + D(Ft || "") : He);
        }
        function ct(Oe) {
          return s(Oe).replace(/\.0(?=$|e)/, "");
        }
        l.exports = { print: Ae, embed: k, insertPragma: J, massageAstNode: j };
      } }), Us = X({ "src/language-css/options.js"(u, l) {
        H();
        var t = en();
        l.exports = { singleQuote: t.singleQuote };
      } }), Ys = X({ "src/language-css/parsers.js"() {
        H();
      } }), zs = X({ "node_modules/linguist-languages/data/CSS.json"(u, l) {
        l.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
      } }), Ks = X({ "node_modules/linguist-languages/data/PostCSS.json"(u, l) {
        l.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
      } }), Qs = X({ "node_modules/linguist-languages/data/Less.json"(u, l) {
        l.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
      } }), Hs = X({ "node_modules/linguist-languages/data/SCSS.json"(u, l) {
        l.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
      } }), Zs = X({ "src/language-css/index.js"(u, l) {
        H();
        var t = Gt(), s = Xs(), a = Us(), e = Ys(), n = [t(zs(), (o) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...o.extensions, ".wxss"] })), t(Ks(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t(Qs(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t(Hs(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], r = { postcss: s };
        l.exports = { languages: n, options: a, printers: r, parsers: e };
      } }), eo = X({ "src/language-handlebars/loc.js"(u, l) {
        H();
        function t(a) {
          return a.loc.start.offset;
        }
        function s(a) {
          return a.loc.end.offset;
        }
        l.exports = { locStart: t, locEnd: s };
      } }), to = X({ "src/language-handlebars/clean.js"(u, l) {
        H();
        function t(s, a) {
          if (s.type === "TextNode") {
            let e = s.chars.trim();
            if (!e)
              return null;
            a.chars = e.replace(/[\t\n\f\r ]+/g, " ");
          }
          s.type === "AttrNode" && s.name.toLowerCase() === "class" && delete a.value;
        }
        t.ignoredProperties = /* @__PURE__ */ new Set(["loc", "selfClosing"]), l.exports = t;
      } }), no = X({ "src/language-handlebars/html-void-elements.evaluate.js"(u, l) {
        l.exports = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];
      } }), ro = X({ "src/language-handlebars/utils.js"(u, l) {
        H();
        var t = Ct(), s = no();
        function a(S) {
          let j = S.getValue(), k = S.getParentNode(0);
          return !!(y(S, ["ElementNode"]) && t(k.children) === j || y(S, ["Block"]) && t(k.body) === j);
        }
        function e(S) {
          return S.toUpperCase() === S;
        }
        function n(S) {
          return m(S, ["ElementNode"]) && typeof S.tag == "string" && !S.tag.startsWith(":") && (e(S.tag[0]) || S.tag.includes("."));
        }
        var r = new Set(s);
        function o(S) {
          return r.has(S.toLowerCase()) && !e(S[0]);
        }
        function c(S) {
          return S.selfClosing === !0 || o(S.tag) || n(S) && S.children.every((j) => h(j));
        }
        function h(S) {
          return m(S, ["TextNode"]) && !/\S/.test(S.chars);
        }
        function m(S, j) {
          return S && j.includes(S.type);
        }
        function y(S, j) {
          let k = S.getParentNode(0);
          return m(k, j);
        }
        function p(S, j) {
          let k = w(S);
          return m(k, j);
        }
        function d(S, j) {
          let k = P(S);
          return m(k, j);
        }
        function C(S, j) {
          var k, J, f, T;
          let D = S.getValue(), F = (k = S.getParentNode(0)) !== null && k !== void 0 ? k : {}, i = (J = (f = (T = F.children) !== null && T !== void 0 ? T : F.body) !== null && f !== void 0 ? f : F.parts) !== null && J !== void 0 ? J : [], g = i.indexOf(D);
          return g !== -1 && i[g + j];
        }
        function w(S) {
          let j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
          return C(S, -j);
        }
        function P(S) {
          return C(S, 1);
        }
        function A(S) {
          return m(S, ["MustacheCommentStatement"]) && typeof S.value == "string" && S.value.trim() === "prettier-ignore";
        }
        function N(S) {
          let j = S.getValue(), k = w(S, 2);
          return A(j) || A(k);
        }
        l.exports = { getNextNode: P, getPreviousNode: w, hasPrettierIgnore: N, isLastNodeOfSiblings: a, isNextNodeOfSomeType: d, isNodeOfSomeType: m, isParentOfSomeType: y, isPreviousNodeOfSomeType: p, isVoid: c, isWhitespaceNode: h };
      } }), uo = X({ "src/language-handlebars/printer-glimmer.js"(u, l) {
        H();
        var { builders: { dedent: t, fill: s, group: a, hardline: e, ifBreak: n, indent: r, join: o, line: c, softline: h }, utils: { getDocParts: m, replaceTextEndOfLine: y } } = Qe(), { getPreferredQuote: p, isNonEmptyArray: d } = at(), { locStart: C, locEnd: w } = eo(), P = to(), { getNextNode: A, getPreviousNode: N, hasPrettierIgnore: S, isLastNodeOfSiblings: j, isNextNodeOfSomeType: k, isNodeOfSomeType: J, isParentOfSomeType: f, isPreviousNodeOfSomeType: T, isVoid: D, isWhitespaceNode: F } = ro(), i = 2;
        function g(G, me, K) {
          let de = G.getValue();
          if (!de)
            return "";
          if (S(G))
            return me.originalText.slice(C(de), w(de));
          let je = me.singleQuote ? "'" : '"';
          switch (de.type) {
            case "Block":
            case "Program":
            case "Template":
              return a(G.map(K, "body"));
            case "ElementNode": {
              let Be = a(x(G, K)), ye = me.htmlWhitespaceSensitivity === "ignore" && k(G, ["ElementNode"]) ? h : "";
              if (D(de))
                return [Be, ye];
              let v = ["</", de.tag, ">"];
              return de.children.length === 0 ? [Be, r(v), ye] : me.htmlWhitespaceSensitivity === "ignore" ? [Be, r(b(G, me, K)), e, r(v), ye] : [Be, r(a(b(G, me, K))), r(v), ye];
            }
            case "BlockStatement": {
              let Be = G.getParentNode(1);
              return Be && Be.inverse && Be.inverse.body.length === 1 && Be.inverse.body[0] === de && Be.inverse.body[0].path.parts[0] === Be.path.parts[0] ? [ie(G, K, Be.inverse.body[0].path.parts[0]), De(G, K, me), fe(G, K, me)] : [O(G, K), a([De(G, K, me), fe(G, K, me), te(G, K, me)])];
            }
            case "ElementModifierStatement":
              return a(["{{", Ze(G, K), "}}"]);
            case "MustacheStatement":
              return a([I(de), Ze(G, K), M(de)]);
            case "SubExpression":
              return a(["(", tt(G, K), h, ")"]);
            case "AttrNode": {
              let Be = de.value.type === "TextNode";
              if (Be && de.value.chars === "" && C(de.value) === w(de.value))
                return de.name;
              let ye = Be ? p(de.value.chars, je).quote : de.value.type === "ConcatStatement" ? p(de.value.parts.filter((Y) => Y.type === "TextNode").map((Y) => Y.chars).join(""), je).quote : "", v = K("value");
              return [de.name, "=", ye, de.name === "class" && ye ? a(r(v)) : v, ye];
            }
            case "ConcatStatement":
              return G.map(K, "parts");
            case "Hash":
              return o(c, G.map(K, "pairs"));
            case "HashPair":
              return [de.key, "=", K("value")];
            case "TextNode": {
              let Be = de.chars.replace(/{{/g, "\\{{"), ye = W(G);
              if (ye) {
                if (ye === "class") {
                  let _e = Be.trim().split(/\s+/).join(" "), ft = !1, Le = !1;
                  return f(G, ["ConcatStatement"]) && (T(G, ["MustacheStatement"]) && /^\s/.test(Be) && (ft = !0), k(G, ["MustacheStatement"]) && /\s$/.test(Be) && _e !== "" && (Le = !0)), [ft ? c : "", _e, Le ? c : ""];
                }
                return y(Be);
              }
              let v = /^[\t\n\f\r ]*$/.test(Be), Y = !N(G), ae = !A(G);
              if (me.htmlWhitespaceSensitivity !== "ignore") {
                let _e = /^[\t\n\f\r ]*/, ft = /[\t\n\f\r ]*$/, Le = ae && f(G, ["Template"]), Ue = Y && f(G, ["Template"]);
                if (v) {
                  if (Ue || Le)
                    return "";
                  let Ye = [c], pe = ne(Be);
                  return pe && (Ye = Fe(pe)), j(G) && (Ye = Ye.map((Bt) => t(Bt))), Ye;
                }
                let [et] = Be.match(_e), [ct] = Be.match(ft), Oe = [];
                if (et) {
                  Oe = [c];
                  let Ye = ne(et);
                  Ye && (Oe = Fe(Ye)), Be = Be.replace(_e, "");
                }
                let He = [];
                if (ct) {
                  if (!Le) {
                    He = [c];
                    let Ye = ne(ct);
                    Ye && (He = Fe(Ye)), j(G) && (He = He.map((pe) => t(pe)));
                  }
                  Be = Be.replace(ft, "");
                }
                return [...Oe, s(we(Be)), ...He];
              }
              let Ae = ne(Be), Se = re(Be), Me = he(Be);
              if ((Y || ae) && v && f(G, ["Block", "ElementNode", "Template"]))
                return "";
              v && Ae ? (Se = Math.min(Ae, i), Me = 0) : (k(G, ["BlockStatement", "ElementNode"]) && (Me = Math.max(Me, 1)), T(G, ["BlockStatement", "ElementNode"]) && (Se = Math.max(Se, 1)));
              let xe = "", mt = "";
              return Me === 0 && k(G, ["MustacheStatement"]) && (mt = " "), Se === 0 && T(G, ["MustacheStatement"]) && (xe = " "), Y && (Se = 0, xe = ""), ae && (Me = 0, mt = ""), Be = Be.replace(/^[\t\n\f\r ]+/g, xe).replace(/[\t\n\f\r ]+$/, mt), [...Fe(Se), s(we(Be)), ...Fe(Me)];
            }
            case "MustacheCommentStatement": {
              let Be = C(de), ye = w(de), v = me.originalText.charAt(Be + 2) === "~", Y = me.originalText.charAt(ye - 3) === "~", ae = de.value.includes("}}") ? "--" : "";
              return ["{{", v ? "~" : "", "!", ae, de.value, ae, Y ? "~" : "", "}}"];
            }
            case "PathExpression":
              return de.original;
            case "BooleanLiteral":
              return String(de.value);
            case "CommentStatement":
              return ["<!--", de.value, "-->"];
            case "StringLiteral": {
              if (Re(G)) {
                let Be = me.singleQuote ? '"' : "'";
                return ve(de.value, Be);
              }
              return ve(de.value, je);
            }
            case "NumberLiteral":
              return String(de.value);
            case "UndefinedLiteral":
              return "undefined";
            case "NullLiteral":
              return "null";
            default:
              throw new Error("unknown glimmer type: " + JSON.stringify(de.type));
          }
        }
        function E(G, me) {
          return C(G) - C(me);
        }
        function x(G, me) {
          let K = G.getValue(), de = ["attributes", "modifiers", "comments"].filter((Be) => d(K[Be])), je = de.flatMap((Be) => K[Be]).sort(E);
          for (let Be of de)
            G.each((ye) => {
              let v = je.indexOf(ye.getValue());
              je.splice(v, 1, [c, me()]);
            }, Be);
          return d(K.blockParams) && je.push(c, le(K)), ["<", K.tag, r(je), B(K)];
        }
        function b(G, me, K) {
          let de = G.getValue().children.every((je) => F(je));
          return me.htmlWhitespaceSensitivity === "ignore" && de ? "" : G.map((je, Be) => {
            let ye = K();
            return Be === 0 && me.htmlWhitespaceSensitivity === "ignore" ? [h, ye] : ye;
          }, "children");
        }
        function B(G) {
          return D(G) ? n([h, "/>"], [" />", h]) : n([h, ">"], ">");
        }
        function I(G) {
          let me = G.escaped === !1 ? "{{{" : "{{", K = G.strip && G.strip.open ? "~" : "";
          return [me, K];
        }
        function M(G) {
          let me = G.escaped === !1 ? "}}}" : "}}";
          return [G.strip && G.strip.close ? "~" : "", me];
        }
        function V(G) {
          let me = I(G), K = G.openStrip.open ? "~" : "";
          return [me, K, "#"];
        }
        function $(G) {
          let me = M(G);
          return [G.openStrip.close ? "~" : "", me];
        }
        function U(G) {
          let me = I(G), K = G.closeStrip.open ? "~" : "";
          return [me, K, "/"];
        }
        function L(G) {
          let me = M(G);
          return [G.closeStrip.close ? "~" : "", me];
        }
        function ee(G) {
          let me = I(G), K = G.inverseStrip.open ? "~" : "";
          return [me, K];
        }
        function R(G) {
          let me = M(G);
          return [G.inverseStrip.close ? "~" : "", me];
        }
        function O(G, me) {
          let K = G.getValue(), de = [], je = Ge(G, me);
          return je && de.push(a(je)), d(K.program.blockParams) && de.push(le(K.program)), a([V(K), $e(G, me), de.length > 0 ? r([c, o(c, de)]) : "", h, $(K)]);
        }
        function Z(G, me) {
          return [me.htmlWhitespaceSensitivity === "ignore" ? e : "", ee(G), "else", R(G)];
        }
        function ie(G, me, K) {
          let de = G.getValue(), je = G.getParentNode(1);
          return a([ee(je), ["else", " ", K], r([c, a(Ge(G, me)), ...d(de.program.blockParams) ? [c, le(de.program)] : []]), h, R(je)]);
        }
        function te(G, me, K) {
          let de = G.getValue();
          return K.htmlWhitespaceSensitivity === "ignore" ? [ge(de) ? h : e, U(de), me("path"), L(de)] : [U(de), me("path"), L(de)];
        }
        function ge(G) {
          return J(G, ["BlockStatement"]) && G.program.body.every((me) => F(me));
        }
        function q(G) {
          return z(G) && G.inverse.body.length === 1 && J(G.inverse.body[0], ["BlockStatement"]) && G.inverse.body[0].path.parts[0] === G.path.parts[0];
        }
        function z(G) {
          return J(G, ["BlockStatement"]) && G.inverse;
        }
        function De(G, me, K) {
          let de = G.getValue();
          if (ge(de))
            return "";
          let je = me("program");
          return K.htmlWhitespaceSensitivity === "ignore" ? r([e, je]) : r(je);
        }
        function fe(G, me, K) {
          let de = G.getValue(), je = me("inverse"), Be = K.htmlWhitespaceSensitivity === "ignore" ? [e, je] : je;
          return q(de) ? Be : z(de) ? [Z(de, K), r(Be)] : "";
        }
        function we(G) {
          return m(o(c, Q(G)));
        }
        function Q(G) {
          return G.split(/[\t\n\f\r ]+/);
        }
        function W(G) {
          for (let me = 0; me < 2; me++) {
            let K = G.getParentNode(me);
            if (K && K.type === "AttrNode")
              return K.name.toLowerCase();
          }
        }
        function ne(G) {
          return G = typeof G == "string" ? G : "", G.split(`
`).length - 1;
        }
        function re(G) {
          G = typeof G == "string" ? G : "";
          let me = (G.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
          return ne(me);
        }
        function he(G) {
          G = typeof G == "string" ? G : "";
          let me = (G.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
          return ne(me);
        }
        function Fe() {
          let G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return Array.from({ length: Math.min(G, i) }).fill(e);
        }
        function ve(G, me) {
          let { quote: K, regex: de } = p(G, me);
          return [K, G.replace(de, `\\${K}`), K];
        }
        function Re(G) {
          let me = 0, K = G.getParentNode(me);
          for (; K && J(K, ["SubExpression"]); )
            me++, K = G.getParentNode(me);
          return !!(K && J(G.getParentNode(me + 1), ["ConcatStatement"]) && J(G.getParentNode(me + 2), ["AttrNode"]));
        }
        function tt(G, me) {
          let K = $e(G, me), de = Ge(G, me);
          return de ? r([K, c, a(de)]) : K;
        }
        function Ze(G, me) {
          let K = $e(G, me), de = Ge(G, me);
          return de ? [r([K, c, de]), h] : K;
        }
        function $e(G, me) {
          return me("path");
        }
        function Ge(G, me) {
          let K = G.getValue(), de = [];
          if (K.params.length > 0) {
            let je = G.map(me, "params");
            de.push(...je);
          }
          if (K.hash && K.hash.pairs.length > 0) {
            let je = me("hash");
            de.push(je);
          }
          return de.length === 0 ? "" : o(c, de);
        }
        function le(G) {
          return ["as |", G.blockParams.join(" "), "|"];
        }
        l.exports = { print: g, massageAstNode: P };
      } }), io = X({ "src/language-handlebars/parsers.js"() {
        H();
      } }), ao = X({ "node_modules/linguist-languages/data/Handlebars.json"(u, l) {
        l.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
      } }), so = X({ "src/language-handlebars/index.js"(u, l) {
        H();
        var t = Gt(), s = uo(), a = io(), e = [t(ao(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], n = { glimmer: s };
        l.exports = { languages: e, printers: n, parsers: a };
      } }), oo = X({ "src/language-graphql/pragma.js"(u, l) {
        H();
        function t(a) {
          return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a);
        }
        function s(a) {
          return `# @format

` + a;
        }
        l.exports = { hasPragma: t, insertPragma: s };
      } }), lo = X({ "src/language-graphql/loc.js"(u, l) {
        H();
        function t(a) {
          return typeof a.start == "number" ? a.start : a.loc && a.loc.start;
        }
        function s(a) {
          return typeof a.end == "number" ? a.end : a.loc && a.loc.end;
        }
        l.exports = { locStart: t, locEnd: s };
      } }), po = X({ "src/language-graphql/printer-graphql.js"(u, l) {
        H();
        var { builders: { join: t, hardline: s, line: a, softline: e, group: n, indent: r, ifBreak: o } } = Qe(), { isNextLineEmpty: c, isNonEmptyArray: h } = at(), { insertPragma: m } = oo(), { locStart: y, locEnd: p } = lo();
        function d(k, J, f) {
          let T = k.getValue();
          if (!T)
            return "";
          if (typeof T == "string")
            return T;
          switch (T.kind) {
            case "Document": {
              let D = [];
              return k.each((F, i, g) => {
                D.push(f()), i !== g.length - 1 && (D.push(s), c(J.originalText, F.getValue(), p) && D.push(s));
              }, "definitions"), [...D, s];
            }
            case "OperationDefinition": {
              let D = J.originalText[y(T)] !== "{", F = !!T.name;
              return [D ? T.operation : "", D && F ? [" ", f("name")] : "", D && !F && h(T.variableDefinitions) ? " " : "", h(T.variableDefinitions) ? n(["(", r([e, t([o("", ", "), e], k.map(f, "variableDefinitions"))]), e, ")"]) : "", C(k, f, T), T.selectionSet ? !D && !F ? "" : " " : "", f("selectionSet")];
            }
            case "FragmentDefinition":
              return ["fragment ", f("name"), h(T.variableDefinitions) ? n(["(", r([e, t([o("", ", "), e], k.map(f, "variableDefinitions"))]), e, ")"]) : "", " on ", f("typeCondition"), C(k, f, T), " ", f("selectionSet")];
            case "SelectionSet":
              return ["{", r([s, t(s, w(k, J, f, "selections"))]), s, "}"];
            case "Field":
              return n([T.alias ? [f("alias"), ": "] : "", f("name"), T.arguments.length > 0 ? n(["(", r([e, t([o("", ", "), e], w(k, J, f, "arguments"))]), e, ")"]) : "", C(k, f, T), T.selectionSet ? " " : "", f("selectionSet")]);
            case "Name":
              return T.value;
            case "StringValue": {
              if (T.block) {
                let D = T.value.replace(/"""/g, "\\$&").split(`
`);
                return D.length === 1 && (D[0] = D[0].trim()), D.every((F) => F === "") && (D.length = 0), t(s, ['"""', ...D, '"""']);
              }
              return ['"', T.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
            }
            case "IntValue":
            case "FloatValue":
            case "EnumValue":
              return T.value;
            case "BooleanValue":
              return T.value ? "true" : "false";
            case "NullValue":
              return "null";
            case "Variable":
              return ["$", f("name")];
            case "ListValue":
              return n(["[", r([e, t([o("", ", "), e], k.map(f, "values"))]), e, "]"]);
            case "ObjectValue":
              return n(["{", J.bracketSpacing && T.fields.length > 0 ? " " : "", r([e, t([o("", ", "), e], k.map(f, "fields"))]), e, o("", J.bracketSpacing && T.fields.length > 0 ? " " : ""), "}"]);
            case "ObjectField":
            case "Argument":
              return [f("name"), ": ", f("value")];
            case "Directive":
              return ["@", f("name"), T.arguments.length > 0 ? n(["(", r([e, t([o("", ", "), e], w(k, J, f, "arguments"))]), e, ")"]) : ""];
            case "NamedType":
              return f("name");
            case "VariableDefinition":
              return [f("variable"), ": ", f("type"), T.defaultValue ? [" = ", f("defaultValue")] : "", C(k, f, T)];
            case "ObjectTypeExtension":
            case "ObjectTypeDefinition":
              return [f("description"), T.description ? s : "", T.kind === "ObjectTypeExtension" ? "extend " : "", "type ", f("name"), T.interfaces.length > 0 ? [" implements ", ...N(k, J, f)] : "", C(k, f, T), T.fields.length > 0 ? [" {", r([s, t(s, w(k, J, f, "fields"))]), s, "}"] : ""];
            case "FieldDefinition":
              return [f("description"), T.description ? s : "", f("name"), T.arguments.length > 0 ? n(["(", r([e, t([o("", ", "), e], w(k, J, f, "arguments"))]), e, ")"]) : "", ": ", f("type"), C(k, f, T)];
            case "DirectiveDefinition":
              return [f("description"), T.description ? s : "", "directive ", "@", f("name"), T.arguments.length > 0 ? n(["(", r([e, t([o("", ", "), e], w(k, J, f, "arguments"))]), e, ")"]) : "", T.repeatable ? " repeatable" : "", " on ", t(" | ", k.map(f, "locations"))];
            case "EnumTypeExtension":
            case "EnumTypeDefinition":
              return [f("description"), T.description ? s : "", T.kind === "EnumTypeExtension" ? "extend " : "", "enum ", f("name"), C(k, f, T), T.values.length > 0 ? [" {", r([s, t(s, w(k, J, f, "values"))]), s, "}"] : ""];
            case "EnumValueDefinition":
              return [f("description"), T.description ? s : "", f("name"), C(k, f, T)];
            case "InputValueDefinition":
              return [f("description"), T.description ? T.description.block ? s : a : "", f("name"), ": ", f("type"), T.defaultValue ? [" = ", f("defaultValue")] : "", C(k, f, T)];
            case "InputObjectTypeExtension":
            case "InputObjectTypeDefinition":
              return [f("description"), T.description ? s : "", T.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", f("name"), C(k, f, T), T.fields.length > 0 ? [" {", r([s, t(s, w(k, J, f, "fields"))]), s, "}"] : ""];
            case "SchemaExtension":
              return ["extend schema", C(k, f, T), ...T.operationTypes.length > 0 ? [" {", r([s, t(s, w(k, J, f, "operationTypes"))]), s, "}"] : []];
            case "SchemaDefinition":
              return [f("description"), T.description ? s : "", "schema", C(k, f, T), " {", T.operationTypes.length > 0 ? r([s, t(s, w(k, J, f, "operationTypes"))]) : "", s, "}"];
            case "OperationTypeDefinition":
              return [f("operation"), ": ", f("type")];
            case "InterfaceTypeExtension":
            case "InterfaceTypeDefinition":
              return [f("description"), T.description ? s : "", T.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", f("name"), T.interfaces.length > 0 ? [" implements ", ...N(k, J, f)] : "", C(k, f, T), T.fields.length > 0 ? [" {", r([s, t(s, w(k, J, f, "fields"))]), s, "}"] : ""];
            case "FragmentSpread":
              return ["...", f("name"), C(k, f, T)];
            case "InlineFragment":
              return ["...", T.typeCondition ? [" on ", f("typeCondition")] : "", C(k, f, T), " ", f("selectionSet")];
            case "UnionTypeExtension":
            case "UnionTypeDefinition":
              return n([f("description"), T.description ? s : "", n([T.kind === "UnionTypeExtension" ? "extend " : "", "union ", f("name"), C(k, f, T), T.types.length > 0 ? [" =", o("", " "), r([o([a, "  "]), t([a, "| "], k.map(f, "types"))])] : ""])]);
            case "ScalarTypeExtension":
            case "ScalarTypeDefinition":
              return [f("description"), T.description ? s : "", T.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", f("name"), C(k, f, T)];
            case "NonNullType":
              return [f("type"), "!"];
            case "ListType":
              return ["[", f("type"), "]"];
            default:
              throw new Error("unknown graphql type: " + JSON.stringify(T.kind));
          }
        }
        function C(k, J, f) {
          if (f.directives.length === 0)
            return "";
          let T = t(a, k.map(J, "directives"));
          return f.kind === "FragmentDefinition" || f.kind === "OperationDefinition" ? n([a, T]) : [" ", n(r([e, T]))];
        }
        function w(k, J, f, T) {
          return k.map((D, F, i) => {
            let g = f();
            return F < i.length - 1 && c(J.originalText, D.getValue(), p) ? [g, s] : g;
          }, T);
        }
        function P(k) {
          return k.kind && k.kind !== "Comment";
        }
        function A(k) {
          let J = k.getValue();
          if (J.kind === "Comment")
            return "#" + J.value.trimEnd();
          throw new Error("Not a comment: " + JSON.stringify(J));
        }
        function N(k, J, f) {
          let T = k.getNode(), D = [], { interfaces: F } = T, i = k.map((g) => f(g), "interfaces");
          for (let g = 0; g < F.length; g++) {
            let E = F[g];
            D.push(i[g]);
            let x = F[g + 1];
            if (x) {
              let b = J.originalText.slice(E.loc.end, x.loc.start), B = b.includes("#"), I = b.replace(/#.*/g, "").trim();
              D.push(I === "," ? "," : " &", B ? a : " ");
            }
          }
          return D;
        }
        function S(k, J) {
          k.kind === "StringValue" && k.block && !k.value.includes(`
`) && (J.value = J.value.trim());
        }
        S.ignoredProperties = /* @__PURE__ */ new Set(["loc", "comments"]);
        function j(k) {
          var J;
          let f = k.getValue();
          return f == null || (J = f.comments) === null || J === void 0 ? void 0 : J.some((T) => T.value.trim() === "prettier-ignore");
        }
        l.exports = { print: d, massageAstNode: S, hasPrettierIgnore: j, insertPragma: m, printComment: A, canAttachComment: P };
      } }), co = X({ "src/language-graphql/options.js"(u, l) {
        H();
        var t = en();
        l.exports = { bracketSpacing: t.bracketSpacing };
      } }), Do = X({ "src/language-graphql/parsers.js"() {
        H();
      } }), fo = X({ "node_modules/linguist-languages/data/GraphQL.json"(u, l) {
        l.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
      } }), mo = X({ "src/language-graphql/index.js"(u, l) {
        H();
        var t = Gt(), s = po(), a = co(), e = Do(), n = [t(fo(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], r = { graphql: s };
        l.exports = { languages: n, options: a, printers: r, parsers: e };
      } }), Vu = X({ "node_modules/collapse-white-space/index.js"(u, l) {
        H(), l.exports = t;
        function t(s) {
          return String(s).replace(/\s+/g, " ");
        }
      } }), Ju = X({ "src/language-markdown/loc.js"(u, l) {
        H();
        function t(a) {
          return a.position.start.offset;
        }
        function s(a) {
          return a.position.end.offset;
        }
        l.exports = { locStart: t, locEnd: s };
      } }), go = X({ "src/language-markdown/constants.evaluate.js"(u, l) {
        l.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
      } }), fr = X({ "src/language-markdown/utils.js"(u, l) {
        H();
        var { getLast: t } = at(), { locStart: s, locEnd: a } = Ju(), { cjkPattern: e, kPattern: n, punctuationPattern: r } = go(), o = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], c = [...o, "tableCell", "paragraph", "heading"], h = new RegExp(n), m = new RegExp(r);
        function y(A, N) {
          let S = "non-cjk", j = "cj-letter", k = "k-letter", J = "cjk-punctuation", f = [], T = (N.proseWrap === "preserve" ? A : A.replace(new RegExp(`(${e})
(${e})`, "g"), "$1$2")).split(/([\t\n ]+)/);
          for (let [F, i] of T.entries()) {
            if (F % 2 === 1) {
              f.push({ type: "whitespace", value: /\n/.test(i) ? `
` : " " });
              continue;
            }
            if ((F === 0 || F === T.length - 1) && i === "")
              continue;
            let g = i.split(new RegExp(`(${e})`));
            for (let [E, x] of g.entries())
              if (!((E === 0 || E === g.length - 1) && x === "")) {
                if (E % 2 === 0) {
                  x !== "" && D({ type: "word", value: x, kind: S, hasLeadingPunctuation: m.test(x[0]), hasTrailingPunctuation: m.test(t(x)) });
                  continue;
                }
                D(m.test(x) ? { type: "word", value: x, kind: J, hasLeadingPunctuation: !0, hasTrailingPunctuation: !0 } : { type: "word", value: x, kind: h.test(x) ? k : j, hasLeadingPunctuation: !1, hasTrailingPunctuation: !1 });
              }
          }
          return f;
          function D(F) {
            let i = t(f);
            i && i.type === "word" && (i.kind === S && F.kind === j && !i.hasTrailingPunctuation || i.kind === j && F.kind === S && !F.hasLeadingPunctuation ? f.push({ type: "whitespace", value: " " }) : !g(S, J) && ![i.value, F.value].some((E) => /\u3000/.test(E)) && f.push({ type: "whitespace", value: "" })), f.push(F);
            function g(E, x) {
              return i.kind === E && F.kind === x || i.kind === x && F.kind === E;
            }
          }
        }
        function p(A, N) {
          let [, S, j, k] = N.slice(A.position.start.offset, A.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
          return { numberText: S, marker: j, leadingSpaces: k };
        }
        function d(A, N) {
          if (!A.ordered || A.children.length < 2)
            return !1;
          let S = Number(p(A.children[0], N.originalText).numberText), j = Number(p(A.children[1], N.originalText).numberText);
          if (S === 0 && A.children.length > 2) {
            let k = Number(p(A.children[2], N.originalText).numberText);
            return j === 1 && k === 1;
          }
          return j === 1;
        }
        function C(A, N) {
          let { value: S } = A;
          return A.position.end.offset === N.length && S.endsWith(`
`) && N.endsWith(`
`) ? S.slice(0, -1) : S;
        }
        function w(A, N) {
          return function S(j, k, J) {
            let f = Object.assign({}, N(j, k, J));
            return f.children && (f.children = f.children.map((T, D) => S(T, D, [f, ...J]))), f;
          }(A, null, []);
        }
        function P(A) {
          if ((A == null ? void 0 : A.type) !== "link" || A.children.length !== 1)
            return !1;
          let [N] = A.children;
          return s(A) === s(N) && a(A) === a(N);
        }
        l.exports = { mapAst: w, splitText: y, punctuationPattern: r, getFencedCodeBlockValue: C, getOrderedListItemInfo: p, hasGitDiffFriendlyOrderedList: d, INLINE_NODE_TYPES: o, INLINE_NODE_WRAPPER_TYPES: c, isAutolink: P };
      } }), yo = X({ "src/language-markdown/embed.js"(u, l) {
        H();
        var { inferParserByLanguage: t, getMaxContinuousCount: s } = at(), { builders: { hardline: a, markAsRoot: e }, utils: { replaceEndOfLine: n } } = Qe(), r = Dr(), { getFencedCodeBlockValue: o } = fr();
        function c(h, m, y, p) {
          let d = h.getValue();
          if (d.type === "code" && d.lang !== null) {
            let C = t(d.lang, p);
            if (C) {
              let w = p.__inJsTemplate ? "~" : "`", P = w.repeat(Math.max(3, s(d.value, w) + 1)), A = { parser: C };
              d.lang === "tsx" && (A.filepath = "dummy.tsx");
              let N = y(o(d, p.originalText), A, { stripTrailingHardline: !0 });
              return e([P, d.lang, d.meta ? " " + d.meta : "", a, n(N), a, P]);
            }
          }
          switch (d.type) {
            case "front-matter":
              return r(d, y);
            case "importExport":
              return [y(d.value, { parser: "babel" }, { stripTrailingHardline: !0 }), a];
            case "jsx":
              return y(`<$>${d.value}</$>`, { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: !0 });
          }
          return null;
        }
        l.exports = c;
      } }), qu = X({ "src/language-markdown/pragma.js"(u, l) {
        H();
        var t = Ru(), s = ["format", "prettier"];
        function a(e) {
          let n = `@(${s.join("|")})`, r = new RegExp([`<!--\\s*${n}\\s*-->`, `{\\s*\\/\\*\\s*${n}\\s*\\*\\/\\s*}`, `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${n}[^\\S
]*($|
)[\\s\\S]*
.*-->`].join("|"), "m"), o = e.match(r);
          return (o == null ? void 0 : o.index) === 0;
        }
        l.exports = { startWithPragma: a, hasPragma: (e) => a(t(e).content.trimStart()), insertPragma: (e) => {
          let n = t(e), r = `<!-- @${s[0]} -->`;
          return n.frontMatter ? `${n.frontMatter.raw}

${r}

${n.content}` : `${r}

${n.content}`;
        } };
      } }), ho = X({ "src/language-markdown/print-preprocess.js"(u, l) {
        H();
        var t = Ct(), { getOrderedListItemInfo: s, mapAst: a, splitText: e } = fr(), n = /^.$/su;
        function r(P, A) {
          return P = h(P, A), P = p(P), P = c(P, A), P = C(P, A), P = w(P, A), P = d(P, A), P = o(P), P = m(P), P;
        }
        function o(P) {
          return a(P, (A) => A.type !== "import" && A.type !== "export" ? A : Object.assign(Object.assign({}, A), {}, { type: "importExport" }));
        }
        function c(P, A) {
          return a(P, (N) => N.type !== "inlineCode" || A.proseWrap === "preserve" ? N : Object.assign(Object.assign({}, N), {}, { value: N.value.replace(/\s+/g, " ") }));
        }
        function h(P, A) {
          return a(P, (N) => N.type !== "text" || N.value === "*" || N.value === "_" || !n.test(N.value) || N.position.end.offset - N.position.start.offset === N.value.length ? N : Object.assign(Object.assign({}, N), {}, { value: A.originalText.slice(N.position.start.offset, N.position.end.offset) }));
        }
        function m(P) {
          return y(P, (A, N) => A.type === "importExport" && N.type === "importExport", (A, N) => ({ type: "importExport", value: A.value + `

` + N.value, position: { start: A.position.start, end: N.position.end } }));
        }
        function y(P, A, N) {
          return a(P, (S) => {
            if (!S.children)
              return S;
            let j = S.children.reduce((k, J) => {
              let f = t(k);
              return f && A(f, J) ? k.splice(-1, 1, N(f, J)) : k.push(J), k;
            }, []);
            return Object.assign(Object.assign({}, S), {}, { children: j });
          });
        }
        function p(P) {
          return y(P, (A, N) => A.type === "text" && N.type === "text", (A, N) => ({ type: "text", value: A.value + N.value, position: { start: A.position.start, end: N.position.end } }));
        }
        function d(P, A) {
          return a(P, (N, S, j) => {
            let [k] = j;
            if (N.type !== "text")
              return N;
            let { value: J } = N;
            return k.type === "paragraph" && (S === 0 && (J = J.trimStart()), S === k.children.length - 1 && (J = J.trimEnd())), { type: "sentence", position: N.position, children: e(J, A) };
          });
        }
        function C(P, A) {
          return a(P, (N, S, j) => {
            if (N.type === "code") {
              let k = /^\n?(?: {4,}|\t)/.test(A.originalText.slice(N.position.start.offset, N.position.end.offset));
              if (N.isIndented = k, k)
                for (let J = 0; J < j.length; J++) {
                  let f = j[J];
                  if (f.hasIndentedCodeblock)
                    break;
                  f.type === "list" && (f.hasIndentedCodeblock = !0);
                }
            }
            return N;
          });
        }
        function w(P, A) {
          return a(P, (j, k, J) => {
            if (j.type === "list" && j.children.length > 0) {
              for (let f = 0; f < J.length; f++) {
                let T = J[f];
                if (T.type === "list" && !T.isAligned)
                  return j.isAligned = !1, j;
              }
              j.isAligned = S(j);
            }
            return j;
          });
          function N(j) {
            return j.children.length === 0 ? -1 : j.children[0].position.start.column - 1;
          }
          function S(j) {
            if (!j.ordered)
              return !0;
            let [k, J] = j.children;
            if (s(k, A.originalText).leadingSpaces.length > 1)
              return !0;
            let f = N(k);
            if (f === -1)
              return !1;
            if (j.children.length === 1)
              return f % A.tabWidth === 0;
            let T = N(J);
            return f !== T ? !1 : f % A.tabWidth === 0 ? !0 : s(J, A.originalText).leadingSpaces.length > 1;
          }
        }
        l.exports = r;
      } }), Eo = X({ "src/language-markdown/clean.js"(u, l) {
        H();
        var t = Vu(), { isFrontMatterNode: s } = at(), { startWithPragma: a } = qu(), e = /* @__PURE__ */ new Set(["position", "raw"]);
        function n(r, o, c) {
          if ((r.type === "front-matter" || r.type === "code" || r.type === "yaml" || r.type === "import" || r.type === "export" || r.type === "jsx") && delete o.value, r.type === "list" && delete o.isAligned, (r.type === "list" || r.type === "listItem") && (delete o.spread, delete o.loose), r.type === "text" || (r.type === "inlineCode" && (o.value = r.value.replace(/[\t\n ]+/g, " ")), r.type === "wikiLink" && (o.value = r.value.trim().replace(/[\t\n]+/g, " ")), (r.type === "definition" || r.type === "linkReference" || r.type === "imageReference") && (o.label = t(r.label)), (r.type === "definition" || r.type === "link" || r.type === "image") && r.title && (o.title = r.title.replace(/\\(["')])/g, "$1")), c && c.type === "root" && c.children.length > 0 && (c.children[0] === r || s(c.children[0]) && c.children[1] === r) && r.type === "html" && a(r.value)))
            return null;
        }
        n.ignoredProperties = e, l.exports = n;
      } }), Co = X({ "src/language-markdown/printer-markdown.js"(u, l) {
        H();
        var t = Vu(), { getLast: s, getMinNotPresentContinuousCount: a, getMaxContinuousCount: e, getStringWidth: n, isNonEmptyArray: r } = at(), { builders: { breakParent: o, join: c, line: h, literalline: m, markAsRoot: y, hardline: p, softline: d, ifBreak: C, fill: w, align: P, indent: A, group: N, hardlineWithoutBreakParent: S }, utils: { normalizeDoc: j, replaceTextEndOfLine: k }, printer: { printDocToString: J } } = Qe(), f = yo(), { insertPragma: T } = qu(), { locStart: D, locEnd: F } = Ju(), i = ho(), g = Eo(), { getFencedCodeBlockValue: E, hasGitDiffFriendlyOrderedList: x, splitText: b, punctuationPattern: B, INLINE_NODE_TYPES: I, INLINE_NODE_WRAPPER_TYPES: M, isAutolink: V } = fr(), $ = /* @__PURE__ */ new Set(["importExport"]), U = ["heading", "tableCell", "link", "wikiLink"], L = /* @__PURE__ */ new Set(["listItem", "definition", "footnoteDefinition"]);
        function ee(le, G, me) {
          let K = le.getValue();
          if (Fe(le))
            return b(G.originalText.slice(K.position.start.offset, K.position.end.offset), G).map((de) => de.type === "word" ? de.value : de.value === "" ? "" : q(le, de.value, G));
          switch (K.type) {
            case "front-matter":
              return G.originalText.slice(K.position.start.offset, K.position.end.offset);
            case "root":
              return K.children.length === 0 ? "" : [j(De(le, G, me)), $.has(Q(K).type) ? "" : p];
            case "paragraph":
              return fe(le, G, me, { postprocessor: w });
            case "sentence":
              return fe(le, G, me);
            case "word": {
              let de = K.value.replace(/\*/g, "\\$&").replace(new RegExp([`(^|${B})(_+)`, `(_+)(${B}|$)`].join("|"), "g"), (ye, v, Y, ae, Ae) => (Y ? `${v}${Y}` : `${ae}${Ae}`).replace(/_/g, "\\_")), je = (ye, v, Y) => ye.type === "sentence" && Y === 0, Be = (ye, v, Y) => V(ye.children[Y - 1]);
              return de !== K.value && (le.match(void 0, je, Be) || le.match(void 0, je, (ye, v, Y) => ye.type === "emphasis" && Y === 0, Be)) && (de = de.replace(/^(\\?[*_])+/, (ye) => ye.replace(/\\/g, ""))), de;
            }
            case "whitespace": {
              let de = le.getParentNode(), je = de.children.indexOf(K), Be = de.children[je + 1], ye = Be && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(Be.value) ? "never" : G.proseWrap;
              return q(le, K.value, { proseWrap: ye });
            }
            case "emphasis": {
              let de;
              if (V(K.children[0]))
                de = G.originalText[K.position.start.offset];
              else {
                let je = le.getParentNode(), Be = je.children.indexOf(K), ye = je.children[Be - 1], v = je.children[Be + 1];
                de = ye && ye.type === "sentence" && ye.children.length > 0 && s(ye.children).type === "word" && !s(ye.children).hasTrailingPunctuation || v && v.type === "sentence" && v.children.length > 0 && v.children[0].type === "word" && !v.children[0].hasLeadingPunctuation || ge(le, "emphasis") ? "*" : "_";
              }
              return [de, fe(le, G, me), de];
            }
            case "strong":
              return ["**", fe(le, G, me), "**"];
            case "delete":
              return ["~~", fe(le, G, me), "~~"];
            case "inlineCode": {
              let de = a(K.value, "`"), je = "`".repeat(de || 1), Be = de && !/^\s/.test(K.value) ? " " : "";
              return [je, Be, K.value, Be, je];
            }
            case "wikiLink": {
              let de = "";
              return G.proseWrap === "preserve" ? de = K.value : de = K.value.replace(/[\t\n]+/g, " "), ["[[", de, "]]"];
            }
            case "link":
              switch (G.originalText[K.position.start.offset]) {
                case "<": {
                  let de = "mailto:";
                  return ["<", K.url.startsWith(de) && G.originalText.slice(K.position.start.offset + 1, K.position.start.offset + 1 + de.length) !== de ? K.url.slice(de.length) : K.url, ">"];
                }
                case "[":
                  return ["[", fe(le, G, me), "](", ve(K.url, ")"), Re(K.title, G), ")"];
                default:
                  return G.originalText.slice(K.position.start.offset, K.position.end.offset);
              }
            case "image":
              return ["![", K.alt || "", "](", ve(K.url, ")"), Re(K.title, G), ")"];
            case "blockquote":
              return ["> ", P("> ", fe(le, G, me))];
            case "heading":
              return ["#".repeat(K.depth) + " ", fe(le, G, me)];
            case "code": {
              if (K.isIndented) {
                let Be = " ".repeat(4);
                return P(Be, [Be, ...k(K.value, p)]);
              }
              let de = G.__inJsTemplate ? "~" : "`", je = de.repeat(Math.max(3, e(K.value, de) + 1));
              return [je, K.lang || "", K.meta ? " " + K.meta : "", p, ...k(E(K, G.originalText), p), p, je];
            }
            case "html": {
              let de = le.getParentNode(), je = de.type === "root" && s(de.children) === K ? K.value.trimEnd() : K.value, Be = /^<!--.*-->$/s.test(je);
              return k(je, Be ? p : y(m));
            }
            case "list": {
              let de = Z(K, le.getParentNode()), je = x(K, G);
              return fe(le, G, me, { processor: (Be, ye) => {
                let v = ae(), Y = Be.getValue();
                if (Y.children.length === 2 && Y.children[1].type === "html" && Y.children[0].position.start.column !== Y.children[1].position.start.column)
                  return [v, R(Be, G, me, v)];
                return [v, P(" ".repeat(v.length), R(Be, G, me, v))];
                function ae() {
                  let Ae = K.ordered ? (ye === 0 ? K.start : je ? 1 : K.start + ye) + (de % 2 === 0 ? ". " : ") ") : de % 2 === 0 ? "- " : "* ";
                  return K.isAligned || K.hasIndentedCodeblock ? O(Ae, G) : Ae;
                }
              } });
            }
            case "thematicBreak": {
              let de = te(le, "list");
              return de === -1 ? "---" : Z(le.getParentNode(de), le.getParentNode(de + 1)) % 2 === 0 ? "***" : "---";
            }
            case "linkReference":
              return ["[", fe(le, G, me), "]", K.referenceType === "full" ? $e(K) : K.referenceType === "collapsed" ? "[]" : ""];
            case "imageReference":
              switch (K.referenceType) {
                case "full":
                  return ["![", K.alt || "", "]", $e(K)];
                default:
                  return ["![", K.alt, "]", K.referenceType === "collapsed" ? "[]" : ""];
              }
            case "definition": {
              let de = G.proseWrap === "always" ? h : " ";
              return N([$e(K), ":", A([de, ve(K.url), K.title === null ? "" : [de, Re(K.title, G, !1)]])]);
            }
            case "footnote":
              return ["[^", fe(le, G, me), "]"];
            case "footnoteReference":
              return Ge(K);
            case "footnoteDefinition": {
              let de = le.getParentNode().children[le.getName() + 1], je = K.children.length === 1 && K.children[0].type === "paragraph" && (G.proseWrap === "never" || G.proseWrap === "preserve" && K.children[0].position.start.line === K.children[0].position.end.line);
              return [Ge(K), ": ", je ? fe(le, G, me) : N([P(" ".repeat(4), fe(le, G, me, { processor: (Be, ye) => ye === 0 ? N([d, me()]) : me() })), de && de.type === "footnoteDefinition" ? d : ""])];
            }
            case "table":
              return z(le, G, me);
            case "tableCell":
              return fe(le, G, me);
            case "break":
              return /\s/.test(G.originalText[K.position.start.offset]) ? ["  ", y(m)] : ["\\", p];
            case "liquidNode":
              return k(K.value, p);
            case "importExport":
              return [K.value, p];
            case "esComment":
              return ["{/* ", K.value, " */}"];
            case "jsx":
              return K.value;
            case "math":
              return ["$$", p, K.value ? [...k(K.value, p), p] : "", "$$"];
            case "inlineMath":
              return G.originalText.slice(D(K), F(K));
            case "tableRow":
            case "listItem":
            default:
              throw new Error(`Unknown markdown type ${JSON.stringify(K.type)}`);
          }
        }
        function R(le, G, me, K) {
          let de = le.getValue(), je = de.checked === null ? "" : de.checked ? "[x] " : "[ ] ";
          return [je, fe(le, G, me, { processor: (Be, ye) => {
            if (ye === 0 && Be.getValue().type !== "list")
              return P(" ".repeat(je.length), me());
            let v = " ".repeat(tt(G.tabWidth - K.length, 0, 3));
            return [v, P(v, me())];
          } })];
        }
        function O(le, G) {
          let me = K();
          return le + " ".repeat(me >= 4 ? 0 : me);
          function K() {
            let de = le.length % G.tabWidth;
            return de === 0 ? 0 : G.tabWidth - de;
          }
        }
        function Z(le, G) {
          return ie(le, G, (me) => me.ordered === le.ordered);
        }
        function ie(le, G, me) {
          let K = -1;
          for (let de of G.children)
            if (de.type === le.type && me(de) ? K++ : K = -1, de === le)
              return K;
        }
        function te(le, G) {
          let me = Array.isArray(G) ? G : [G], K = -1, de;
          for (; de = le.getParentNode(++K); )
            if (me.includes(de.type))
              return K;
          return -1;
        }
        function ge(le, G) {
          let me = te(le, G);
          return me === -1 ? null : le.getParentNode(me);
        }
        function q(le, G, me) {
          if (me.proseWrap === "preserve" && G === `
`)
            return p;
          let K = me.proseWrap === "always" && !ge(le, U);
          return G !== "" ? K ? h : " " : K ? d : "";
        }
        function z(le, G, me) {
          let K = le.getValue(), de = [], je = le.map((Ae) => Ae.map((Se, Me) => {
            let xe = J(me(), G).formatted, mt = n(xe);
            return de[Me] = Math.max(de[Me] || 3, mt), { text: xe, width: mt };
          }, "children"), "children"), Be = v(!1);
          if (G.proseWrap !== "never")
            return [o, Be];
          let ye = v(!0);
          return [o, N(C(ye, Be))];
          function v(Ae) {
            let Se = [ae(je[0], Ae), Y(Ae)];
            return je.length > 1 && Se.push(c(S, je.slice(1).map((Me) => ae(Me, Ae)))), c(S, Se);
          }
          function Y(Ae) {
            return `| ${de.map((Se, Me) => {
              let xe = K.align[Me], mt = xe === "center" || xe === "left" ? ":" : "-", _e = xe === "center" || xe === "right" ? ":" : "-", ft = Ae ? "-" : "-".repeat(Se - 2);
              return `${mt}${ft}${_e}`;
            }).join(" | ")} |`;
          }
          function ae(Ae, Se) {
            return `| ${Ae.map((Me, xe) => {
              let { text: mt, width: _e } = Me;
              if (Se)
                return mt;
              let ft = de[xe] - _e, Le = K.align[xe], Ue = 0;
              Le === "right" ? Ue = ft : Le === "center" && (Ue = Math.floor(ft / 2));
              let et = ft - Ue;
              return `${" ".repeat(Ue)}${mt}${" ".repeat(et)}`;
            }).join(" | ")} |`;
          }
        }
        function De(le, G, me) {
          let K = [], de = null, { children: je } = le.getValue();
          for (let [Be, ye] of je.entries())
            switch (W(ye)) {
              case "start":
                de === null && (de = { index: Be, offset: ye.position.end.offset });
                break;
              case "end":
                de !== null && (K.push({ start: de, end: { index: Be, offset: ye.position.start.offset } }), de = null);
                break;
            }
          return fe(le, G, me, { processor: (Be, ye) => {
            if (K.length > 0) {
              let v = K[0];
              if (ye === v.start.index)
                return [we(je[v.start.index]), G.originalText.slice(v.start.offset, v.end.offset), we(je[v.end.index])];
              if (v.start.index < ye && ye < v.end.index)
                return !1;
              if (ye === v.end.index)
                return K.shift(), !1;
            }
            return me();
          } });
        }
        function fe(le, G, me) {
          let K = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: de } = K, je = K.processor || (() => me()), Be = le.getValue(), ye = [], v;
          return le.each((Y, ae) => {
            let Ae = Y.getValue(), Se = je(Y, ae);
            if (Se !== !1) {
              let Me = { parts: ye, prevNode: v, parentNode: Be, options: G };
              ne(Ae, Me) && (ye.push(p), v && $.has(v.type) || (re(Ae, Me) || he(Ae, Me)) && ye.push(p), he(Ae, Me) && ye.push(p)), ye.push(Se), v = Ae;
            }
          }, "children"), de ? de(ye) : ye;
        }
        function we(le) {
          if (le.type === "html")
            return le.value;
          if (le.type === "paragraph" && Array.isArray(le.children) && le.children.length === 1 && le.children[0].type === "esComment")
            return ["{/* ", le.children[0].value, " */}"];
        }
        function Q(le) {
          let G = le;
          for (; r(G.children); )
            G = s(G.children);
          return G;
        }
        function W(le) {
          let G;
          if (le.type === "html")
            G = le.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
          else {
            let me;
            le.type === "esComment" ? me = le : le.type === "paragraph" && le.children.length === 1 && le.children[0].type === "esComment" && (me = le.children[0]), me && (G = me.value.match(/^prettier-ignore(?:-(start|end))?$/));
          }
          return G ? G[1] || "next" : !1;
        }
        function ne(le, G) {
          let me = G.parts.length === 0, K = I.includes(le.type), de = le.type === "html" && M.includes(G.parentNode.type);
          return !me && !K && !de;
        }
        function re(le, G) {
          var me, K, de;
          let je = (G.prevNode && G.prevNode.type) === le.type && L.has(le.type), Be = G.parentNode.type === "listItem" && !G.parentNode.loose, ye = ((me = G.prevNode) === null || me === void 0 ? void 0 : me.type) === "listItem" && G.prevNode.loose, v = W(G.prevNode) === "next", Y = le.type === "html" && ((K = G.prevNode) === null || K === void 0 ? void 0 : K.type) === "html" && G.prevNode.position.end.line + 1 === le.position.start.line, ae = le.type === "html" && G.parentNode.type === "listItem" && ((de = G.prevNode) === null || de === void 0 ? void 0 : de.type) === "paragraph" && G.prevNode.position.end.line + 1 === le.position.start.line;
          return ye || !(je || Be || v || Y || ae);
        }
        function he(le, G) {
          let me = G.prevNode && G.prevNode.type === "list", K = le.type === "code" && le.isIndented;
          return me && K;
        }
        function Fe(le) {
          let G = ge(le, ["linkReference", "imageReference"]);
          return G && (G.type !== "linkReference" || G.referenceType !== "full");
        }
        function ve(le) {
          let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], me = [" ", ...Array.isArray(G) ? G : [G]];
          return new RegExp(me.map((K) => `\\${K}`).join("|")).test(le) ? `<${le}>` : le;
        }
        function Re(le, G) {
          let me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
          if (!le)
            return "";
          if (me)
            return " " + Re(le, G, !1);
          if (le = le.replace(/\\(["')])/g, "$1"), le.includes('"') && le.includes("'") && !le.includes(")"))
            return `(${le})`;
          let K = le.split("'").length - 1, de = le.split('"').length - 1, je = K > de ? '"' : de > K || G.singleQuote ? "'" : '"';
          return le = le.replace(/\\/, "\\\\"), le = le.replace(new RegExp(`(${je})`, "g"), "\\$1"), `${je}${le}${je}`;
        }
        function tt(le, G, me) {
          return le < G ? G : le > me ? me : le;
        }
        function Ze(le) {
          let G = Number(le.getName());
          if (G === 0)
            return !1;
          let me = le.getParentNode().children[G - 1];
          return W(me) === "next";
        }
        function $e(le) {
          return `[${t(le.label)}]`;
        }
        function Ge(le) {
          return `[^${le.label}]`;
        }
        l.exports = { preprocess: i, print: ee, embed: f, massageAstNode: g, hasPrettierIgnore: Ze, insertPragma: T };
      } }), Fo = X({ "src/language-markdown/options.js"(u, l) {
        H();
        var t = en();
        l.exports = { proseWrap: t.proseWrap, singleQuote: t.singleQuote };
      } }), Ao = X({ "src/language-markdown/parsers.js"() {
        H();
      } }), Gu = X({ "node_modules/linguist-languages/data/Markdown.json"(u, l) {
        l.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: !0, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
      } }), vo = X({ "src/language-markdown/index.js"(u, l) {
        H();
        var t = Gt(), s = Co(), a = Fo(), e = Ao(), n = [t(Gu(), (o) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...o.filenames, "README"], extensions: o.extensions.filter((c) => c !== ".mdx") })), t(Gu(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], r = { mdast: s };
        l.exports = { languages: n, options: a, printers: r, parsers: e };
      } }), xo = X({ "src/language-html/clean.js"(u, l) {
        H();
        var { isFrontMatterNode: t } = at(), s = /* @__PURE__ */ new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
        function a(e, n) {
          if (e.type === "text" || e.type === "comment" || t(e) || e.type === "yaml" || e.type === "toml")
            return null;
          e.type === "attribute" && delete n.value, e.type === "docType" && delete n.value;
        }
        a.ignoredProperties = s, l.exports = a;
      } }), bo = X({ "src/language-html/constants.evaluate.js"(u, l) {
        l.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
      } }), So = X({ "src/language-html/utils/is-unknown-namespace.js"(u, l) {
        H();
        function t(s) {
          return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
        }
        l.exports = t;
      } }), tn = X({ "src/language-html/utils/index.js"(u, l) {
        H();
        var { inferParserByLanguage: t, isFrontMatterNode: s } = at(), { builders: { line: a, hardline: e, join: n }, utils: { getDocParts: r, replaceTextEndOfLine: o } } = Qe(), { CSS_DISPLAY_TAGS: c, CSS_DISPLAY_DEFAULT: h, CSS_WHITE_SPACE_TAGS: m, CSS_WHITE_SPACE_DEFAULT: y } = bo(), p = So(), d = /* @__PURE__ */ new Set(["	", `
`, "\f", "\r", " "]), C = (v) => v.replace(/^[\t\n\f\r ]+/, ""), w = (v) => v.replace(/[\t\n\f\r ]+$/, ""), P = (v) => C(w(v)), A = (v) => v.replace(/^[\t\f\r ]*\n/g, ""), N = (v) => A(w(v)), S = (v) => v.split(/[\t\n\f\r ]+/), j = (v) => v.match(/^[\t\n\f\r ]*/)[0], k = (v) => {
          let [, Y, ae, Ae] = v.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
          return { leadingWhitespace: Y, trailingWhitespace: Ae, text: ae };
        }, J = (v) => /[\t\n\f\r ]/.test(v);
        function f(v, Y) {
          return !!(v.type === "ieConditionalComment" && v.lastChild && !v.lastChild.isSelfClosing && !v.lastChild.endSourceSpan || v.type === "ieConditionalComment" && !v.complete || re(v) && v.children.some((ae) => ae.type !== "text" && ae.type !== "interpolation") || K(v, Y) && !i(v) && v.type !== "interpolation");
        }
        function T(v) {
          return v.type === "attribute" || !v.parent || !v.prev ? !1 : D(v.prev);
        }
        function D(v) {
          return v.type === "comment" && v.value.trim() === "prettier-ignore";
        }
        function F(v) {
          return v.type === "text" || v.type === "comment";
        }
        function i(v) {
          return v.type === "element" && (v.fullName === "script" || v.fullName === "style" || v.fullName === "svg:style" || p(v) && (v.name === "script" || v.name === "style"));
        }
        function g(v) {
          return v.children && !i(v);
        }
        function E(v) {
          return i(v) || v.type === "interpolation" || x(v);
        }
        function x(v) {
          return Re(v).startsWith("pre");
        }
        function b(v, Y) {
          let ae = Ae();
          if (ae && !v.prev && v.parent && v.parent.tagDefinition && v.parent.tagDefinition.ignoreFirstLf)
            return v.type === "interpolation";
          return ae;
          function Ae() {
            return s(v) ? !1 : (v.type === "text" || v.type === "interpolation") && v.prev && (v.prev.type === "text" || v.prev.type === "interpolation") ? !0 : !v.parent || v.parent.cssDisplay === "none" ? !1 : re(v.parent) ? !0 : !(!v.prev && (v.parent.type === "root" || re(v) && v.parent || i(v.parent) || G(v.parent, Y) || !fe(v.parent.cssDisplay)) || v.prev && !W(v.prev.cssDisplay));
          }
        }
        function B(v, Y) {
          return s(v) ? !1 : (v.type === "text" || v.type === "interpolation") && v.next && (v.next.type === "text" || v.next.type === "interpolation") ? !0 : !v.parent || v.parent.cssDisplay === "none" ? !1 : re(v.parent) ? !0 : !(!v.next && (v.parent.type === "root" || re(v) && v.parent || i(v.parent) || G(v.parent, Y) || !we(v.parent.cssDisplay)) || v.next && !Q(v.next.cssDisplay));
        }
        function I(v) {
          return ne(v.cssDisplay) && !i(v);
        }
        function M(v) {
          return s(v) || v.next && v.sourceSpan.end && v.sourceSpan.end.line + 1 < v.next.sourceSpan.start.line;
        }
        function V(v) {
          return $(v) || v.type === "element" && v.children.length > 0 && (["body", "script", "style"].includes(v.name) || v.children.some((Y) => te(Y))) || v.firstChild && v.firstChild === v.lastChild && v.firstChild.type !== "text" && R(v.firstChild) && (!v.lastChild.isTrailingSpaceSensitive || O(v.lastChild));
        }
        function $(v) {
          return v.type === "element" && v.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(v.name) || v.cssDisplay.startsWith("table") && v.cssDisplay !== "table-cell");
        }
        function U(v) {
          return Z(v) || v.prev && L(v.prev) || ee(v);
        }
        function L(v) {
          return Z(v) || v.type === "element" && v.fullName === "br" || ee(v);
        }
        function ee(v) {
          return R(v) && O(v);
        }
        function R(v) {
          return v.hasLeadingSpaces && (v.prev ? v.prev.sourceSpan.end.line < v.sourceSpan.start.line : v.parent.type === "root" || v.parent.startSourceSpan.end.line < v.sourceSpan.start.line);
        }
        function O(v) {
          return v.hasTrailingSpaces && (v.next ? v.next.sourceSpan.start.line > v.sourceSpan.end.line : v.parent.type === "root" || v.parent.endSourceSpan && v.parent.endSourceSpan.start.line > v.sourceSpan.end.line);
        }
        function Z(v) {
          switch (v.type) {
            case "ieConditionalComment":
            case "comment":
            case "directive":
              return !0;
            case "element":
              return ["script", "select"].includes(v.name);
          }
          return !1;
        }
        function ie(v) {
          return v.lastChild ? ie(v.lastChild) : v;
        }
        function te(v) {
          return v.children && v.children.some((Y) => Y.type !== "text");
        }
        function ge(v) {
          let { type: Y, lang: ae } = v.attrMap;
          if (Y === "module" || Y === "text/javascript" || Y === "text/babel" || Y === "application/javascript" || ae === "jsx")
            return "babel";
          if (Y === "application/x-typescript" || ae === "ts" || ae === "tsx")
            return "typescript";
          if (Y === "text/markdown")
            return "markdown";
          if (Y === "text/html")
            return "html";
          if (Y && (Y.endsWith("json") || Y.endsWith("importmap")) || Y === "speculationrules")
            return "json";
          if (Y === "text/x-handlebars-template")
            return "glimmer";
        }
        function q(v, Y) {
          let { lang: ae } = v.attrMap;
          if (!ae || ae === "postcss" || ae === "css")
            return "css";
          if (ae === "scss")
            return "scss";
          if (ae === "less")
            return "less";
          if (ae === "stylus")
            return t("stylus", Y);
        }
        function z(v, Y) {
          if (v.name === "script" && !v.attrMap.src)
            return !v.attrMap.lang && !v.attrMap.type ? "babel" : ge(v);
          if (v.name === "style")
            return q(v, Y);
          if (Y && K(v, Y))
            return ge(v) || !("src" in v.attrMap) && t(v.attrMap.lang, Y);
        }
        function De(v) {
          return v === "block" || v === "list-item" || v.startsWith("table");
        }
        function fe(v) {
          return !De(v) && v !== "inline-block";
        }
        function we(v) {
          return !De(v) && v !== "inline-block";
        }
        function Q(v) {
          return !De(v);
        }
        function W(v) {
          return !De(v);
        }
        function ne(v) {
          return !De(v) && v !== "inline-block";
        }
        function re(v) {
          return Re(v).startsWith("pre");
        }
        function he(v, Y) {
          let ae = 0;
          for (let Ae = v.stack.length - 1; Ae >= 0; Ae--) {
            let Se = v.stack[Ae];
            Se && typeof Se == "object" && !Array.isArray(Se) && Y(Se) && ae++;
          }
          return ae;
        }
        function Fe(v, Y) {
          let ae = v;
          for (; ae; ) {
            if (Y(ae))
              return !0;
            ae = ae.parent;
          }
          return !1;
        }
        function ve(v, Y) {
          if (v.prev && v.prev.type === "comment") {
            let Ae = v.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
            if (Ae)
              return Ae[1];
          }
          let ae = !1;
          if (v.type === "element" && v.namespace === "svg")
            if (Fe(v, (Ae) => Ae.fullName === "svg:foreignObject"))
              ae = !0;
            else
              return v.name === "svg" ? "inline-block" : "block";
          switch (Y.htmlWhitespaceSensitivity) {
            case "strict":
              return "inline";
            case "ignore":
              return "block";
            default:
              return Y.parser === "vue" && v.parent && v.parent.type === "root" ? "block" : v.type === "element" && (!v.namespace || ae || p(v)) && c[v.name] || h;
          }
        }
        function Re(v) {
          return v.type === "element" && (!v.namespace || p(v)) && m[v.name] || y;
        }
        function tt(v) {
          let Y = Number.POSITIVE_INFINITY;
          for (let ae of v.split(`
`)) {
            if (ae.length === 0)
              continue;
            if (!d.has(ae[0]))
              return 0;
            let Ae = j(ae).length;
            ae.length !== Ae && Ae < Y && (Y = Ae);
          }
          return Y === Number.POSITIVE_INFINITY ? 0 : Y;
        }
        function Ze(v) {
          let Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : tt(v);
          return Y === 0 ? v : v.split(`
`).map((ae) => ae.slice(Y)).join(`
`);
        }
        function $e(v, Y) {
          let ae = 0;
          for (let Ae = 0; Ae < v.length; Ae++)
            v[Ae] === Y && ae++;
          return ae;
        }
        function Ge(v) {
          return v.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
        }
        var le = /* @__PURE__ */ new Set(["template", "style", "script"]);
        function G(v, Y) {
          return me(v, Y) && !le.has(v.fullName);
        }
        function me(v, Y) {
          return Y.parser === "vue" && v.type === "element" && v.parent.type === "root" && v.fullName.toLowerCase() !== "html";
        }
        function K(v, Y) {
          return me(v, Y) && (G(v, Y) || v.attrMap.lang && v.attrMap.lang !== "html");
        }
        function de(v) {
          let Y = v.fullName;
          return Y.charAt(0) === "#" || Y === "slot-scope" || Y === "v-slot" || Y.startsWith("v-slot:");
        }
        function je(v, Y) {
          let ae = v.parent;
          if (!me(ae, Y))
            return !1;
          let Ae = ae.fullName, Se = v.fullName;
          return Ae === "script" && Se === "setup" || Ae === "style" && Se === "vars";
        }
        function Be(v) {
          let Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : v.value;
          return v.parent.isWhitespaceSensitive ? v.parent.isIndentationSensitive ? o(Y) : o(Ze(N(Y)), e) : r(n(a, S(Y)));
        }
        function ye(v, Y) {
          return me(v, Y) && v.name === "script";
        }
        l.exports = { htmlTrim: P, htmlTrimPreserveIndentation: N, hasHtmlWhitespace: J, getLeadingAndTrailingHtmlWhitespace: k, canHaveInterpolation: g, countChars: $e, countParents: he, dedentString: Ze, forceBreakChildren: $, forceBreakContent: V, forceNextEmptyLine: M, getLastDescendant: ie, getNodeCssStyleDisplay: ve, getNodeCssStyleWhiteSpace: Re, hasPrettierIgnore: T, inferScriptParser: z, isVueCustomBlock: G, isVueNonHtmlBlock: K, isVueScriptTag: ye, isVueSlotAttribute: de, isVueSfcBindingsAttribute: je, isVueSfcBlock: me, isDanglingSpaceSensitiveNode: I, isIndentationSensitiveNode: x, isLeadingSpaceSensitiveNode: b, isPreLikeNode: re, isScriptLikeTag: i, isTextLikeNode: F, isTrailingSpaceSensitiveNode: B, isWhitespaceSensitiveNode: E, isUnknownNamespace: p, preferHardlineAsLeadingSpaces: U, preferHardlineAsTrailingSpaces: L, shouldPreserveContent: f, unescapeQuoteEntities: Ge, getTextValueParts: Be };
      } }), To = X({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 }), u.$EOF = 0, u.$BSPACE = 8, u.$TAB = 9, u.$LF = 10, u.$VTAB = 11, u.$FF = 12, u.$CR = 13, u.$SPACE = 32, u.$BANG = 33, u.$DQ = 34, u.$HASH = 35, u.$$ = 36, u.$PERCENT = 37, u.$AMPERSAND = 38, u.$SQ = 39, u.$LPAREN = 40, u.$RPAREN = 41, u.$STAR = 42, u.$PLUS = 43, u.$COMMA = 44, u.$MINUS = 45, u.$PERIOD = 46, u.$SLASH = 47, u.$COLON = 58, u.$SEMICOLON = 59, u.$LT = 60, u.$EQ = 61, u.$GT = 62, u.$QUESTION = 63, u.$0 = 48, u.$7 = 55, u.$9 = 57, u.$A = 65, u.$E = 69, u.$F = 70, u.$X = 88, u.$Z = 90, u.$LBRACKET = 91, u.$BACKSLASH = 92, u.$RBRACKET = 93, u.$CARET = 94, u.$_ = 95, u.$a = 97, u.$b = 98, u.$e = 101, u.$f = 102, u.$n = 110, u.$r = 114, u.$t = 116, u.$u = 117, u.$v = 118, u.$x = 120, u.$z = 122, u.$LBRACE = 123, u.$BAR = 124, u.$RBRACE = 125, u.$NBSP = 160, u.$PIPE = 124, u.$TILDA = 126, u.$AT = 64, u.$BT = 96;
        function l(r) {
          return r >= u.$TAB && r <= u.$SPACE || r == u.$NBSP;
        }
        u.isWhitespace = l;
        function t(r) {
          return u.$0 <= r && r <= u.$9;
        }
        u.isDigit = t;
        function s(r) {
          return r >= u.$a && r <= u.$z || r >= u.$A && r <= u.$Z;
        }
        u.isAsciiLetter = s;
        function a(r) {
          return r >= u.$a && r <= u.$f || r >= u.$A && r <= u.$F || t(r);
        }
        u.isAsciiHexDigit = a;
        function e(r) {
          return r === u.$LF || r === u.$CR;
        }
        u.isNewLine = e;
        function n(r) {
          return u.$0 <= r && r <= u.$7;
        }
        u.isOctalDigit = n;
      } }), Bo = X({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = class {
          constructor(s, a, e) {
            this.filePath = s, this.name = a, this.members = e;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        u.StaticSymbol = l;
        var t = class {
          constructor() {
            this.cache = /* @__PURE__ */ new Map();
          }
          get(s, a, e) {
            e = e || [];
            let n = e.length ? `.${e.join(".")}` : "", r = `"${s}".${a}${n}`, o = this.cache.get(r);
            return o || (o = new l(s, a, e), this.cache.set(r, o)), o;
          }
        };
        u.StaticSymbolCache = t;
      } }), wo = X({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = /-+([a-z0-9])/g;
        function t(i) {
          return i.replace(l, function() {
            for (var g = arguments.length, E = new Array(g), x = 0; x < g; x++)
              E[x] = arguments[x];
            return E[1].toUpperCase();
          });
        }
        u.dashCaseToCamelCase = t;
        function s(i, g) {
          return e(i, ":", g);
        }
        u.splitAtColon = s;
        function a(i, g) {
          return e(i, ".", g);
        }
        u.splitAtPeriod = a;
        function e(i, g, E) {
          let x = i.indexOf(g);
          return x == -1 ? E : [i.slice(0, x).trim(), i.slice(x + 1).trim()];
        }
        function n(i, g, E) {
          return Array.isArray(i) ? g.visitArray(i, E) : A(i) ? g.visitStringMap(i, E) : i == null || typeof i == "string" || typeof i == "number" || typeof i == "boolean" ? g.visitPrimitive(i, E) : g.visitOther(i, E);
        }
        u.visitValue = n;
        function r(i) {
          return i != null;
        }
        u.isDefined = r;
        function o(i) {
          return i === void 0 ? null : i;
        }
        u.noUndefined = o;
        var c = class {
          visitArray(i, g) {
            return i.map((E) => n(E, this, g));
          }
          visitStringMap(i, g) {
            let E = {};
            return Object.keys(i).forEach((x) => {
              E[x] = n(i[x], this, g);
            }), E;
          }
          visitPrimitive(i, g) {
            return i;
          }
          visitOther(i, g) {
            return i;
          }
        };
        u.ValueTransformer = c, u.SyncAsync = { assertSync: (i) => {
          if (k(i))
            throw new Error("Illegal state: value cannot be a promise");
          return i;
        }, then: (i, g) => k(i) ? i.then(g) : g(i), all: (i) => i.some(k) ? Promise.all(i) : i };
        function h(i) {
          throw new Error(`Internal Error: ${i}`);
        }
        u.error = h;
        function m(i, g) {
          let E = Error(i);
          return E[y] = !0, g && (E[p] = g), E;
        }
        u.syntaxError = m;
        var y = "ngSyntaxError", p = "ngParseErrors";
        function d(i) {
          return i[y];
        }
        u.isSyntaxError = d;
        function C(i) {
          return i[p] || [];
        }
        u.getParseErrors = C;
        function w(i) {
          return i.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        u.escapeRegExp = w;
        var P = Object.getPrototypeOf({});
        function A(i) {
          return typeof i == "object" && i !== null && Object.getPrototypeOf(i) === P;
        }
        function N(i) {
          let g = "";
          for (let E = 0; E < i.length; E++) {
            let x = i.charCodeAt(E);
            if (x >= 55296 && x <= 56319 && i.length > E + 1) {
              let b = i.charCodeAt(E + 1);
              b >= 56320 && b <= 57343 && (E++, x = (x - 55296 << 10) + b - 56320 + 65536);
            }
            x <= 127 ? g += String.fromCharCode(x) : x <= 2047 ? g += String.fromCharCode(x >> 6 & 31 | 192, x & 63 | 128) : x <= 65535 ? g += String.fromCharCode(x >> 12 | 224, x >> 6 & 63 | 128, x & 63 | 128) : x <= 2097151 && (g += String.fromCharCode(x >> 18 & 7 | 240, x >> 12 & 63 | 128, x >> 6 & 63 | 128, x & 63 | 128));
          }
          return g;
        }
        u.utf8Encode = N;
        function S(i) {
          if (typeof i == "string")
            return i;
          if (i instanceof Array)
            return "[" + i.map(S).join(", ") + "]";
          if (i == null)
            return "" + i;
          if (i.overriddenName)
            return `${i.overriddenName}`;
          if (i.name)
            return `${i.name}`;
          if (!i.toString)
            return "object";
          let g = i.toString();
          if (g == null)
            return "" + g;
          let E = g.indexOf(`
`);
          return E === -1 ? g : g.substring(0, E);
        }
        u.stringify = S;
        function j(i) {
          return typeof i == "function" && i.hasOwnProperty("__forward_ref__") ? i() : i;
        }
        u.resolveForwardRef = j;
        function k(i) {
          return !!i && typeof i.then == "function";
        }
        u.isPromise = k;
        var J = class {
          constructor(i) {
            this.full = i;
            let g = i.split(".");
            this.major = g[0], this.minor = g[1], this.patch = g.slice(2).join(".");
          }
        };
        u.Version = J;
        var f = typeof window < "u" && window, T = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, D = typeof globalThis < "u" && globalThis, F = D || f || T;
        u.global = F;
      } }), No = X({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = Bo(), t = wo(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function a(E) {
          return E.replace(/\W/g, "_");
        }
        u.sanitizeIdentifier = a;
        var e = 0;
        function n(E) {
          if (!E || !E.reference)
            return null;
          let x = E.reference;
          if (x instanceof l.StaticSymbol)
            return x.name;
          if (x.__anonymousType)
            return x.__anonymousType;
          let b = t.stringify(x);
          return b.indexOf("(") >= 0 ? (b = `anonymous_${e++}`, x.__anonymousType = b) : b = a(b), b;
        }
        u.identifierName = n;
        function r(E) {
          let x = E.reference;
          return x instanceof l.StaticSymbol ? x.filePath : `./${t.stringify(x)}`;
        }
        u.identifierModuleUrl = r;
        function o(E, x) {
          return `View_${n({ reference: E })}_${x}`;
        }
        u.viewClassName = o;
        function c(E) {
          return `RenderType_${n({ reference: E })}`;
        }
        u.rendererTypeName = c;
        function h(E) {
          return `HostView_${n({ reference: E })}`;
        }
        u.hostViewClassName = h;
        function m(E) {
          return `${n({ reference: E })}NgFactory`;
        }
        u.componentFactoryName = m;
        var y;
        (function(E) {
          E[E.Pipe = 0] = "Pipe", E[E.Directive = 1] = "Directive", E[E.NgModule = 2] = "NgModule", E[E.Injectable = 3] = "Injectable";
        })(y = u.CompileSummaryKind || (u.CompileSummaryKind = {}));
        function p(E) {
          return E.value != null ? a(E.value) : n(E.identifier);
        }
        u.tokenName = p;
        function d(E) {
          return E.identifier != null ? E.identifier.reference : E.value;
        }
        u.tokenReference = d;
        var C = class {
          constructor() {
            let { moduleUrl: E, styles: x, styleUrls: b } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = E || null, this.styles = k(x), this.styleUrls = k(b);
          }
        };
        u.CompileStylesheetMetadata = C;
        var w = class {
          constructor(E) {
            let { encapsulation: x, template: b, templateUrl: B, htmlAst: I, styles: M, styleUrls: V, externalStylesheets: $, animations: U, ngContentSelectors: L, interpolation: ee, isInline: R, preserveWhitespaces: O } = E;
            if (this.encapsulation = x, this.template = b, this.templateUrl = B, this.htmlAst = I, this.styles = k(M), this.styleUrls = k(V), this.externalStylesheets = k($), this.animations = U ? f(U) : [], this.ngContentSelectors = L || [], ee && ee.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = ee, this.isInline = R, this.preserveWhitespaces = O;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        u.CompileTemplateMetadata = w;
        var P = class {
          static create(E) {
            let { isHost: x, type: b, isComponent: B, selector: I, exportAs: M, changeDetection: V, inputs: $, outputs: U, host: L, providers: ee, viewProviders: R, queries: O, guards: Z, viewQueries: ie, entryComponents: te, template: ge, componentViewType: q, rendererType: z, componentFactory: De } = E, fe = {}, we = {}, Q = {};
            L != null && Object.keys(L).forEach((re) => {
              let he = L[re], Fe = re.match(s);
              Fe === null ? Q[re] = he : Fe[1] != null ? we[Fe[1]] = he : Fe[2] != null && (fe[Fe[2]] = he);
            });
            let W = {};
            $ != null && $.forEach((re) => {
              let he = t.splitAtColon(re, [re, re]);
              W[he[0]] = he[1];
            });
            let ne = {};
            return U != null && U.forEach((re) => {
              let he = t.splitAtColon(re, [re, re]);
              ne[he[0]] = he[1];
            }), new P({ isHost: x, type: b, isComponent: !!B, selector: I, exportAs: M, changeDetection: V, inputs: W, outputs: ne, hostListeners: fe, hostProperties: we, hostAttributes: Q, providers: ee, viewProviders: R, queries: O, guards: Z, viewQueries: ie, entryComponents: te, template: ge, componentViewType: q, rendererType: z, componentFactory: De });
          }
          constructor(E) {
            let { isHost: x, type: b, isComponent: B, selector: I, exportAs: M, changeDetection: V, inputs: $, outputs: U, hostListeners: L, hostProperties: ee, hostAttributes: R, providers: O, viewProviders: Z, queries: ie, guards: te, viewQueries: ge, entryComponents: q, template: z, componentViewType: De, rendererType: fe, componentFactory: we } = E;
            this.isHost = !!x, this.type = b, this.isComponent = B, this.selector = I, this.exportAs = M, this.changeDetection = V, this.inputs = $, this.outputs = U, this.hostListeners = L, this.hostProperties = ee, this.hostAttributes = R, this.providers = k(O), this.viewProviders = k(Z), this.queries = k(ie), this.guards = te, this.viewQueries = k(ge), this.entryComponents = k(q), this.template = z, this.componentViewType = De, this.rendererType = fe, this.componentFactory = we;
          }
          toSummary() {
            return { summaryKind: y.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        u.CompileDirectiveMetadata = P;
        var A = class {
          constructor(E) {
            let { type: x, name: b, pure: B } = E;
            this.type = x, this.name = b, this.pure = !!B;
          }
          toSummary() {
            return { summaryKind: y.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        u.CompilePipeMetadata = A;
        var N = class {
        };
        u.CompileShallowModuleMetadata = N;
        var S = class {
          constructor(E) {
            let { type: x, providers: b, declaredDirectives: B, exportedDirectives: I, declaredPipes: M, exportedPipes: V, entryComponents: $, bootstrapComponents: U, importedModules: L, exportedModules: ee, schemas: R, transitiveModule: O, id: Z } = E;
            this.type = x || null, this.declaredDirectives = k(B), this.exportedDirectives = k(I), this.declaredPipes = k(M), this.exportedPipes = k(V), this.providers = k(b), this.entryComponents = k($), this.bootstrapComponents = k(U), this.importedModules = k(L), this.exportedModules = k(ee), this.schemas = k(R), this.id = Z || null, this.transitiveModule = O || null;
          }
          toSummary() {
            let E = this.transitiveModule;
            return { summaryKind: y.NgModule, type: this.type, entryComponents: E.entryComponents, providers: E.providers, modules: E.modules, exportedDirectives: E.exportedDirectives, exportedPipes: E.exportedPipes };
          }
        };
        u.CompileNgModuleMetadata = S;
        var j = class {
          constructor() {
            this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(E, x) {
            this.providers.push({ provider: E, module: x });
          }
          addDirective(E) {
            this.directivesSet.has(E.reference) || (this.directivesSet.add(E.reference), this.directives.push(E));
          }
          addExportedDirective(E) {
            this.exportedDirectivesSet.has(E.reference) || (this.exportedDirectivesSet.add(E.reference), this.exportedDirectives.push(E));
          }
          addPipe(E) {
            this.pipesSet.has(E.reference) || (this.pipesSet.add(E.reference), this.pipes.push(E));
          }
          addExportedPipe(E) {
            this.exportedPipesSet.has(E.reference) || (this.exportedPipesSet.add(E.reference), this.exportedPipes.push(E));
          }
          addModule(E) {
            this.modulesSet.has(E.reference) || (this.modulesSet.add(E.reference), this.modules.push(E));
          }
          addEntryComponent(E) {
            this.entryComponentsSet.has(E.componentType) || (this.entryComponentsSet.add(E.componentType), this.entryComponents.push(E));
          }
        };
        u.TransitiveCompileNgModuleMetadata = j;
        function k(E) {
          return E || [];
        }
        var J = class {
          constructor(E, x) {
            let { useClass: b, useValue: B, useExisting: I, useFactory: M, deps: V, multi: $ } = x;
            this.token = E, this.useClass = b || null, this.useValue = B, this.useExisting = I, this.useFactory = M || null, this.dependencies = V || null, this.multi = !!$;
          }
        };
        u.ProviderMeta = J;
        function f(E) {
          return E.reduce((x, b) => {
            let B = Array.isArray(b) ? f(b) : b;
            return x.concat(B);
          }, []);
        }
        u.flatten = f;
        function T(E) {
          return E.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function D(E, x, b) {
          let B;
          return b.isInline ? x.type.reference instanceof l.StaticSymbol ? B = `${x.type.reference.filePath}.${x.type.reference.name}.html` : B = `${n(E)}/${n(x.type)}.html` : B = b.templateUrl, x.type.reference instanceof l.StaticSymbol ? B : T(B);
        }
        u.templateSourceUrl = D;
        function F(E, x) {
          let b = E.moduleUrl.split(/\/\\/g), B = b[b.length - 1];
          return T(`css/${x}${B}.ngstyle.js`);
        }
        u.sharedStylesheetJitUrl = F;
        function i(E) {
          return T(`${n(E.type)}/module.ngfactory.js`);
        }
        u.ngModuleJitUrl = i;
        function g(E, x) {
          return T(`${n(E)}/${n(x.type)}.ngfactory.js`);
        }
        u.templateJitUrl = g;
      } }), ko = X({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(u) {
        H(), Object.defineProperty(u, "__esModule", { value: !0 });
        var l = To(), t = No(), s = class {
          constructor(h, m, y, p) {
            this.file = h, this.offset = m, this.line = y, this.col = p;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(h) {
            let m = this.file.content, y = m.length, p = this.offset, d = this.line, C = this.col;
            for (; p > 0 && h < 0; )
              if (p--, h++, m.charCodeAt(p) == l.$LF) {
                d--;
                let w = m.substr(0, p - 1).lastIndexOf(String.fromCharCode(l.$LF));
                C = w > 0 ? p - w : p;
              } else
                C--;
            for (; p < y && h > 0; ) {
              let w = m.charCodeAt(p);
              p++, h--, w == l.$LF ? (d++, C = 0) : C++;
            }
            return new s(this.file, p, d, C);
          }
          getContext(h, m) {
            let y = this.file.content, p = this.offset;
            if (p != null) {
              p > y.length - 1 && (p = y.length - 1);
              let d = p, C = 0, w = 0;
              for (; C < h && p > 0 && (p--, C++, !(y[p] == `
` && ++w == m)); )
                ;
              for (C = 0, w = 0; C < h && d < y.length - 1 && (d++, C++, !(y[d] == `
` && ++w == m)); )
                ;
              return { before: y.substring(p, this.offset), after: y.substring(this.offset, d + 1) };
            }
            return null;
          }
        };
        u.ParseLocation = s;
        var a = class {
          constructor(h, m) {
            this.content = h, this.url = m;
          }
        };
        u.ParseSourceFile = a;
        var e = class {
          constructor(h, m) {
            let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = h, this.end = m, this.details = y;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        u.ParseSourceSpan = e, u.EMPTY_PARSE_LOCATION = new s(new a("", ""), 0, 0, 0), u.EMPTY_SOURCE_SPAN = new e(u.EMPTY_PARSE_LOCATION, u.EMPTY_PARSE_LOCATION);
        var n;
        (function(h) {
          h[h.WARNING = 0] = "WARNING", h[h.ERROR = 1] = "ERROR";
        })(n = u.ParseErrorLevel || (u.ParseErrorLevel = {}));
        var r = class {
          constructor(h, m) {
            let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n.ERROR;
            this.span = h, this.msg = m, this.level = y;
          }
          contextualMessage() {
            let h = this.span.start.getContext(100, 3);
            return h ? `${this.msg} ("${h.before}[${n[this.level]} ->]${h.after}")` : this.msg;
          }
          toString() {
            let h = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${h}`;
          }
        };
        u.ParseError = r;
        function o(h, m) {
          let y = t.identifierModuleUrl(m), p = y != null ? `in ${h} ${t.identifierName(m)} in ${y}` : `in ${h} ${t.identifierName(m)}`, d = new a("", p);
          return new e(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
        }
        u.typeSourceSpan = o;
        function c(h, m, y) {
          let p = `in ${h} ${m} in ${y}`, d = new a("", p);
          return new e(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
        }
        u.r3JitTypeSourceSpan = c;
      } }), Po = X({ "src/language-html/print-preprocess.js"(u, l) {
        H();
        var { ParseSourceSpan: t } = ko(), { htmlTrim: s, getLeadingAndTrailingHtmlWhitespace: a, hasHtmlWhitespace: e, canHaveInterpolation: n, getNodeCssStyleDisplay: r, isDanglingSpaceSensitiveNode: o, isIndentationSensitiveNode: c, isLeadingSpaceSensitiveNode: h, isTrailingSpaceSensitiveNode: m, isWhitespaceSensitiveNode: y, isVueScriptTag: p } = tn(), d = [w, P, N, j, k, T, J, f, D, S, F];
        function C(i, g) {
          for (let E of d)
            E(i, g);
          return i;
        }
        function w(i) {
          i.walk((g) => {
            if (g.type === "element" && g.tagDefinition.ignoreFirstLf && g.children.length > 0 && g.children[0].type === "text" && g.children[0].value[0] === `
`) {
              let E = g.children[0];
              E.value.length === 1 ? g.removeChild(E) : E.value = E.value.slice(1);
            }
          });
        }
        function P(i) {
          let g = (E) => E.type === "element" && E.prev && E.prev.type === "ieConditionalStartComment" && E.prev.sourceSpan.end.offset === E.startSourceSpan.start.offset && E.firstChild && E.firstChild.type === "ieConditionalEndComment" && E.firstChild.sourceSpan.start.offset === E.startSourceSpan.end.offset;
          i.walk((E) => {
            if (E.children)
              for (let x = 0; x < E.children.length; x++) {
                let b = E.children[x];
                if (!g(b))
                  continue;
                let B = b.prev, I = b.firstChild;
                E.removeChild(B), x--;
                let M = new t(B.sourceSpan.start, I.sourceSpan.end), V = new t(M.start, b.sourceSpan.end);
                b.condition = B.condition, b.sourceSpan = V, b.startSourceSpan = M, b.removeChild(I);
              }
          });
        }
        function A(i, g, E) {
          i.walk((x) => {
            if (x.children)
              for (let b = 0; b < x.children.length; b++) {
                let B = x.children[b];
                if (B.type !== "text" && !g(B))
                  continue;
                B.type !== "text" && (B.type = "text", B.value = E(B));
                let I = B.prev;
                !I || I.type !== "text" || (I.value += B.value, I.sourceSpan = new t(I.sourceSpan.start, B.sourceSpan.end), x.removeChild(B), b--);
              }
          });
        }
        function N(i) {
          return A(i, (g) => g.type === "cdata", (g) => `<![CDATA[${g.value}]]>`);
        }
        function S(i) {
          let g = (E) => E.type === "element" && E.attrs.length === 0 && E.children.length === 1 && E.firstChild.type === "text" && !e(E.children[0].value) && !E.firstChild.hasLeadingSpaces && !E.firstChild.hasTrailingSpaces && E.isLeadingSpaceSensitive && !E.hasLeadingSpaces && E.isTrailingSpaceSensitive && !E.hasTrailingSpaces && E.prev && E.prev.type === "text" && E.next && E.next.type === "text";
          i.walk((E) => {
            if (E.children)
              for (let x = 0; x < E.children.length; x++) {
                let b = E.children[x];
                if (!g(b))
                  continue;
                let B = b.prev, I = b.next;
                B.value += `<${b.rawName}>` + b.firstChild.value + `</${b.rawName}>` + I.value, B.sourceSpan = new t(B.sourceSpan.start, I.sourceSpan.end), B.isTrailingSpaceSensitive = I.isTrailingSpaceSensitive, B.hasTrailingSpaces = I.hasTrailingSpaces, E.removeChild(b), x--, E.removeChild(I);
              }
          });
        }
        function j(i, g) {
          if (g.parser === "html")
            return;
          let E = /{{(.+?)}}/s;
          i.walk((x) => {
            if (n(x))
              for (let b of x.children) {
                if (b.type !== "text")
                  continue;
                let B = b.sourceSpan.start, I = null, M = b.value.split(E);
                for (let V = 0; V < M.length; V++, B = I) {
                  let $ = M[V];
                  if (V % 2 === 0) {
                    I = B.moveBy($.length), $.length > 0 && x.insertChildBefore(b, { type: "text", value: $, sourceSpan: new t(B, I) });
                    continue;
                  }
                  I = B.moveBy($.length + 4), x.insertChildBefore(b, { type: "interpolation", sourceSpan: new t(B, I), children: $.length === 0 ? [] : [{ type: "text", value: $, sourceSpan: new t(B.moveBy(2), I.moveBy(-2)) }] });
                }
                x.removeChild(b);
              }
          });
        }
        function k(i) {
          i.walk((g) => {
            if (!g.children)
              return;
            if (g.children.length === 0 || g.children.length === 1 && g.children[0].type === "text" && s(g.children[0].value).length === 0) {
              g.hasDanglingSpaces = g.children.length > 0, g.children = [];
              return;
            }
            let E = y(g), x = c(g);
            if (!E)
              for (let b = 0; b < g.children.length; b++) {
                let B = g.children[b];
                if (B.type !== "text")
                  continue;
                let { leadingWhitespace: I, text: M, trailingWhitespace: V } = a(B.value), $ = B.prev, U = B.next;
                M ? (B.value = M, B.sourceSpan = new t(B.sourceSpan.start.moveBy(I.length), B.sourceSpan.end.moveBy(-V.length)), I && ($ && ($.hasTrailingSpaces = !0), B.hasLeadingSpaces = !0), V && (B.hasTrailingSpaces = !0, U && (U.hasLeadingSpaces = !0))) : (g.removeChild(B), b--, (I || V) && ($ && ($.hasTrailingSpaces = !0), U && (U.hasLeadingSpaces = !0)));
              }
            g.isWhitespaceSensitive = E, g.isIndentationSensitive = x;
          });
        }
        function J(i) {
          i.walk((g) => {
            g.isSelfClosing = !g.children || g.type === "element" && (g.tagDefinition.isVoid || g.startSourceSpan === g.endSourceSpan);
          });
        }
        function f(i, g) {
          i.walk((E) => {
            E.type === "element" && (E.hasHtmComponentClosingTag = E.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(g.originalText.slice(E.endSourceSpan.start.offset, E.endSourceSpan.end.offset)));
          });
        }
        function T(i, g) {
          i.walk((E) => {
            E.cssDisplay = r(E, g);
          });
        }
        function D(i, g) {
          i.walk((E) => {
            let { children: x } = E;
            if (x) {
              if (x.length === 0) {
                E.isDanglingSpaceSensitive = o(E);
                return;
              }
              for (let b of x)
                b.isLeadingSpaceSensitive = h(b, g), b.isTrailingSpaceSensitive = m(b, g);
              for (let b = 0; b < x.length; b++) {
                let B = x[b];
                B.isLeadingSpaceSensitive = (b === 0 || B.prev.isTrailingSpaceSensitive) && B.isLeadingSpaceSensitive, B.isTrailingSpaceSensitive = (b === x.length - 1 || B.next.isLeadingSpaceSensitive) && B.isTrailingSpaceSensitive;
              }
            }
          });
        }
        function F(i, g) {
          if (g.parser === "vue") {
            let E = i.children.find((b) => p(b, g));
            if (!E)
              return;
            let { lang: x } = E.attrMap;
            (x === "ts" || x === "typescript") && (g.__should_parse_vue_template_with_ts = !0);
          }
        }
        l.exports = C;
      } }), jo = X({ "src/language-html/pragma.js"(u, l) {
        H();
        function t(a) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a);
        }
        function s(a) {
          return `<!-- @format -->

` + a.replace(/^\s*\n/, "");
        }
        l.exports = { hasPragma: t, insertPragma: s };
      } }), mr = X({ "src/language-html/loc.js"(u, l) {
        H();
        function t(a) {
          return a.sourceSpan.start.offset;
        }
        function s(a) {
          return a.sourceSpan.end.offset;
        }
        l.exports = { locStart: t, locEnd: s };
      } }), mn = X({ "src/language-html/print/tag.js"(u, l) {
        H();
        var t = pn(), { isNonEmptyArray: s } = at(), { builders: { indent: a, join: e, line: n, softline: r, hardline: o }, utils: { replaceTextEndOfLine: c } } = Qe(), { locStart: h, locEnd: m } = mr(), { isTextLikeNode: y, getLastDescendant: p, isPreLikeNode: d, hasPrettierIgnore: C, shouldPreserveContent: w, isVueSfcBlock: P } = tn();
        function A(L, ee) {
          return [L.isSelfClosing ? "" : N(L, ee), S(L, ee)];
        }
        function N(L, ee) {
          return L.lastChild && i(L.lastChild) ? "" : [j(L, ee), J(L, ee)];
        }
        function S(L, ee) {
          return (L.next ? D(L.next) : F(L.parent)) ? "" : [f(L, ee), k(L, ee)];
        }
        function j(L, ee) {
          return F(L) ? f(L.lastChild, ee) : "";
        }
        function k(L, ee) {
          return i(L) ? J(L.parent, ee) : g(L) ? $(L.next) : "";
        }
        function J(L, ee) {
          if (t(!L.isSelfClosing), T(L, ee))
            return "";
          switch (L.type) {
            case "ieConditionalComment":
              return "<!";
            case "element":
              if (L.hasHtmComponentClosingTag)
                return "<//";
            default:
              return `</${L.rawName}`;
          }
        }
        function f(L, ee) {
          if (T(L, ee))
            return "";
          switch (L.type) {
            case "ieConditionalComment":
            case "ieConditionalEndComment":
              return "[endif]-->";
            case "ieConditionalStartComment":
              return "]><!-->";
            case "interpolation":
              return "}}";
            case "element":
              if (L.isSelfClosing)
                return "/>";
            default:
              return ">";
          }
        }
        function T(L, ee) {
          return !L.isSelfClosing && !L.endSourceSpan && (C(L) || w(L.parent, ee));
        }
        function D(L) {
          return L.prev && L.prev.type !== "docType" && !y(L.prev) && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
        }
        function F(L) {
          return L.lastChild && L.lastChild.isTrailingSpaceSensitive && !L.lastChild.hasTrailingSpaces && !y(p(L.lastChild)) && !d(L);
        }
        function i(L) {
          return !L.next && !L.hasTrailingSpaces && L.isTrailingSpaceSensitive && y(p(L));
        }
        function g(L) {
          return L.next && !y(L.next) && y(L) && L.isTrailingSpaceSensitive && !L.hasTrailingSpaces;
        }
        function E(L) {
          let ee = L.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
          return ee ? ee[1] ? ee[1].split(/\s+/) : !0 : !1;
        }
        function x(L) {
          return !L.prev && L.isLeadingSpaceSensitive && !L.hasLeadingSpaces;
        }
        function b(L, ee, R) {
          let O = L.getValue();
          if (!s(O.attrs))
            return O.isSelfClosing ? " " : "";
          let Z = O.prev && O.prev.type === "comment" && E(O.prev.value), ie = typeof Z == "boolean" ? () => Z : Array.isArray(Z) ? (De) => Z.includes(De.rawName) : () => !1, te = L.map((De) => {
            let fe = De.getValue();
            return ie(fe) ? c(ee.originalText.slice(h(fe), m(fe))) : R();
          }, "attrs"), ge = O.type === "element" && O.fullName === "script" && O.attrs.length === 1 && O.attrs[0].fullName === "src" && O.children.length === 0, q = ee.singleAttributePerLine && O.attrs.length > 1 && !P(O, ee) ? o : n, z = [a([ge ? " " : n, e(q, te)])];
          return O.firstChild && x(O.firstChild) || O.isSelfClosing && F(O.parent) || ge ? z.push(O.isSelfClosing ? " " : "") : z.push(ee.bracketSameLine ? O.isSelfClosing ? " " : "" : O.isSelfClosing ? n : r), z;
        }
        function B(L) {
          return L.firstChild && x(L.firstChild) ? "" : U(L);
        }
        function I(L, ee, R) {
          let O = L.getValue();
          return [M(O, ee), b(L, ee, R), O.isSelfClosing ? "" : B(O)];
        }
        function M(L, ee) {
          return L.prev && g(L.prev) ? "" : [V(L, ee), $(L)];
        }
        function V(L, ee) {
          return x(L) ? U(L.parent) : D(L) ? f(L.prev, ee) : "";
        }
        function $(L) {
          switch (L.type) {
            case "ieConditionalComment":
            case "ieConditionalStartComment":
              return `<!--[if ${L.condition}`;
            case "ieConditionalEndComment":
              return "<!--<!";
            case "interpolation":
              return "{{";
            case "docType":
              return "<!DOCTYPE";
            case "element":
              if (L.condition)
                return `<!--[if ${L.condition}]><!--><${L.rawName}`;
            default:
              return `<${L.rawName}`;
          }
        }
        function U(L) {
          switch (t(!L.isSelfClosing), L.type) {
            case "ieConditionalComment":
              return "]>";
            case "element":
              if (L.condition)
                return "><!--<![endif]-->";
            default:
              return ">";
          }
        }
        l.exports = { printClosingTag: A, printClosingTagStart: N, printClosingTagStartMarker: J, printClosingTagEndMarker: f, printClosingTagSuffix: k, printClosingTagEnd: S, needsToBorrowLastChildClosingTagEndMarker: F, needsToBorrowParentClosingTagStartMarker: i, needsToBorrowPrevClosingTagEndMarker: D, printOpeningTag: I, printOpeningTagStart: M, printOpeningTagPrefix: V, printOpeningTagStartMarker: $, printOpeningTagEndMarker: U, needsToBorrowNextOpeningTagStartMarker: g, needsToBorrowParentOpeningTagEndMarker: x };
      } }), Io = X({ "node_modules/parse-srcset/src/parse-srcset.js"(u, l) {
        H(), function(t, s) {
          typeof l == "object" && l.exports ? l.exports = s() : t.parseSrcset = s();
        }(u, function() {
          return function(t, s) {
            var a = s && s.logger || console;
            function e(J) {
              return J === " " || J === "	" || J === `
` || J === "\f" || J === "\r";
            }
            function n(J) {
              var f, T = J.exec(t.substring(N));
              if (T)
                return f = T[0], N += f.length, f;
            }
            for (var r = t.length, o = /^[ \t\n\r\u000c]+/, c = /^[, \t\n\r\u000c]+/, h = /^[^ \t\n\r\u000c]+/, m = /[,]+$/, y = /^\d+$/, p = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, d, C, w, P, A, N = 0, S = []; ; ) {
              if (n(c), N >= r)
                return S;
              d = n(h), C = [], d.slice(-1) === "," ? (d = d.replace(m, ""), k()) : j();
            }
            function j() {
              for (n(o), w = "", P = "in descriptor"; ; ) {
                if (A = t.charAt(N), P === "in descriptor")
                  if (e(A))
                    w && (C.push(w), w = "", P = "after descriptor");
                  else if (A === ",") {
                    N += 1, w && C.push(w), k();
                    return;
                  } else if (A === "(")
                    w = w + A, P = "in parens";
                  else if (A === "") {
                    w && C.push(w), k();
                    return;
                  } else
                    w = w + A;
                else if (P === "in parens")
                  if (A === ")")
                    w = w + A, P = "in descriptor";
                  else if (A === "") {
                    C.push(w), k();
                    return;
                  } else
                    w = w + A;
                else if (P === "after descriptor" && !e(A))
                  if (A === "") {
                    k();
                    return;
                  } else
                    P = "in descriptor", N -= 1;
                N += 1;
              }
            }
            function k() {
              var J = !1, f, T, D, F, i = {}, g, E, x, b, B;
              for (F = 0; F < C.length; F++)
                g = C[F], E = g[g.length - 1], x = g.substring(0, g.length - 1), b = parseInt(x, 10), B = parseFloat(x), y.test(x) && E === "w" ? ((f || T) && (J = !0), b === 0 ? J = !0 : f = b) : p.test(x) && E === "x" ? ((f || T || D) && (J = !0), B < 0 ? J = !0 : T = B) : y.test(x) && E === "h" ? ((D || T) && (J = !0), b === 0 ? J = !0 : D = b) : J = !0;
              J ? a && a.error && a.error("Invalid srcset descriptor found in '" + t + "' at '" + g + "'.") : (i.url = d, f && (i.w = f), T && (i.d = T), D && (i.h = D), S.push(i));
            }
          };
        });
      } }), Lo = X({ "src/language-html/syntax-attribute.js"(u, l) {
        H();
        var t = Io(), { builders: { ifBreak: s, join: a, line: e } } = Qe();
        function n(o) {
          let c = t(o, { logger: { error(j) {
            throw new Error(j);
          } } }), h = c.some((j) => {
            let { w: k } = j;
            return k;
          }), m = c.some((j) => {
            let { h: k } = j;
            return k;
          }), y = c.some((j) => {
            let { d: k } = j;
            return k;
          });
          if (h + m + y > 1)
            throw new Error("Mixed descriptor in srcset is not supported");
          let p = h ? "w" : m ? "h" : "d", d = h ? "w" : m ? "h" : "x", C = (j) => Math.max(...j), w = c.map((j) => j.url), P = C(w.map((j) => j.length)), A = c.map((j) => j[p]).map((j) => j ? j.toString() : ""), N = A.map((j) => {
            let k = j.indexOf(".");
            return k === -1 ? j.length : k;
          }), S = C(N);
          return a([",", e], w.map((j, k) => {
            let J = [j], f = A[k];
            if (f) {
              let T = P - j.length + 1, D = S - N[k], F = " ".repeat(T + D);
              J.push(s(F, " "), f + d);
            }
            return J;
          }));
        }
        function r(o) {
          return o.trim().split(/\s+/).join(" ");
        }
        l.exports = { printImgSrcset: n, printClassNames: r };
      } }), _o = X({ "src/language-html/syntax-vue.js"(u, l) {
        H();
        var { builders: { group: t } } = Qe();
        function s(r, o) {
          let { left: c, operator: h, right: m } = a(r);
          return [t(o(`function _(${c}) {}`, { parser: "babel", __isVueForBindingLeft: !0 })), " ", h, " ", o(m, { parser: "__js_expression" }, { stripTrailingHardline: !0 })];
        }
        function a(r) {
          let o = /(.*?)\s+(in|of)\s+(.*)/s, c = /,([^,\]}]*)(?:,([^,\]}]*))?$/, h = /^\(|\)$/g, m = r.match(o);
          if (!m)
            return;
          let y = {};
          if (y.for = m[3].trim(), !y.for)
            return;
          let p = m[1].trim().replace(h, ""), d = p.match(c);
          d ? (y.alias = p.replace(c, ""), y.iterator1 = d[1].trim(), d[2] && (y.iterator2 = d[2].trim())) : y.alias = p;
          let C = [y.alias, y.iterator1, y.iterator2];
          if (!C.some((w, P) => !w && (P === 0 || C.slice(P + 1).some(Boolean))))
            return { left: C.filter(Boolean).join(","), operator: m[2], right: y.for };
        }
        function e(r, o) {
          return o(`function _(${r}) {}`, { parser: "babel", __isVueBindings: !0 });
        }
        function n(r) {
          let o = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, c = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, h = r.trim();
          return o.test(h) || c.test(h);
        }
        l.exports = { isVueEventBindingExpression: n, printVueFor: s, printVueBindings: e };
      } }), Wu = X({ "src/language-html/get-node-content.js"(u, l) {
        H();
        var { needsToBorrowParentClosingTagStartMarker: t, printClosingTagStartMarker: s, needsToBorrowLastChildClosingTagEndMarker: a, printClosingTagEndMarker: e, needsToBorrowParentOpeningTagEndMarker: n, printOpeningTagEndMarker: r } = mn();
        function o(c, h) {
          let m = c.startSourceSpan.end.offset;
          c.firstChild && n(c.firstChild) && (m -= r(c).length);
          let y = c.endSourceSpan.start.offset;
          return c.lastChild && t(c.lastChild) ? y += s(c, h).length : a(c) && (y -= e(c.lastChild, h).length), h.originalText.slice(m, y);
        }
        l.exports = o;
      } }), Oo = X({ "src/language-html/embed.js"(u, l) {
        H();
        var { builders: { breakParent: t, group: s, hardline: a, indent: e, line: n, fill: r, softline: o }, utils: { mapDoc: c, replaceTextEndOfLine: h } } = Qe(), m = Dr(), { printClosingTag: y, printClosingTagSuffix: p, needsToBorrowPrevClosingTagEndMarker: d, printOpeningTagPrefix: C, printOpeningTag: w } = mn(), { printImgSrcset: P, printClassNames: A } = Lo(), { printVueFor: N, printVueBindings: S, isVueEventBindingExpression: j } = _o(), { isScriptLikeTag: k, isVueNonHtmlBlock: J, inferScriptParser: f, htmlTrimPreserveIndentation: T, dedentString: D, unescapeQuoteEntities: F, isVueSlotAttribute: i, isVueSfcBindingsAttribute: g, getTextValueParts: E } = tn(), x = Wu();
        function b(I, M, V) {
          let $ = (te) => new RegExp(te.join("|")).test(I.fullName), U = () => F(I.value), L = !1, ee = (te, ge) => {
            let q = te.type === "NGRoot" ? te.node.type === "NGMicrosyntax" && te.node.body.length === 1 && te.node.body[0].type === "NGMicrosyntaxExpression" ? te.node.body[0].expression : te.node : te.type === "JsExpressionRoot" ? te.node : te;
            q && (q.type === "ObjectExpression" || q.type === "ArrayExpression" || ge.parser === "__vue_expression" && (q.type === "TemplateLiteral" || q.type === "StringLiteral")) && (L = !0);
          }, R = (te) => s(te), O = function(te) {
            let ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
            return s([e([o, te]), ge ? o : ""]);
          }, Z = (te) => L ? R(te) : O(te), ie = (te, ge) => M(te, Object.assign({ __onHtmlBindingRoot: ee, __embeddedInHtml: !0 }, ge));
          if (I.fullName === "srcset" && (I.parent.fullName === "img" || I.parent.fullName === "source"))
            return O(P(U()));
          if (I.fullName === "class" && !V.parentParser) {
            let te = U();
            if (!te.includes("{{"))
              return A(te);
          }
          if (I.fullName === "style" && !V.parentParser) {
            let te = U();
            if (!te.includes("{{"))
              return O(ie(te, { parser: "css", __isHTMLStyleAttribute: !0 }));
          }
          if (V.parser === "vue") {
            if (I.fullName === "v-for")
              return N(U(), ie);
            if (i(I) || g(I, V))
              return S(U(), ie);
            let te = ["^@", "^v-on:"], ge = ["^:", "^v-bind:"], q = ["^v-"];
            if ($(te)) {
              let z = U(), De = j(z) ? "__js_expression" : V.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
              return Z(ie(z, { parser: De }));
            }
            if ($(ge))
              return Z(ie(U(), { parser: "__vue_expression" }));
            if ($(q))
              return Z(ie(U(), { parser: "__js_expression" }));
          }
          if (V.parser === "angular") {
            let te = (Q, W) => ie(Q, Object.assign(Object.assign({}, W), {}, { trailingComma: "none" })), ge = ["^\\*"], q = ["^\\(.+\\)$", "^on-"], z = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], De = ["^i18n(-.+)?$"];
            if ($(q))
              return Z(te(U(), { parser: "__ng_action" }));
            if ($(z))
              return Z(te(U(), { parser: "__ng_binding" }));
            if ($(De)) {
              let Q = U().trim();
              return O(r(E(I, Q)), !Q.includes("@@"));
            }
            if ($(ge))
              return Z(te(U(), { parser: "__ng_directive" }));
            let fe = /{{(.+?)}}/s, we = U();
            if (fe.test(we)) {
              let Q = [];
              for (let [W, ne] of we.split(fe).entries())
                if (W % 2 === 0)
                  Q.push(h(ne));
                else
                  try {
                    Q.push(s(["{{", e([n, te(ne, { parser: "__ng_interpolation", __isInHtmlInterpolation: !0 })]), n, "}}"]));
                  } catch {
                    Q.push("{{", h(ne), "}}");
                  }
              return s(Q);
            }
          }
          return null;
        }
        function B(I, M, V, $) {
          let U = I.getValue();
          switch (U.type) {
            case "element": {
              if (k(U) || U.type === "interpolation")
                return;
              if (!U.isSelfClosing && J(U, $)) {
                let L = f(U, $);
                if (!L)
                  return;
                let ee = x(U, $), R = /^\s*$/.test(ee), O = "";
                return R || (O = V(T(ee), { parser: L, __embeddedInHtml: !0 }, { stripTrailingHardline: !0 }), R = O === ""), [C(U, $), s(w(I, $, M)), R ? "" : a, O, R ? "" : a, y(U, $), p(U, $)];
              }
              break;
            }
            case "text": {
              if (k(U.parent)) {
                let L = f(U.parent, $);
                if (L) {
                  let ee = L === "markdown" ? D(U.value.replace(/^[^\S\n]*\n/, "")) : U.value, R = { parser: L, __embeddedInHtml: !0 };
                  if ($.parser === "html" && L === "babel") {
                    let O = "script", { attrMap: Z } = U.parent;
                    Z && (Z.type === "module" || Z.type === "text/babel" && Z["data-type"] === "module") && (O = "module"), R.__babelSourceType = O;
                  }
                  return [t, C(U, $), V(ee, R, { stripTrailingHardline: !0 }), p(U, $)];
                }
              } else if (U.parent.type === "interpolation") {
                let L = { __isInHtmlInterpolation: !0, __embeddedInHtml: !0 };
                return $.parser === "angular" ? (L.parser = "__ng_interpolation", L.trailingComma = "none") : $.parser === "vue" ? L.parser = $.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L.parser = "__js_expression", [e([n, V(U.value, L, { stripTrailingHardline: !0 })]), U.parent.next && d(U.parent.next) ? " " : n];
              }
              break;
            }
            case "attribute": {
              if (!U.value)
                break;
              if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test($.originalText.slice(U.valueSpan.start.offset, U.valueSpan.end.offset)))
                return [U.rawName, "=", U.value];
              if ($.parser === "lwc" && /^{.*}$/s.test($.originalText.slice(U.valueSpan.start.offset, U.valueSpan.end.offset)))
                return [U.rawName, "=", U.value];
              let L = b(U, (ee, R) => V(ee, Object.assign({ __isInHtmlAttribute: !0, __embeddedInHtml: !0 }, R), { stripTrailingHardline: !0 }), $);
              if (L)
                return [U.rawName, '="', s(c(L, (ee) => typeof ee == "string" ? ee.replace(/"/g, "&quot;") : ee)), '"'];
              break;
            }
            case "front-matter":
              return m(U, V);
          }
        }
        l.exports = B;
      } }), Xu = X({ "src/language-html/print/children.js"(u, l) {
        H();
        var { builders: { breakParent: t, group: s, ifBreak: a, line: e, softline: n, hardline: r }, utils: { replaceTextEndOfLine: o } } = Qe(), { locStart: c, locEnd: h } = mr(), { forceBreakChildren: m, forceNextEmptyLine: y, isTextLikeNode: p, hasPrettierIgnore: d, preferHardlineAsLeadingSpaces: C } = tn(), { printOpeningTagPrefix: w, needsToBorrowNextOpeningTagStartMarker: P, printOpeningTagStartMarker: A, needsToBorrowPrevClosingTagEndMarker: N, printClosingTagEndMarker: S, printClosingTagSuffix: j, needsToBorrowParentClosingTagStartMarker: k } = mn();
        function J(D, F, i) {
          let g = D.getValue();
          return d(g) ? [w(g, F), ...o(F.originalText.slice(c(g) + (g.prev && P(g.prev) ? A(g).length : 0), h(g) - (g.next && N(g.next) ? S(g, F).length : 0))), j(g, F)] : i();
        }
        function f(D, F) {
          return p(D) && p(F) ? D.isTrailingSpaceSensitive ? D.hasTrailingSpaces ? C(F) ? r : e : "" : C(F) ? r : n : P(D) && (d(F) || F.firstChild || F.isSelfClosing || F.type === "element" && F.attrs.length > 0) || D.type === "element" && D.isSelfClosing && N(F) ? "" : !F.isLeadingSpaceSensitive || C(F) || N(F) && D.lastChild && k(D.lastChild) && D.lastChild.lastChild && k(D.lastChild.lastChild) ? r : F.hasLeadingSpaces ? e : n;
        }
        function T(D, F, i) {
          let g = D.getValue();
          if (m(g))
            return [t, ...D.map((x) => {
              let b = x.getValue(), B = b.prev ? f(b.prev, b) : "";
              return [B ? [B, y(b.prev) ? r : ""] : "", J(x, F, i)];
            }, "children")];
          let E = g.children.map(() => Symbol(""));
          return D.map((x, b) => {
            let B = x.getValue();
            if (p(B)) {
              if (B.prev && p(B.prev)) {
                let ee = f(B.prev, B);
                if (ee)
                  return y(B.prev) ? [r, r, J(x, F, i)] : [ee, J(x, F, i)];
              }
              return J(x, F, i);
            }
            let I = [], M = [], V = [], $ = [], U = B.prev ? f(B.prev, B) : "", L = B.next ? f(B, B.next) : "";
            return U && (y(B.prev) ? I.push(r, r) : U === r ? I.push(r) : p(B.prev) ? M.push(U) : M.push(a("", n, { groupId: E[b - 1] }))), L && (y(B) ? p(B.next) && $.push(r, r) : L === r ? p(B.next) && $.push(r) : V.push(L)), [...I, s([...M, s([J(x, F, i), ...V], { id: E[b] })]), ...$];
          }, "children");
        }
        l.exports = { printChildren: T };
      } }), Mo = X({ "src/language-html/print/element.js"(u, l) {
        H();
        var { builders: { breakParent: t, dedentToRoot: s, group: a, ifBreak: e, indentIfBreak: n, indent: r, line: o, softline: c }, utils: { replaceTextEndOfLine: h } } = Qe(), m = Wu(), { shouldPreserveContent: y, isScriptLikeTag: p, isVueCustomBlock: d, countParents: C, forceBreakContent: w } = tn(), { printOpeningTagPrefix: P, printOpeningTag: A, printClosingTagSuffix: N, printClosingTag: S, needsToBorrowPrevClosingTagEndMarker: j, needsToBorrowLastChildClosingTagEndMarker: k } = mn(), { printChildren: J } = Xu();
        function f(T, D, F) {
          let i = T.getValue();
          if (y(i, D))
            return [P(i, D), a(A(T, D, F)), ...h(m(i, D)), ...S(i, D), N(i, D)];
          let g = i.children.length === 1 && i.firstChild.type === "interpolation" && i.firstChild.isLeadingSpaceSensitive && !i.firstChild.hasLeadingSpaces && i.lastChild.isTrailingSpaceSensitive && !i.lastChild.hasTrailingSpaces, E = Symbol("element-attr-group-id"), x = (M) => a([a(A(T, D, F), { id: E }), M, S(i, D)]), b = (M) => g ? n(M, { groupId: E }) : (p(i) || d(i, D)) && i.parent.type === "root" && D.parser === "vue" && !D.vueIndentScriptAndStyle ? M : r(M), B = () => g ? e(c, "", { groupId: E }) : i.firstChild.hasLeadingSpaces && i.firstChild.isLeadingSpaceSensitive ? o : i.firstChild.type === "text" && i.isWhitespaceSensitive && i.isIndentationSensitive ? s(c) : c, I = () => (i.next ? j(i.next) : k(i.parent)) ? i.lastChild.hasTrailingSpaces && i.lastChild.isTrailingSpaceSensitive ? " " : "" : g ? e(c, "", { groupId: E }) : i.lastChild.hasTrailingSpaces && i.lastChild.isTrailingSpaceSensitive ? o : (i.lastChild.type === "comment" || i.lastChild.type === "text" && i.isWhitespaceSensitive && i.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${D.tabWidth * C(T, (M) => M.parent && M.parent.type !== "root")}}$`).test(i.lastChild.value) ? "" : c;
          return i.children.length === 0 ? x(i.hasDanglingSpaces && i.isDanglingSpaceSensitive ? o : "") : x([w(i) ? t : "", b([B(), J(T, D, F)]), I()]);
        }
        l.exports = { printElement: f };
      } }), $o = X({ "src/language-html/printer-html.js"(u, l) {
        H();
        var { builders: { fill: t, group: s, hardline: a, literalline: e }, utils: { cleanDoc: n, getDocParts: r, isConcat: o, replaceTextEndOfLine: c } } = Qe(), h = xo(), { countChars: m, unescapeQuoteEntities: y, getTextValueParts: p } = tn(), d = Po(), { insertPragma: C } = jo(), { locStart: w, locEnd: P } = mr(), A = Oo(), { printClosingTagSuffix: N, printClosingTagEnd: S, printOpeningTagPrefix: j, printOpeningTagStart: k } = mn(), { printElement: J } = Mo(), { printChildren: f } = Xu();
        function T(D, F, i) {
          let g = D.getValue();
          switch (g.type) {
            case "front-matter":
              return c(g.raw);
            case "root":
              return F.__onHtmlRoot && F.__onHtmlRoot(g), [s(f(D, F, i)), a];
            case "element":
            case "ieConditionalComment":
              return J(D, F, i);
            case "ieConditionalStartComment":
            case "ieConditionalEndComment":
              return [k(g), S(g)];
            case "interpolation":
              return [k(g, F), ...D.map(i, "children"), S(g, F)];
            case "text": {
              if (g.parent.type === "interpolation") {
                let x = /\n[^\S\n]*$/, b = x.test(g.value), B = b ? g.value.replace(x, "") : g.value;
                return [...c(B), b ? a : ""];
              }
              let E = n([j(g, F), ...p(g), N(g, F)]);
              return o(E) || E.type === "fill" ? t(r(E)) : E;
            }
            case "docType":
              return [s([k(g, F), " ", g.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), S(g, F)];
            case "comment":
              return [j(g, F), ...c(F.originalText.slice(w(g), P(g)), e), N(g, F)];
            case "attribute": {
              if (g.value === null)
                return g.rawName;
              let E = y(g.value), x = m(E, "'"), b = m(E, '"'), B = x < b ? "'" : '"';
              return [g.rawName, "=", B, ...c(B === '"' ? E.replace(/"/g, "&quot;") : E.replace(/'/g, "&apos;")), B];
            }
            default:
              throw new Error(`Unexpected node type ${g.type}`);
          }
        }
        l.exports = { preprocess: d, print: T, insertPragma: C, massageAstNode: h, embed: A };
      } }), Ro = X({ "src/language-html/options.js"(u, l) {
        H();
        var t = en(), s = "HTML";
        l.exports = { bracketSameLine: t.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s, type: "boolean", default: !1, description: "Indent script and style tags in Vue files." } };
      } }), Vo = X({ "src/language-html/parsers.js"() {
        H();
      } }), gr = X({ "node_modules/linguist-languages/data/HTML.json"(u, l) {
        l.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
      } }), Jo = X({ "node_modules/linguist-languages/data/Vue.json"(u, l) {
        l.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
      } }), qo = X({ "src/language-html/index.js"(u, l) {
        H();
        var t = Gt(), s = $o(), a = Ro(), e = Vo(), n = [t(gr(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t(gr(), (o) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...o.extensions, ".mjml"] })), t(gr(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t(Jo(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], r = { html: s };
        l.exports = { languages: n, printers: r, options: a, parsers: e };
      } }), Go = X({ "src/language-yaml/pragma.js"(u, l) {
        H();
        function t(e) {
          return /^\s*@(?:prettier|format)\s*$/.test(e);
        }
        function s(e) {
          return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(e);
        }
        function a(e) {
          return `# @format

${e}`;
        }
        l.exports = { isPragma: t, hasPragma: s, insertPragma: a };
      } }), Wo = X({ "src/language-yaml/loc.js"(u, l) {
        H();
        function t(a) {
          return a.position.start.offset;
        }
        function s(a) {
          return a.position.end.offset;
        }
        l.exports = { locStart: t, locEnd: s };
      } }), Xo = X({ "src/language-yaml/embed.js"(u, l) {
        H();
        function t(s, a, e, n) {
          if (s.getValue().type === "root" && n.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(n.filepath))
            return e(n.originalText, Object.assign(Object.assign({}, n), {}, { parser: "json" }));
        }
        l.exports = t;
      } }), nn = X({ "src/language-yaml/utils.js"(u, l) {
        H();
        var { getLast: t, isNonEmptyArray: s } = at();
        function a(f, T) {
          let D = 0, F = f.stack.length - 1;
          for (let i = 0; i < F; i++) {
            let g = f.stack[i];
            e(g) && T(g) && D++;
          }
          return D;
        }
        function e(f, T) {
          return f && typeof f.type == "string" && (!T || T.includes(f.type));
        }
        function n(f, T, D) {
          return T("children" in f ? Object.assign(Object.assign({}, f), {}, { children: f.children.map((F) => n(F, T, f)) }) : f, D);
        }
        function r(f, T, D) {
          Object.defineProperty(f, T, { get: D, enumerable: !1 });
        }
        function o(f, T) {
          let D = 0, F = T.length;
          for (let i = f.position.end.offset - 1; i < F; i++) {
            let g = T[i];
            if (g === `
` && D++, D === 1 && /\S/.test(g))
              return !1;
            if (D === 2)
              return !0;
          }
          return !1;
        }
        function c(f) {
          switch (f.getValue().type) {
            case "tag":
            case "anchor":
            case "comment":
              return !1;
          }
          let T = f.stack.length;
          for (let D = 1; D < T; D++) {
            let F = f.stack[D], i = f.stack[D - 1];
            if (Array.isArray(i) && typeof F == "number" && F !== i.length - 1)
              return !1;
          }
          return !0;
        }
        function h(f) {
          return s(f.children) ? h(t(f.children)) : f;
        }
        function m(f) {
          return f.value.trim() === "prettier-ignore";
        }
        function y(f) {
          let T = f.getValue();
          if (T.type === "documentBody") {
            let D = f.getParentNode();
            return N(D.head) && m(t(D.head.endComments));
          }
          return C(T) && m(t(T.leadingComments));
        }
        function p(f) {
          return !s(f.children) && !d(f);
        }
        function d(f) {
          return C(f) || w(f) || P(f) || A(f) || N(f);
        }
        function C(f) {
          return s(f == null ? void 0 : f.leadingComments);
        }
        function w(f) {
          return s(f == null ? void 0 : f.middleComments);
        }
        function P(f) {
          return f == null ? void 0 : f.indicatorComment;
        }
        function A(f) {
          return f == null ? void 0 : f.trailingComment;
        }
        function N(f) {
          return s(f == null ? void 0 : f.endComments);
        }
        function S(f) {
          let T = [], D;
          for (let F of f.split(/( +)/))
            F !== " " ? D === " " ? T.push(F) : T.push((T.pop() || "") + F) : D === void 0 && T.unshift(""), D = F;
          return D === " " && T.push((T.pop() || "") + " "), T[0] === "" && (T.shift(), T.unshift(" " + (T.shift() || ""))), T;
        }
        function j(f, T, D) {
          let F = T.split(`
`).map((i, g, E) => g === 0 && g === E.length - 1 ? i : g !== 0 && g !== E.length - 1 ? i.trim() : g === 0 ? i.trimEnd() : i.trimStart());
          return D.proseWrap === "preserve" ? F.map((i) => i.length === 0 ? [] : [i]) : F.map((i) => i.length === 0 ? [] : S(i)).reduce((i, g, E) => E !== 0 && F[E - 1].length > 0 && g.length > 0 && !(f === "quoteDouble" && t(t(i)).endsWith("\\")) ? [...i.slice(0, -1), [...t(i), ...g]] : [...i, g], []).map((i) => D.proseWrap === "never" ? [i.join(" ")] : i);
        }
        function k(f, T) {
          let { parentIndent: D, isLastDescendant: F, options: i } = T, g = f.position.start.line === f.position.end.line ? "" : i.originalText.slice(f.position.start.offset, f.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], E;
          if (f.indent === null) {
            let B = g.match(/^(?<leadingSpace> *)[^\n\r ]/m);
            E = B ? B.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
          } else
            E = f.indent - 1 + D;
          let x = g.split(`
`).map((B) => B.slice(E));
          if (i.proseWrap === "preserve" || f.type === "blockLiteral")
            return b(x.map((B) => B.length === 0 ? [] : [B]));
          return b(x.map((B) => B.length === 0 ? [] : S(B)).reduce((B, I, M) => M !== 0 && x[M - 1].length > 0 && I.length > 0 && !/^\s/.test(I[0]) && !/^\s|\s$/.test(t(B)) ? [...B.slice(0, -1), [...t(B), ...I]] : [...B, I], []).map((B) => B.reduce((I, M) => I.length > 0 && /\s$/.test(t(I)) ? [...I.slice(0, -1), t(I) + " " + M] : [...I, M], [])).map((B) => i.proseWrap === "never" ? [B.join(" ")] : B));
          function b(B) {
            if (f.chomping === "keep")
              return t(B).length === 0 ? B.slice(0, -1) : B;
            let I = 0;
            for (let M = B.length - 1; M >= 0 && B[M].length === 0; M--)
              I++;
            return I === 0 ? B : I >= 2 && !F ? B.slice(0, -(I - 1)) : B.slice(0, -I);
          }
        }
        function J(f) {
          if (!f)
            return !0;
          switch (f.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
            case "alias":
            case "flowMapping":
            case "flowSequence":
              return !0;
            default:
              return !1;
          }
        }
        l.exports = { getLast: t, getAncestorCount: a, isNode: e, isEmptyNode: p, isInlineNode: J, mapNode: n, defineShortcut: r, isNextLineEmpty: o, isLastDescendantNode: c, getBlockValueLineContents: k, getFlowScalarLineContents: j, getLastDescendantNode: h, hasPrettierIgnore: y, hasLeadingComments: C, hasMiddleComments: w, hasIndicatorComment: P, hasTrailingComment: A, hasEndComments: N };
      } }), Uo = X({ "src/language-yaml/print-preprocess.js"(u, l) {
        H();
        var { defineShortcut: t, mapNode: s } = nn();
        function a(n) {
          return s(n, e);
        }
        function e(n) {
          switch (n.type) {
            case "document":
              t(n, "head", () => n.children[0]), t(n, "body", () => n.children[1]);
              break;
            case "documentBody":
            case "sequenceItem":
            case "flowSequenceItem":
            case "mappingKey":
            case "mappingValue":
              t(n, "content", () => n.children[0]);
              break;
            case "mappingItem":
            case "flowMappingItem":
              t(n, "key", () => n.children[0]), t(n, "value", () => n.children[1]);
              break;
          }
          return n;
        }
        l.exports = a;
      } }), _n = X({ "src/language-yaml/print/misc.js"(u, l) {
        H();
        var { builders: { softline: t, align: s } } = Qe(), { hasEndComments: a, isNextLineEmpty: e, isNode: n } = nn(), r = /* @__PURE__ */ new WeakMap();
        function o(m, y) {
          let p = m.getValue(), d = m.stack[0], C;
          return r.has(d) ? C = r.get(d) : (C = /* @__PURE__ */ new Set(), r.set(d, C)), !C.has(p.position.end.line) && (C.add(p.position.end.line), e(p, y) && !c(m.getParentNode())) ? t : "";
        }
        function c(m) {
          return a(m) && !n(m, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
        }
        function h(m, y) {
          return s(" ".repeat(m), y);
        }
        l.exports = { alignWithSpaces: h, shouldPrintEndComments: c, printNextEmptyLine: o };
      } }), Yo = X({ "src/language-yaml/print/flow-mapping-sequence.js"(u, l) {
        H();
        var { builders: { ifBreak: t, line: s, softline: a, hardline: e, join: n } } = Qe(), { isEmptyNode: r, getLast: o, hasEndComments: c } = nn(), { printNextEmptyLine: h, alignWithSpaces: m } = _n();
        function y(d, C, w) {
          let P = d.getValue(), A = P.type === "flowMapping", N = A ? "{" : "[", S = A ? "}" : "]", j = a;
          A && P.children.length > 0 && w.bracketSpacing && (j = s);
          let k = o(P.children), J = k && k.type === "flowMappingItem" && r(k.key) && r(k.value);
          return [N, m(w.tabWidth, [j, p(d, C, w), w.trailingComma === "none" ? "" : t(","), c(P) ? [e, n(e, d.map(C, "endComments"))] : ""]), J ? "" : j, S];
        }
        function p(d, C, w) {
          let P = d.getValue();
          return d.map((A, N) => [C(), N === P.children.length - 1 ? "" : [",", s, P.children[N].position.start.line !== P.children[N + 1].position.start.line ? h(A, w.originalText) : ""]], "children");
        }
        l.exports = { printFlowMapping: y, printFlowSequence: y };
      } }), zo = X({ "src/language-yaml/print/mapping-item.js"(u, l) {
        H();
        var { builders: { conditionalGroup: t, group: s, hardline: a, ifBreak: e, join: n, line: r } } = Qe(), { hasLeadingComments: o, hasMiddleComments: c, hasTrailingComment: h, hasEndComments: m, isNode: y, isEmptyNode: p, isInlineNode: d } = nn(), { alignWithSpaces: C } = _n();
        function w(S, j, k, J, f) {
          let { key: T, value: D } = S, F = p(T), i = p(D);
          if (F && i)
            return ": ";
          let g = J("key"), E = A(S) ? " " : "";
          if (i)
            return S.type === "flowMappingItem" && j.type === "flowMapping" ? g : S.type === "mappingItem" && P(T.content, f) && !h(T.content) && (!j.tag || j.tag.value !== "tag:yaml.org,2002:set") ? [g, E, ":"] : ["? ", C(2, g)];
          let x = J("value");
          if (F)
            return [": ", C(2, x)];
          if (o(D) || !d(T.content))
            return ["? ", C(2, g), a, n("", k.map(J, "value", "leadingComments").map(($) => [$, a])), ": ", C(2, x)];
          if (N(T.content) && !o(T.content) && !c(T.content) && !h(T.content) && !m(T) && !o(D.content) && !c(D.content) && !m(D) && P(D.content, f))
            return [g, E, ": ", x];
          let b = Symbol("mappingKey"), B = s([e("? "), s(C(2, g), { id: b })]), I = [a, ": ", C(2, x)], M = [E, ":"];
          o(D.content) || m(D) && D.content && !y(D.content, ["mapping", "sequence"]) || j.type === "mapping" && h(T.content) && d(D.content) || y(D.content, ["mapping", "sequence"]) && D.content.tag === null && D.content.anchor === null ? M.push(a) : D.content && M.push(r), M.push(x);
          let V = C(f.tabWidth, M);
          return P(T.content, f) && !o(T.content) && !c(T.content) && !m(T) ? t([[g, V]]) : t([[B, e(I, V, { groupId: b })]]);
        }
        function P(S, j) {
          if (!S)
            return !0;
          switch (S.type) {
            case "plain":
            case "quoteSingle":
            case "quoteDouble":
              break;
            case "alias":
              return !0;
            default:
              return !1;
          }
          if (j.proseWrap === "preserve")
            return S.position.start.line === S.position.end.line;
          if (/\\$/m.test(j.originalText.slice(S.position.start.offset, S.position.end.offset)))
            return !1;
          switch (j.proseWrap) {
            case "never":
              return !S.value.includes(`
`);
            case "always":
              return !/[\n ]/.test(S.value);
            default:
              return !1;
          }
        }
        function A(S) {
          return S.key.content && S.key.content.type === "alias";
        }
        function N(S) {
          if (!S)
            return !0;
          switch (S.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
              return S.position.start.line === S.position.end.line;
            case "alias":
              return !0;
            default:
              return !1;
          }
        }
        l.exports = w;
      } }), Ko = X({ "src/language-yaml/print/block.js"(u, l) {
        H();
        var { builders: { dedent: t, dedentToRoot: s, fill: a, hardline: e, join: n, line: r, literalline: o, markAsRoot: c }, utils: { getDocParts: h } } = Qe(), { getAncestorCount: m, getBlockValueLineContents: y, hasIndicatorComment: p, isLastDescendantNode: d, isNode: C } = nn(), { alignWithSpaces: w } = _n();
        function P(A, N, S) {
          let j = A.getValue(), k = m(A, (F) => C(F, ["sequence", "mapping"])), J = d(A), f = [j.type === "blockFolded" ? ">" : "|"];
          j.indent !== null && f.push(j.indent.toString()), j.chomping !== "clip" && f.push(j.chomping === "keep" ? "+" : "-"), p(j) && f.push(" ", N("indicatorComment"));
          let T = y(j, { parentIndent: k, isLastDescendant: J, options: S }), D = [];
          for (let [F, i] of T.entries())
            F === 0 && D.push(e), D.push(a(h(n(r, i)))), F !== T.length - 1 ? D.push(i.length === 0 ? e : c(o)) : j.chomping === "keep" && J && D.push(s(i.length === 0 ? e : o));
          return j.indent === null ? f.push(t(w(S.tabWidth, D))) : f.push(s(w(j.indent - 1 + k, D))), f;
        }
        l.exports = P;
      } }), Qo = X({ "src/language-yaml/printer-yaml.js"(u, l) {
        H();
        var { builders: { breakParent: t, fill: s, group: a, hardline: e, join: n, line: r, lineSuffix: o, literalline: c }, utils: { getDocParts: h, replaceTextEndOfLine: m } } = Qe(), { isPreviousLineEmpty: y } = at(), { insertPragma: p, isPragma: d } = Go(), { locStart: C } = Wo(), w = Xo(), { getFlowScalarLineContents: P, getLastDescendantNode: A, hasLeadingComments: N, hasMiddleComments: S, hasTrailingComment: j, hasEndComments: k, hasPrettierIgnore: J, isLastDescendantNode: f, isNode: T, isInlineNode: D } = nn(), F = Uo(), { alignWithSpaces: i, printNextEmptyLine: g, shouldPrintEndComments: E } = _n(), { printFlowMapping: x, printFlowSequence: b } = Yo(), B = zo(), I = Ko();
        function M(O, Z, ie) {
          let te = O.getValue(), ge = [];
          te.type !== "mappingValue" && N(te) && ge.push([n(e, O.map(ie, "leadingComments")), e]);
          let { tag: q, anchor: z } = te;
          q && ge.push(ie("tag")), q && z && ge.push(" "), z && ge.push(ie("anchor"));
          let De = "";
          T(te, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !f(O) && (De = g(O, Z.originalText)), (q || z) && (T(te, ["sequence", "mapping"]) && !S(te) ? ge.push(e) : ge.push(" ")), S(te) && ge.push([te.middleComments.length === 1 ? "" : e, n(e, O.map(ie, "middleComments")), e]);
          let fe = O.getParentNode();
          return J(O) ? ge.push(m(Z.originalText.slice(te.position.start.offset, te.position.end.offset).trimEnd(), c)) : ge.push(a(V(te, fe, O, Z, ie))), j(te) && !T(te, ["document", "documentHead"]) && ge.push(o([te.type === "mappingValue" && !te.content ? "" : " ", fe.type === "mappingKey" && O.getParentNode(2).type === "mapping" && D(te) ? "" : t, ie("trailingComment")])), E(te) && ge.push(i(te.type === "sequenceItem" ? 2 : 0, [e, n(e, O.map((we) => [y(Z.originalText, we.getValue(), C) ? e : "", ie()], "endComments"))])), ge.push(De), ge;
        }
        function V(O, Z, ie, te, ge) {
          switch (O.type) {
            case "root": {
              let { children: q } = O, z = [];
              ie.each((fe, we) => {
                let Q = q[we], W = q[we + 1];
                we !== 0 && z.push(e), z.push(ge()), U(Q, W) ? (z.push(e, "..."), j(Q) && z.push(" ", ge("trailingComment"))) : W && !j(W.head) && z.push(e, "---");
              }, "children");
              let De = A(O);
              return (!T(De, ["blockLiteral", "blockFolded"]) || De.chomping !== "keep") && z.push(e), z;
            }
            case "document": {
              let q = Z.children[ie.getName() + 1], z = [];
              return L(O, q, Z, te) === "head" && ((O.head.children.length > 0 || O.head.endComments.length > 0) && z.push(ge("head")), j(O.head) ? z.push(["---", " ", ge(["head", "trailingComment"])]) : z.push("---")), $(O) && z.push(ge("body")), n(e, z);
            }
            case "documentHead":
              return n(e, [...ie.map(ge, "children"), ...ie.map(ge, "endComments")]);
            case "documentBody": {
              let { children: q, endComments: z } = O, De = "";
              if (q.length > 0 && z.length > 0) {
                let fe = A(O);
                T(fe, ["blockFolded", "blockLiteral"]) ? fe.chomping !== "keep" && (De = [e, e]) : De = e;
              }
              return [n(e, ie.map(ge, "children")), De, n(e, ie.map(ge, "endComments"))];
            }
            case "directive":
              return ["%", n(" ", [O.name, ...O.parameters])];
            case "comment":
              return ["#", O.value];
            case "alias":
              return ["*", O.value];
            case "tag":
              return te.originalText.slice(O.position.start.offset, O.position.end.offset);
            case "anchor":
              return ["&", O.value];
            case "plain":
              return ee(O.type, te.originalText.slice(O.position.start.offset, O.position.end.offset), te);
            case "quoteDouble":
            case "quoteSingle": {
              let q = "'", z = '"', De = te.originalText.slice(O.position.start.offset + 1, O.position.end.offset - 1);
              if (O.type === "quoteSingle" && De.includes("\\") || O.type === "quoteDouble" && /\\[^"]/.test(De)) {
                let we = O.type === "quoteDouble" ? z : q;
                return [we, ee(O.type, De, te), we];
              }
              if (De.includes(z))
                return [q, ee(O.type, O.type === "quoteDouble" ? De.replace(/\\"/g, z).replace(/'/g, q.repeat(2)) : De, te), q];
              if (De.includes(q))
                return [z, ee(O.type, O.type === "quoteSingle" ? De.replace(/''/g, q) : De, te), z];
              let fe = te.singleQuote ? q : z;
              return [fe, ee(O.type, De, te), fe];
            }
            case "blockFolded":
            case "blockLiteral":
              return I(ie, ge, te);
            case "mapping":
            case "sequence":
              return n(e, ie.map(ge, "children"));
            case "sequenceItem":
              return ["- ", i(2, O.content ? ge("content") : "")];
            case "mappingKey":
            case "mappingValue":
              return O.content ? ge("content") : "";
            case "mappingItem":
            case "flowMappingItem":
              return B(O, Z, ie, ge, te);
            case "flowMapping":
              return x(ie, ge, te);
            case "flowSequence":
              return b(ie, ge, te);
            case "flowSequenceItem":
              return ge("content");
            default:
              throw new Error(`Unexpected node type ${O.type}`);
          }
        }
        function $(O) {
          return O.body.children.length > 0 || k(O.body);
        }
        function U(O, Z) {
          return j(O) || Z && (Z.head.children.length > 0 || k(Z.head));
        }
        function L(O, Z, ie, te) {
          return ie.children[0] === O && /---(?:\s|$)/.test(te.originalText.slice(C(O), C(O) + 4)) || O.head.children.length > 0 || k(O.head) || j(O.head) ? "head" : U(O, Z) ? !1 : Z ? "root" : !1;
        }
        function ee(O, Z, ie) {
          let te = P(O, Z, ie);
          return n(e, te.map((ge) => s(h(n(r, ge)))));
        }
        function R(O, Z) {
          if (T(Z))
            switch (delete Z.position, Z.type) {
              case "comment":
                if (d(Z.value))
                  return null;
                break;
              case "quoteDouble":
              case "quoteSingle":
                Z.type = "quote";
                break;
            }
        }
        l.exports = { preprocess: F, embed: w, print: M, massageAstNode: R, insertPragma: p };
      } }), Ho = X({ "src/language-yaml/options.js"(u, l) {
        H();
        var t = en();
        l.exports = { bracketSpacing: t.bracketSpacing, singleQuote: t.singleQuote, proseWrap: t.proseWrap };
      } }), Zo = X({ "src/language-yaml/parsers.js"() {
        H();
      } }), el = X({ "node_modules/linguist-languages/data/YAML.json"(u, l) {
        l.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
      } }), tl = X({ "src/language-yaml/index.js"(u, l) {
        H();
        var t = Gt(), s = Qo(), a = Ho(), e = Zo(), n = [t(el(), (r) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...r.filenames.filter((o) => o !== "yarn.lock"), ".prettierrc", ".stylelintrc", ".lintstagedrc"] }))];
        l.exports = { languages: n, printers: { yaml: s }, options: a, parsers: e };
      } }), nl = X({ "src/languages.js"(u, l) {
        H(), l.exports = [Ls(), Zs(), so(), mo(), vo(), qo(), tl()];
      } });
      H();
      var { version: rl } = xt(), rn = Ha(), { getSupportInfo: ul } = Kn(), il = Za(), al = nl(), sl = Qe();
      function Xt(u) {
        let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return function() {
          for (var t = arguments.length, s = new Array(t), a = 0; a < t; a++)
            s[a] = arguments[a];
          let e = s[l] || {}, n = e.plugins || [];
          return s[l] = Object.assign(Object.assign({}, e), {}, { plugins: [...al, ...Array.isArray(n) ? n : Object.values(n)] }), u(...s);
        };
      }
      var yr = Xt(rn.formatWithCursor);
      oe.exports = { formatWithCursor: yr, format(u, l) {
        return yr(u, l).formatted;
      }, check(u, l) {
        let { formatted: t } = yr(u, l);
        return t === u;
      }, doc: sl, getSupportInfo: Xt(ul, 0), version: rl, util: il, __debug: { parse: Xt(rn.parse), formatAST: Xt(rn.formatAST), formatDoc: Xt(rn.formatDoc), printToDoc: Xt(rn.printToDoc), printDocToString: Xt(rn.printDocToString) } };
    });
    return Ji();
  });
})(Qu);
var pl = Qu.exports;
const fl = /* @__PURE__ */ ll(pl);
export {
  fl as default
};
